export const ko = {
    "name": "한국어",
    "flagCode": "kr",
    "locale": "ko-KR",
    "project": {
        "name": "QUp New CC"
    },
    "MigrationBanner": {
        "title": "Next-Generation Command Center",
        "subtitle": "새 대시보드를 살펴보고 %{deadline}까지 마이그레이션을 완료하세요.",
        "tryNow": "지금 사용해 보기",
        "dismiss": "닫기"
    },

    "Sidebar": {
        "Product_Discovery": "제품 탐색",
        "Setting": "설정",
        "Map": "지도",
        "Cue": "큐",
        "Invoice": "송장",
        "Supplier": "공급자",
        "Vehicle": "차량",
        "Merchant": "상인",
        "ImportBookings": "운송 예약 가져오기",
        "ImportDeliveryBookings": "배송 예약 가져오기",
        "Trip": "여행",
        "New_booking": "새로운 예약",
        "City": "도시",
        "Chauffeur": "교통",
        "Delivery": "배달",
        "Shuttle": "셔틀",
        "Intercity": "도시 간",
        "Customer": "고객",
        "Driver": "운전자",
        "REPORTS": "보고서",
        "Corporate": "기업",
        "mDispatcher": "파트너",
        "Reservation": "달력",
        "withdrawalRequest": "출금 요청",
        "Driver_Settlement": "운전자 결제",
        "Dashboard": "분석",
        "SmartData": "스마트 데이터",
        "Smart_Data": "스마트 데이터",
        "Campaign_Builder": "캠페인 빌더",
        "Company_operator": "회사 운영자",
        "Queuing_area": "대기 영역",
        "Withdrawal_Requests": "출금 요청",
        "pickUp": "픽업",
        "dropOff": "하차",
        "SignUpNotifications": "가입 알림",
        "Payout": "지급",
        "Payout_label": "지급",
        "Invoice_Setting": "송장",
        "payout": {
            "payoutDriver": "운전자 지급",
            "payoutMerchant": "상인 지급",
            "payoutSupplier": "공급자 지급",
            "Pay_To_Driver": "운전자에게 지급",
            "payoutDriverHistory": "운전자 지급 기록",
            "Pay_To_Merchant": "상인에게 지급",
            "Payout_History_For_Merchant": "상인 지급 기록",
            "Pay_To_Supplier": "공급자에게 지급",
            "payoutSupplierHistory": "공급자 지급 기록",
            "Driver_Payout": "운전자 지급",
            "Supplier_Payout": "공급자 지급",
            "Merchant_Payout": "상인 지급"
        },
        "number_of_records_to_export": "내보낼 레코드의 개수",
        "export": "내보내기",
        "Airline": "항공사",
        "driverPayout": {
            "Pay_to_driver": "운전자에게 지급",
            "Payout_history": "지급 기록"
        },
        "Reports": {
            "Driver_Referral_history": "운전자가 고객을 추천함",
            "Driver_refers_Pax": "운전자",
            "Refund": "환불",
            "Driver_refers_Pax_Customers": "고객",
            "Driver_refers_Pax_Bookings": "예약",
            "Driver_refers_customer_Drivers": "운전자가 고객을 추천함 (운전자)",
            "Driver_refers_customer_Customers": "운전자가 고객을 추천함 (고객)",
            "Driver_refers_customer_Bookings": "운전자가 고객을 추천함 (예약)",
            "Passenger_refers_Passengers": "고객이 고객을 추천함",
            "Driver_refers_drivers_Referrer": "운전자가 운전자를 추천함 (추천인)",
            "Deletion_request": "삭제 요청",
            "Driver_refers_drivers_Referee": "운전자가 운전자를 추천함 (피추천인)",
            "Supplier_Wallet": "공급자 지갑",
            "Driver_refers_Driver": "운전자가 운전자를 추천함",
            "Driver_refers_driver_Referrer": "추천인",
            "Driver_refers_driver_Referee": "피추천인",
            "Referral_history": "추천 기록",
            "Booking_details": "예약 세부 정보",
            "Financial": "재무",
            "Financial_driver": "운전자",
            "Financial_fleet": "차량대열",
            "Financial_company": "공급자",
            "Financial_Driver": "재무 (운전자)",
            "Financial_Fleet": "재무 (차량대열)",
            "Financial_Company": "재무 (회사)",
            "Financial_fleet_profit": "차량대열 이익",
            "Financial_Company_Tooltip": "회사 별 운전자 순 이익 보고서",
            "Financial_Driver_ToolTip": "각 운전자의 순 이익 보고서",
            "Financial_Fleet_Profit_ToolTip": "차량대열의 이익",
            "Driver_activity": "운전자의 활동",
            "Revenue_Summary": "수익 요약",
            "Revenue_fleet": "차량대열",
            "Revenue_driver": "운전자",
            "Revenue_monthly": "월간",
            "Revenue_Summary_Fleet": "수익 요약 (차량대열)",
            "Revenue_Summary_Driver": "수익 요약 (운전자)",
            "Revenue_Summary_Monthly": "수익 요약 (월간)",
            "Total_adjustment": "전체 조정",
            "Promotion": "프로모션",
            "Incident_Cancellation": "사건 및 취소",
            "Booking_logs": "예약 로그",
            "Rating": "등급",
            "Thumbs_rating": "등급",
            "Stars_rating": "등급",
            "Operator_logs": "운영자 로그",
            "Daily": "일일",
            "Daily_Driver": "일일 운전자",
            "Daily_Car": "일일차량",
            "Daily_Driver_Car": "일일 운전자 차량",
            "mDispatcher": "파트너",
            "Corporate": "기업 예약",
            "Driver_login_status": "운전자 로그인 상태",
            "Car_activity": "차량 활동",
            "Partner": "파트너",
            "Prepaid_top_up": "기업 선불",
            "Affiliation": "제휴",
            "Affiliation_penalty_compensation": "벌금/보상",
            "Affiliation_payout_history": "결산 이력",
            "Affiliation_bookings": "예약",
            "Booking_summary": "예약 요약",
            "Cash_Wallet": "현금 지갑",
            "Credit_Wallet": "신용 지갑",
            "Driver_wallet": "운전자 지갑",
            "Driver_Deposit": "운전자 예금",
            "Driver_cash_wallet": "현금 지갑",
            "Driver_Deposit_old": "운전자 예금",
            "Document_expiry": "문서 만료",
            "Settlement": "결산",
            "Unapproved_Driver": "미승인 운전자",
            "Approved_Driver": "승인된 운전자",
            "Pay_to_driver": "운전자에게 지불",
            "Settlement_history": "결산 이력",
            "Withdrawal_History": "운전자 출금",
            "creditWalletTooltip": "운전자가 신용 지갑으로 예금",
            "Incomplete_payment": "미완성 결제",
            "Driver_withdrawal": "운전자 출금",
            "Incident_&_Cancellation": "사건 및 취소",
            "Passenger_wallet": "승객 지갑",
            "Accept_Cancel_rate": "운전자 성과",
            "Acceptance/Cancellation_rate": "운전자 성과",
            "driverDepositTooltip": "운전자가 신용 지갑으로 예금",
            "Customer_quest": "퀘스트",
            "First_will_win": "첫번째가 이김",
            "Largest_will_win": "가장 큰 점수가 이김",
            "redeemed": "코드 #",
            "Code_#": "코드 #",
            "Quests": "퀘스트",
            "Merchant_Report": "상인",
            "Merchant_Financial_Report": "재무",
            "Merchant_Cash_Report": "현금 지갑",
            "Merchant_Credit_Report": "신용 지갑",
            "Deletion_Request": "삭제 요청",
            "Driver_Rating": "고객이 운전자를 평가",
            "Passenger_Rating": "운전자가 고객을 평가",
            "Company_settlement": "회사 결산",
            "Export": "이력 내보내기",
            "Third_Party_Booking": "3자 예약",
            "BookingDotCom": "Booking.com",
            "Third_Party_Booking_Bookingcom": "제 3자 예약 (Booking.com)",
            "Third_Party_Booking_HolidayTaxis": "제 3자 예약 (HolidayTaxis)",
            "Third_Party_Booking_Karhoo": "제 3자 예약 (Karhoo)",
            "Third_Party_Booking_Hoppa": "제 3자 예약 (Hoppa)",
            "Third_Party_Booking_Klook": "제 3자 예약 (Klook)",
            "Third_Party_Booking_TransferZ": "제 3자 예약 (TransferZ)",
            "supplierWallet": "공급자 지갑"
        },
        "Settings": {
            "Block_Passenger": "승객 차단",
            "Fleet_info": "차량 정보",
            "Product_Discovery": "제품 탐색",
            "Surchage_Policy": "할증 정책",
            "RateLegacy": "요금 (레거시)",
            "Driver": "운전자",
            "Merchant": "상인",
            "Calendar": "달력",
            "Socaial": "Socaial",
            "Quest": "퀘스트",
            "Referral": "추천인",
            "Addon_Template": "Add-On Template",
            "Social": "사회",
            "Shift": "교대",
            "Rate_Templates": "요금 템플릿",
            "Supplier_Plan": "공급 계획",
            "Vehicle_Lead_Time": "차량 리드 타임",
            "Penalty_Policy": "벌금 정책",
            "Stripe_connect": "Stripe Connect",
            "stripe_title_connect": "당신의 Stripe Connect 계정을 활성화하여 자동으로 지급받으세요.",
            "Payment_info": "청구 정보",
            "Permission": "허가",
            "Driver_refer_driver": "운전자가 운전자를 추천",
            "Show_referal_history": "운전자 앱에서 추천 이력 보기/숨기기",
            "companyTooltip": "공급회사",
            "User": "사용자",
            "General": "일반",
            "Regular": "일반",
            "Sharing": "스트리트 공유",
            "Flat": "플랫",
            "Hourly": "시간당 - 일일",
            "Company": "대리인 (회사)",
            "Dispatch": "발송",
            "Voice_SMS": "음성 & SMS",
            "Rate": "요금",
            "RateNew": "요금",
            "Car": "차량",
            "Car_type": "차량 유형",
            "Car_mgmt": "차량 관리",
            "Car_Make": "제작 & 모델",
            "Meeting_Zone": "회의 지역",
            "Restricted_Zone": "제한 지역",
            "Stripe_Connect": "Stripe Connect",
            "Voice_&_SMS": "음성 & SMS",
            "Street-sharing_rate": "스트리트 공유 요금",
            "Partner_type": "파트너 유형",
            "Shift_template": "근무 템플릿",
            "Billing_Usage": "청구 사용",
            "Driver_App": "드라이버 앱",
            "Shift_settings": "근무 설정",
            "Operation": "운영",
            "Driver_Note": "드라이버 노트",
            "Promotion_code": "프로모션 코드",
            "Point_config": "포인트 설정",
            "Code_#": "코드 #",
            "Voucher_code": "코드 #",
            "Campaign": "캠페인",
            "Queuing_area": "대기 영역",
            "Referral_code": "추천 코드",
            "City": "도시",
            "category": "카테고리",
            "3rd_party_location": "제3자 위치",
            "Zone": "구역",
            "App_banner": "앱 배너",
            "App_banner_pegasus": "앱 배너 (페가수스)",
            "Flight_integration": "항공 통합",
            "SMS_integration": "SMS 통합",
            "Invoice_Setting": "송장 템플릿",
            "Payout_Setting": "지급 템플릿",
            "AI_Atlas": "아틀라스 AI 챗봇",
            "Driver_refers_customer": "운전자가 고객을 추천함",
            "Pax_refers_Pax": "고객이 고객을 추천함",
            "Customer_refers_customer": "고객이 고객을 추천함",
            "Dynamic_Surcharge": "동적 할증",
            "Dynamic_Fare": "동적 요금",
            "FlatZone": "정액 요금",
            "IntercityZone": "도시 간",
            "Intercity_Zone": "시외 구역",
            "Intercity_Rate": "시외 요금",
            "Car_Color": "차량 색상",
            "third_party_integration": "제3자 통합",
            "bookingCom": "Booking.com",
            "HolidayTaxis": "HolidayTaxis",
            "Karhoo": "Karhoo",
            "Corporate": "기업",
            "KarhooIntegration": "Karhoo 통합",
            "holidaytaxis": "HolidayTaxis",
            "karhoo": "Karhoo",
            "hoppa": "Hoppa",
            "Hoppa": "Hoppa",
            "HoppaIntegration": "Hoppa 통합",
            "Third_Party_Integration_Hoppa": "제3자 통합 (Hoppa.com)",
            "titleHoppa": "Hoppa API 자격증명",
            "noteHoppa": "Hoppa의 기술 팀과 소통하여 그들의 시스템에 연결하기 위한 클라이언트와 비밀 키를 제공합니다.",
            "titleHoppaWebhook": "Webhook Configuration",
            "noteHoppaWebhook": "Hoppa가 구성할수 있게 아래의 파라미터를 제공합니다. 이 자격증명은 두 플랫폼 간의 통신에 사용됩니다. 문제가 있으면 기술 제공업체에게 연락하십시오.",
            "klook": "Klook",
            "Klook": "Klook",
            "KlookIntegration": "Klook 통합",
            "Third_Party_Integration_Klook": "제3자 통합 (Klook.com)",
            "titleKlook": "Klook API 자격증명",
            "noteKlook": "Klook의 기술 팀과 소통하여 그들의 시스템에 연결하기 위한 클라이언트와 비밀 키를 제공합니다.",
            "titleKlookWebhook": "Webhook Configuration",
            "noteKlookWebhook": "Klook가 구성할수 있게 아래의 파라미터를 제공합니다. 이 자격증명은 두 플랫폼 간 통신에 사용됩니다. 문제가 있으면 기술 제공업체에게 연락하십시오.",
            "transferZ": "TransferZ",
            "TransferZ": "TransferZ",
            "TransferZIntegration": "TransferZ 통합",
            "Third_Party_Integration_TransferZ": "제3자 통합 (TransferZ.com)",
            "titleTransferZ": "TransferZ API 자격증명",
            "noteTransferZ": "TransferZ의 기술 팀과 소통하여 그들의 시스템에 연결하기 위한 클라이언트와 비밀 키를 제공합니다.",
            "titleTransferZWebhook": "Webhook Configuration",
            "noteTransferZWebhook": "TransferZ가 구성할수 있게 아래의 파라미터를 제공합니다. 이 자격증명은 두 플랫폼 간 통신에 사용됩니다. 문제가 있으면 기술 제공업체에게 연락하십시오.",
            "Third_Party_Integration_Booking": "제3자 통합 (Booking.com)",
            "Third_Party_Integration_HolidayTaxis": "제3자 통합 (HolidayTaxis)",
            "Third_Party_Integration_Karhoo": "제3자 통합 (Karhoo.com)",
            "Third_Party_Integration_Mozio": "제3자 통합 (Mozio.com)",
            "invoiceBranding": "송장 브랜딩",
            "invoiceLogo": "송장 로고",
            "invoiceColor": "송장 색상",
            "payoutBranding": "지급 브랜딩",
            "titleInvoice": "회사의 헤더와 푸터 정보를 개인화하십시오.",
            "titlePayout": "회사의 헤더와 푸터 정보를 개인화하십시오.",
            "titleheader": "헤더 제목",
            "descriptionHeader": "헤더 설명",
            "placehodelHeader": "예를 들어, 이메일, 전화번호, 주소, 세금 번호 등 회사의 세부 사항을 추가합니다.",
            "titleFooter": "푸터 제목",
            "placehodelFooter": "예를 들어, 은행 와이어 정보나 정책 등을 추가합니다",
            "descriptionFooter": "푸터 설명",
            "defaultEmailMessage": "기본 이메일 메시지",
            "placeholderEmailMessage": "금액은 선호하는 지불 방식을 사용하여 계정으로 이체될 것입니다. <email>로 문의 사항이 있으면 언제든지 연락하십시오.\n제공해주신 서비스에 감사드립니다. 앞으로의 성공적인 협력을 기대하고 있습니다.\n최고의 인사를 보냅니다.\n좋은 여행 팀\n7일 내에 이의신청이 접수되지 않으면, 자동생성된 송장은 승인된 것으로 간주됩니다.",
            "titleBookingCom": "Booking.com API 자격증명",
            "noteBookingCom": "Booking.com의 기술 팀과 소통하여 그들의 시스템에 연결하기 위한 클라이언트와 비밀 키를 제공합니다.",
            "clientKey": "클라이언트 키",
            "placeHolderClientKey": "클라이언트 키 입력",
            "secretKey": "비밀 키",
            "placeHolderSecretKey": "클라이언트 비밀 키 입력",
            "titleBookingComWebhook": "Webhook Configuration",
            "noteBookingComWebhook": "Booking.com이 구성하기 위해 아래의 매개변수를 제공합니다. 이 자격증명은 두 플랫폼 간의 통신에 사용됩니다. 문제가 있으면 기술 제공업체에게 연락하십시오.",
            "webhook": "플릿 웹훅 URL",
            "clientId": "플릿 클라이언트 키",
            "clientSecret": "플릿 비밀 키",
            "driver_app": "드라이버 앱",
            "Jobs_tab": "작업 탭",
            "Email_config": "이메일 설정",
            "Driver_fields": "드라이버 필드",
            "Driver_document": "드라이버 문서",
            "Selected": "선택된",
            "API_Management": "API 관리",
            "Penalty_Policy_Customer": "고객 패널티 정책",
            "Penalty_Policy_Supplier": "공급업체 벌금 정책",
            "Stop_Sales": "판매 중지",
            "RestrictedZone": "제한 지역",
            "MeetingZone": "회의 지역",
            "block_passenger": "승객 차단",
            "Billing_usage": "청구 사용"
        }
    },
    "welcome": {
        "next": "Next",
        "getStarted": "Get Started",
        "step1": {
            "title": "Product Discovery",
            "description": "Welcome to Good Journey! Access all the products included in your plan, such as the <span class=\"highlight-white\">Driver App, Customer Web Booker</span> and more.",
            "button": "Learn more"
        },
        "step2": {
            "title": "Introducing Fleet Wallet",
            "description": "Once you reach your free allowance, any additional overage will check your fleet wallet to deduct per additional request.",
            "moreInfo": "💡 Maintain a positive balance, check usage and transaction reports here."
        },
        "step3": {
            "title": "Never Miss a Beat",
            "description": "You can setup <span class=\"highlight-white\">Automated Top-up</span> to ensure no service disruption on top of usage.",
            "description2": "This ensures your drivers stay on the road and your data keeps flowing, no matter how busy things get."
        },
        "step4": {
            "title": "Getting Started",
            "description": "We’re thrilled to have you onboard! Check out our <span class=\"highlight-white\">Guides & Tutorials</span> section to master the platform and get the most out of your fleet management tools."
        }
    },
    "productDiscovery": {
        "title": "제품 탐색",
        "fleetCode": "차량 코드",
        "fleetCodeDescription": "글로벌 드라이버 앱을 사용하는 드라이버는 로그인하기 전에 이 코드를 입력해야 합니다.",
        "description": "탐색하고 편의와 성장을 위한 툴을 활성화하세요. 드라이버 앱, 고객 앱, 웹 예약 포털 및 파트너 예약 앱 접속 — 운영을 간소화하고, 승객들과 연결하고, 사업을 확장하도록 설계되었습니다.",
        "web": "웹",
        "ios": "iOS",
        "android": "Android",
        "guide": "가이드",
        "gallery": "갤러리",
        "downloadLinks": "다운로드 링크",
        "customize": "설정",
        "base": "지식베이스",
        "base_description": "플랫폼에 대한 종합 가이드입니다. 예약, 배차, 결제 등을 완벽하게 다루기 위한 단계별 튜토리얼, 자주 묻는 질문, 모범 사례를 탐색하십시오.",
        "base_allowed": {
            "platform_guides": "플랫폼 가이드",
            "step_by_step_tutorials": "단계별 튜토리얼",
            "faqs_troubleshooting": "자주 묻는 질문 및 문제 해결",
            "best_practices": "모범사례",
            "product_releases_updates": "제품 출시 및 업데이트"
        },
        "driver_app": "드라이버 앱",
        "driver_app_description": "드라이버에게 작업 관리, 승차 완료, 예약 업데이트 등을 쉽게 수행할 수 있는 앱을 제공하세요.",
        "driver_app_allowed": {
            "booking_notifications": "예약 알림",
            "trip_management": "여행 관리",
            "navigate_realtime_tracking": "네비게이션 및 실시간 추적",
            "inapp_communication_support": "앱 내 커뮤니케이션 및 지원",
            "track_driver_earnings": "드라이버 수익 추적",
            "driver_signup_link": "운전자 가입 링크"
        },
        "passenger_app": "승객 앱",
        "passenger_app_description": "쉽게 탑승 및 관리하실 수 있습니다. 승객 앱은 여행자에게 시간과 장소에 상관없이 최상의 경험을 제공합니다 — 즉시 예약에서 실시간 업데이트까지 — 매 단계에서의 편안함, 신뢰성, 제어력을 보장합니다.",
        "passenger_app_allowed": {
            "seamless_ride_booking": "탄력적인 탑승 예약",
            "realtime_tracking_notifications": "실시간 추적 및 알림",
            "inapp_communication": "앱 내 커뮤니케이션",
            "flexible_payment_receipts": "유연한 결제 및 영수증",
            "ride_history_favorites": "탑승 히스토리 및 즐겨찾기"
        },
        "web_driver_app": "드라이버 웹 앱",
        "web_driver_app_description": "하청업체와 파트너 드라이버에게 앱 설치 없이 작업을 수락하고 관리할 수 있는 쉬운 방법을 제공합니다. 드라이버 웹 앱은 브라우저에서 직접 실행되며, 알림은 이메일, SMS, 웹 알림을 통해 전송됩니다.",
        "web_driver_app_allowed": {
            "job_access_via_web_link": "웹 링크를 통한 작업 접근",
            "trip_management": "여행 관리",
            "notifications_email_sms_web": "이메일/SMS/웹을 통한 알림",
            "navigation_status_updates": "네비게이션 및 상태 업데이트",
            "simple_lightweight": "간단하고 가벼운",
            "signup_link": "운전자 가입 링크"
        },
        "web_passenger_app": "웹 예약 앱",
        "web_passenger_app_description": "고객과 파트너가 직접 웹사이트에서 탑승 예약을 할 수 있도록 허용합니다. 웹 예약 앱은 공항 이동, 샤퍼 서비스, 요구에 따른 예약을 위해 만들어졌으며 — OTAs, 호텔, 여행 대행사가 손쉽게 여행자를 차량에 연결할 수 있는 간단한 방법을 제공합니다.",
        "web_passenger_app_allowed": {
            "embed_anywhere": "어디에나 임베디드",
            "create_ride_bookings": "탑승 예약 생성",
            "seamless_web_experience": "웹 경험",
            "partner_ready": "파트너용",
            "customer_friendly_checkout": "고객 친화적인 체크아웃"
        },
        "concierge_booker": "콘시어지 북커",
        "concierge_booker_description": "파트너와 직원 — 호텔 콘시어지 및 주차 보조원, 바텐더, 레스토랑 주인 — 을 위한 간단한 웹 앱으로, 손님을 위해 몇 번의 클릭만으로 탑승 예약을 생성할 수 있습니다. 각 사용자는 자신의 로그인을 가지고, 여행자를 대신해서 예약하고, 얻은 커미션을 추적할 수 있습니다.",
        "concierge_booker_allowed": {
            "quick_guest_booking": "빠른 손님 예약",
            "individual_user_login": "개별 사용자 로그인",
            "commission_tracking": "커미션 추적",
            "easy_web_access": "웹 접근 용이",
            "partner_friendly_setup": "파트너 친화적인 설정"
        },
        "gojo_api": "굿 저니 API",
        "gojo_api_description": "신뢰하고 만드세요. 개발자 포털에 접속하여 예약, 배차, 결제 등에 대한 API 참조, 통합 가이드, 샘플 워크플로를 검토하세요.",
        "gojo_api_allowed": {
            "comprehensive_api_reference": "포괄적인 API 참조",
            "integration_guides": "통합 가이드",
            "sandbox_testing_tools": "샌드박스와 테스팅 툴"
        },
        "gojo_canvas": "굿 저니 캔버스",
        "gojo_canvas_description": "당신의 슈퍼앱 경험을 설계하고 사용자 정의하세요. 굿저니 캔버스를 통해 메뉴, 배달 폼, 프로모션, 홈스크린 레이아웃등을 관리하고 — 모두 하나의 간단한 인터페이스에서.",
        "gojo_canvas_allowed": {
            "menu_management": "메뉴 관리",
            "custom_delivery_forms": "사용자 지정 배송 폼",
            "super_app_home_builder": "슈퍼앱 홈 빌더",
            "promotion_advertising": "프로모션 & 광고",
            "flexible_content_management": "유연한 콘텐츠 관리"
        },
        "gojo_chatbot": "굿저니 AI 챗봇",
        "gojo_chatbot_description": "대화만으로도 탑승 예약이 가능합니다. AI 피워된 채팅 어시스턴트는 고객, 파트너, 직원이 요청을 입력하거나, 자연스러운 언어를 사용하거나, 심지어 일정을 업로드하여 즉시 예약을 생성하는 데 도움이 됩니다.",
        "gojo_chatbot_allowed": {
            "conversational_booking": "대화형 예약",
            "file_itinerary_uploads": "파일 & 일정 업로드",
            "multi_channel_access": "멀티 채널 접근",
            "smart_suggestions": "스마트 제안",
            "operator_assistance": "운영자 지원"
        },
        "concierge_booker_web_setting": "설정 - 콘시어지 북커",
        "pax_app_setting": "설정 - 승객 앱",
        "driver_app_setting": "설정 - 글로벌 드라이버 앱",
        "pax_web_setting": "설정 - 웹 예약 앱",
        "driver_web_setting": "설정 - 드라이버 웹 앱",
        "save": "저장",
        "cancel": "취소",
        "themes": "테마",
        "links": "링크",
        "ios_driver_app": "iOS 드라이버 앱",
        "android_driver_app": "Android 드라이버 앱",
        "gallery_driver_app": "갤러리 드라이버 앱",
        "ios_pax_app": "iOS 승객 앱",
        "android_pax_app": "Android 승객 앱",
        "gallery_pax_app": "갤러리 승객 앱",
        "light_mode": "라이트 모드",
        "dark_mode": "다크 모드",
        "primary_color": "기본 색상",
        "secondary_color": "보조 색상",
        "longName": "PWA Long 이름",
        "shortName": "PWA Short 이름",
        "adsTracking": "광고 추적",
        "googleId": "구글 태그 ID",
        "metaId": "메타 픽셀 ID",
        "customUrl": "예약 웹 링크",
        "partnerLink": "파트너 웹 링크",
        "webBookingSettings": "웹 예약 설정",
        "enableBookNow": "즉시 예약",
        "enableBookLater": "미래의 예약",
        "enableGuestCheckout": "비회원 결제",
        "icon192": "PWA 앱 아이콘 (192x192)",
        "icon512": "PWA 앱 아이콘 (512x512)",
        "icon192Driver": "PWA 앱 아이콘 (192x192)",
        "icon512Driver": "PWA 앱 아이콘 (512x512)",
        "pax_app": "승객 앱",
        "default": "기본",
        "customized": "맞춤설정",
        "html": "HTML",
        "about": "소개",
        "email": "이메일 지원",
        "enablePhone": "전화번호",
        "phone": "",
        "policy": "개인정보 보호정책 링크",
        "termOfUse": "이용 약관 링크",
        "site": "웹사이트",
        "logoDriverIOS": "로고 - IOS",
        "logoDriverAndroid": "로고 - Android",
        "htmlUrl": "HTML 파일",
        "Update_fail": "오류가 발생했습니다",
        "Update_success": "설정이 성공적으로 업데이트되었습니다",
        "driverSignUp": "운전자 가입 링크",
        "customUrlDriver": "드라이버 웹 앱 링크"
    },
    "APIKeySetting": {
        "APIKey": "API 키",
        "APIKey_title": "API 키를 다른 사람과 공유하거나, 브라우저나 다른 클라이언트 사이드 코드에서 노출하지 마십시오. 계정의 보안을 보호하기 위해, Good Journey는 공개적으로 유출된 것으로 확인된 API 키를 자동으로 비활성화할 수 있습니다.",
        "newKeyBtn": "새 키 생성",
        "updateApplication": "애플리케이션 업데이트",
        "RegisterApp": "새 애플리케이션 등록",
        "RegisterBtn": "애플리케이션 등록",
        "appDescription": "앱 설명",
        "webhookUrl": "Webhook 엔드포인트",
        "appName": "앱 이름",
        "clientKey": "클라이언트 키",
        "secretKey": "비밀 키",
        "hostedEndPoint": "호스팅된 엔드포인트",
        "maxEndpoints": "최대 5개의 엔드포인트를 사용할 수 있습니다",
        "addEndpoint": "엔드포인트 추가",
        "updateEndpoint": "엔드포인트 업데이트",
        "ManageWebhooks": "웹훅 관리",
        "CreateWebhook": "웹훅 생성",
        "subscriptionID": "구독 ID",
        "webhookURL": "웹훅 URL",
        "signingSecret": "서명 암호",
        "eventsToSend": "보내야하는 이벤트",
        "listeningFor": "듣고있는 이벤트",
        "assignedDriver": "배정된 드라이버",
        "bookingStatus": "예약 상태",
        "driverLocation": "드라이버 위치",
        "titleSigningSecret": "이 비밀번호는 파트너에 의해 제공됩니다. 비밀번호가 노출된 경우라면, 비밀번호를 업데이트하거나 웹훅을 삭제할 수 있습니다.",
        "notUsingHTTPS": "웹훅 URL이 HTTPS를 사용하지 않습니다.",
        "invalidURL": "웹훅 URL이 유효하지 않습니다.",
        "clientType": "클라이언트 유형",
        "individual": "개인",
        "corporate": "기업",
        "signingSecretLength": "서명 암호는 최소 30자 이상이어야 합니다.",
        "bookingCreated": "예약 생성됨",
        "partner": "파트너",
        "fleetManager": "차량 관리자",
        "apiProvider": "API 제공업체",
        "selectAPITitle": "통합하려는 API를 선택하십시오",
        "isAutoAccept": "예약 자동 수락",
        "isAutoAcceptPA": "보류 중인 수정사항 자동 승인",
        "assignedVehicle": "배정된 차량"
    },
    "messages": {
        "credits": {
            "406": "작업 실패",
            "407": "작업 실패",
            "416": "쿠폰이 사용되었습니다",
            "417": "귀하의 계정이 비활성화되었습니다. 관리자에게 문의하십시오",
            "418": "결제 시 오류가 발생했습니다",
            "419": "프로모션 코드가 유효하지 않습니다!",
            "420": "이 프로모션 코드는 다른 탑승에 적용되었습니다. 다른 코드를 사용하십시오.",
            "421": "카드 번호가 유효하지 않습니다.",
            "422": "만료 날짜가 유효하지 않습니다.",
            "429": "우편번호가 유효하지 않습니다.",
            "430": "AVS 우편 번호가 일치하지 않습니다",
            "431": "AVS 우편 번호가 검증되지 않았습니다",
            "432": "CVV가 유효하지 않습니다.",
            "433": "CVV가 일치하지 않습니다.",
            "434": "CVV가 검증되지 않았습니다",
            "435": "CVV 발행자가 참여하지 않습니다",
            "436": "귀하의 카드가 거절되었습니다",
            "437": "카드 처리 중에 오류가 발생했습니다. 잠시 후 다시 시도하십시오.",
            "439": "CVV가 처리되지 않았습니다",
            "441": "발행자로부터 CVV 데이터 없음",
            "443": "발행자/방클넷 스위치로부터 데이터 없음",
            "445": "AVS 시스템 처리 불가",
            "446": "발행은행에서 AVS를 지원하지 않습니다",
            "447": "귀하의 비즈니스에 대해 AVS를 지원하지 않습니다",
            "448": "이 카드는 반복적인 미수금 결제 시도로 인해 차단되었습니다. 결제 방법을 변경하거나 나중에 다시 시도하십시오",
            "452": "귀하의 카드가 거절되었습니다. 전화번호와 같은 지역에 등록된 다른 신용카드를 입력해주세요",
            "453": "이 결제 게이트웨이는 지원되지 않습니다",
            "454": "AVS 주소가 일치하지 않습니다",
            "455": "AVS 우편 코드와 주소가 일치하지 않습니다",
            "458": "인증 실패",
            "459": "은행 카드를 지원하지 않습니다",
            "461": "이 카드는 지원되지 않습니다",
            "462": "카드 소지자 이름이 유효하지 않습니다",
            "463": "인증 코드가 유효하지 않습니다",
            "464": "은행이 인증 코드 생성 및 발송를 지원하지 않습니다",
            "470": "신용카드 결제로 예약을 생성하기 전에 여행자의 이메일 주소를 입력해주세요",
            "474": "신용카드로 예약을 생성하기 전에 여행자의 이름을 입력해주세요",
            "475": "전화번호가 필요합니다",
            "476": "금액이 유효하지 않습니다",
            "524": "잔액이 부족합니다. 계정에 거래 금액을 충당할 충분한 잔액이 없습니다.",
            "911": "결제 방법을 인증할 수 없습니다. 다른 결제 방법을 선택하고 다시 시도하십시오.",
            "2000": "불예",
            "2001": "잔액이 부족합니다. 계정에 거래 금액을 충당할 충분한 잔액이 없습니다.",
            "2002": "한도 초과",
            "2003": "카드 소지자의 활동 한도 초과",
            "2004": "만료된 카드",
            "2005": "유효하지 않은 신용 카드 번호",
            "2006": "유효하지 않은 만료 일자",
            "2007": "계정 없음",
            "2008": "카드 계정 길이 오류",
            "2009": "해당 발행자 없음",
            "2010": "카드 발행자가 CVV를 거부함",
            "2011": "음성 승인 필요. 카드 소지자의 은행이 이 거래를 완료하려면 특별한 승인 코드를 얻기 위해 가맹점에 전화 요청하고 있음",
            "2012": "처리기 거부 - 분실 카드 가능성",
            "2013": "처리기 거부 - 도난 카드 가능성",
            "2014": "처리기 거부 - 사기 의심",
            "2015": "거래 허용되지 않음",
            "2016": "중복 거래",
            "2017": "카드 소지자가 청구를 멈춤",
            "2018": "카드 소유자가 모든 청구를 중지함",
            "2019": "유효하지 않은 거래",
            "2020": "위반",
            "2021": "보안 위반",
            "2022": "거부됨 - 업데이트된 카드 소유자 사용 가능",
            "2023": "프로세서는 이 기능을 지원하지 않음",
            "2024": "카드 유형이 활성화되지 않음",
            "2025": "설정 오류 - 판매자",
            "2026": "유효하지 않은 판매자 ID",
            "2027": "설정 오류 - 금액",
            "2028": "설정 오류 - 계층",
            "2029": "설정 오류 - 카드",
            "2030": "설정 오류 - 터미널",
            "2031": "암호화 오류",
            "2032": "추가 요금이 허용되지 않음",
            "2033": "데이터가 일치하지 않음",
            "2034": "동작이 취해지지 않음",
            "2035": "그룹 III 버전의 금액에 대한 부분 승인",
            "2036": "취소를 위한 승인을 찾을 수 없음",
            "2037": "이미 취소됨",
            "2038": "프로세서가 거부함. 고객의 은행이 거래를 받아들이지 않을 의향이 있어, 자세한 사항은 그들의 은행에 문의해야 함.",
            "2039": "유효하지 않은 승인 코드",
            "2040": "유효하지 않은 저장소",
            "2041": "거부됨 - 승인을 위해 전화",
            "2042": "유효하지 않은 클라이언트 ID",
            "2043": "오류 - 재시도하지 말고, 발급자에게 전화하십시오",
            "2044": "거부됨 - 발급자에게 전화하십시오",
            "2045": "유효하지 않은 판매자 번호",
            "2046": "거부됨. 고객의 은행이 거래를 수락하는 데 부정적이므로, 자세한 사항은 그들의 은행에 문의해야 함.",
            "2047": "발급자에게 전화하십시오. 카드를 가져가십시오. 이 오류는 카드가 카드 소유자에게 분실 또는 도난 보고되었음을 나타냅니다.",
            "2048": "유효하지 않은 금액",
            "2049": "유효하지 않은 SKU 번호",
            "2050": "유효하지 않은 신용 계획",
            "2051": "신용 카드 번호가 결제 방법과 일치하지 않음",
            "2052": "유효하지 않은 III 레벨 구매",
            "2053": "분실 또는 도난으로 카드가 보고됨",
            "2054": "취소 금액이 승인 금액과 일치하지 않음",
            "2055": "유효하지 않은 거래 부서 번호",
            "2056": "거래 금액이 거래 부서 한도를 초과함",
            "2057": "발급자 또는 카드 소유자가 카드에 제한을 둠",
            "2058": "판매자가 MasterCard SecureCode를 활성화하지 않음.",
            "2060": "주소 확인 및 카드 보안 코드 실패",
            "2061": "유효하지 않은 거래 데이터",
            "2062": "유효하지 않은 세금 금액",
            "2064": "유효하지 않은 통화 코드",
            "2078": "유효하지 않은 보안 결제 데이터",
            "2080": "유효하지 않은 사용자 자격 증명",
            "3000": "프로세서 네트워크를 사용할 수 없음 - 다시 시도하십시오",
            "4001": "결제가 거부됨",
            "4006": "캡처 금액이 허용된 한도를 초과함",
            "81703": "이 상점 계정에서는 해당 신용 카드 유형을 수락하지 않습니다.",
            "81706": "CVV가 필요합니다",
            "81707": "CVV는 3자리 또는 4자리여야 합니다.",
            "81709": "만료 날짜가 필요합니다.",
            "81710": "만료 날짜가 유효하지 않습니다.",
            "81714": "신용 카드 번호가 필요합니다.",
            "81715": "신용 카드 번호가 유효하지 않습니다.",
            "81716": "신용 카드 번호는 12자리에서 19자리여야 합니다.",
            "81717": "신용 카드 번호는 테스트 번호로 받아들여지지 않습니다.",
            "81718": "구독과 연결되어 있을 때 업데이트되지 않는 카드 유형으로 신용 카드 번호를 업데이트할 수 없습니다.",
            "81723": "카드 소유자 이름이 너무 깁니다. 최대 175자.",
            "81809": "우편 번호는 9자로 된 문자 또는 숫자 이상을 포함하지 않을 수 있습니다.",
            "81813": "우편 번호는 문자, 숫자, 공백, 그리고 하이픈만 포함할 수 있습니다.",
            "91722": "결제 방법 토큰이 필요합니다.",
            "91723": "기존 토큰 업데이트가 유효하지 않습니다.",
            "91730": "이 상점 계정에서는 검증이 지원되지 않습니다.",
            "91734": "이 상점 계정에서는 해당 신용 카드 유형을 수락하지 않습니다.",
            "91738": "지정된 결제 방법은 신용 카드가 아닙니다.",
            "91745": "신용 카드 업데이트에 대한 파라미터가 유효하지 않습니다.",
            "91826": "우편 번호가 유효하지 않습니다. 우편 번호는 숫자 5자리 또는 9자리로 구성되어야 하며, 선택적으로 대시 또는 공백으로 구분됩니다.",
            "-1": "이 고객 계정이 비활성화되었습니다. 관리자에게 문의하십시오."
        },
        "reBookingMsg": {
            "303": "선택한 시간은 현재 시간보다 늦어야 합니다!",
            "304": "이 예약이 찾을 수 없습니다",
            "500": "일부 예약 정보가 유효하지 않거나 누락되었습니다. 확인 후 다시 시도하십시오!"
        },
        "promoMsg": {
            "304": "프로모션 코드가 유효하지 않습니다",
            "306": "프로모션 코드가 유효하지 않습니다. 프로모션 코드가 다른 지역에 적용된 것 같습니다.",
            "413": "죄송합니다, 이 프로모션 코드는 현재 사용할 수 없습니다",
            "414": "프로모션 코드가 유효하지 않습니다",
            "415": "프로모션 코드가 유효하지 않습니다",
            "416": "이 프로모션 코드는 이미 사용되었습니다.",
            "419": "죄송합니다, 이 프로모션 코드는 현재 사용할 수 없습니다",
            "420": "죄송합니다, 프로모션 사용 횟수를 초과하였습니다",
            "421": "죄송합니다, 이 프로모션 코드가 출시 이후 사용 횟수를 초과하였습니다",
            "422": "이 프로모션 코드는 계정에서 사용할 수 없습니다",
            "423": "죄송합니다, 프로모션 예산을 초과하였습니다",
            "424": "유효하지 않은 프로모션 코드입니다. 이 프로모션 코드는 추천 고객에게만 적용된 것 같습니다",
            "425": "이 프로모션 코드는 일일 사용 한도를 초과했습니다.",
            "426": "일일 프로모션 사용 한도를 초과하였습니다.",
            "427": "프로모션 코드를 적용할 수 없습니다. 이 고객의 프로필이 완성되지 않았습니다.",
            "428": "이 고객은 월간 프로모션 코드를 모두 사용하였습니다.",
            "430": "당신은 연간 프로모션 코드를 모두 사용했습니다.",
            "431": "이 결제 방법에는 프로모션 코드를 사용할 수 없습니다.",
            "432": "이 요금 금액은 프로모션 코드에 적합하지 않습니다.",
            "433": "선택한 시간에는 프로모션 코드를 사용할 수 없습니다.",
            "434": "죄송합니다, 프로모션 예산을 초과하였습니다.",
            "phoneInvalid": "프로모션 코드를 적용하기 전에 승객의 전화번호를 입력해 주세요"
        },
        "updateBookingMsg": {
            "303": "예약을 업데이트하지 못했습니다. 다시 시도해 주세요!",
            "304": "이 예약이 찾을 수 없습니다",
            "pickUpTime": "선택한 시간은 현재 시간보다 늦어야 합니다!",
            "pickup": "이 지역에는 예약 서비스가 없습니다",
            "destination": "일부 예약 정보가 유효하지 않거나 누락되었습니다. 확인 후 다시 시도하십시오!",
            "dispatchType": "일부 예약 정보가 유효하지 않거나 누락되었습니다. 확인 후 다시 시도하십시오!"
        },
        "sessionExpired": {
            "403": "계정이 다른 기기에서 로그인하거나 세션이 만료되어 로그아웃되었습니다"
        },
        "not_found": {
            "404": "요청하신 페이지를 찾을 수 없습니다"
        },
        "booking": {
            "303": "선택한 시간은 현재 시간보다 늦어야 합니다!",
            "304": "진행 중인 작업으로 인해 예약 {0}의 업데이트에 실패했습니다. 나중에 다시 시도해 주세요.",
            "305": "Booking.com에 의해 예약이 취소되었거나 완료되었습니다. 큐에서 제거하려면 작업을 거부해 주세요.",
            "306": "선택한 차량 유형에 요금이 지정되지 않았습니다. 차량 유형별로 요금을 적용하려면 설정 > 차량 > 차량 유형으로 가세요.",
            "307": "예약 업데이트를 할 수 없습니다. 나중에 다시 시도해 주세요.",
            "407": "유형별 요금은 추가 위치를 지원하지 않습니다",
            "500": "일부 예약 정보가 유효하지 않거나 누락되었습니다. 확인 후 다시 시도하십시오!",
            "upgroup_success": "예약이 성공적으로 그룹에서 분리되었습니다",
            "Please_Select_driver": "운전자를 선택해 주세요",
            "assign_driver_vehicle_success": "운전자/차량이 성공적으로 할당되었습니다",
            "assign_driver_success": "운전자가 성공적으로 할당되었습니다",
            "detach_driver_success": "운전자가 성공적으로 분리되었습니다",
            "detach_vehicle_success": "차량이 성공적으로 분리되었습니다",
            "Group_success": "예약이 성공적으로 그룹화되었습니다",
            "change_supplier_success": "공급업체 변경이 성공적으로 이루어졌습니다",
            "change_supplier_partial": "일부 성공: 진행 중인 작업으로 인해 다음 여행들(예약 ID)에 대한 배치 할당이 실패했습니다: {0}.",
            "detach_driver_partial": "일부 성공: 진행 중인 작업으로 인해 다음 여행들(예약 ID)에 대한 배치 할당이 실패했습니다: {0}.",
            "assign_driver_partial": "일부 성공: 진행 중인 작업으로 인해 다음 여행들(예약 ID)에 대한 배치 할당이 실패했습니다: {0}.",
            "update_dispatch": "업데이트 및 배치",
            "remove_booking_false": "예약 제거에 실패했습니다",
            "remove_booking_success": "예약이 성공적으로 제거되었습니다",
            "GROUP_NOT_FOUND": "그룹 ID를 찾을 수 없습니다",
            "NO_SHARING_BOOKINGS": "고객의 예약이 공유 탑승을 허용하는 경우에만 예약을 그룹화할 수 있습니다",
            "DIFFERENT_CAR_TYPES": "그룹화하려는 예약이 다른 차량 유형을 가지고 있습니다",
            "LIMIT_EXCEEDED_ON_SEATS_OR_LUGGAGE": "예약을 그룹화할 수 없습니다: 좌석 또는 수화물 한도 초과.",
            "INVALID_CAR_TYPE": "운전자를 할당할 수 없습니다, 운전자의 차량 좌석 & 수하물 용량을 확인하세요.",
            "VALIDATION_ERROR": "검증 오류",
            "INTERNAL": "내부 서버 오류",
            "fare_gt_zero": "운임은 0보다 커야 합니다!",
            "edit_total_fail": "전체 값 편집 실패!",
            "complete_fail": "예약을 완료할 수 없습니다!",
            "cancle_fail": "이 예약을 취소하는 도중에 문제가 발생했습니다. 다시 시도해 주세요!",
            "incident_fail": "사고 실패",
            "phone_invalid": "유효한 전화번호를 입력하십시오",
            "add_psg_fail": "새 승객을 추가할 수 없습니다",
            "REMOVE_RECIPIENT_DELIVERED": "배달된 수령인을 제거할 수 없습니다",
            "REMOVE_LAST_ACTIVE_RECIPIENT": "마지막 활성 수령인을 제거할 수 없습니다",
            "ORDER_HAS_BEEN_FINISHED": "주문이 이미 완료되었습니다",
            "end_booking_leave": "이 페이지를 벗어나면 예약이 종료됩니다.",
            "update_booking_fail": "예약 업데이트에 실패했습니다",
            "EXTERNAL_ID_EXISTED": "외부 ID가 시스템에 이미 존재합니다.",
            "area_service_unavailable": "이 지역에는 예약 서비스가 없습니다",
            "pickupSameDestination": "출발지 주소는 목적지와 달라야 합니다.",
            "time_invalid": "선택한 시간은 현재 시간보다 늦어야 합니다!",
            "psg_inactivate": "이 고객 계정이 비활성화되었습니다. 관리자에게 문의해 주세요",
            "data_incorect": "문제가 발생했습니다. 다시 시도해 주세요.",
            "preAuthorize": "예약을 보장하기 위해 계정을 확인하고 {0}의 금액이 필요합니다",
            "booking_limited": "죄송합니다, 분/일당 최대 예약 횟수에 도달하였습니다. 나중에 다시 시도해 주세요.",
            "minimumBookAhead": "예약 픽업 시간은 현재 시간으로부터 최소 {0} 시간 {1} 분 이후여야 합니다",
            "exDoDiffDo": "추가 목적지는 목적지와 다르게 설정해야 합니다.",
            "recurringTimeRange": "날짜가 범위를 벗어났습니다. 어떤 문제가 있을 경우 관리자에게 연락하십시오.",
            "recipientsLimit": "수신자의 최대 수는 {0}입니다.",
            "maximumBookAhead": "예약 픽업 시간은 현재 시간보다 {0} 일 이후가 될 수 없습니다",
            "Please_select_or_add_a_card": "카드를 선택하거나 추가해 주세요!",
            "Unable_to_process_by_fare_zero": "요청을 처리할 수 없습니다, 차량 유형이나 예약 유형을 변경한 후 다시 시도해 주세요. 도움이 필요하면 지원 팀에 문의해 주세요.",
            "Can_not_connect_to_server": "서버에 연결할 수 없습니다!",
            "Check_connection_or_contact_system_support": "연결 상태를 확인하거나 시스템 지원에게 도움을 요청해 주세요!",
            "Create_new_booking_success": "새 예약이 성공적으로 생성되었습니다!",
            "Create_new_recurring_booking_success": "새 예약이 성공적으로 생성되었습니다",
            "Update_booking_success": "이 예약이 성공적으로 업데이트되었습니다!",
            "addon_exceeded": "{0} 큐오타를 초과했습니다.",
            "addon_exceeded_with_params": "{0}을 계속 사용하려면 월렛 잔액을 업데이트해 주세요.",
            "Booking_drop_of_success": "예약 하차 성공",
            "Cancel_booking_success": "이 예약이 성공적으로 취소되었습니다!",
            "Cancel_booking_fails": "이 예약은 취소할 수 없습니다!",
            "adjust_fare_booking_success": "운임이 성공적으로 조정되었습니다!",
            "adjust_fare_booking_fail": "운임 조정 실패!",
            "Booking_detail_not_found": "예약 세부 정보를 찾을 수 없습니다!",
            "Check_promo_error": "프로모션 코드 오류를 확인해 주세요!",
            "Invalid_format": "잘못된 형식",
            "Flight_not_found": "비행기를 찾을 수 없습니다!",
            "Add_new_credit_error": "신용카드 추가 오류!",
            "Socket_server_disconnected": "소켓 서버가 연결이 끊어졌습니다!",
            "Please_reload_page_or_check_your_connection": "죄송합니다. 요청을 처리할 수 없습니다. 다시 시도해 주세요.",
            "request_timeout": "죄송합니다. 요청 시간이 초과되었습니다. 다시 시도해 주세요.",
            "Check_customer_error": "고객 오류를 확인해 주세요!",
            "Please_select_car_type": "차량 유형을 선택해 주세요",
            "DropOff_country": "이 차량 유형에 사용할 수 없는 하차 지점입니다. 다른 차량 유형을 선택하거나 경로를 조정하세요.",
            "Different_Country": "픽업과 하차 지점은 다른 국가에 있어야 합니다.",
            "Please_enter_destination_for_ridesharing_booking": "동승 예약에 대한 목적지를 입력해 주세요",
            "Extra_detination_must_be_difference_from_destination": "추가 목적지와 현재 목적지가 달라야 합니다",
            "Pickup_address_must_be_different_from_destination": "출발지 주소는 목적지와 달라야 합니다.",
            "Best_price": "최고의 가격",
            "You_may_be_charged_extra_fee_if_your_trip_excceds": "여행이 초과되면 추가 요금이 청구될 수 있습니다",
            "You_may_be_charged_extra_fee_if_your_trip_excceds_with_params": "여행이 {0} {1}, {2} {3}를 초과하면 추가 요금이 청구될 수 있습니다",
            "Reject_booking_success": "이 예약이 성공적으로 거부되었습니다!",
            "Reject_fail": "이 예약을 거부하는 도중에 문제가 발생했습니다. 다시 시도해 주세요!",
            "Please_select_payment_method": "결제 방법을 선택해 주세요",
            "Driver_signed_out_or_deactivated": "이 운전자는 방금 로그아웃하거나 비활성화되었습니다",
            "reservation_booking_overlaps": "죄송합니다, 이 예약은 운전자가 이미 수락한 다른 예약과 겹칩니다.",
            "driver_is_not_available": "죄송합니다, 이 운전자는 현재 사용할 수 없습니다.",
            "seats_luggage_limit": "예약을 운전자에게 할당할 수 없습니다. 좌석 또는 수하물이 제한을 초과했습니다.",
            "full_capacity": "이 예약은 운전자에게 할당할 수 없습니다. 왜냐하면 여행이 최대 용량에 도달했기 때문입니다.",
            "marked_failed_ok": "주문이 실패로 표시되었습니다.",
            "warning_markFail_lastRecipient": "이게 이 예약의 마지막 수령인입니다. 이 주문을 실패로 표시하면 이 예약을 완료해야 합니다.",
            "BOOKINGS_LIMIT_EXCEEDED": "각 그룹에는 최대 5개의 주문만 할당할 수 있습니다",
            "bookingCanceled": "Booking.com에 의해 예약이 취소되었거나 완료되었습니다. 큐에서 제거하려면 작업을 거부해 주세요.",
            "contact_info_required": "진행하기 전에 유효한 사용자 프로필을 선택하거나 새로 만들어 주세요. 또는 게스트 예약을 만들 수 있습니다.",
            "UNSUPPORTED_ZONE": "존이 지원되지 않습니다",
            "INVALID_GUEST_PHONE_NUMBER": "승객 전화번호가 잘못되었습니다",
            "NEGATIVE_FLEET_BALANCE": "잔액이 부족하여 새 예약을 생성할 수 없어 보입니다. 진행하려면 자금을 추가하거나 미지급 비용을 청산하십시오."
        },
        "item_no_found": "아이템을 찾을 수 없습니다",
        "commonMessages": {
            "greater_than_0": "0보다 큰 값을 입력해 주세요.",
            "Required_field": "이 필드는 필수입니다",
            "bankPhone_is_required": "전화번호가 유효하지 않습니다",
            "bankPhone": "전화번호",
            "distance_from_equa_or_smaller": "부터'의 거리는 '까지'의 거리보다 작거나 같아야 합니다",
            "must_be_number": "올바른 번호를 입력해 주세요",
            "equal_or_greater_than_0": "0 이상의 값을 입력하십시오.",
            "must_be_integer": "정수를 입력하십시오.",
            "invalid_email_format": "올바른 이메일을 입력해 주세요.",
            "greater_or_equa": "{0} 이상의 값을 입력하세요.",
            "value_must_between": "{0}과 {1} 사이의 값으로 입력해주세요.",
            "large_10x_markup_price": "편집된 요금은 예상 요금의 10배를 넘어서는 안됩니다.",
            "greater_than": "{0}보다 큰 값을 입력하세요.",
            "less_than": "{0}보다 작은 값을 입력하세요.",
            "less_or_equal": "{0}보다 작거나 같은 값을 입력하세요.",
            "driver_earnings_warning": "오프라인 결제 : 운전기사의 수익은 수집된 요금을 초과해서는 안됩니다.",
            "limit_amount": "한도 금액 이하의 값을 입력하세요",
            "Integer_from_range": "{0} - {1} 사이의 정수를 입력하세요",
            "integer_greater_than_0": "0보다 큰 정수를 입력하십시오. (퍼센트와 소수 구분 기호가 1개인 100 미만)",
            "Error_message": "오류!",
            "callcenter_newbooking_message": "전화로 새 예약 요청 <span class='bold'>{0}</span>",
            "callcenter_existed_booking_message": "전화로 이미 활성화된 예약 <span class='bold'>#{0}</span> 가 있습니다 <span class='bold'>{1}</span>",
            "callcenter_close_newbooking_form_warning": "현재의 예약을 완료하거나 닫은 후 새 고객 요청을 받으십시오",
            "Emergency_SOS_Title": "긴급 SOS",
            "Please_enter_a_future_date": "미래의 날짜를 입력하십시오.",
            "Card_holder_is_required": "카드 소지자가 필요합니다",
            "Card_number_is_required": "카드 번호가 필요합니다",
            "Expired_date_is_required": "만료 날짜가 필요합니다",
            "Credit_code_is_required": "신용 코드를 입력하십시오 (마지막 유효성 검사)",
            "Expired_date_is_invalid": "만료일이 유효하지 않습니다. mm/yy 형식으로 만료일을 입력하십시오",
            "cvv_is_required": "CVV가 필요합니다",
            "City_is_required": "도시가 필요합니다",
            "State_is_required": "주가 필요합니다",
            "Address_is_required": "주소가 필요합니다",
            "Zipcode_is_required": "우편번호가 필요합니다",
            "Country_is_required": "국가가 필요합니다",
            "Over_query_limit": "Google API는 일시적인 오류로 인해 로드 할 수 없습니다. 나중에 다시 시도하십시오.",
            "outOfInputQueueOrder": "주문 번호는 대기중인 드라이버 수를 초과할 수 없습니다.",
            "Same_pickup_destination": "출발지 주소는 목적지 주소와 달라야 합니다.",
            "Max_length": "최대 길이는 {0} 문자입니다.",
            "choose_at_least_one": "적어도 하나의 옵션을 선택하십시오.",
            "choose_at_least_one_intercity_schedule": "일정을 추가하거나 고객이 선호하는 시간을 요청하도록 허용하십시오.",
            "startDate_greater_than_endDate": "시작 날짜가 종료 날짜보다 더 늦습니다"
        },
        "trip": {
            "cancel_trip_success": "이 여행은 성공적으로 취소되었습니다!",
            "data_incorect": "드라이버가 할당되지 않았습니다. 드롭다운 목록에서 드라이버를 선택하십시오. <br/> 만약 드라이버가 없다면 나중에 할당하기 위해 자동 디스패치를 선택하십시오.",
            "INTERNAL": "내부 서버 오류.",
            "NOT_FOUND": "트립을 찾을 수 없거나 상태가 잘못되었습니다.",
            "SAME_DRIVER": "할당받은 사람은 현재 드라이버와 달라야 합니다.",
            "OVERLAP": "죄송합니다, 이 트립은 이 드라이버가 수락한 다른 트립과 겹칩니다.",
            "CANNOT_ASSIGN": "이 드라이버는 유효하지 않습니다 (즉, 드라이버를 찾을 수 없거나, 온라인이 아니거나, 로그인하지 않음)."
        },
        "car_mgmt": {
            "Search_car_color": "자동차 색상 검색",
            "Searching": "검색 중"
        },
        "driver_note": {
            "Search_driver_note": "드라이버 노트 검색",
            "Searching": "검색 중"
        }
    },
    "errors": {
        "303": "사용자를 찾을 수 없습니다",
        "453": "게이트웨이가 지원되지 않습니다",
        "553": "죄송합니다! 고객이 진행 중인 예약이 있습니다, 나중에 다시 시도하십시오.",
        "1007": "시작 날짜와 종료 날짜 사이의 기간은 60일 미만이어야 합니다!!",
        "3001": "전화번호가 이미 존재합니다",
        "3002": "생년월일이 유효하지 않습니다",
        "3003": "만료일이 유효하지 않습니다",
        "3004": "드라이버를 찾을 수 없습니다",
        "3005": "드라이버 결산 정보 누락 (은행 주소, 도시, 주, 우편번호)",
        "3006": "계좌 정보 누락 (계좌명, 계좌 유형, 라우팅 번호, 계좌 번호, ssn)",
        "3007": "고용 중인 이 드라이버를 편집할 수 없습니다.",
        "3008": "이 드라이버는 현재 로그인 중입니다. 정보를 수정하기 위해 그에게 로그아웃하라고 요청하십시오.",
        "3009": "이 드라이버는 하나 이상의 예약을 받아들였습니다. 드라이버의 정보를 업데이트/변경하기 전에 예약을 다른 드라이버에게 할당하십시오.",
        "3010": "디스패치 연결에 실패하였습니다.",
        "3011": "이 드라이버가 활성화되기 전에 운영을 위해 설정해야 합니다.",
        "3012": "이 드라이버가 활성화되기 전에 운영을 위해 설정해야 합니다.",
        "3013": "비활성 상태의 항목만 삭제할 수 있습니다.",
        "3014": "필수 필드가 누락되었습니다. 확인해주세요.",
        "3015": "생년이 유효하지 않습니다. 확인해 주세요.",
        "3016": "우편번호가 유효하지 않습니다. 확인해 주세요.",
        "3017": "주/도가 유효하지 않습니다. 확인해 주세요.",
        "3018": "계좌의 이름이 유효하지 않습니다. 확인해 주세요.",
        "3019": "라우팅 번호가 유효하지 않습니다. 확인해 주세요.",
        "3020": "생일이 필요합니다. 확인해 주세요.",
        "3021": "ssn 번호가 유효하지 않습니다. 확인해 주세요.",
        "3022": "운전자의 계좌로 돈을 받을 수 없습니다.",
        "3023": "로그인한 드라이버는 운영할 수 없습니다. 나중에 다시 시도하십시오.",
        "3026": "드라이버가 더 이상 존재하지 않습니다.",
        "3027": "드라이버의 은행 계좌가 설정되지 않았습니다. 그의 은행 계좌를 설정하기 위해 운전자 모듈로 이동하십시오.",
        "3028": "선택된 운전자에게 결제를 실패하였습니다. 다시 시도하십시오.",
        "3029": "운전자의 수익 데이터를 지우는데 실패하였습니다. 다시 시도하십시오.",
        "3032": "이 사용자이름은 이미 우리 시스템에 존재합니다. 다른 이름을 입력하십시오.",
        "3033": "BSB가 유효하지 않습니다. 숫자는 xxxxxx 형식의 6자리어야 합니다.",
        "3036": "Captcha가 필요합니다",
        "3037": "Captcha가 유효하지 않습니다",
        "3039": "그룹 ID가 필요합니다.",
        "3040": "이 전화번호는 이미 %{brandName} 드라이버가 사용 중입니다 (즉, 전화번호를 중복해서 사용할 수 없습니다). 다른 번호를 입력하십시오",
        "3041": "사용자 이름이 이미 존재합니다.",
        "3044": "국믄ID가 중복되었습니다.",
        "3045": "운전자에게 이미 차량이 있습니다, 페이지를 새로 고침하십시오",
        "3046": "차량의 회사와 운전자의 회사가 다릅니다.",
        "4001": "당신의 차량 번호가 이미 시스템에 존재합니다. 다른 번호를 입력해 주십시오.",
        "4002": "만료일이 유효하지 않습니다",
        "4003": "삭제 전에 차량을 비활성화해야 합니다",
        "4004": "차량을 찾을 수 없습니다",
        "4005": "이 차량은 이미 비활성 상태입니다",
        "4006": "이 차량은 사용 중이며 삭제또는 비활성화할 수 없습니다",
        "4007": "차량 번호가 필요합니다",
        "4009": "차량이 예약에 할당되어 있습니다.",
        "4010": "차량이 드라이버에게 할당되어 있습니다.",
        "5001": "회사가 존재합니다",
        "5004": "회사를 찾을 수 없습니다",
        "6001": "차량 모델이 존재합니다",
        "6004": "차량 모델을 찾을 수 없습니다",
        "6005": "차량 모델이 사용 중입니다",
        "7001": "시스템에 이미 존재하는 차량 제조사 이름입니다. 다른 이름을 입력해주세요.",
        "7004": "차량 제조사를 찾을 수 없습니다",
        "8001": "차량 유형이 존재합니다",
        "8004": "차량 유형을 찾을 수 없습니다",
        "9001": "평평한 경로가 존재합니다",
        "9004": "평평한 경로를 찾을 수 없습니다",
        "10001": "지역이 존재합니다",
        "10004": "지역을 찾을 수 없습니다",
        "11001": "지역이 존재합니다",
        "11002": "이 지역은 다른 지역과 겹칩니다. 다시 그려주세요.",
        "11003": "지역은 폴리곤 객체여야합니다",
        "11004": "지역을 찾을 수 없습니다",
        "11005": "지역이 사용 중입니다",
        "12001": "받은편지함이 존재합니다",
        "12002": "SMS Twilio를 설정해주세요",
        "12004": "받은편지함을 찾을 수 없습니다",
        "12005": "필터에 일치하는 수신인이 없습니다. 목록을 확인하고 다시 시도해주세요.",
        "12006": "파일에 고객이 존재하지 않습니다",
        "13001": "이 프로모션 코드는 시스템에 이미 존재합니다. 다른 코드를 입력해주세요.",
        "13002": "유효하지 않은 날짜",
        "13003": "개인",
        "13004": "프로모션 코드를 찾을 수 없습니다",
        "13005": "신규 고객 전용",
        "13006": "수량 제한 초과",
        "13007": "예산 제한 초과",
        "13008": "전체 사용 제한 초과",
        "13011": "이 프로모션 캠페인은 비활성화되었거나 삭제되었습니다",
        "13012": "날짜 범위가 잘못되었습니다",
        "13013": "유효하지 않은 프로모션 코드입니다. 이 프로모션 코드는 다른 지역에 적용된 것 같습니다",
        "13014": "선택한 지역이 비활성화되었습니다.",
        "14004": "예약을 찾을 수 없습니다",
        "15002": "귀하의 차량대열이 비활성화되었습니다. 관리자에게 문의하십시오",
        "15004": "차량대열을 찾을 수 없습니다",
        "16001": "시스템에 이미 존재하는 정액 요금 이름입니다. 다른 이름을 입력해주세요.",
        "16004": "요금을 찾을 수 없습니다",
        "17001": "이름이 존재합니다",
        "17004": "패키지 요금이 없습니다",
        "18001": "이름이 존재합니다",
        "18002": "요금을 사용 중입니다",
        "18004": "요금을 찾을 수 없습니다",
        "19001": "시스템에 이미 등록된 패키지 이름입니다. 다른 이름을 입력해주세요.",
        "19002": "요금을 사용 중입니다",
        "19004": "요금을 찾을 수 없습니다",
        "20001": "이 사용자이름은 이미 우리 시스템에 존재합니다. 다른 이름을 입력하십시오.",
        "20002": "계정이 비활성화되었습니다. 관리자에게 문의해주세요.",
        "20003": "입력하신 사용자 이름 또는 비밀번호가 올바르지 않습니다. 다시 시도해주세요.",
        "20004": "사용자 이름이 시스템에 등록되어 있지 않습니다.",
        "20005": "이 링크는 만료되었습니다",
        "20006": "현재 비밀번호와 일치하지 않습니다. 다시 시도하세요.",
        "20007": "사용자 #이 존재합니다",
        "20008": "이 이메일은 시스템에 이미 존재합니다. 다른 이메일을 입력해주세요.",
        "20012": "대열 ID가 이미 존재합니다",
        "21001": "시스템에 이미 등록된 권한 이름입니다. 다른 이름을 입력해주세요.",
        "21002": "이 권한은 현재 사용자에게 할당되어 있어 비활성화 할 수 없습니다.",
        "21003": "역할 활성화",
        "21004": "역할을 찾을 수 없습니다",
        "22001": "고객이 존재합니다",
        "22004": "고객을 찾을 수 없습니다",
        "22005": "잘못된 파일 형식입니다.",
        "22006": "전화번호가 존재합니다",
        "24001": "전화번호가 잘못되었습니다",
        "25001": "이 이름은 시스템에 이미 존재합니다. 다른 이름을 입력해주세요.",
        "25002": "유효하지 않은 시간 범위",
        "25004": "Shift를 찾을 수 없습니다",
        "26001": "이 이름은 시스템에 이미 존재합니다. 다른 이름을 입력해주세요.",
        "26002": "이 shift는 현재 운영에서 사용되고 있으므로 삭제하기 전에 제거해야 합니다",
        "26004": "Shift 템플릿을 찾을 수 없습니다",
        "27001": "캠페인이 존재합니다",
        "27002": "캠페인이 활성화되었습니다",
        "27004": "캠페인을 찾을 수 없습니다",
        "28001": "도시가 존재합니다",
        "28002": "도시가 활성화되고 있습니다",
        "28003": "도시가 사용 중입니다",
        "28004": "도시를 찾을 수 없습니다",
        "29002": "전화번호가 존재합니다",
        "30001": "대기 목록을 찾을 수 없습니다",
        "30002": "대기 목록이 사용 중입니다",
        "30003": "시스템에 이미 등록된 대기 지역 이름입니다. 다른 이름을 입력해주세요.",
        "30004": "대기 지역들은 서로 겹치지 않아야 합니다",
        "30005": "대기 지역 좌표가 잘못되었습니다",
        "30006": "픽업 지역이 유효하지 않습니다",
        "31001": "시스템에 이미 등록된 회사 ID입니다. 다른 이름을 입력해주세요.",
        "31002": "이 사용자이름은 이미 우리 시스템에 존재합니다. 다른 이름을 입력하십시오.",
        "31003": "법인을 찾을 수 없습니다.",
        "31004": "법인 사용자를 찾을 수 없습니다.",
        "31005": "비활성화된 법인만 삭제할 수 있습니다.",
        "31006": "이 전화번호는 법인 사용자에 이미 존재합니다. 다른 이름을 입력해주세요.",
        "31007": "법인 여행자를 찾을 수 없습니다.",
        "31008": "카드를 찾을 수 없습니다.",
        "31009": "이 전화번호는 시스템에 이미 존재합니다. 다른 이메일을 입력해주세요.",
        "31010": "이 법인은 현재 비활성화 상태입니다. 자세한 정보는 관리자에게 문의해주십시오",
        "31011": "이 여행자는 비활성화 상태의 법인 계정에 속해있기 때문에 활성화할 수 없습니다",
        "31013": "이 별칭은 이미 사용중입니다. 다른 별칭을 선택해주세요!",
        "31014": "차량 유형에 대한 요금을 적어도 하나 지정해야합니다",
        "31015": "이 이메일/전화번호는 이미 다른 계정에 연결되어 있습니다.",
        "31016": "이 이메일/전화번호는 다른 법인 계정에 연결되어 있습니다. 프로필을 업데이트하거나 사용자를 기존 계정에서 제거한 후 새 계정에 지정하십시오.",
        "31017": "이 이메일/폰은 비어 있습니다. 유효한 이메일/폰을 입력해 주세요.",
        "32001": "서비스 이름이 시스템에 이미 존재합니다. 다른 이름을 입력해 주세요.",
        "32004": "서비스를 찾을 수 없습니다",
        "33002": "시간 범위는 서로 겹치지 않아야 합니다",
        "34001": "코드가 이미 존재합니다",
        "34013": "날짜 범위가 잘못되었습니다",
        "36001": "이름이 존재합니다",
        "39001": "문서가 필요합니다",
        "43001": "벌금 템플릿이 이미 존재합니다",
        "43002": "벌금 템플릿을 찾을 수 없습니다",
        "44001": "요금 템플릿이 이미 존재합니다",
        "44002": "요금 템플릿을 찾을 수 없습니다",
        "44003": "요금 템플릿이 현재 기업에 할당되어 있습니다. 삭제하기 전에 이를 해제하세요.",
        "45001": "할증 정책이 이미 존재합니다",
        "45002": "할증 정책을 찾을 수 없습니다",
        "45003": "할증 항목을 찾을 수 없습니다",
        "46001": "이름이 존재합니다",
        "46002": "항목을 찾을 수 없습니다",
        "47001": "판매 중지가 이미 존재합니다",
        "47002": "판매 중지를 찾을 수 없습니다",
        "48003": "사용자 지정 위치에 같은 영역이 포함되지 않습니다",
        "49003": "지급에서 중복된 기업이 있습니다",
        "49004": "Imei가 존재합니다",
        "50001": "Add-on template existed",
        "50002": "Add-on template not found",
        "50003": "Add-on service existed",
        "50004": "Add-on service not found",
        "71001": "동적 할증이 이미 존재합니다",
        "71002": "이 지역은 다른 지역과 겹칩니다. 다시 그려주세요.",
        "71003": "동적 할증은 폴리곤 객체여야 합니다",
        "71004": "동적 할증을 찾을 수 없습니다",
        "72001": "동적 요금이 이미 존재합니다",
        "72002": "이 지역은 다른 지역과 겹칩니다. 다시 그려주세요.",
        "72003": "동적 요금은 폴리곤 객체여야 합니다",
        "72004": "동적 요금을 찾을 수 없습니다",
        "74001": "지역이 존재합니다",
        "74002": "이 지역은 다른 지역과 겹칩니다. 다시 그려주세요.",
        "74003": "지역은 폴리곤 객체여야합니다",
        "74004": "영역 요금을 찾을 수 없습니다",
        "74005": "영역 요금을 찾을 수 없습니다",
        "80001": "앱 배너가 이미 존재합니다.",
        "80002": "앱 배너를 찾을 수 없습니다.",
        "80003": "비활성 상태의 항목만 삭제할 수 있습니다.",
        "81001": "파일 업로드가 비어 있습니다.",
        "81002": "파일 업로드의 크기가 제한되었습니다.",
        "82002": "flightaware 설정 중에 문제가 발생했습니다. 나중에 다시 시도해 주세요.",
        "90001": "도시간 영역이 이미 존재합니다",
        "90002": "이 지역은 다른 지역과 겹칩니다. 다시 그려주세요.",
        "90003": "도시간 영역은 반드시 폴리곤 객체이어야 합니다",
        "90004": "도시간 영역을 찾을 수 없습니다",
        "90005": "도시간 영역이 사용 중입니다",
        "91001": "도시간 요금이 이미 존재합니다",
        "91002": "도시간 요금이 사용 중입니다",
        "91003": "도시간 요금을 찾을 수 없습니다",
        "92001": "경로 이름이 이미 존재합니다",
        "92002": "경로를 찾을 수 없습니다",
        "92003": "이 경로는 다른 경로에서 이미 존재합니다, 확인 후 다시 시도해주세요",
        "92004": "이 경로에는 활성화된 여행이 있습니다.",
        "93001": "기사 노트가 시스템에 이미 존재합니다. 다른 것을 입력해 주세요.",
        "93002": "기사 노트는 비활성 상태일 때만 삭제할 수 있습니다.",
        "93003": "기사 노트가 사용 중입니다.",
        "93004": "기사 노트를 찾을 수 없습니다.",
        "94001": "자동차 색상 이름이 시스템에 이미 존재합니다. 다른 이름을 입력해 주세요.",
        "94002": "자동차 색상을 찾을 수 없습니다",
        "400000": "전화 번호가 유효하지 않습니다!",
        "400002": "유효성 검사 오류가 발생했습니다.",
        "400003": "권한이 거부되었습니다",
        "400005": "파일 내용이 유효하지 않습니다",
        "400008": "구역 이름을 입력하십시오",
        "500000": "시스템 내부 오류.",
        "500001": "SMS Twilio를 설정해주세요",
        "500002": "요청 시간 초과. 나중에 다시 시도하세요",
        "500004": "시스템 내부 오류",
        "600001": "위치를 찾을 수 없습니다",
        "600002": "이 경도 & 위도 좌표는 시스템에 이미 존재합니다. 다른 좌표를 추가해 주세요",
        "610001": "카테고리가 이미 존재합니다",
        "610002": "카테고리를 찾을 수 없습니다",
        "610003": "카테고리가 파티 위치에 이미 존재합니다",
        "700001": "유형이 사용 중입니다",
        "700002": "파트너를 찾을 수 없습니다",
        "700003": "파트너 유형 이름이 시스템에 이미 존재합니다. 다른 이름을 입력해 주세요.",
        "800000": "이 상점은 다른 판매자 계정에 이미 할당되어 있습니다. 다른 계정을 선택해 주세요.",
        "800001": "판매자의 은행 계좌로는 자금을 받을 수 없습니다.",
        "800002": "판매자의 은행 계좌로는 자금을 받을 수 없습니다.",
        "limitMessage": {
            "upgrade": "Upgrade",
            "cancel": "Cancel",
            "driver": {
                "title": "Driver limit reached",
                "description": "Your current subscription allows up to %{limitation} drivers. To add more drivers, please upgrade to the higher plan."
            },
            "vehicle": {
                "title": "Vehicle limit reached",
                "description": "Your current subscription allows up to %{limitation} vehicles. To add more vehicles, please upgrade to the higher plan."
            },
            "operator": {
                "title": "Operator limit reached",
                "description": "Your current subscription allows up to %{limitation} operators. To add more operators, please upgrade to the higher plan."
            }
        },
        "31016_2": "메시지: 이 이메일/폰은 이미 다른 계정과 연결되어 있습니다. 계정 관리자에게 문의해 주세요.",
        "undefined": "서버에 문제가 발생했습니다, 다시 시도해 주세요.",
        "completeBooking": {
            "113": "결제 방법을 인증할 수 없습니다. 다른 결제 방법을 선택하고 다시 시도하십시오.",
            "450": "잔액이 부족하여 결제할 수 없습니다. 다른 방법을 선택해 주세요.",
            "451": "잔액이 부족하여 결제할 수 없습니다. 다른 방법을 선택해 주세요.",
            "521": "지갑에 충분한 자금이 없습니다."
        },
        "upload_file_fail": "파일이 유효하지 않습니다, 확인 후 다시 시도해 주세요.",
        "upload_photo_fail": "파일이 유효하지 않습니다, 확인 후 다시 시도해 주세요.",
        "missing_some_field": "필드가 유효하지 않습니다, 확인 후 다시 시도해 주세요.",
        "validAddress": "유효한 주소를 선택해 주세요."
    },
    "statusDisplay": {
        "supplierAccepted": "공급자가 수락",
        "pendingAmmendment": "보류 중인 수정",
        "supplierAllocated": "할당된 공급 업체",
        "delivery_supplierAccepted": "공급자가 수락",
        "completedWithoutService": "운전자 없이 완료",
        "confirmed": "예약 확정",
        "pending": "대기 중",
        "queue": "배차 중",
        "offered": "배차 중",
        "booked": "운전자가 이동 중",
        "engaged": "P.O.B",
        "droppedOff": "하차 완료",
        "inReview": "검토 필요",
        "pre": "주문 수락",
        "recurrent": "반복적인",
        "vacant": "",
        "vacantTime": "",
        "arrived": "도착하고 대기 중",
        "completed": "완료",
        "canceled": "취소",
        "noShow": "불참",
        "driverNoShow": "기사 불참",
        "action": "진행 대기 중",
        "incident": "사건",
        "pickupTimeExceeded": "시간 초과",
        "canceledByCC": "CC에 의해 취소됨",
        "canceledByPassenger": "승객에 의해 취소됨",
        "canceledByDriver": "기사에 의해 취소됨",
        "canceledByPartner": "파트너에 의해 취소됨",
        "canceledBymDispatcher": "파트너에 의해 취소됨",
        "canceledByCorporateAdmin": "기업 관리자에 의해 취소됨",
        "canceledByAPI": "API에 의해 취소됨",
        "canceledByWebBooking": "웹 예약에 의해 취소됨",
        "canceledByTimeout": "시간 초과로 인해 취소됨",
        "accepted": "수락됨",
        "rejected": "거절됨",
        "canceledByCorpAd": "기업 관리자에 의해 취소됨",
        "started": "시작됨",
        "intransit": "이동 중",
        "empty": "빈값",
        "notLive": "부분 - 실시간 아님",
        "live": "부분 - 실시간",
        "full": "전체",
        "delivering": "배달 중",
        "delivery_booked": "기사가 발송인에게 이동 중",
        "delivery_arrived": "발송인을 기다리며 도착함",
        "shopForYou_booked": "기사가 현금을 수집하러 이동 중",
        "shopForYou_arrived": "현금을 수집하려고 기다리며 도착함",
        "collecting": "기사가 상품을 수집하러 이동 중",
        "confirmed_delivery": "확인됨",
        "food_booked": "기사가 상인에게 이동 중",
        "food_collecting": "아이템을 수집하려고 기다리며 도착함",
        "mart_collecting": "아이템을 수집하려고 기다리며 도착함",
        "otwMerchant": "기사가 상인에게 이동 중",
        "arrivedAndWaitingToCollectItem": "아이템을 수집하려고 기다리며 도착함",
        "canceledByAirlineAdmin": "항공사 관리자에 의해 취소됨",
        "partialCompleted": "부분 완료",
        "failed": "실패",
        "allocated": "배정됨"
    },
    "tripTypes": {
        "scheduled": "예정된 여행",
        "requested": "요청된 여행",
        "preferred": "선호"
    },
    "login": {
        "Username": "사용자 이름",
        "Password": "비밀번호",
        "Remember_me": "저를 기억해주세요",
        "Forgot_your_password": "비밀번호를 잊어버리셨나요",
        "Login": "로그인"
    },
    "invoice": {
        "createBtn": "청구서 만들기",
        "searchPlInvoice": "클라이언트, 연락처, 청구서 번호 검색",
        "searchPl": "bookId, 고객 이름 검색",
        "createInvoice": "청구서 만들기",
        "invoicePeriod": "청구 기간",
        "invoicePeriodNote": "월부터 월까지 날짜 범위를 선택할 수 있습니다.",
        "viewEdit": "보기/편집",
        "billingContact": "청구 연락처",
        "memo": "메모",
        "memoMessage": "고객에게 메시지 남기기",
        "dueDate": "만기 날짜",
        "updateInvoice": "청구서 업데이트",
        "chargeCustomer": "고객에게 청구",
        "invoiceNumber": "청구서 번호",
        "noItem": "아이템 수",
        "issuedDate": "발행 날짜",
        "refId": "참조 #",
        "pickupTime": "픽업",
        "pickup": "픽업 위치",
        "destination": "배달 위치",
        "customerName": "고객 이름",
        "totalAmount": "전체 금액",
        "amountDue": "미결제 금액",
        "sendInvoice": "청구서 보내기",
        "copyInvoice": "청구서 복사",
        "downloadPDF": "PDF로 다운로드",
        "paymentLink": "결제 링크",
        "deleteInvoice": "청구서 삭제",
        "onlySave": "청구서 저장",
        "saveSend": "청구서 저장 및 보내기",
        "sendEmail": "이메일 보내기",
        "addRecipients": "수신자 추가",
        "editInvoice": "청구서 수정",
        "check": "체크",
        "wire": "와이어",
        "digitalWallet": "디지털 지갑",
        "cash": "현금",
        "completedTime": "완료 시간",
        "Status": "상태",
        "bookingStatus": "예약 상태",
        "chargeBtn": "{0} 청구",
        "pastDue": "연체",
        "payCompleted": "이 청구서는 성공적으로 결제되었습니다!",
        "Delete": "청구서를 삭제하시겠습니까?",
        "Delete_content": "이 행동은 이 청구서를 영구적으로 제거합니다. 필요하다면 이 주문(들)을 위해 새로운 청구서를 생성할 수 있습니다.",
        "viewInvoice": "청구서 보기",
        "pending": "대기 중",
        "paid": "지불됨",
        "CopyLink": "링크 복사",
        "partial": "부분적",
        "corporatePrepaid": "기업 선불"
    },
    "cue": {
        "bookingServiceType": "서비스 유형",
        "pointToPoint": "점대점",
        "fromAirport": "공항 출발",
        "toAirport": "공항 도착",
        "hourly": "시간당",
        "roundTrip": "왕복",
        "jobVisibility": "작업 가시성",
        "jobPubic": "공개",
        "jobPrivate": "개인",
        "jobSetPubic": "공개 설정",
        "jobSetPrivate": "비공개 설정",
        "supplierAccepted": "공급자가 수락",
        "pendingAmmendment": "보류 중인 수정",
        "supplierAllocated": "할당된 공급 업체",
        "creationTime": "생성 시간",
        "Pax": "승객 #",
        "Luggage": "수하물",
        "allocated": "배정됨",
        "completedWithoutService": "운전자 없이 완료",
        "shuttle": "셔틀",
        "farmIn": "Farm In",
        "chargeCode": "요금 코드",
        "clientCaseMatter": "여행 설명",
        "operatorNote": "내부 메모",
        "farmOut": "Farm Out",
        "roaming": "로밍",
        "FlightUpdate": "비행 업데이트",
        "networkType": "네트워크 유형",
        "InHouse": "내부",
        "External": "외부",
        "carHailing": "자동차 호출",
        "uploadBookings": "예약 업로드",
        "moreActions": "더 많은 조치",
        "rideSharing": "라이드 공유",
        "Rearrange": "재배치",
        "GroupId": "그룹 ID #",
        "Active": "활성",
        "Finished": "완료",
        "Home_affiliate": "홈 / 제휴사",
        "Booking_type": "예약 유형",
        "From": "에서",
        "balanceWallet": "{0}: {1} 잔여",
        "partialWallet": "지갑으로 부분 결제",
        "To": "로",
        "Status": "상태",
        "Migration_Status": "이전 상태",
        "Migrated": "이전됨",
        "Select_Status": "상태 선택",
        "Operator": "운영자",
        "Car_types": "자동차 유형",
        "Service_class": "서비스 등급",
        "Booking_from": "에서 예약",
        "All": "모두",
        "Pending": "대기 중",
        "Dispatching": "배차 중",
        "Waiting_for_process": "진행 대기 중",
        "Confirmed_reservation": "예약 확정",
        "Driver_on_the_way": "운전자가 이동 중",
        "Arrived_and_waiting": "도착하고 대기 중",
        "Passenger_on_board": "승객 탑승 중",
        "Dropped_off": "하차 완료",
        "combobox_select": "선택...",
        "Search_here": "여기에 검색",
        "Bookingid": "예약 #",
        "Pickup_Drop_Off": "픽업/하차",
        "Pickup_Drop_Off_Crew": "픽업/하차 시간",
        "Pickup_Drop_Off_Local_Time": "운영자 시간",
        "Pickup_Location_Destination": "픽업 위치/ 목적지",
        "Passenger": "승객",
        "Intercity_Route": "도시간 루트",
        "Airport_Pickup": "공항 픽업",
        "Airport_Pickup_Crew": "공항",
        "Flight_Status": "상태",
        "Payment": "결제",
        "Vehicle": "차량",
        "Car_type": "차량 유형",
        "Driver": "운전자",
        "Estimated_Fare": "추정 요금",
        "Notes": "메모",
        "Note": "메모",
        "Type": "유형",
        "Home": "홈",
        "Affiliate": "제휴사",
        "now": "지금 (운송)",
        "reservation": "예약 (운송)",
        "recurring": "되풀이 (운송)",
        "No_show": "불참",
        "Canceled_by_CC": "CC에 의해 취소됨",
        "Canceled_by_passenger": "승객에 의해 취소됨",
        "Canceled_by_partner": "파트너에 의해 취소됨",
        "Canceled_by_mDispatcher": "파트너에 의해 취소됨",
        "Canceled_by_Corporate_Admin": "기업 관리자에 의해 취소됨",
        "Canceled_by_API": "API에 의해 취소됨",
        "canceled_By_Web_Booking": "웹 예약에 의해 취소됨",
        "canceled_By_Time_Out": "시간 초과로 인해 취소됨",
        "Canceled": "취소",
        "Completed": "완료",
        "Incident": "사건",
        "Payment_Method": "결제 방법",
        "No_Phone": "전화 없음",
        "VIP": "VIP",
        "Non_VIP": "비VIP",
        "Passenger_type": "승객 유형",
        "Error_load_booking": "예약을 불러올 수 없습니다, 다시 시도하거나 페이지를 새로 고침해주세요!",
        "Edit_total_success": "총액이 성공적으로 수정되었습니다!",
        "Edit_total_fail": "총 요금은 {0} 이상이어야 합니다",
        "Time_out": "시간 초과",
        "Ride_Service": "라이드 서비스",
        "Regulation": "규제",
        "Ride_Sharing": "라이드 공유",
        "Unmatching": "불일치",
        "Matching": "일치",
        "all": "모두",
        "matching": "일치",
        "unmatching": "불일치",
        "regulation": "규제",
        "Support_service": "지원 서비스",
        "SOS": "SOS",
        "Non_SOS": "비SOS",
        "Corporate": "기업",
        "Individual": "개인",
        "On_curb": "보도 위",
        "Meet_Greet": "만나러 가기",
        "Close": "닫기",
        "auto_refrest_cue": "자동 새로 고침 ({0} 초)",
        "Ride_type": "라이드 타입",
        "Edit_total_note": "참고: 총액을 변경할 때 소계, 기술비, 예약비, 세금 및 팁이 업데이트됩니다",
        "Booking": "예약",
        "Edit_fare": "요금 편집",
        "Adjust_price": "가격 조정",
        "Total": "총계",
        "Reason": "이유",
        "Please_enter_reason": "이유를 입력해 주세요.",
        "Save": "저장",
        "Cancel": "취소",
        "dmc": "예약 보드",
        "corp": "예약 보드 (CTM)",
        "Zone": "픽업 지역",
        "dropOffZone": "반납 지역",
        "mDispatcher": "파트너",
        "streetSharing": "스트리트 공유",
        "Driver_No_Job_found": "배정을 기다리는 중...",
        "expandFilter": "필터 보기",
        "collapseFilter": "필터 숨기기",
        "clearSelectedItems": "선택항목 초기화",
        "Accepted": "수락됨",
        "Yes": "예",
        "No": "아니오",
        "Order_accepted": "주문 수락",
        "Confirmed": "확인됨",
        "spotTime": "승차 시간",
        "ETA": "ETA",
        "spareTime": "여유 시간",
        "expectedTime": "예상 픽업 시간",
        "Driver_on_the_way_to_sender": "기사가 발송인에게 이동 중",
        "Driver_on_the_way_to_recipient": "수령인에게 차량이 이동 중",
        "Driver_on_the_way_to_collect_cash": "기사가 현금을 수집하러 이동 중",
        "Driver_on_the_way_to_collect_goods": "기사가 상품을 수집하러 이동 중",
        "Arrived_waiting_for_sender": "발송인을 기다리며 도착함",
        "Arrived_waiting_for_recipient": "수령인을 기다리며 도착함",
        "Arrived_waiting_to_collect_cash": "현금을 수집하려고 기다리며 도착함",
        "Arrived_waiting_to_deliver_goods": "물품 배달을 기다리며 도착함",
        "Delivered": "배달 중",
        "delivery": "배달",
        "Service": "서비스",
        "intercity": "도시 간",
        "Transport": "교통",
        "About_Sender": "발송인 정보",
        "About_Merchant": "판매자 정보",
        "About_Recipient": "수령인 정보",
        "photos": "사진",
        "listOfItems": "아이템 목록",
        "cashOnPickUp": "COP",
        "Package_information": "택배 안내",
        "otwMerchant": "기사가 상인에게 이동 중",
        "arrivedAndWaitingToCollectItem": "아이템을 수집하려고 기다리며 도착함",
        "Save_Filter": "필터 저장",
        "add_favorite_filter": "필터 추가",
        "favorite_filter_name": "이름",
        "list_favorite_filter": "필터 관리",
        "favorite_filter_actions": "동작",
        "clear_all_filters": "모든 필터 초기화",
        "Delete_Filter": "필터 삭제",
        "CONFIRM_DELETE_FILTER_TEMPLATE": "이 필터를 삭제하시겠습니까?",
        "batchDelivery": "배차 배송",
        "editFare": {
            "creditTransactionFee": "신용카드 수수료",
            "preferredAdjustment": "선호 변경",
            "editFareFee": "요금 및 수수료 수정",
            "markupPrice": "마크업 가격",
            "quotedPrice": "견적 가격",
            "basicFare": "기본 요금",
            "preferredEarning": "선호 수익",
            "difference": "차이",
            "rushHourFee": "할증",
            "serviceFee": "추가 서비스",
            "otherFees": "다른 요금",
            "subTotal": "소계",
            "airportFee": "공항 요금",
            "meetDriverFee": "기사 만나기",
            "deliveryFee": "배송 요금",
            "tollFee": "통행료",
            "parkingFee": "주차 요금",
            "gasFee": "가스 요금",
            "techFee": "기술 요금",
            "tip": "팁",
            "bookingFee": "예약 비용",
            "tax": "세금",
            "promoAmount": "프로모션 금액",
            "etaFare": "총계",
            "fleetService": "플릿 서비스",
            "Note_serviceFee": "(추가 서비스를 수정하려면 외부 목록을 방문하십시오)",
            "startingFee": "시작",
            "moveFeeInJourney": "이동",
            "waitFeeInJourney": "여행 중 대기",
            "total": "총계",
            "totalPayout": "지급",
            "updatedTotal": "수정된 총액",
            "updatedPayout": "수정된 지불액",
            "profit": "이익",
            "extraWaitFee": "대기 요금 초기",
            "heavyTraffic": "신호 대기",
            totalWithoutPromo: 'Total before promo',
        },
        "partialCompleted": "부분 완료",
        "failed": "실패",
        "Recurring": "상환 #",
        "DragAndDrop": "열을 재정렬하려면 드래그 앤 드롭을 사용하십시오.",
        "bookingCom": "Booking.com",
        "syncingCompleted": "동기화 완료",
        "groupManifest": "그룹 명단",
        "assignSuppliers": "공급 업체 지정",
        "viewActions": "작업 보기",
        "holidaytaxis": "HolidayTaxis",
        "karhoo": "Karhoo",
        "klook": "Klook",
        "transferZ": "TransferZ",
        "pickupTime": "픽업 시간",
        "AssignSupplier": "공급 업체 할당",
        "sharedTransfer": "공유 이송 (%{id})",
        "batchDeliveryGroup": "배치 배달 (%{id})",
        "foundersFund": "Founders Fund",
        "zeroCommission": "제로 커미션",
        "unassignDriver": "운전자 지정 취소",
        "notUnassignDriver": "운전자를 지정 취소할 수 없습니다. 다시 시도해주세요",
        "notAssignDriver": "운전자를 지정할 수 없습니다. 다시 시도해 주세요",
        "selectDriver": "운전자 선택",
        "unassignVehicle": "장비 지정 해제",
        "unassignAll": "모두 지정 해제",
        "notUnassignAll": "모두 지정 취소할 수 없습니다. 다시 시도해주십시오",
        "unassignAllSuccess": "차량과 운전자가 성공적으로 분리되었습니다.",
        "unassign_all_partial": "부분 성공: 다음 여행에 대한 일괄 지정 해제 실패 (예약 ID) 작업 중인 작업으로 인해: {0}.",
        "notUnassignVehicle": "장비를 지정 취소할 수 없습니다. 다시 시도해 주세요",
        "notAssignVehicle": "차량을 지정할 수 없습니다. 다시 시도해 주세요",
        "selectVehicle": "차량 선택",
        "confirmUnassign": "지정을 취소하시겠습니까?",
        "printMeetingBoard": "미팅 보드 출력",
        "needReview": "검토 필요"
    },
    "trip": {
        "Driver_vehicle": "운전자의 차량",
        "tripId": "여행 #",
        "tripTypes": "여행 유형",
        "Start_Time": "출발 시간",
        "Seats_Status": "좌석 상태",
        "No_Of_Booking": "예약 수",
        "Vehicle": "운전자의 차량",
        "Estimated_Fare": "요금",
        "capacityStatus": "좌석 상태",
        "Trip_Types": "여행 유형",
        "scheduled": "예정된 여행",
        "requested": "요청된 여행",
        "preferred": "선호",
        "All": "모두",
        "Confirmed": "확인됨",
        "Started": "시작됨",
        "In_Transit": "이동 중",
        "Empty": "빈값",
        "Partial_not_live": "부분 - 실시간 아님",
        "Partial_live": "부분 - 실시간",
        "Full": "전체",
        "Error_load_trip": "여행을 불러올 수 없습니다. 다시 시도하거나 페이지를 새로 고침하세요!"
    },
    "tripDetails": {
        "Trip_ID": "시내 여행",
        "DRIVER_JOB": "운전자 정보",
        "BOOKINGS": "예약",
        "updateTrip": "여행 업데이트",
        "cancelTrip": "여행 취소",
        "note_cancel": "이 여행을 취소하기 전에 모든 예약을 다른 운전자에게 지정해 주십시오.",
        "TRIP_INFORMATION": "여행 정보",
        "route": "경로",
        "startTime": "출발 시간",
        "distance": "거리",
        "duration": "기간",
        "fare": "요금",
        "cartype": "시티 카타입",
        "seatStatus": "좌석 상태",
        "started": "시작됨",
        "intransit": "이동 중",
        "empty": "빈값",
        "notLive": "부분 - 실시간 아님",
        "live": "부분 - 실시간",
        "full": "전체",
        "noOfBooking": "예약 수",
        "luggage": "수하물",
        "nameDriver": "이름",
        "vehicleType": "차량",
        "assignDriver": "운전자 지정",
        "pickUpAddress": "픽업",
        "destinationAddress": "하차",
        "customerName": "이름",
        "customerPhone": "전화",
        "customerNumber": "좌석",
        "customerLuggageNumber": "수하물",
        "additionalService": "추가 서비스",
        "paymentBooking": "결제",
        "note": "메모",
        "CONFIRM_UPDATE": "업데이트 확인",
        "CONFIRM_UPDATE_MESSAGE": "이 여행 정보를 업데이트하겠습니까?",
        "Yes": "예",
        "No": "아니오",
        "Update_info": "예, 정보 업데이트"
    },
    "newbooking": {
        "Addon_driver_capability": "This assignment does not fully meet the customer’s service requirements. Missing Requirements ({0})",
        "Search_Vehicle": "차량 검색",
        "rideSharing_multi_point": "라이드 공유 예약은 픽업 1곳 및 드롭 오프 1곳만 허용됩니다.",
        "Pick_up_time": "픽업 시간",
        "Drop_off_time": "하차 시간",
        "All_Suppliers": "모든 공급업체",
        "Recipient": "수신인",
        "All": "모두",
        "New_Booking": "새로운 예약",
        "GoogleMapRoute": "Google Map",
        "BOOKING_INFORMATION": "예약 정보",
        "TIP_PROMO": "팁 - 프로모션",
        "Pick_up": "픽업",
        "instructions": "지시사항",
        "instructions_placeholder": "여기에 지시사항을 나열하세요...",
        "Enter_a_location": "위치 입력",
        "Enter_a_location_delivery": "위치 입력",
        "Enter_3rd_party_location": "3rd party 위치 입력",
        "Enter_a_sender": "발신인 입력",
        "Enter_a_recipient": "수신인 입력",
        "Vehicle_Selection": "차량 선택",
        "Destination": "목적지",
        "Pickup_time": "픽업 시간",
        "Note": "메모",
        "note_for_driver": "운전자에 대한 노트",
        "affiliate_note": "제휴사에 대한 노트",
        "affiliate_note_placeholder": "운영자를 위한 제휴사 노트 입력",
        "operator_note": "운영자를 위한 내부 노트 입력",
        "TRAVELER_INFORMATION": "여행자 정보",
        "Traveler_type": "여행자 유형",
        "Individual": "개인",
        "Corporation": "회사",
        "Phone_number": "전화번호",
        "First_name": "이름",
        "Last_name": "성",
        "Email_address": "이메일 주소",
        "Corp_id": "회사 id",
        "Manager_name": "관리자의 이름",
        "Manager_email": "관리자의 이메일",
        "Cost_centre": "비용 센터",
        "Department": "부서",
        "Corp_division": "회사 부서",
        "Tip": "팁",
        "Promo_code": "프로모션 코드",
        "Apply": "적용",
        "Promo": "프로모션:",
        "DISPATCH": "발송",
        "Auto_dispatch": "자동 배차",
        "Assign_driver": "할당",
        "FarmOut": "팜-아웃",
        "Driver": "운전자",
        "Driver_Supplier": "공급업체/운전자",
        "PAYMENT_METHOD": "결제 방법",
        "OPERATOR_NOTE": "내부 메모",
        "TRIP_ESTIMATE": "여행 비용 추정",
        "Choose_a_stored_card": "저장된 카드 선택",
        "Choose_a_payment_method": "결제 방법 선택",
        "Use_new_card": "새 카드 사용",
        "Card_holder": "카드 소유자",
        "Card_number": "카드 번호",
        "Expired_date": "만료 날짜(mm/yy)",
        "ccv": "CVV",
        "Distance": "거리",
        "Duration": "기간",
        "Fare": "요금",
        "Route": "경로",
        "Create": "생성",
        "Cancel": "취소",
        "Meet_driver": "기사 만나기",
        "Airline": "항공사",
        "Flight": "편 번호",
        "FLY_INFO": "항공편 정보",
        "Ride_Sharing": "라이드 공유",
        "Round_trip": "왕복",
        "Car_type": "차량 유형",
        "Address": "주소",
        "City": "도시",
        "State": "주",
        "Zip_code": "우편 번호",
        "Remove": "제거",
        "Client_case_matter": "고객 케이스 내용 / 여행 설명",
        "Charge_code": "사용 코드 / 여행 코드",
        "CANCEL_BOOKING": "예약 확인 닫기",
        "CANCEL_BOOKING_CONFIRM": "이 양식을 떠나시겠습니까? 모든 예약 데이터가 손실됩니다.",
        "Search_here": "드라이버 검색",
        "No_support_location": "불행히도 이 지역에서는 서비스를 이용하실 수 없습니다",
        "Closest_driver_message": "가장 가까운 운전사는 대략 {0} 거리에 있습니다",
        "No_cars_available": "배차 반경 내에 차량이 없습니다.",
        "processed_by_affiliate": "귀하의 요청은 제휴 파트너들에 의해 처리됩니다",
        "FlightExample": "항공편 번호, 예시 AA1097",
        "Yes": "예",
        "No": "아니오",
        "dispatch_3rd": "3차 파티를 통한 디스패치",
        "Company": "회사",
        "Card_required": "카드를 선택하거나 추가해 주세요!",
        "Tip_value": "해당 없음",
        "Calendar": "달력",
        "Extra_Destination": "추가 목적지",
        "Driver_credit_limited_balance_warning": "이 운전사의 잔액이 제한 금액 이하입니다",
        "Meet_Greet_option": "만나러 가기",
        "On_Curb_option": "보도 위",
        "Extra_Services": "추가 서비스",
        "Addl_Services": "추가 서비스",
        "Save": "저장",
        "Regular": "일반",
        "Please_fill_in_all_the_required_fields": "모든 필수 필드를 입력해주세요.",
        "Route_names_not_dup": "경로 이름이 중복되어서는 안 됩니다.",
        "Please_select_weekdays": "예약이 이루어질 당신이 원하는 날을 선택해주세요",
        "Flat_rate": "정액 요금",
        "All_company": "모든 회사",
        "Best_price": "최고의 가격",
        "PromoTitle": "프로모션",
        "Show_more": "더 보기",
        "Warning_pending_payment": "이 고객은 과거 예약에서 미결제 상태입니다: %{fare}",
        "Warning_outstanding_balance": "미수 잔액은 트립이 끝나면 적용됩니다.",
        "Not_available": "사용 불가능",
        "Warning_assigned_rate": "해당 차량 타입에 대해 요금을 설정하고 지정하여 계속하십시오.",
        "PaxLuggageNumber": "승차객/수하물 수",
        "paxNumber": "승객",
        "luggageNumber": "수하물",
        "Date": "날짜",
        "Single": "단일",
        "Recurring": "반복적인",
        "Date_range": "맞춤형 날짜",
        "WeekDays": "일에 반복",
        "Create_Route": "경로 만들기",
        "Pickup_Point": "픽업",
        "Drag_To_Render": "재정렬을 위해 드래그 앤 드롭",
        "DropOff_Point": "하차 지점",
        "Sender": "송신자",
        "Recipients": "수신자",
        "Sender_Infomation": "송신자 정보",
        "Recipient_Infomation": "수신자 정보",
        "Recipient_Name": "수신자 이름 *",
        "Recipient_Phone": "전화번호 *",
        "Room_floor_block": "방, 층, 블록 (선택적)",
        "Details": "세부사항",
        "Package_Content": "패키지 내용 *",
        "Order_ID": "주문 번호 (예. shopify 주문번호)",
        "Instructions_for_driver": "운전사에게의 지시",
        "Cost_of_Goods": "착불",
        "Enter_amount": "금액 입력",
        "Additional_Information": "추가 정보",
        "Insurance": "보험",
        "Special_Care": "특별 보호",
        "Delivery_Fee": "배송 요금",
        "Item_fees": "품목 수수료",
        "Tech_Fee": "기술 요금",
        "Tax": "세금",
        "driverNotes": "운전사 노트",
        "rejectModal": "예약 거절",
        "rejectModalBody": "이 예약을 거절하시겠습니까?",
        "rejectButton": "예약 거절",
        "acceptModal": "예약 수락",
        "acceptModalBody": "이 예약을 수락하시겠습니까?",
        "ConfirmedTo": "({0})에게 확정되었습니다",
        "proceedAction": "이 작업을 계속하시겠습니까?",
        "acceptButton": "예약 수락",
        "denyModal": "예약 거부",
        "denyModalBody": "이 예약을 거부하시겠습니까?",
        "denyButton": "예약 거부",
        "Accept_booking_success": "이 예약은 성공적으로 수락되었습니다!",
        "Deny_booking_success": "이 예약은 성공적으로 거부되었습니다!",
        "adjustFare": "요금 조정",
        "totalFare": "합계 요금",
        "Profit": "이익",
        "DriverEarning": "운전사 수입",
        "Payout": "지급",
        "totalPayout": "총 지불",
        "DriverPayOut": "지급",
        "confirmReject": "거절 확정",
        "confirmCancelMSG": "이 예약을 거절하시겠습니까? 공급업체로부터 벌금이 부과될 수 있습니다.",
        "reasonCancel3rd": "거절 이유",
        "welcome_psg": "승객 환영",
        "AmountDue": "미결제 금액",
        "Fleet_Company": "차량대열",
        "Search_driver_hydra": "곧 운전사를 찾아볼 것입니다.",
        "ExternalID": "외부 ID",
        "viewRate": "요금 확인",
        "PointToPoint": "점대점",
        "Offer_driver": "운전사에게 제안",
        "Assign_driver_vehicle": "운전사 / 차량 배정",
        "notify_via_email": "이메일로 고객에게 알림",
        "fleetFare": "차량 요금",
        "onlySave": "저장",
        "saveCharge": "저장 및 청구",
        "saveRefund": "저장 및 환불",
        "lateCancelConfirm": "이 예약을 완료하시겠습니까",
        "canceledDriverConfirm": "이 운전사에 대한 예약을 취소하시겠습니까? 패널티 요금이 부과됩니다.",
        "canceledDriverNoChargeConfirm": "이 운전사에 대한 예약을 취소하시겠습니까",
        "canceledCustomerNoChargeConfirm": "이 고객을 표시하시겠습니까",
        "noshowDriverConfirmCharge": "운전사를 불참으로 표시하시겠습니까? 벌금이 부과될 수 있습니다.",
        "noshowDriverConfirmNoCharge": "드라이버를 불출석으로 표시하시겠습니까?",
        "NoShowConfirm": "불참 정책이 적용됩니다.",
        "completeConfirm": "운전사 없이 완료하시겠습니까?",
        "completeChargeConfirm": "고객에게는 전체 요금이 청구됩니다. 운전사는 이 예약에서 어떠한 커미션도 받지 못합니다.",
        "PricingPlan": "가격 플랜",
        "editFerviceFees": "서비스 요금을 수정하려면 외부 목록을 방문하세요",
        "ungroupAll": "모두 그룹 해제",
        "satisfaction": "만족도",
        "Reassign": "재할당",
        "addNote": "메모 추가",
        "noteMagicSend": "즉시 예약 키워드 제안에 액세스하려면 마법사 아이콘을 선택하거나 [를 입력하세요.",
        "items": "아이템",
        "PaidAmount": "지불된 금액",
        "ExternalPartner": "외부 파트너",
        "ExternalPartnerNote": "자체 드라이버와 차량을 관리하는 독립 파트너입니다. 지불은 공급자와 직접 처리됩니다.",
        "InHousePartner": "내부 파트너",
        "InHousePartnerNote": "귀사의 차량 직접 관리. 지불은 드라이버에게 직접 이루어집니다.",
        "Role": "역할",
        "Client": "클라이언트",
        "ApplyCancellation": "취소 정책 적용",
        "unassigned": "미할당",
        "bookingSelected": "예약 선택됨",
        "Update": "업데이트",
        "emailInvoice": "전자 청구서",
        "Receipt": "영수증",
        "addItem": "아이템 추가",
        "newCustomer": "새 고객 추가",
        "forGuest": "손님을 위한 예약",
        "invalid_some_field": "필드가 유효하지 않습니다, 확인 후 다시 시도해 주세요.",
        "ExpandCorp": "회사 세부 정보 확장",
        "hideCorp": "회사 세부 정보 숨기기",
        "searchCusPlaceholder": "연락처 이름, 전화, 이메일 검색",
        "CorporationGuest": "회사 - 게스트",
        "IndividualGuest": "개인 - 게스트",
        "passInfo": "승객 정보",
        "noAdjustmentPickupTime": "픽업 시간에 변경 없음",
        "whenFlightArrives": "비행기가 도착할 때",
        "minAfterArrival": "{0} 분 후 비행 도착",
        "pickupInstructions": "픽업 지시사항",
        "selectMeetingPoint": "픽업 지점 선택",
        "durationTrip": "기간 (시간)"
    },
    "bookingDetailLogs": {
        "recipient": "수신인",
        "updatedInfo": "업데이트된 정보",
        "updatedField": "업데이트된 필드",
        "valueBefore": "이전 값",
        "valueAfter": "이후 값",
        "location": "위치",
        "etaFare": "요금",
        "dispatchType": "발송",
        "drvInfo": "운전자",
        "meetingPoint": "회의 지점",
        "vehicleTypeRequest": "차량 요청",
        "clientCaseMatter": "여행 설명",
        "chargeCode": "여행 코드",
        "driverEarningType": "드라이버 수익 종류",
        "editedDriverEarning": "운전사 수입",
        "reasonEditFare": "이유",
        "bookingReference": "외부 ID",
        "tip": "팁",
        "type": "서비스 유형",
        "promo": "프로모션",
        "dispatch3rd": "3차 배치",
        "rideSharing": "라이드 공유",
        "notes": "운전사 노트",
        "operatorNote": "내부 메모",
        "welcomeMessage": "환영 메시지",
        "flightNumber": "비행 번호",
        "fullName": "성명",
        "email": "이메일",
        "cardMask": "카드 마스크",
        "paymentType": "결제 방법",
        "recipients": "수신자",
        "sender": "송신자",
        "pickupName": "픽업 이름",
        "pickupPhone": "픽업 전화",
        "pickupEmail": "픽업 이메일",
        "supplierEarningType": "지불 유형",
        "editedSupplierEarning": "지불 값",
        "route": "경로 이름",
        "markupDifference": "마크업 차이",
        "selectedDates": "선택된 날짜",
        "services": "차량 서비스",
        "destinationAddress": "목적지 위치",
        "pickupAddress": "픽업 위치",
        "tripType": "여행 유형",
        "pickUpTime": "픽업 시간",
        "paxNumber": "승객",
        "luggageNumber": "수하물",
        "vehicle": "차량",
        "minutesToArrive": "예상 드라이버 도착 시간",
        "affiliateNote": "제휴사 메모",
        "packageRateName": "패키지 이름",
        "supplierCompanies": "회사",
        "puPoints": "픽업 위치",
        "doPoints": "목적지 위치",
        "promoValue": "프로모션 값",
        "packageInfo": "패키지 정보",
        "orderId": "주문 ID",
        "cashOnDelivery": "현장결제",
        "externalId": "외부 ID",
        "recurring": "반복적인",
        "batchDelivery": "배차 배송",
        "payout": "지급",
        "locationDetails": "위치 세부 정보",
        "name": "이름",
        "phone": "전화",
        "address": "주소",
        "basicFare": "기본 요금",
        "airportFee": "공항 요금",
        "bookingFee": "예약 비용",
        "creditTransactionFee": "신용카드 수수료",
        "fleetService": "플릿 서비스",
        "fleetServices": "차량 서비스",
        "gasFee": "가스 요금",
        "meetDriverFee": "드라이버 만나기 요금",
        "moveFeeInJourney": "이동 요금",
        "otherFees": "기타 요금",
        "parkingFee": "주차 요금",
        "promoAmount": "프로모션 금액",
        "rushHourFee": "급행 요금",
        "serviceFee": "서비스 요금",
        "startingFee": "시작 요금",
        "subTotal": "소계",
        "tax": "세금",
        "techFee": "기술 요금",
        "tollFee": "통행료",
        "waitFeeInJourney": "대기(이동 중) 요금",
        "psgPhone": "승객 전화",
        "totalAddonFee": "Addon fee",
        "addonServices": "Addon services"
    },
    "bookingdetail": {
        "RefreshFare": "요금 새로고침",
        "noShowAction": "불출석 조치",
        "noShowClose": "불출석 적용 및 예약 마치기",
        "noShowNotClose": "불출석 적용 & 배정 취소",
        "cancelAction": "취소 조치",
        "cancelClose": "취소 적용 & 예약 마치기",
        "cancelNotClose": "취소 적용 & 배정 취소",
        "settings": "설정",
        "updateSuccessJobVisibilitySingle": "가시성 성공적으로 업데이트",
        "updateSuccessJobVisibilityMulti": "%{number} 예약이 성공적으로 업데이트되었습니다",
        "failApi": "문제가 발생했습니다!",
        "settingsTooltip": "드라이버는 이미 배정되었거나 현재 트립이 진행 중입니다.",
        "shareJobPublicly": "공개적으로 작업 공유",
        "groupOder": "그룹 주문",
        "ExistingGroup": "기존 그룹",
        "NewGroup": "새 그룹",
        "Search_trip": "트립 # 검색",
        "All": "모두",
        "creditTransactionFee": "신용카드 수수료",
        "partial_payment": "부분 결제",
        "Write_off_debt": "빚 탕감",
        "Booking_detail": "예약",
        "Order_detail": "주문",
        "Completed_Booking": "완료된 예약",
        "Late_Cancel_Passenger": "승객에 의한 늦은 취소",
        "Late_Cancel_Driver": "운전자에 의한 늦은 취소",
        "No_Show_Passenger": "승객 불참",
        "No_Show_Driver": "운전자 불참",
        "Late_Cancel": "늦은 취소",
        "Cancel_Driver": "운전자에 의한 취소",
        "No_Show": "불참",
        "Without_driver": "운전자 없이 완료",
        "Complete_driver": "운전자와 함께 완료",
        "BOOKING_INFORMATION": "예약 정보",
        "TIP_PROMO": "팁 - 프로모션",
        "Rearrange_Column": "칼럼 재배치",
        "Pick_up": "픽업",
        "Enter_a_location": "위치 입력",
        "Destination": "목적지",
        "Pickup_time": "픽업",
        "Notes": "메모",
        "TRAVELER_INFORMATION": "여행자 정보",
        "Traveler_type": "여행자 유형",
        "Individual": "개인",
        "Corporation": "회사",
        "Phone_number": "전화번호",
        "First_name": "이름",
        "Last_name": "성",
        "Email_address": "이메일 주소",
        "Corp_id": "회사 id",
        "Manager_name": "관리자의 이름",
        "Manager_email": "관리자의 이메일",
        "Cost_centre": "비용 센터",
        "Department": "부서",
        "Corp_division": "회사 부서",
        "Tip": "팁",
        "Promo_code": "프로모션 코드",
        "Apply": "적용",
        "Promo": "프로모션",
        "DISPATCH": "발송",
        "Auto_dispatch": "자동 배차",
        "Assign_driver": "할당",
        "Driver": "운전자",
        "PAYMENT_METHOD": "결제 방법",
        "Payment_methods": "결제 방법들",
        "pending_payment": "미결제",
        "TRIP_ESTIMATE": "여행 비용 추정",
        "Choose_a_stored_card": "저장된 카드 선택",
        "Choose_a_payment_method": "결제 방법 선택",
        "OPERATOR_NOTE": "내부 메모",
        "Use_new_card": "새 카드 사용",
        "Card_holder": "카드 소유자",
        "Card_number": "카드 번호",
        "Expired_date": "만료 날짜(mm/yy)",
        "ccv": "CVV",
        "Distance": "거리",
        "Duration": "기간",
        "Fare": "요금",
        "Route": "경로",
        "Meet_driver": "기사 만나기",
        "Airline": "항공사",
        "Flight": "편 번호",
        "FLY_INFO": "항공편 정보",
        "Ride_Sharing": "라이드 공유",
        "Round_trip": "왕복",
        "Car_type": "차량 유형",
        "Address": "주소",
        "City": "도시",
        "State": "주",
        "Zip_code": "우편 번호",
        "Remove": "제거",
        "New_Booking": "새로운 예약",
        "Clone_Booking": "예약 복제",
        "New_Order": "주문 복제",
        "ViewTrackLink": "링크 추적",
        "driverLink": "드라이버 링크",
        "ClickCopy": "링크 복사를 위해 클릭",
        "meetingBoard": "회의 \n보드",
        "ViewLog": "디스패치 로그",
        "Message": "메시지",
        "Update_Booking": "예약 업데이트",
        "Cancel_Booking": "예약 취소",
        "Complete_with_payment": "결제 완료",
        "Incident": "사건",
        "CONFIRM_CANCEL": "취소 확인",
        "CONFIRM_CANCEL_MESSAGE": "이 예약을 취소하겠습니까?",
        "CONFIRM_UPDATE": "업데이트 확인",
        "CONFIRM_UPDATE_MESSAGE": "이 예약을 업데이트하겠습니까?",
        "CONFIRM_RESET_EDIT_FARE_MESSAGE": "편집된 요금이 재설정되었습니다, 계속하기 전에 다시 확인하십시오.",
        "Close": "닫기",
        "Update_info": "예, 정보 업데이트",
        "Update_info_dispatch": "예, 정보 업데이트 및 배차",
        "Update_info_tooltip": "이 예약을 새로운 드라이버에게 재할당하려면 \"\"예, 정보 업데이트 및 배차\"\" 버튼을 선택하십시오.",
        "BOOKING": "예약",
        "DROPPED_OFF": "하차 완료",
        "Payment_Type": "결제 유형",
        "Total": "총계",
        "Next": "다음",
        "Pay_here": "여기에서 지불",
        "Complete_booking": "예약 완료",
        "Complete_booking_tooltip": "\"\"예약 업데이트\"\"를 클릭하여 계속하기 전에 변경사항을 저장하십시오.,",
        "Cancel": "취소",
        "Back": "뒤로",
        "Tax": "세금",
        "Booking_fees": "예약 수수료",
        "Tech_fees": "기술 수수료",
        "Subtotal": "소계",
        "Other_fees": "다른 요금",
        "Waiting_fee": "대기료",
        "Toll_fees": "통행료",
        "Heavy_traffic": "신호 대기",
        "Rush_hour": "할증",
        "Basic_fare": "기본 요금",
        "Ok": "확인",
        "Input_reason": "사유 입력",
        "Client_case_matter": "고객 케이스 내용 / 여행 설명",
        "Charge_code": "사용 코드 / 여행 코드",
        "Enter_3rd_party_location": "3rd party 위치 입력",
        "Company": "회사",
        "Check_promo_error": "프로모션 코드 오류를 확인해 주세요!",
        "Add_new_credit_error": "신용카드 추가 오류!",
        "Can_not_get_fare_setting": "요금 설정을 가져올 수 없음!",
        "Can_not_get_affilate_fare_setting": "제휴사 요금 설정을 가져올 수 없음!",
        "Can_not_check_commisson": "커미션을 확인할 수 없음!",
        "No_flight_info": "비행 정보 없음!",
        "Socket_server_disconnected": "소켓 서버가 연결이 끊어졌습니다!",
        "Please_reload_page_or_check_your_connection": "죄송합니다. 요청을 처리할 수 없습니다. 다시 시도해 주세요.",
        "View_Logs": "로그 보기",
        "Bookingid": "예약 #",
        "Calendar": "달력",
        "Extra_Destination": "추가 목적지",
        "Meet_Greet_option": "만나러 가기",
        "On_Curb_option": "보도 위",
        "Credit_Card": "신용 카드",
        "Charge": "충전",
        "No_charge": "무료",
        "QR_Code_method_not_allow_error_message": "QRCode로 지불하는 것은 대시보드에서 사용할 수 없으므로 다른 결제 유형을 선택하십시오!",
        "change_payment_method_note": "결제 방식을 변경하려면 예약 양식으로 돌아가야 합니다.",
        "Airport_Fee": "공항 요금",
        "Addi_service": "추가 서비스",
        "Additional_Services": "추가 서비스",
        "Minimum": "최소",
        "Search_here": "드라이버 검색",
        "No_Driver_Yet": "아직 드라이버가 할당되지 않음",
        "Personal_Card": "개인 카드",
        "Reject_booking": "예약 거절",
        "Confirm_reject": "거부 확인",
        "Confirm_reject_message": "이 예약을 거절하시겠습니까?",
        "Confirm_reject_booking_with_charge": "취소 정책에 따라 견적 요금의 {0}%가 청구됩니다. 이 예약을 거절하시겠습니까?",
        "Yes": "예",
        "No": "아니오",
        "shortTrip": "단거리 여행",
        "Add_new_card": "새 카드 추가",
        "Require_customer_info": "계속하려면 연락처 정보를 입력하십시오.",
        "Require_corp_info": "계속하려면 회사 정보를 입력하십시오.",
        "Require_corp_customer_info": "새 카드를 만들려면 사용자 정보가 필요합니다.",
        "confirm_force_overlap": "확인",
        "confirm_force_overlap_message": "이 예약은 드라이버가 이미 수락한 예약과 겹칩니다. 이 드라이버에게 할당하시겠습니까?",
        "select": "선택",
        "PICKUP_TIME_RANGE": "{0}에서 예상 픽업",
        "food": "음식",
        "mart": "마트",
        "Order_summary": "주문 요약",
        "addOnPrice": "조정된 가격",
        "applicableFee": "총계 (적용)",
        "itemValue": "품목 가치",
        "promotion_note_paymentMethod": "이 주문은 제한된 결제 방식을 가진 프로모션 코드가 적용되었습니다: %{method}.",
        "promotion_note_minimum_fare": "이 주문은 제한된 최소 요금을 가진 프로모션 코드가 적용되었습니다: %{fare}.",
        "promotion_note_schedules": "이 주문은 제한된 픽업 시간을 가진 프로모션 코드가 적용되었습니다.",
        "edited_fare_note": "이것은 참고용 요금 조정 로그입니다. 최종 요금 및 수수료를 확인하려면 보고서를 방문하십시오.",
        "view_good_receipt": "상품 영수증 보기",
        "confirmRemoveGroupTransport": "이 예약을 이 매니페스트에서 제거하시겠습니까?",
        "confirmRemoveGroupDelivery": "현재 예약을 이 그룹에서 제거하시겠습니까?",
        "confirmUngroupTransport": "모든 예약을 이 실적에서 그룹 해제하시겠습니까?",
        "confirmUngroupDelivery": "모든 예약을 이 그룹에서 그룹 해제하시겠습니까?",
        "view_delivery_receipt": "배송 사진 보기",
        "select_time": "시간 선택",
        "InputReason": "사유 입력",
        "viewOrder": "주문 보기",
        "markFailed": "실패로 표시",
        "corporateName": "기업명",
        "sendMessage": "메시지 보내기",
        "AmountDueBefore": "이전에 납부할 금액",
        "AmountDueAfter": "이후에 납부할 금액",
        "chargeCustomer": "고객에게 청구",
        "pending": "미결제",
        "refundPayment": "고객에게 환불",
        "refundableAmount": "환불 가능 금액",
        "refundReason": "환불 이유 추가",
        "refundBtn": "%{0} 환불",
        "partial": "부분적",
        "paid": "지불됨",
        "ViewPaymentLogs": "결제 로그",
        "pmActivity": "결제 활동",
        "paidStatus": "결제 상태",
        "paymentLog": "결제 로그",
        "extraWaitFee": "대기 요금 초기",
        "extraWaitTime": "대기 시간(초기)",
        "copied": "복사됨",
        "warnningCancelCorporate": "고객님께서는 취소 정책에 따라 청구될 금액을 부과받을 수 있음을 알려드립니다.",
        "customerAdjustments": "고객 조정",
        "customerAdjustmentsTooltip": "고객 조정",
        "supplierDriverAdjustments": "공급자/운전자 조정",
        "updateSummary": "요약 업데이트",
        "orderDetails": "주문 상세정보",
        "saveAndSendEmail": "저장 및 전자 영수증 보내기",
        "pastDetacted": "과거 예약 감지",
        "pastDetactedContent": "과거 예약을 생성하려 합니다",
        "DriverSupplier": "운전자/공급자",
        "supplierCancelCharge": "경고: 취소 벌금",
        "supplierCancelNoCharge": "취소 확인",
        "supplierCancelChargeBody": "예약을 취소하시겠습니까?",
        "willChargedPenalty": "%{0}의 벌금을 부과 받게 됩니다.",
        "noChargedPenalty": "이는 무료 취소이며 벌금이 부과되지 않습니다.",
        "errorGetToken": "토큰을 받을 수 없습니다, 나중에 다시 시도해 주십시오",
        "unlinkFlight": "항공편 연결 해제",
        "unlinkFlightBody": "주의! 픽업 시간을 변경하면 항공편 세부 정보가 연결 해제되고 항공편 번호가 삭제 됩니다."
    },
    "map": {
        "AWS_map_hint": "힌트: 그리기를 마치려면 Enter 또는 Esc를 누르세요.",
        "Apple_map_hint": "힌트: 클릭하고 잡아당기면 다각형의 크기를 조정할 수 있습니다.",
        "Enter_a_location": "위치 입력",
        "All_company": "모든 회사",
        "All_cars": "모든 차량",
        "Show_all_cars": "모든 차량 보기",
        "Hide_all_cars": "모든 차량 숨기기",
        "Vacant": "사용 가능",
        "Dispatching": "배차 중",
        "Driver_on_the_way": "운전자가 이동 중",
        "Arrived_and_waiting": "도착하고 대기 중",
        "P_O_B": "P.O.B",
        "Dropped_off": "하차 완료",
        "Waiting_for_process": "진행 대기 중",
        "Unavailable": "사용 불가",
        "Total_Drivers": "운전자 총계",
        "Estimate": "예상",
        "Destination": "목적지",
        "Pickup": "픽업",
        "Start_point": "출발지",
        "Passenger": "승객",
        "Driver_name": "운전자 이름",
        "Search_car_here": "차량/운전사 이름 검색",
        "Error_load_booking": "예약을 불러올 수 없습니다, 다시 시도하거나 페이지를 새로 고침해주세요!",
        "Show_all": "지도 상태 표시",
        "BookCardInfo": "예약 카드 정보",
        "drvPhoneNo": "운전자 전화번호",
        "vhcPhoneNo": "차량 전화번호",
        "driversLiveMap": "운전자 맵",
        "heatMap": "수요 맵",
        "Trip": "여행",
        "traffic": "교통",
        "bicyclingLayers": "자전거",
        "layer": "세부사항",
        "trafficBicycling": "교통, 자전거",
        "All_airline": "모든 항공사"
    },
    "customer": {
        "Customers": "고객",
        "Points": "포인트",
        "Migration_Status": "이전 상태",
        "ADD_CUSTOMER": "고객 추가",
        "EDIT_CUSTOMER": "고객 수정",
        "Add": "추가",
        "Activate": "활성화",
        "Deactivate": "비활성화",
        "Delete": "삭제",
        "Import": "가져오기",
        "Download_template": "템플릿 다운로드",
        "View_Message": "메시지",
        "Send_Message": "메시지 보내기",
        "Export_to_excel": "엑셀로 내보내기",
        "Filter": "필터",
        "Apply": "적용",
        "Clear": "지우기",
        "Name": "이름",
        "Phone_Number": "전화번호",
        "Email": "이메일",
        "Vip": "VIP",
        "companies": "회사",
        "File": "파일",
        "Number_successful_imports": "성공적으로 가져온 수:",
        "Number_skipped": "건너뛴 수:",
        "Number_duplicate_phone_numbers": "중복된 전화번호 수:",
        "Number_wrong_phone_numbers": "잘못된 전화번호 수:",
        "Corporate_Name": "회사",
        "Registered_From": "등록 from",
        "Registration_Date": "등록 날짜",
        "Registration_date_from": "등록 날짜 from",
        "Registration_date_to": "등록 날짜 to",
        "IOS_Last_Login_Version": "IOS 마지막 로그인 버전",
        "Android_Last_Login_Version": "안드로이드 마지막 로그인 버전",
        "Last_Active_Date": "마지막 활동 일자",
        "Verification": "검증",
        "Support_ID": "지원 ID",
        "Days_Since_Last_Active": "마지막 활동 이후 일수",
        "Completed_Bookings": "완료된 예약",
        "Outstanding_amount": "미결제 금액",
        "Status": "상태",
        "Actions": "행동",
        "Action": "동작",
        "Inactive": "비활성화",
        "Active": "활성",
        "Edit": "편집",
        "View": "보기",
        "ALERT_SELECT_ACTIVATE": "활성화할 고객을 선택하십시오.",
        "ALERT_SELECT_DEACTIVATE": "비활성화할 고객을 선택하십시오.",
        "ALERT_SELECT_DELETE": "삭제할 고객을 선택하십시오.",
        "CONFIRM_DELETE": "이 계정을 삭제하시겠습니까? 고객은 계정 제거 후 빈 데이터로 새 프로필을 등록할 수 있습니다.",
        "CONFIRM_DELETE_MULTI": "이 고객들을 삭제하시겠습니까? 앱을 통해 등록하지 않은 비활성 고객만 삭제할 수 있습니다.",
        "CONFIRM_DEACTIVATE_MULTI": "이 고객들을 비활성화하시겠습니까?",
        "CONFIRM_ACTIVATE_MULTI": "이 고객들을 활성화하시겠습니까?",
        "CONFIRM_EXPORT_TO_EXCEL": "모든 데이터를 .xlsx 파일로 내보내시겠습니까?",
        "Add_card_top_up_success": "선불 카드가 성공적으로 충전되었습니다",
        "Add_card_success": "카드가 성공적으로 추가되었습니다!",
        "Add_customer_success": "새 고객이 성공적으로 생성되었습니다",
        "Update_customer_success": "고객이 성공적으로 업데이트되었습니다",
        "Deleted_customer_success": "고객이 성공적으로 삭제되었습니다",
        "Create_customer_fail": "고객 생성에 실패했습니다",
        "Update_customer_fail": "고객 업데이트에 실패했습니다",
        "ERROR_EXISTED_PHONE": "이 전화는 이미 시스템에 존재합니다. 다른 번호를 입력하십시오.",
        "ERROR_INPUT_FIRSTNAME": "이름을 입력하십시오.",
        "ERROR_INPUT_PHONE": "전화번호를 입력하십시오.",
        "ERROR_INPUT_VALIDPHONE": "유효한 전화번호를 입력하십시오.",
        "ERROR_INPUT_VALIDEMAIL": "유효한 이메일 주소를 입력하십시오.",
        "CONFIRM_DELETE_CARD": "이 카드를 삭제하시겠습니까?",
        "First_name": "이름",
        "Last_name": "성",
        "Phone_number": "전화번호",
        "Email_address": "이메일 주소",
        "Notes": "메모",
        "Account": "계정",
        "Card_management": "카드 관리",
        "Home": "홈",
        "Affiliate": "제휴사",
        "SHOW_PERSONAL_CARD": "개인 카드 보기",
        "ADD_PERSONAL_CARD": "개인 카드 추가",
        "SHOW_mDISPATCHER_CARD": "파트너 카드 보기",
        "ADD_mDISPATCHER_CARD": "파트너 카드 추가",
        "Personal_card": "개인 카드",
        "mDispatcher_card": "파트너 카드",
        "Card_holder": "카드 소유자",
        "Card_number": "카드 번호",
        "Credit_type": "크레딧 타입",
        "Credit_code": "크레딧 코드",
        "Sms_verification": "SMS 검증",
        "Sms_verification_placeholder": "검증 코드 입력",
        "Expired_date": "만료 날짜",
        "CVV": "CVV",
        "Address": "주소",
        "Country": "국가",
        "City": "도시",
        "State": "주",
        "Zip_code": "우편 번호",
        "postal_code": "우편번호",
        "Required_fields": "필수 입력란",
        "Cancel": "취소",
        "Save": "저장",
        "ERROR_INPUT_CARD_HOLDER": "카드 소지자를 입력하십시오.",
        "ERROR_INPUT_CARD_NUMBER": "카드 번호를 입력하십시오.",
        "ERROR_INPUT_EXPIRED_DATE": "만료 날짜를 입력하십시오.",
        "ERROR_VAILD_EXPIRED_DATE": "만료 날짜가 유효하지 않습니다",
        "ERROR_INPUT_CVV": "CVV를 입력하십시오.",
        "ERROR_INPUT_ADDRESS": "주소를 입력하십시오.",
        "ERROR_INPUT_CITY": "도시를 입력하십시오.",
        "ERROR_INPUT_ZIPCODE": "우편번호를 입력하십시오.",
        "ERROR_INPUT_COUNTRY": "국가를 선택하십시오.",
        "Info_edit_error": "오류!",
        "Gender": "성별",
        "Select_Gender": "선택",
        "Select_Idtype": "ID 유형 선택",
        "Male": "남성",
        "Female": "여성",
        "Other": "기타",
        "Date_of_birth": "출생일",
        "Street_address": "거리 주소",
        "Select_Zone": "존 선택",
        "ERROR_GET_GATEWAYS": "오류 !!! 게이트웨이 가져오기",
        "Require_email": "새로운 카드를 추가하기 전에 이메일을 입력하십시오.",
        "Require_lastName": "새 카드를 추가하기 전에 성을 입력해주세요",
        "Require_phone_number": "신용카드로 예약하기 전에 여행자의 전화번호를 입력해주세요",
        "IMPORT_CUSTOMER_SUCCESS": "고객 임포트 성공",
        "No_card": "카드를 찾을 수 없음",
        "No_Support": "이 지역에서는 새로운 카드 추가가 현재 지원되지 않습니다",
        "Card_Management": "카드 관리",
        "Emergency_contacts": "긴급 연락처",
        "DETAIL_CUSTOMER": "고객 상세 정보",
        "Select_Country": "국가 선택",
        "Customer_ID": "아이디#/국가 신분증#",
        "Credit_balance": "신용 잔액",
        "required_email_payment": "고객의 이메일이 필요합니다. 계속 진행하려면 프로필을 업데이트해주세요.",
        "Yes": "예",
        "No": "아니오",
        "WriteOffDebt": "빚 탕감",
        "selectPayment": "미납결제가 있는 모든 예약을 종료하기 위한 결제 방법을 선택해주세요",
        "writeOffDebtSuccess": "채무 청산 성공",
        "writeOffDebtNotes": "주의: 이 청산 작업은 미납 금액을 모두 완전히 지불한 후에만 확정되어야 합니다.",
        "totalCustomer": "총 고객 수",
        "Personal_Card": "개인 카드",
        "INFO_ADD_BALANCE_SUCCESS": "승객 잔액이 성공적으로 업데이트되었습니다",
        "INFO_UPDATE_POINT_SUCCESS": "포인트가 성공적으로 업데이트되었습니다",
        "currency": "통화",
        "balance": "잔액",
        "changeBalance": "잔액 변경",
        "change": "변경",
        "WALLET_DEPOSIT": "지갑",
        "AccessDenied": "이 모듈에 대한 접근 권한이 없습니다!",
        "referral_code": "추천 코드",
        "loginMethod": "로그인 방법",
        "searchCustomerPlaceholder": "연락처 이름, 전화번호, 이메일, 기업, 서포트 ID 검색"
    },
    "importBookings": {
        "no": "No.",
        "status": "상태",
        "pickupDate": "픽업 날짜",
        "pickup": "픽업 주소",
        "dropoff": "목적지 주소",
        "passenger": "승객",
        "phone": "전화번호",
        "seats": "좌석",
        "luggages": "수하물",
        "rideSharing": "카풀",
        "flightNumber": "항공편 번호",
        "notes": "메모",
        "externalId": "외부 ID",
        "operatorNote": "내부 메모",
        "clientCaseMatter": "여행 설명",
        "chargeCode": "여행 코드",
        "price": "가격",
        "payout": "지급",
        "paymentType": "결제",
        "vehicleTypeRequest": "차량 유형",
        "importBookings": "예약 임포트",
        "corporation": "회사",
        "clickOrDropCsvFile": ".csv 파일을 클릭하거나 드롭하세요",
        "importingFileForReview": "파일 검토를 위해 가져오는 중...",
        "import": "가져오기",
        "submit": "제출",
        "downloadTemplate": "템플릿 다운로드",
        "learnMore": "더 알아보기",
        "total": "총계",
        "valid": "유효",
        "invalid": "무효",
        "failed": "실패",
        "processing": "진행 중",
        "success": "성공",
        "confirm": "확인",
        "confirmMessage": "주문이 생성될 예정입니다. 진행하시겠습니까?",
        "create": "생성",
        "cancel": "취소",
        "close": "닫기",
        "leavingConfirmMessage": "작업이 저장되지 않았습니다! 떠나시겠습니까?",
        "resultMessage": "${success} 개의 예약이 성공적으로 생성되었고, ${failed} 개는 실패하였습니다.",
        "limitExceededBookings": "최대 임포트 파일 사이즈: 100 개의 예약",
        "delivery": {
            "no": "#",
            "pickupDate": "픽업 날짜",
            "senderName": "발신자 이름",
            "senderPhone": "발신자 전화번호",
            "senderMail": "발신자 이메일",
            "senderAddress": "발신자 주소",
            "recipients": "수신자",
            "senderDistrictOptional": "지구",
            "senderLocationDetails": "위치 세부 정보",
            "recipientName": "수신인 이름",
            "recipientPhone": "수신인 전화번호",
            "recipientAddress": "수신인 주소",
            "recipientDistrictOptional": "지구",
            "recipientLocationDetailsOptional": "위치 세부 정보",
            "packageContent": "패키지 내용",
            "orderNumber": "주문번호#",
            "instructions": "운전사에게의 지시",
            "cod": "COD 항목 금액",
            "rideShare": "카풀",
            "paymentType": "결제 유형",
            "carType": "차량 유형",
            "recipientLocationDetails": "위치 세부 정보",
            "operatorNote": "내부 메모",
            "rideSharing": "배차 배송"
        }
    },
    "merchant": {
        "INFO_ADD_BALANCE_SUCCESS": "상인 잔액이 성공적으로 업데이트되었습니다",
        "ADD_MERCHANT_USER": "상인 계정 추가",
        "EDIT_MERCHANT_USER": "상인 계정 수정",
        "MERCHANT_USER_DETAILS": "상인 계좌 세부 정보",
        "CASH_WALLET": "현금 지갑",
        "CREDIT_WALLET": "신용 지갑",
        "ADD_MERCHANT": "상인 추가",
        "ACCOUNT_INFO": "계정 정보",
        "BILLING_ADDRESS": "은행 정보",
        "user": {
            "fullName": "상인 사용자",
            "Phone_Number": "전화번호",
            "Email": "이메일",
            "storeName": "상인",
            "status": "상태",
            "actions": "동작",
            "First_name": "이름",
            "Last_name": "성",
            "Select_store": "상인 선택",
            "accountHolder": "계좌 소유자의 이름",
            "First_M_Last": "이름. 성",
            "accountNumber": "계좌 번호",
            "ibanNumber": "IBAN 번호",
            "bankName": "은행 이름",
            "IDtype": "ID 유형",
            "IDnumber": "아이디#/국가 신분증#",
            "routingNumber": "Routing/Transit/Branch 번호",
            "checkNumber": "수표 번호",
            "ssn": "SSN/NI",
            "sortCode": "정렬 코드",
            "transitNumber": "전송 번호",
            "institutionNumber": "기관 번호",
            "birthDay": "생년월일",
            "address": "주소",
            "city": "도시",
            "state": "주",
            "postalCode": "우편번호",
            "beneficiaryIDIC": "수혜자 ID# / IC#",
            "relationshipOtherName": "다른 사람과의 관계는?",
            "verificationDocumentFront": "검증 문서 (앞)",
            "verificationDocumentBack": "검증 문서 (뒤)",
            "Verification_document_tooltip": "신분증으로 인정되는 형식: \n- 여권 \n- 운전 면허증 \n- 거주 허가증 \n- 시민 카드 \n- ID 카드",
            "additionalDocumentFront": "추가 문서 (앞)",
            "additionalDocumentBack": "추가 문서 (뒤)",
            "Additional_document_tooltip": "주소 확인 가능한 형식: \n- 운전 면허증 \n- 공공 요금 청구서 \n- 정부에서 발행한 편지 \n- 금융 기관의 발언문 \n- 선거 등록 엔트리",
            "please_select": "선택해 주세요",
            "commission": "수수료",
            "ERROR_INPUT_VALIDPHONE": "유효한 전화번호를 입력하십시오.",
            "ERROR_EXISTED_PHONE": "이 전화는 이미 시스템에 존재합니다. 다른 번호를 입력하십시오.",
            "Activate": "활성화",
            "Deactivate": "비활성화",
            "ALERT_SELECT_ACTIVATE": "활성화할 사용자를 선택해 주세요.",
            "ALERT_SELECT_DEACTIVATE": "비활성화할 사용자를 선택해 주세요.",
            "CONFIRM_ACTIVATE_MULTI": "이 사용자들을 활성화하고 싶으십니까?",
            "CONFIRM_DEACTIVATE_MULTI": "이 사용자들을 비활성화하시겠습니까?",
            "RESET_PASSWORD": "비밀번호를 재설정하시겠습니까?",
            "CONFIRM_RESET_PASSWORD": "비밀번호를 재설정하시겠습니까?",
            "REMOVE_BANK_INFO": "은행 정보 제거 확정",
            "CONFIRM_REMOVE_BANK_INFO": "은행 정보를 제거하시겠습니까?",
            "note_account_password_default": "참고: 새로운 상인 계정의 기본 비밀번호는 \"\"12345678\"\"입니다",
            "Cash_Balance": "현금 잔액",
            "Credit_Balance": "신용 잔액"
        },
        "Update_merchant_user_success": "상인 사용자가 성공적으로 업데이트되었습니다",
        "Update_merchant_user_fail": "상인 사용자 업데이트 실패",
        "Create_merchant_user_success": "새로운 상인 사용자가 성공적으로 생성되었습니다",
        "Create_merchant_user_fail": "상인 사용자 생성 실패",
        "Update_merchant_user_status_success": "상인 사용자가 성공적으로 업데이트되었습니다",
        "Update_merchant_user_status_fail": "상인 사용자 업데이트 실패",
        "Reset_password_merchant_user_success": "비밀번호 성공적으로 재설정",
        "Reset_password_merchant_user_fail": "비밀번호 재설정 실패",
        "Deleted_merchant_bank_info_success": "은행 정보 제거 성공",
        "Deleted_merchant_bank_info_fail": "은행 정보 제거 실패"
    },
    "table_header": {
        "Items_per_page": "페이지 당 항목 수",
        "Page": "페이지",
        "Search_here": "여기에 검색",
        "Shown_Active": "%{start} - %{end} 중 %{total} 표시됨",
        "Active": "%{active} 활성화",
        "OF": "의"
    },
    "driver": {
        "Driver": "운전자",
        "Add": "추가",
        "addDriver": "운전자 추가",
        "Detail": "세부 사항",
        "detailDriver": "운전자 세부 정보",
        "addNewVehicle": "차량 추가",
        "serviceType": "서비스 유형",
        "transport": "교통",
        "delivery": "배달",
        "stripeConnect": "Stripe Connect",
        "stripeConnectDes": "간편한 지불을 위해 스트라이프 커넥트 계정 추가",
        "bankAccount": "은행 정보",
        "bankAccountDes": "지불 관리를 위한 운전자의 은행 정보",
        "supplierComission": "공급자 수수료",
        "supplierComissionDes": "각 완료된 주문에 대해 공급자가 벌 수 있는 수수료를 설정합니다.",
        "fleetCommission": "Fleet/Supplier 수수료",
        "fleetCommissionDes": "플릿 또는 공급자가 모든 완료된 주문에서 벌 수 있는 수수료를 설정합니다. 운전자가 공급자의 운전자라면, 수수료는 공급자의 수익에서 공제됩니다.",
        "operationZones": "운영 구역",
        "operationZonesDes": "공급자가 작업을 받을 수 있는 구역:",
        "notes": "메모",
        "notesDes": "이 운전자에 대한 내부 노트:",
        "searchNotes": "운전자에 대한 메모 추가",
        "marketplace": "마켓플레이스",
        "marketplaceDes": "운전자가 원하는 작업을 수락하도록 허용합니다.",
        "otherSettings": "기타 설정",
        "topDriver": "TOP 운전자",
        "topDriverDes": "\"\"Top Driver\"\"태그를 가진 최우수 운전자를 우선시하여 더 많은 운행을 하게 하십시오.",
        "walletTransferBetweenDriver": "운전자간의 지갑 이체",
        "walletTransferBetweenDriverDes": "운전자들이 서로에게 자금을 직접 이전할 수 있게 하여, 팀 리더나 대사들에 의한 크레딧 분배를 쉽게 합니다.",
        "rideSharing": "라이드 공유",
        "rideSharingDes": "운전자들이 라이드 공유 일을 수행하게 하십시오. 이 고급 기능에 대해서는 계정 관리자에게 문의하십시오.",
        "individual_vehicle": "개인 차량",
        "company_vehicle": "회사 차량",
        "ContactInfo": "연락처 정보",
        "name": "이름",
        "expiryDate": "만료일",
        "action": "동작",
        "editDocument": "문서 편집",
        "documentToUpload": "업로드할 문서",
        "addFiles": "업로드를 위해 이 영역에 파일을 클릭하거나 드래그하십시오.",
        "fileSize": "최대 파일 크기 10 MB",
        "fileSizeDes": "파일 확장자는 .jpg, .jpeg, .png, .doc, .docx, .xls, .xlsx, .pdf, .7z, .rar, .zip이어야 합니다.",
        "removeOldFile": "새 파일을 업로드하기 전에 이전 파일을 제거하십시오.",
        "maxLengthFiles": "최대 길이 1 파일 업로드 하십시오",
        "maxSizeFiles": "파일 크기가 10MB 미만인 파일을 업로드하십시오",
        "typeFiles": ".jpg, .jpeg, .png, .doc, .docx, .xls, .xlsx, .pdf, .7z, .rar, .zip 형식의 파일을 업로드하십시오",
        "maxAvatarSizeFiles": "아바타 크기가 8MB 미만인 파일을 업로드하십시오",
        "IFSCCode": "IFSC 코드",
        "Drivers": "운전자",
        "default": "기본",
        "customize": "맞춤설정",
        "Activate": "활성화",
        "Stripe_connect": "Stripe Connect",
        "status_stripe": "상태: {0}",
        "stripeConnectStatus": "Stripe Connect",
        "stripeStatus": "Stripe 계정 상태",
        "Deactivate": "비활성화",
        "Delete": "삭제",
        "acceptInDay": "운전자가 하루에 수락 할 수 있는 예약 최대 수",
        "acceptATime": "운전자가 한 번에 수락 할 수 있는 예약 총 수",
        "Commission": "블릿 커미션 설정",
        "Title_Commission": "모든 운전자에 대해 블릿 커미션 설정",
        "Confirm_Set_Commission": "이 커미션 값을 모든 운전자에게 설정하시겠습니까?",
        "Commission_Successfully": "운전자 커미션이 성공적으로 업데이트되었습니다",
        "Apply": "적용",
        "Type": "유형",
        "Currency": "통화",
        "View_Message": "메시지",
        "Send_Message": "메시지 보내기",
        "Driver_Name": "운전자 이름",
        "Driver_ID": "아이디#/국가 신분증#",
        "Phone_Number": "전화번호",
        "Driver_Type": "운전자 유형",
        "TOP": "TOP",
        "Company": "회사",
        "City": "도시",
        "Driver_License_Number": "운전면허 번호",
        "License_Plate": "차량 번호판",
        "Car_Type": "차량 유형",
        "Zone": "구역",
        "Registered_From": "등록 from",
        "Registration_Date": "등록 날짜",
        "IOS_Last_Login_Version": "IOS 마지막 로그인 버전",
        "Android_Last_Login_Version": "안드로이드 마지막 로그인 버전",
        "Last_Active_Date": "마지막 활동 일자",
        "Days_Since_Last_Active": "마지막 활동 이후 일수",
        "Completed_bookings": "완료된 예약",
        "Status": "상태",
        "Actions": "행동",
        "Action": "동작",
        "Inactive": "비활성화",
        "Active": "활성",
        "Edit": "편집",
        "View": "보기",
        "ALERT_SELECT_ACTIVATE": "활성화 할 운전자를 선택하십시오.",
        "ALERT_SELECT_DEACTIVATE": "비활성화 할 운전자를 선택하십시오.",
        "ALERT_SELECT_DELETE": "삭제할 운전자를 선택하십시오.",
        "CONFIRM_DELETE": "이 운전자 계정을 삭제하시겠습니까? 한 번 삭제하면, 운전자는 새 프로필을 등록할 수 있지만, 이전 데이터는 영구적으로 손실됩니다.",
        "CONFIRM_DEACTIVATE_MULTI": "선택한 운전자(들)를 비활성화하시겠습니까? 그들의 연결된 하드웨어 미터도 비활성화됩니다. 현재 여행이나 예약이 없는 운전자만 비활성화 될 수 있습니다.",
        "CONFIRM_ACTIVATE_MULTI": "이 운전자들을 활성화하시겠습니까? 완전히 운영 준비가 된 운전자만 활성화 될 수 있습니다.",
        "CONFIRM_DELETE_MULTI": "이 운전자들을 삭제하시겠습니까? 비활성 상태인 운전자만 삭제 될 수 있습니다.",
        "CONFIRM_REMOVE_BANKING_INFOR": "은행 정보를 삭제하시겠습니까?",
        "REMOVE_BANKING_INFOR": "은행 정보 제거",
        "ADD_DRIVER": "운전자 추가",
        "Avatar": "아바타",
        "Individual_Driver": "교통 - 회사 차량",
        "Owner_Operator": "교통 - 개인 차량",
        "deliveryCompany": "배송 - 회사 차량",
        "deliveryIndividual": "배송 - 개인 차량",
        "CONTACT_INFO": "연락처 정보",
        "Home_address": "집 주소",
        "Username": "사용자 이름",
        "First_name": "이름",
        "Last_name": "성",
        "Phone_number": "전화번호",
        "Email_address": "이메일 주소",
        "Select_city": "도시 선택",
        "State": "주",
        "Zip_code": "우편 번호",
        "Date_of_birth": "출생일",
        "placeholderDate": "mm/dd/yyyy",
        "City_driver_want_to_drive": "운전자가 운전하길 원하는 도시",
        "Driver_license_number": "운전면허 번호",
        "Driver_license_state": "운전면허 발행 주/성",
        "Driver_license_expiry": "운전 면허 만료",
        "FOR_INSPECTOR": "검사관용",
        "Document": "문서",
        "Document_Id": "문서 ID",
        "Link": "링크",
        "Notes": "메모",
        "UPLOAD_DOCUMENT": "문서 업로드",
        "Click_here_to_download": "다운로드를 위해 클릭",
        "Click_here_to_view": "보기를 위해 클릭",
        "EXTENSION_REQUIREMENT": "파일 확장자는 .jpg, .jpeg, .png, .doc, .docx, .xls, .xlsx, .pdf, .7z, .rar, .zip이며 5Mb 미만이어야합니다.",
        "Invalid_file": "파일 내용이 유효하지 않습니다",
        "File_size_larger_than_5Mb": "파일 크기는 5MB보다 커야합니다",
        "BANK_ACCOUNT": "은행 계좌",
        "Name_of_bank": "은행 이름",
        "Name_of_account": "계좌 소유자의 이름",
        "First_M_Last": "이름. 성",
        "RTBnumber": "Routing/Transit/Branch 번호",
        "bankName": "은행명",
        "Select_a_bank": "은행 선택",
        "Account_number": "계좌 번호",
        "IBAN_number": "IBAN 번호",
        "Check_number": "수표 번호",
        "Swift_code_number": "스위프트 코드 번호",
        "SSNNI": "SSN/ NI",
        "sortCode": "정렬 코드",
        "Verification_document": "검증 문서 (앞)",
        "Additional_document": "추가 문서 (앞)",
        "Verification_document_back": "검증 문서 (뒤)",
        "Additional_document_back": "추가 문서 (뒤)",
        "others": "기타",
        "signedW9Form": "서명된 W-9 양식",
        "driverLicense": "운전면허증",
        "Verification_document_tooltip": "신분증으로 인정되는 형식: \n- 여권 \n- 운전 면허증 \n- 거주 허가증 \n- 시민 카드 \n- ID 카드",
        "Additional_document_tootip": "주소 확인 가능한 형식: \n- 운전 면허증 \n- 공공 요금 청구서 \n- 정부에서 발행한 편지 \n- 금융 기관의 발언문 \n- 선거 등록 엔트리",
        "isBankAccountOwner": "이 계좌는 당신의 것인가요?",
        "yes": "예",
        "no": "아니오",
        "beneficiary_name": "수취인 이름",
        "beneficiary_idic": "수취인 ID/IC",
        "relationship": "관계",
        "select_relationship": "관계 상태 선택",
        "spouse": "배우자",
        "daughterOrSon": "딸/아들",
        "brotherOrSister": "형제/자매",
        "relative": "친척",
        "friends": "친구",
        "other": "기타",
        "relationshipOtherName": "다른 사람과의 관계는?",
        "OPERATION": "운영",
        "CAR_INSURANCE": "자동차 보험",
        "Policy_number": "정책 번호",
        "Effective_date": "유효한 날짜",
        "Expired_date": "만료 날짜",
        "Select_company": "회사 선택",
        "All_company": "모든 회사",
        "All_Car_Type": "모든 차종",
        "Car": "차량",
        "Existing_car": "기존 차",
        "New_car": "새 차",
        "License_plate": "차량 번호판",
        "Select_license_plate": "차량 번호판 선택",
        "Select_Car_Type": "차량 유형 선택",
        "vehicleOwner": "차량의 소유자 이름",
        "Make": "제조사",
        "Select_Car_Make": "차량 제조사 선택",
        "Model": "모델",
        "Select_Car_Model": "차량 모델 선택",
        "Year": "년도",
        "Select_Year": "년도 선택",
        "Color": "색상",
        "Passengers": "승객",
        "Luggage": "수하물",
        "License_expiry": "운전 면허 만료",
        "Shift": "교대",
        "Select_Shift_Template": "근무 시간표 선택",
        "Fleet_commission": "편성 커미션 (보고서)",
        "Company_commission": "회사 커미션 (보고서)",
        "rideHailing": "거리 헤일링",
        "intercity": "도시 간",
        "food": "음식",
        "mart": "마트",
        "streetSharing": "스트리트 공유",
        "Shuttle": "셔틀",
        "parcel": "소포",
        "driverInsurance": "운전자 보험",
        "Percentage": "퍼센티지",
        "Amount": "금액",
        "transaction": "트랜잭션",
        "Terminal_ID": "터미널 ID",
        "Auth_key": "인증키",
        "CREDIT_DEPOSIT": "신용 지갑",
        "Credit_Balance": "신용 잔액",
        "Balance": "잔액",
        "Change_balance": "잔액 변경",
        "Select_balance": "잔액 선택",
        "Adjust_amount": "금액 조정",
        "Adjust_value": "값 조정",
        "New_balance": "새로운 잔액",
        "New_point": "새로운 포인트",
        "Enter_reason": "이유 입력",
        "ERROR_INPUT_BALANCE": "잔액을 선택하십시오.",
        "ERROR_INPUT_AMOUNT": "이 값을 입력하십시오.",
        "ERROR_INPUT_REASON": "이유를 입력해 주세요.",
        "ERROR_INPUT_VALID_AMOUNT": "0 이상의 값을 입력하십시오.",
        "INFO_ADD_BALANCE_SUCCESS": "운전자 잔액이 성공적으로 업데이트되었습니다",
        "INFO_ADD_CASH_BALANCE_SUCCESS": "운전자 현금 잔액이 성공적으로 업데이트되었습니다",
        "Force_meter": "강제 미터",
        "Force_meter_tooltip": "운전사 앱은 운용하기 전에 미터기에 연결되어야 합니다. 풀사르 & 센트로다인의 미터기에 적용됩니다",
        "ERROR_EXISTED_PHONE": "이 전화는 이미 시스템에 존재합니다. 다른 번호를 입력하십시오.",
        "TOP_driver": "TOP 운전자",
        "Ride_sharing": "라이드 공유",
        "Note_password": "참고: 새 운전사 계정의 기본 비밀번호는 \"\"12345678\"\"입니다",
        "Required_fields": "필수 입력란",
        "Cancel": "취소",
        "Save": "저장",
        "SaveAndInProgress": "저장 & 진행 중",
        "SaveAndDeactivate": "저장 & 비활성화",
        "ERROR_REQUIRE_": "입력해 주세요",
        "ERROR_INPUT_AVATAR": "아바타를 업로드 해주세요.",
        "ERROR_INPUT_DRIVER_TYPE": "운전사 유형을 선택해 주세요.",
        "ERROR_INPUT_DOCUMENT": "업로드 해주세요",
        "ERROR_INPUT_USERNAME": "사용자 이름을 입력해 주세요.",
        "ERROR_INPUT_VALID_USERNAME": "사용자 이름은 소문자 및 숫자만 포함해야 하며, 길이는 3~20자 사이여야 합니다",
        "ERROR_INPUT_PHONE": "올바른 휴대폰 번호를 지정해 주세요.",
        "ERROR_INPUT_VALID_EMAIL": "올바른 이메일을 입력해 주세요.",
        "ERROR_INPUT_EMAIL": "이메일을 입력해 주세요.",
        "ERROR_INPUT_FIRSTNAME": "이름을 입력하십시오.",
        "ERROR_INPUT_LASTNAME": "성을 입력해 주세요.",
        "ERROR_INPUT_ADDRESS": "집 주소를 입력해 주세요.",
        "ERROR_INPUT_CITY": "도시를 입력해 주세요.",
        "ERROR_INPUT_STATE": "주를 입력해 주세요.",
        "ERROR_INPUT_ZIPCODE": "우편번호를 입력해 주세요.",
        "ERROR_INPUT_BIRTHDAY": "생일을 입력해 주세요.",
        "ERROR_INPUT_NAME_OF_BANK": "은행 이름을 입력해 주세요.",
        "ERROR_INPUT_NAME_OF_ACCOUNT": "계좌 소유주 이름을 입력해 주세요.",
        "ERROR_INPUT_ROUTING_NUMBER": "라우팅 번호를 입력해 주세요.",
        "ERROR_INPUT_BANK_NAME": "은행을 선택해 주세요.",
        "ERROR_INPUT_ACCOUNT_NUMBER": "계좌 번호를 입력해 주세요",
        "ERROR_INPUT_CHECK_NUMBER": "체크 번호를 입력해 주세요.",
        "ERROR_INPUT_SSN": "SSN을 입력해 주세요.",
        "ERROR_INPUT_DocumentId": "문서 ID를 입력해 주세요.",
        "ERROR_INPUT_SORTCODE": "정렬 코드를 입력해 주세요.",
        "ERROR_INPUT_COMPANY": "활성화할 회사를 선택해 주세요.",
        "ERROR_INPUT_LICENSE_PLATE": "번호판을 선택해주세요.",
        "ERROR_INPUT_ZONE": "활성화할 지역을 선택해 주세요.",
        "ERROR_INPUT_SHIFT": "활성화할 쉬프트를 선택해 주세요.",
        "ERROR_ACCOUNT_NUMBER_ONLY_NUMBERS": "이곳에는 숫자만 들어갈 수 있습니다",
        "ERROR_SSN_ONLY_NUMBERS": "이곳에는 숫자만 들어갈 수 있습니다",
        "ERROR_SSN_LENGTH": "SSN은 최소 4자 이상이어야 합니다",
        "ERROR_COMMISSION_NUMBERS": "올바른 번호를 입력해 주세요.",
        "INFO_DEACTIVAED_SUCCESS": "운전사가 성공적으로 비활성화되었습니다.",
        "INFO_ACTIVAED_SUCCESS": "운전사가 성공적으로 활성화되었습니다.",
        "INFO_DEACTIVAED_SUCCESS_BUT_HARDWARE": "운전사가 비활성화되었지만, 예상치 못한 이유로 통합 하드웨어 미터는 꺼질 수 없습니다.",
        "INFO_MULTIDEACTIVAED_SUCCESS": "{0}명의 선택된 운전사가 성공적으로 비활성화되었습니다.",
        "INFO_MULTIDEACTIVAED_HARDWARE_SUCCESS": "{0}명의 선택된 운전사가 성공적으로 비활성화되었습니다. {1} 연결된 하드웨어 미터가 비활성화되었습니다.",
        "INFO_MULTIDEACTIVAED_SUCCESS_BUT_HARDWARE": "{0}명의 선택된 운전사가 성공적으로 비활성화되었습니다. {1} 연결된 하드웨어 미터가 비활성화되었습니다. {2}은 예상치못한 이유로 종료되지 않았습니다.",
        "INFO_MULTIACTIVAED_SUCCESS": "{0}명의 선택된 운전사가 성공적으로 활성화되었습니다.",
        "DRIVER_UPDATE_SUCCESS": "운전사 정보가 성공적으로 업데이트되었습니다.",
        "DRIVER_CREATE_SUCCESS": "운전사 정보가 성공적으로 추가되었습니다",
        "Expiry_Date": "만료일",
        "Case_number": "사건 번호",
        "Export_to_csv": "CSV로 내보내기",
        "CONFIRM_EXPORT_TO_CSV": ".csv 형식으로 모든 데이터를 내보내고 싶으십니까?",
        "Ride_sharing_tooltip": "라이드 쉐어링은 고급 기능이므로, 자세한 정보는 당사 지원팀에 문의하십시오.",
        "In_Review": "검토 중",
        "Reset_password_success": "비밀번호 성공적으로 재설정",
        "Topup_note": "(운전사를 활성화한 후에 운전사의 잔액을 충전할 수 있습니다)",
        "cash_balance": "현금 잔액",
        "cash_wallet": "현금 지갑",
        "total_balance": "총 잔액",
        "total_cash_balance": "총 현금 잔액",
        "total_credit_balance": "총 신용 잔액",
        "banking_status": "은행 상태",
        "bankingStatus": {
            "verified": "인증됨",
            "not_verified": "인증되지 않음",
            "inComplete": "미완료",
            "connected": "연결됨",
            "disconnected": "연결 해제"
        },
        "INVALID_FILE_SIZE": "파일 크기는 8MB 미만이어야 합니다.",
        "totalDrivers": "총 운전사 수",
        "profileStatus": "프로필 상태",
        "profile_completed": "프로필 완료",
        "profile_incomplete": "프로필 미완료",
        "profile_inProgress": "프로필 작성 중",
        "in_review_completed": "검토 중 (프로필 완료)",
        "in_review_incomplete": "검토 중 (프로필 미완료)",
        "in_review_inProgress": "검토 중 (프로필 작성 중)",
        "CASH_WALLET_DEPOSIT": "현금 지갑",
        "payoutSelect": "지불 (지불 후 운전사에게 인박스 및 이메일이 전송됩니다)",
        "Confirm_update_cash_balance": "현금 잔액 변경",
        "Confirm_update_cash_balance_msg": "운전사의 잔액을 변경하시겠습니까?",
        "cashBalance": "현금 잔액",
        "cashBalance_unavailable": "0.00",
        "cashBalance_active": "활성",
        "cashBalance_negative": "음수",
        "creditBalance": "신용 잔액",
        "ERROR_INPUT_DOCUMETID": "문서 ID를 입력해 주세요.",
        "ERROR_INPUT_EXPIRYDATE": "만료 날짜를 입력해 주세요.",
        "driverType": "운전자 유형",
        "tooltip_in_review_completed": "프로필을 완료한 '검토 중' 운전사에게 메시지를 보냅니다.",
        "tooltip_in_review_incomplete": "프로필을 완료하지 못한 '검토 중' 운전사에게 메시지를 보냅니다.",
        "tooltip_in_review_inProgress": "프로필을 완료했지만 추가 확인이 필요한 '검토 중' 운전사에게 메시지를 보냅니다.",
        "tooltip_active": "활성화'된 운전사에게 메시지를 보냅니다.",
        "tooltip_inactive": "계정이 재활성화 된 운전사에게 메시지를 보냅니다.",
        "active": "활성화",
        "inactive": "비활성화",
        "inReviewInProgress": "검토 중",
        "Market_place": "마켓플레이스",
        "Market_place_tooltip": "운전사들이 수요에 따라 혹은 예약을 받아 선택할 수 있게 함",
        "selectDriverType": "운전사 유형 선택",
        "PlsSelectDriverType": "운전사 유형을 선택해주세요",
        "emergencyContacts": "긴급 연락처",
        "switchVehicle": "다른 차량으로 전환",
        "switchVehicleNote": "드라이버가 지정된 공급업체 회사의 모든 차량으로 전환할 수 있게 하십시오.",
        "vehicleModel": "모델",
        "licensePlateNumber": "차량 번호판",
        "addVehicle": "차량 추가",
        "newVehicle": "새 차량",
        "linkVehicle": "차량 연결",
        "modal": "모달",
        "selectVehicle": "차량 선택",
        "selectVehicleNote": "예약을 위한 차량을 선택하거나 변경할 수 있게 하십시오.",
        "Warning_change_company": "경고: 이 운전사를 다른 회사에 재배치하면 모든 연결된 차량과의 연결이 끊어집니다.",
        "searchDriverPlaceholder": "이름, 전화, 이메일, 사용자 이름, 자동차 번호판 검색",
        "please_select_a_name_of_bank": "은행 이름을 선택하십시오"
    },
    "corporate": {
        "User_Name": "사용자 이름",
        "Edit_Balance": "잔액 편집",
        "Corporates": "기업",
        "Supplier": "공급자",
        "CarTypes": "자동차 유형",
        "Add": "추가",
        "Balance": "잔액",
        "Activate": "활성화",
        "Deactivate": "비활성화",
        "Delete": "삭제",
        "Company_Name": "회사 이름",
        "Admin_Name": "관리자 이름",
        "Username": "사용자 이름",
        "Phone_Number": "전화번호",
        "importBooking": "예약을 가져올 수 있음",
        "Email": "이메일",
        "Registered_From": "등록 from",
        "Registration_Date": "등록 날짜",
        "Status": "상태",
        "Actions": "행동",
        "Action": "동작",
        "Inactive": "비활성화",
        "Active": "활성",
        "In_Review": "검토 중",
        "Edit": "편집",
        "View": "보기",
        "ADD_CORPORATE_CARD": "기업 카드 추가",
        "selectCountry": "국가 선택",
        "CONFIRM_DELETE_CARD": "이 카드를 삭제하시겠습니까?",
        "ALERT_SELECT_ACTIVATE": "활성화할 기업을 선택하십시오.",
        "ALERT_SELECT_DEACTIVATE": "비활성화할 기업을 선택하십시오.",
        "ALERT_SELECT_DELETE": "삭제할 기업을 선택하십시오.",
        "CONFIRM_DELETE": "이 기업을 삭제하시겠습니까?",
        "CONFIRM_DELETE_USER": "이 기업 사용자를 삭제하시겠습니까?",
        "CONFIRM_DEACTIVATE_MULTI": "이 기업을 비활성화하시겠습니까?",
        "CONFIRM_ACTIVATE_MULTI": "이 기업을 활성화하시겠습니까?",
        "CONFIRM_DELETE_MULTI": "이 기업을 삭제하시겠습니까?\n** 비활성인 기업만 삭제할 수 있습니다.",
        "ERROR_INPUT_PHONE": "올바른 휴대폰 번호를 지정해 주세요.",
        "ERROR_INPUT_VALIDPHONE": "유효한 전화번호를 입력하십시오.",
        "ERROR_EXISTED_PHONE": "이 전화는 이미 시스템에 존재합니다. 다른 번호를 입력하십시오.",
        "Account": "계정",
        "Corp_traveler": "기업 사용자",
        "Payment_methods": "결제 방법들",
        "Corp_operators": "기업 운영자",
        "Pricing": "가격결정",
        "COMPANY_INFORMATION": "회사 정보",
        "Company_name": "회사 이름",
        "Company_ID": "회사 ID (기업 사용자 가입용)",
        "Company_address": "회사 주소",
        "Invoice_email": "청구서 이메일",
        "Confirmation_email": "확인 이메일",
        "colorCodeBooking": "색상 코드",
        "ADMIN_ACCOUNT": "관리자 계정",
        "First_name": "이름",
        "Last_name": "성",
        "Commission": "수수료",
        "commissionBooking": "앱/웹앱의 예약에서 커미션 적용",
        "Required_fields": "필수 입력란",
        "Save": "저장",
        "Cancel": "취소",
        "Reset_password": "비밀번호 재설정",
        "Employee_Name": "이름",
        "Created_Date": "생성 날짜",
        "Add_corporate_card": "기업 카드 추가",
        "Corp_Users": "기업 사용자",
        "Pricing_Default": "기업 요금 템플릿",
        "Pricing_Discount": "할인율 백분율 (기업 사용자에게만 적용)",
        "Markup_By_Percent": "마크업율 (기업 사용자에게만 적용)",
        "Pricing_Discount_new": "할인율",
        "Markup_By_Percent_new": "마크업",
        "Pricing_Add_different_rates": "다른 이율 추가",
        "ERROR_INPUT_COMPANYNAME": "회사 이름을 입력하십시오.",
        "ERROR_INPUT_USERNAME": "사용자 이름을 입력해 주세요.",
        "ERROR_INPUT_FIRSTNAME": "이름을 입력하십시오.",
        "ERROR_INPUT_EMAIL": "이메일을 입력해 주세요.",
        "ERROR_INPUT_VALID_EMAIL": "유효한 이메일 주소를 입력하십시오.",
        "ERROR_INPUT_VALID_NUMBER": "올바른 번호를 입력해 주세요",
        "ERROR_INPUT_VALID_RANGE_AMOUNT": "{0}과 {1} 사이의 값으로 입력해주세요.",
        "INFO_ADD_CORPORATE_SUCCESS": "계정 {0}이(가) 성공적으로 생성되었습니다. 로그인 자격증명 상세 정보는 이메일 {1}을 참고해주십시오.",
        "INFO_UPDATE_CORPORATE_SUCCESS": "정보가 성공적으로 업데이트되었습니다.",
        "INFO_UPDATE_PRICING_SUCCESS": "가격결정이 성공적으로 업데이트되었습니다.",
        "INFO_RESET_PASSWORD_SUCCESS": "계정 {0}이(가) 성공적으로 재설정되었습니다. 로그인 자격증명 상세 정보는 이메일 {1}을 참조하십시오.",
        "COMFIRM_RESET_PASSWORD": "비밀번호를 재설정하시겠습니까?",
        "Traveler_signature": "여행자 서명",
        "Parcel_Delivery": "택배 서비스 활성화",
        "Tracking_log": "추적 로그",
        "Rating": "등급",
        "Email_address": "이메일 주소",
        "Assistant_email": "보조 이메일",
        "Corp_PO": "회사 PO",
        "Cost_centre": "비용 센터",
        "Corp_division": "회사 부서",
        "Corp_id": "회사 id",
        "Department": "부서",
        "Manager_email": "관리자의 이메일",
        "Manager_name": "관리자의 이름",
        "Corporate_card": "기업 카드",
        "Direct_invoicing": "직접 청구",
        "Corporate_Prepaid": "기업 선불",
        "Cash": "현금",
        "Car_Type_ID": "차량 유형 ID",
        "App_Display_Name": "앱 표시 이름",
        "Normal_Fare": "일반",
        "Flat_Fare": "정액 요금",
        "Hourly_Daily_Rate": "시간/일별",
        "Delivery_Rate": "배달",
        "Assign_rate": "요금 할당",
        "Zone": "구역",
        "Rate": "요금",
        "Zone_Rate": "지역 - 요금",
        "Please_select_rate": "요금을 선택해 주세요",
        "Paid_by": "지불자",
        "Enter_new_credit_card": "새로운 신용카드 입력",
        "TOP_UP": "충전",
        "Top_up": "충전",
        "Topup_amount": "충전 금액",
        "Currency": "통화",
        "ERROR_INPUT_AMOUNT": "올바른 금액을 입력해주세요.",
        "VAT_number": "VAT 번호",
        "Gender": "성별",
        "Select_Gender": "선택",
        "Male": "남성",
        "Female": "여성",
        "Date_of_birth": "출생일",
        "Street_address": "거리 주소",
        "City": "도시",
        "State": "주",
        "Zip_code": "우편 번호",
        "Country": "국가",
        "adding_new_card": "%{zoneName} 지역에서 서비스를 이용하기 위해 새 카드를 추가하고 있습니다",
        "No_Support": "이 지역에서는 새로운 카드 추가가 현재 지원되지 않습니다",
        "Job_title": "직함",
        "required_phone_number_payment": "기업의 전화번호는 필수입니다. 계속하려면 프로필을 업데이트해 주세요.",
        "Yes": "예",
        "No": "아니오",
        "AddCardBeforeTopup": "신용카드를 찾을 수 없습니다. 계속하려면 새 카드를 추가해주세요.",
        "flightNumber": "비행 번호",
        "Company_Type": "회사 유형",
        "Standard": "표준 기업",
        "Airline": "항공사",
        "Branding": "브랜딩",
        "bgImage": "배경 이미지 (1600x900)",
        "logoImage": "로고 이미지",
        "aliasTitle": "별칭 (URL) 매개변수",
        "importChauffeurBooking": "교통 예약을 수입할 수 있음",
        "isCorporateVip": "기업 VIP",
        "isCorporateVipToolTip": "이 설정을 활성화하면 모든 기업 여행객에게 자동으로 VIP 상태를 부여하며, 개별 사용자별로 이 기능을 끌 수 있습니다.",
        "qrTitle": "QR 웹 예약 링크",
        "qrNote": "당신의 개인화된 파트너 예약 링크가 여기에 있습니다! 바, 호텔 리셉션, 게스트 룸, 웹사이트 등 고객이 택시 또는 배송 서비스가 필요한 어디에서나 눈에 띄게 표시하세요. 고객들이 쉽고 빠르게 여행을 예약하도록 독특한 QR 코드로 스탠디를 디자인해 보세요!",
        "PricingLegacy": "요금(레거시)",
        "defaultTemplate": "기본 템플릿",
        "Select_Rate_Template": "요금 템플릿 선택"
    },
    "airline": {
        "Airlines": "항공사",
        "Add": "추가",
        "Activate": "활성화",
        "Deactivate": "비활성화",
        "Delete": "삭제",
        "Company_Name": "회사 이름",
        "Admin_Name": "관리자 이름",
        "Username": "사용자 이름",
        "Phone_Number": "전화번호",
        "Email": "이메일",
        "Registered_From": "등록 from",
        "Registration_Date": "등록 날짜",
        "Status": "상태",
        "Actions": "행동",
        "Action": "동작",
        "Inactive": "비활성화",
        "Active": "활성",
        "In_Review": "검토 중",
        "Edit": "편집",
        "View": "보기",
        "ADD_CORPORATE_CARD": "항공사 카드 추가",
        "selectCountry": "국가 선택",
        "CONFIRM_DELETE_CARD": "이 카드를 삭제하시겠습니까?",
        "ALERT_SELECT_ACTIVATE": "활성화할 항공사를 선택해주세요.",
        "ALERT_SELECT_DEACTIVATE": "비활성화할 항공사를 선택해주세요.",
        "ALERT_SELECT_DELETE": "삭제할 항공사를 선택해주세요.",
        "CONFIRM_DELETE": "이 항공사를 삭제하시겠습니까?",
        "CONFIRM_DELETE_USER": "이 항공사 사용자를 삭제하시겠습니까?",
        "CONFIRM_DEACTIVATE_MULTI": "이 회사를 비활성화하시겠습니까?",
        "CONFIRM_ACTIVATE_MULTI": "이 회사를 활성화하시겠습니까?",
        "CONFIRM_DELETE_MULTI": "이 회사를 삭제하시겠습니까?\n** 비활성한 회사만 삭제할 수 있습니다.",
        "ERROR_INPUT_PHONE": "올바른 휴대폰 번호를 지정해 주세요.",
        "ERROR_INPUT_VALIDPHONE": "유효한 전화번호를 입력하십시오.",
        "ERROR_EXISTED_PHONE": "이 전화는 이미 시스템에 존재합니다. 다른 번호를 입력하십시오.",
        "Airline": "항공사",
        "Crew": "승무원",
        "Payment_methods": "결제 방법들",
        "Airline_operators": "항공사 운영자",
        "Pricing": "가격결정",
        "COMPANY_INFORMATION": "회사 정보",
        "Company_name": "회사 이름",
        "Company_ID": "회사 ID",
        "Company_address": "회사 주소",
        "Invoice_email": "청구서 이메일",
        "Confirmation_email": "확인 이메일",
        "colorCodeBooking": "색상 코드",
        "ADMIN_ACCOUNT": "관리자 계정",
        "First_name": "이름",
        "Last_name": "성",
        "Commission": "수수료",
        "Required_fields": "필수 입력란",
        "Required_fields_crews": "참고: 새로운 크루 계정의 기본 암호는 \"\"12345678\"\"입니다",
        "Save": "저장",
        "Cancel": "취소",
        "Reset_password": "비밀번호 재설정",
        "Crew_Name": "승무원",
        "Created_Date": "생성 날짜",
        "Add_corporate_card": "항공사 카드 추가",
        "Corp_Users": "운영자",
        "Pricing_Default": "기본",
        "Pricing_Discount": "퍼센트 할인",
        "Markup_By_Percent": "퍼센트로 마크업",
        "Pricing_Add_different_rates": "다른 이율 추가",
        "ERROR_INPUT_COMPANYNAME": "회사 이름을 입력하십시오.",
        "ERROR_INPUT_USERNAME": "사용자 이름을 입력해 주세요.",
        "ERROR_INPUT_FIRSTNAME": "이름을 입력하십시오.",
        "ERROR_INPUT_EMAIL": "이메일을 입력해 주세요.",
        "ERROR_INPUT_VALID_EMAIL": "유효한 이메일 주소를 입력하십시오.",
        "ERROR_INPUT_VALID_NUMBER": "올바른 번호를 입력해 주세요",
        "ERROR_INPUT_VALID_RANGE_AMOUNT": "{0}과 {1} 사이의 값으로 입력해주세요.",
        "INFO_ADD_CORPORATE_SUCCESS": "계정 {0}이(가) 성공적으로 생성되었습니다.",
        "INFO_UPDATE_CORPORATE_SUCCESS": "정보가 성공적으로 업데이트되었습니다.",
        "INFO_UPDATE_PRICING_SUCCESS": "가격결정이 성공적으로 업데이트되었습니다.",
        "INFO_RESET_PASSWORD_SUCCESS": "계정 {0}이(가) 성공적으로 재설정되었습니다.",
        "COMFIRM_RESET_PASSWORD": "비밀번호를 재설정하시겠습니까?",
        "Traveler_signature": "여행자 서명",
        "Tracking_log": "추적 로그",
        "Rating": "등급",
        "Email_address": "이메일 주소",
        "Assistant_email": "보조 이메일",
        "Corp_PO": "회사 PO",
        "Cost_centre": "비용 센터",
        "Corp_division": "회사 부서",
        "Corp_id": "회사 id",
        "Department": "부서",
        "Manager_email": "관리자의 이메일",
        "Manager_name": "관리자의 이름",
        "Corporate_card": "항공사 카드",
        "Direct_invoicing": "직접 청구",
        "Corporate_Prepaid": "항공사 선불",
        "Cash": "현금",
        "Car_Type_ID": "차량 유형 ID",
        "App_Display_Name": "앱 표시 이름",
        "Normal_Fare": "일반",
        "Flat_Fare": "정액 요금",
        "Hourly_Daily_Rate": "시간/일별",
        "Delivery_Rate": "배달",
        "Assign_rate": "요금 할당",
        "Zone": "구역",
        "Rate": "요금",
        "Zone_Rate": "지역 - 요금",
        "Please_select_rate": "요금을 선택해 주세요",
        "Paid_by": "지불자",
        "Enter_new_credit_card": "새로운 신용카드 입력",
        "TOP_UP": "충전",
        "Top_up": "충전",
        "Topup_amount": "충전 금액",
        "Currency": "통화",
        "ERROR_INPUT_AMOUNT": "올바른 금액을 입력해주세요.",
        "VAT_number": "VAT 번호",
        "Gender": "성별",
        "Select_Gender": "선택",
        "Male": "남성",
        "Female": "여성",
        "Date_of_birth": "출생일",
        "Street_address": "거리 주소",
        "City": "도시",
        "State": "주",
        "Zip_code": "우편 번호",
        "Country": "국가",
        "adding_new_card": "%{zoneName} 지역에서 서비스를 이용하기 위해 새 카드를 추가하고 있습니다",
        "No_Support": "이 지역에서는 새로운 카드 추가가 현재 지원되지 않습니다",
        "Job_title": "직함",
        "required_phone_number_payment": "기업의 전화번호는 필수입니다. 계속하려면 프로필을 업데이트해 주세요.",
        "Yes": "예",
        "No": "아니오",
        "AddCardBeforeTopup": "신용카드를 찾을 수 없습니다. 계속하려면 새 카드를 추가해주세요."
    },
    "message": {
        "Add": "추가",
        "Delete": "삭제",
        "Items_per_page": "페이지 당 항목 수",
        "Page": "페이지",
        "Search_here": "여기에 검색",
        "Shown_Active": "{0} - {1} of {2} 표시됨",
        "Date": "날짜",
        "Subject": "제목",
        "To": "로",
        "Type": "유형",
        "Result": "결과",
        "Actions": "행동",
        "New_message": "새 메시지",
        "MESSAGE_DETAILS": "메시지 세부사항",
        "All": "모두",
        "Company": "회사",
        "Active": "활성",
        "In_Active": "비활성화",
        "In_Review": "검토 중",
        "Send_to": "보내기",
        "All_drivers": "모든 드라이버",
        "All_customers": "모든 고객",
        "All_merchants": "모든 판매자",
        "Customized_driver": "맞춤 드라이버",
        "Customized_customer": "맞춤 고객",
        "Customized_merchant": "맞춤 판매자",
        "Receiver_list": "받는 사람 목록",
        "Content": "내용",
        "Required_fields": "필수 입력란",
        "Search_driver_name_driver_phone_number": "드라이버 이름, 드라이버 전화번호 검색",
        "Search_category_name": "카테고리 이름 검색",
        "Search_customer_name_customer_phone_number": "고객 이름, 고객 전화번호 검색",
        "Search_merchant_name_merchant_phone_number": "판매자 이름, 판매자 전화번호 검색",
        "Search_car_type": "차량 타입 검색",
        "Searching": "검색 중...",
        "No_results": "결과 없음",
        "Send": "보내기",
        "Cancel": "취소",
        "SMS_failed_Inbox_succeeded": "SMS 실패, 인박스 성공",
        "Failed": "실패",
        "Succeeded": "성공",
        "CONFIRM_DELETE": "이 메시지를 삭제하시겠습니까?",
        "CONFIRM_DELETE_MULTI": "이 메시지들을 삭제하시겠습니까?",
        "ALERT_SELECT_DELETE": "삭제할 메시지를 선택해주세요.",
        "ERROR_INPUT_RECEIVERLIST": "메시지를 보낼 드라이버를 최소 한 명 선택해주세요.",
        "ERROR_INPUT_CUSTOMER_RECEIVERLIST": "메시지를 보낼 고객을 최소 한 명 선택해주세요.",
        "ERROR_INPUT_SUBJECT": "제목을 입력해주세요.",
        "ERROR_INPUT_CONTENT": "내용을 입력해주세요.",
        "ERROR_INPUT_LEAST_ONE_SUBJECT_CONTENT": "계속 진행하려면 최소 한 가지 언어를 설정해주세요.",
        "ERROR_INPUT_SUBJECT_MULTI_LANGUAGE": "{0} 언어에 대한 제목을 입력해주세요.",
        "ERROR_INPUT_CONTENT_MULTI_LANGUAGE": "{0} 언어에 대한 내용을 입력해주세요.",
        "ERROR_INPUT_URL_MULTI_LANGUAGE": "{0} 언어에 대한 URL을 입력해주세요.",
        "ERROR_INPUT_TITLE_MULTI_LANGUAGE": "{0} 언어에 대한 제목을 입력해주세요.",
        "ERROR_INPUT_BODY_MULTI_LANGUAGE": "{0} 언어에 대한 본문을 입력해주세요.",
        "import_fail_success_driver": "%{success} 드라이버(들)가 성공적으로 가져왔습니다, %{fail} 실패.",
        "import_fail_success_passenger": "%{success} 고객(들)이 성공적으로 가져왔습니다, %{fail} 실패.",
        "import_fail_success_merchant": "%{success} 판매자(들)가 성공적으로 가져왔습니다, %{fail} 실패.",
        "CONFIRM_SEND_SUCCESS": "당신의 메시지가 전송되었습니다. 이 작업은 몇분이 걸릴 수 있습니다. 시스템이 요청을 처리하는 동안 기다려주세요.",
        "Load_message_and_sms_fail": "메시지와 SMS 세부사항을 로딩하는 동안 에러가 발생하였습니다.",
        "Update_message_and_sms_fail": "메시지와 SMS 세부사항을 업데이트하는 동안 에러가 발생하였습니다.",
        "Update_message_and_sms_success": "메시지와 SMS 세부사항이 성공적으로 업데이트되었습니다.",
        "Driver_List": "운전자 목록",
        "Car_Type_List": "차량 타입 목록",
        "Search_vehicle_type_name": "차량 타입 이름 검색",
        "ALERT_PROCESSING_DELETE": "요청이 처리되고 있습니다. 이 작업은 몇 초 정도 걸릴 수 있습니다",
        "Customer": "고객",
        "Driver": "운전자",
        "StatusOfCustomer": "고객의 상태",
        "StatusOfDriver": "드라이버의 상태",
        "StatusOfMerchant": "판매자의 상태",
        "SendTo": "보내기",
        "DownloadReceiverList": "받는 사람 목록 다운로드",
        "warningInputChangeOver": "최근 두 입력 사이에 20% 이상 상대 변동이 있습니다. 고려해주세요!",
        "NoteDownloadReveverList": "1개월 후, 수신자 목록 다운로드가 비활성화됩니다.",
        "Load_voip_fail": "VOIP 세부사항을 로딩하는 동안 문제가 발생했습니다.",
        "Update_voip_success": "VOIP 세부사항이 성공적으로 업데이트되었습니다.",
        "Update_voip_fail": "VOIP 세부사항을 업데이트 하는 동안 문제가 발생했습니다.",
        "expiryDate": "새 사용자까지 보내기",
        "expiryDate_placeholder": "만료일 (mm/dd/yyyy)",
        "NA": "해당 없음",
        "PleaseSelectStatusOfDriver": "드라이버의 상태를 선택해주세요",
        "versionApp": "앱 버전",
        "platform": "플랫폼",
        "contentType": "콘텐츠 타입",
        "url": "URL",
        "title": "제목",
        "contentId": "ContentId",
        "body": "본문",
        "image_notification": "이미지",
        "platformItem": {
            "all": "모두",
            "iOS": "iOS",
            "android": "Android"
        },
        "comparisonVersionApp": {
            "is": "다음 중 하나임",
            "is_not": "다음 중 하나가 아님",
            "is_one_of": "다음 중 하나에 속함",
            "is_not_one_of": "다음 중 어느 것에도 속하지 않음",
            "greater_or_equal": "다음 이상",
            "less_or_equal": "다음 이하"
        },
        "contentTypeItem": {
            "html": "HTML",
            "link": "링크"
        },
        "Please_input": "이 필드는 필수입니다"
    },
    "fleetInfo": {
        "Fleet_name": "편대명",
        "Phone_number": "전화번호",
        "Email_address": "이메일 주소",
        "Country": "국가",
        "Time_zone": "시간대",
        "Address": "주소",
        "Website": "웹사이트",
        "Currency": "통화",
        "Distance_unit": "거리 단위",
        "Load_fleet_info_fail": "플릿 정보를 로딩하는 동안 오류가 발생했습니다"
    },
    "surchargePolicy": {
        "Surchage_Policy": "할증 정책",
        "SurgePolicy": "서지 정책",
        "surgeType": "서지 유형",
        "bookingTimeCoverage": "예약 시간 범위",
        "Delete_surcharge": "선택한 할증을 삭제하시겠습니까?",
        "Delete_surcharge_item": "선택한 할증 항목을 삭제하시겠습니까?",
        "Delete_surcharge_item_success": "할증이 성공적으로 비활성화되었습니다",
        "Delete_surcharge_item_fail": "할증 항목을 비활성화하는 동안 오류가 발생했습니다",
        "linkNewPolicy": "새로운 정책 링크",
        "Link": "링크",
        "ViewPolicy": "정책 보기",
        "Unlink": "연결 해제",
        "Create_Surcharge_Item_success": "할증 항목이 성공적으로 생성되었습니다",
        "Create_Surcharge_Item_fail": "할증 항목 생성 중 오류가 발생했습니다",
        "Update_Surcharge_Item_success": "할증 항목이 성공적으로 업데이트되었습니다",
        "Update_Surcharge_Item_fail": "할증 항목 업데이트 중 오류가 발생했습니다",
        "single": "단일 날짜",
        "yearly": "연간",
        "weekly": "요일",
        "Please_select_at_least_one_day": "최소한 하루를 선택해 주세요",
        "Booking_lead_time": "예약 리드 타임",
        "Start_date_must_be_before_end_date": "The start date must be before the end date"
    },
    "penaltyPolicy": {
        "penaltyPolicy": "벌금 정책",
        "Reservation": "예약",
        "onDemand": "즉시 요청",
        "noShow": "불참",
        "driverNoShow": "기사 불참",
        "freeCancellation": "무료 취소 버퍼",
        "fieldExclusions": "포함된 필드",
        "penaltyActive": "취소 기간 단계 - 픽업 시간 전",
        "penaltyType": "패널티 유형",
        "Compensation": "공급업체/운전자 보상",
        "Create_penalty_success": "패널티 템플릿이 성공적으로 생성되었습니다",
        "Create_penalty_fail": "패널티 템플릿 생성 중 오류가 발생했습니다",
        "Update_penalty_success": "패널티 템플릿이 성공적으로 업데이트되었습니다",
        "Update_penalty_fail": "패널티 템플릿 업데이트 중 오류가 발생했습니다",
        "confirmDelete": "삭제 확인",
        "confirmDeleteContent": "이 패널티 정책을 삭제하시겠습니까? 이 정책을 삭제하면 모든 예약 요금에서 연결이 해제됩니다.",
        "Delete_success": "패널티 템플릿이 성공적으로 삭제되었습니다",
        "Delete_fail": "패널티 템플릿 삭제 중 오류가 발생했습니다",
        "payoutPolicy": "지급 정책",
        "commission": "고객 패널티의 비율",
        "commissionPayout": "공급업체 지급의 비율",
        "fixAmount": "금액",
        "amount": "금액",
        "amount_driver": "금액",
        "percent": "퍼센티지",
        "percent_driver": "요금에 기반된 백분율",
        "basedOnPayout_driver": "지급액에 기반된 백분율",
        "percentPayout": "% 지급",
        "percentFare": "% 요금",
        "penaltyFee": "취소 수수료",
        "commissionType": "컴타입",
        "commissionFee": "보상",
        "tax": "세금",
        "techFee": "기술 요금",
        "minute": "분",
        "hour": "시간",
        "setDefaultSuccess": "기본 벌금 정책이 성공적으로 설정되었습니다",
        "setDefaultFail": "기본 벌금 정책 설정 중 오류가 발생했습니다"
    },
    "rateTemplates": {
        "Rate_Templates": "요금 템플릿",
        "newRate": "새 요금 템플릿",
        "placeHolderName": "요금 템플릿 이름 입력",
        "Assign_Rate": "요금 할당",
        "carTypeName": "Car Type Name",
        "appDisplayName": "앱 표시 이름",
        "assign_rate_success": "Car Type에 성공적으로 요금이 할당되었습니다",
        "assign_rate_fail": "요금 할당 중 오류가 발생했습니다",
        "confirmDeleteTitle": "삭제 확인",
        "confirmDelete": "이 템플릿을 삭제하시겠습니까? 이 템플릿 삭제 시 모든 파트너/법인과의 연결이 해제됩니다.",
        "setDefaultSuccess": "기본 요금 템플릿이 성공적으로 설정되었습니다",
        "setDefaultFail": "기본 요금 템플릿 설정 중 오류가 발생했습니다",
        "Delete_rate_template_success": "요금 템플릿이 성공적으로 삭제되었습니다",
        "Delete_rate_template_fail": "요금 템플릿 삭제 중 오류가 발생했습니다",
        "setDefault": "기본으로 설정",
        "Regular": "정규 요금",
        "Sharing": "스트리트 공유 요금",
        "Flat": "정액 요금",
        "Hourly": "시간/일별",
        "Delete_default": "기본 템플릿을 삭제하려고 시도하면 다른 기본 요금을 설정하도록 허용하지 않아야 합니다."
    },
    "supplierPlan": {
        "Supplier_Plan": "공급 계획",
        "rateTemplate": "요금 스키마",
        "rateTemplateNote": "운전자 또는 공급업체에 지불되는 금액을 결정하는 요금 계산.",
        "percent": "Fleet Commission",
        "percentNote": "각 예약에 대해 플릿이 청구하는 비율.",
        "amount": "고정 금액",
        "amountNote": "각 예약에 대해 플릿이 공제하는 금액.",
        "supplierPenaltyId": "공급업체 벌금 정책",
        "payoutType": "유형",
        "Select_penalty_policy": "패널티 정책 선택",
        "Select_corporate": "Corporate 선택",
        "Select_supplier_plan": "공급업체 플랜 선택",
        "Create_supplier_plan_success": "공급업체 플랜이 성공적으로 생성되었습니다",
        "Create_supplier_plan_fail": "공급업체 플랜 생성 중 오류가 발생했습니다",
        "Update_supplier_plan_success": "공급업체 플랜이 성공적으로 업데이트되었습니다",
        "Update_supplier_plan_fail": "공급업체 플랜 업데이트 중 오류가 발생했습니다",
        "Payout_Plan": "지급 플랜",
        "Payout_Plan_note": "공급업체가 지불 받는 금액을 설정하십시오.",
        "default": "기본",
        "custom": "맞춤 계획",
        "cannotSetPayout": "외부 파트너의 드라이버에 대한 지급 계획을 설정할 수 없습니다."
    },
    "stopSales": {
        "stopSales": "판매 중단",
        "confirm_delete": "이 정책을 삭제하시겠습니까?",
        "Create_stop_sales_success": "정지 판매가 성공적으로 생성되었습니다",
        "Create_stop_sales_fail": "정지 판매를 생성하는 동안 오류가 발생했습니다",
        "Update_stop_sales_success": "정지 판매가 성공적으로 업데이트되었습니다",
        "Update_stop_sales_fail": "정지 판매를 업데이트하는 동안 오류가 발생했습니다",
        "Delete_success": "정지 판매가 성공적으로 삭제되었습니다",
        "Delete_fail": "정지 판매를 삭제하는 동안 오류가 발생했습니다",
        "allVehicle": "모든 차량",
        "allZone": "모든 지역"
    },
    "generalSetting": {
        "alertNotifications": {
            "title": "알림",
            "emails": "이메일",
            "emailsPlaceholder": "이메일 입력",
            "slack": "슬랙 채널 (설명서)",
            "slackPlaceholder": "슬랙 POST URL",
            "discord": "디스코드 채널 (설명서)",
            "discordPlaceholder": "디스코드 채널 입력",
            "telegram": "텔레그램 채널 (설명서)",
            "telegramPlaceholder": "텔레그램 채널 입력"
        },
        "showFare": {
            "title": "운전사에게 요금 보여주기",
            "totalFare": "합계 요금",
            "estimateGross": "예상 총 수익"
        },
        "carHailing": "거리 헤일링",
        "regular": "일반",
        "cancelTimeout": "시간 초과 예약 자동 취소",
        "allowStripePaymentLink": "Stripe 결제 링크 생성 허용",
        "flat": "플랫",
        "techFee": "거래 당 기술비",
        "customizeLogo": "대시보드 로고 사용자 지정",
        "logo": "로고",
        "customerApp": "고객 앱",
        "hourly": "시간당",
        "shuttle": "셔틀",
        "parcel": "소포",
        "freeCancelTime": "하루 무료 취소 횟수",
        "AM": "오전",
        "PM": "오후",
        "RUSH_HOUR": "할증",
        "Name": "이름",
        "Date": "날짜",
        "Mon": "월",
        "Tue": "화",
        "Wed": "수",
        "Thu": "목",
        "Fri": "금",
        "Sat": "토",
        "Sun": "일",
        "Time_range": "시간 범위",
        "From": "에서",
        "To": "로",
        "Rush_hour_time_calculation": "할증시간 계산",
        "Rush_hour_surcharge": "할증",
        "Required_fields": "필수 입력란",
        "Save": "저장",
        "Cancel": "취소",
        "MDISPATCHER_CANCELLATION": "탑승객 / 파트너 / 웹 예약 취소",
        "Book_now": "지금 예약하기",
        "MDISPATCHER_CANCELLATION_TOOLTIP": "탑승객 / 파트너 / 웹 예약 취소",
        "Book_now_toolTip": "예약 즉시 취소시 취소 수수료가 적용됩니다",
        "Book_later_toolTip": "픽업 시간 전에 예약이 취소될 경우 취소 수수료가 부과됩니다",
        "Drv_Book_now_toolTip": "온디맨드 예약이 수락 시간 내에 취소되면 취소 수수료가 적용됩니다",
        "Drv_Book_later_toolTip": "예정된 픽업 시간 전에 사전 예약이 취소되면 취소 수수료가 적용됩니다",
        "Free_cancel": "무료 취소 기간",
        "Hide_cancel_btn": "설정된 시간 후 취소 버튼 숨기기",
        "Driver_cancellation": "운전자 취소",
        "Time_day": "하루 횟수",
        "Duration": "기간",
        "Times": "횟수",
        "Book_later": "나중에 예약",
        "Intercity": "도시 간",
        "Intercity_tooltip": "시외 예약이 예정된 픽업 시간 이전에 취소되면 취소 수수료가 적용됩니다.",
        "MDISPATCHER_NO_SHOW": "불참",
        "AIRPORT_FEE": "공항 요금",
        "From_airport": "공항 출발",
        "To_airport": "공항 도착",
        "MEET_DRIVER": "기사 만나기",
        "On_curb": "보도 위",
        "Meet_Greet": "만나러 가기",
        "Add": "추가",
        "Edit": "편집",
        "DELETE_SURCHARGE": "할증 삭제",
        "DELETE_SERVICE": "서비스 삭제",
        "CHANGE_APPLY_SERVICE_FEES": "서비스 요금 변경",
        "DELETE_CONFIRM": "이 항목을 삭제하시겠습니까?",
        "DELETE_SURCHARGE_CONFIRM": "선택한 할증을 삭제하시겠습니까?",
        "DELETE_ADDITIONAL_SERVICES_CONFIRM": "선택된 서비스를 삭제하시겠습니까?",
        "CHANGE_APPLY_SERVICE_FEES_CONFIRM_CUSTOM": "분리된 지역에 대해 다른 요금을 적용하시겠습니까?",
        "CHANGE_APPLY_SERVICE_FEES_CONFIRM_ALL": "모든 지역에 동일한 요금을 적용하시겠습니까?",
        "EDIT_SERVICE_FEES": "서비스 요금 편집",
        "EDIT_SERVICE_FEES_CONFIRM": "%{currentZone}에 대한 설정을 저장하지 않고 나가시겠습니까?",
        "HEAVY_TRAFFIC": "신호 대기",
        "Heavy_traffic_surcharge": "교통체증 할증",
        "TOLL_FEE": "통행료",
        "parkingFee": "주차 요금",
        "gasFee": "가스 요금",
        "OTHER_FEES": "다른 요금",
        "Can_edit": "편집 가능",
        "Can_add_note": "메모 추가 가능",
        "Other_fees_amount": "기타 수수료 금액",
        "TAX": "세금",
        "Tax_surcharge": "세금 할증",
        "TIP": "팁",
        "Default_tip": "기본 팁",
        "RESERVATION_REMINDER": "예약 알림",
        "Driver_app_SMS_alert_before": "드라이버 앱 - 출발 전 SMS 및 알림",
        "notifyWhenDriverFailStartTrip": "드라이버가 픽업 시간 전에 여행 시작에 실패하면 운영자에게 알림",
        "notifyWhenDriverFailStartTripTooltip": "알림은 플랫폼의 알림 섹션에 표시됩니다. 이메일, 슬랙, 디스코드, 텔레그램을 통해 적시에 업데이트를 받을 수 있도록 알림을 설정할 수도 있습니다.",
        "Pax_app_alert_before": "Pax 앱 - 출바전 알림",
        "Confirm_driver_info_via_email_before": "출발 전 고객에게 이메일 / sms 예약 확인 문자를 보내기",
        "Confirm_driver_info_via_email_before_hint": "시스템은 픽업 시간 이전에 설정한 시간에 기반하여 고객에게 예약 확인을 보냅니다.",
        "Show_request_tab_on_driver_app": "드라이버 앱에 '요청' 탭 표시",
        "Show_preferred_tab_on_driver_app": "드라이버 앱에 '선호' 탭 표시",
        "Sound_notification": "소리 알림",
        "Advance_information": "기업 사용자를 위한 선진 정보",
        "Load_general_fail": "일반 설정을 로드하는 동안 오류가 발생했습니다.",
        "Update_general_success": "일반 설정이 성공적으로 업데이트되었습니다.",
        "Update_general_fail": "일반 설정 업데이트 중 오류가 발생했습니다.",
        "Time_over_lap": "시간 범위는 서로 겹치지 않아야 합니다",
        "Allow_passenger_to_register_as_corp_traveler": "승객에게 기업 사용자로 등록하도록 허용",
        "Not_Allow_Make_Booking_Without_Assign_Fare": "요금 할당이 없는 경우 PWA 및 앱에서 차량 유형 보이지 않게 하기 (v4.6.60 이상)",
        "Not_Allow_show_car_type_on_cc": "요금 할당이 없는 경우 CC에서 차량 유형 보이지 않게 하기",
        "Disable_Direct_Invoicing_Receipt_Email": "직접 인보이스 수신 이메일 비활성화",
        "Additional_services": "추가 서비스",
        "Edit_additional_services": "추가 서비스 편집",
        "Service_Fee_By_Currencies": "서비스 요금",
        "Service_type": "서비스 유형",
        "Optional": "선택 사항",
        "Compulsory": "필수",
        "Vehicle_type": "차량 유형",
        "Adding_additional_service_success": "새로운 서비스가 성공적으로 생성되었습니다.",
        "Update_additional_service_success": "서비스가 성공적으로 업데이트되었습니다.",
        "Delete_additional_service_success": "서비스가 성공적으로 삭제되었습니다.",
        "Adding_additional_service_fail": "서비스 추가에 실패하였습니다.",
        "Update_additional_service_fail": "서비스 업데이트에 실패하였습니다.",
        "Other_settings": "기타 설정",
        "Operator_assign_error": "운영자를 할당하는 중 오류가 발생했습니다.",
        "Create_surcharge_success": "새로운 할증료가 성공적으로 생성되었습니다.",
        "Update_surcharge_success": "할증료가 성공적으로 업데이트되었습니다.",
        "Delete_surcharge_success": "할증료가 성공적으로 삭제되었습니다.",
        "Create_surcharge_fail": "할증료 생성에 실패하였습니다.",
        "Update_surcharge_fail": "할증료 업데이트에 실패하였습니다.",
        "Delete_surcharge_fail": "할증료 삭제에 실패하였습니다.",
        "Get_surcharge_detail_fail": "할증료 세부정보 불러오기에 실패하였습니다.",
        "Repeat": "반복",
        "DayOfWeek": "요일",
        "SingleDay": "단일 날짜",
        "Yearly": "연간",
        "Backup_phone_number": "백업 번호",
        "Backup_phone_number_hint": "운전자와 승객이 운영구역에서 벗어났을 때 이 번호로 직접 연결",
        "Apply_countdown_clock": "카운트다운 시계 적용",
        "No_show_duration_tooltip": "드라이버 앱에서 도착 버튼을 누른 후 NO Show 버튼이 표시될 시간 설정",
        "Limit_radius": "반경 제한",
        "Limit_radius_tooltip": "이 반경 내에서 드라이버는 예약을 No-show로 보고할 수 있습니다.",
        "Limit_radius_arrive_pickup": "운송 예약을 위해 드라이버 도착 및 픽업을 제한할 반경",
        "Booking_validation": "예약 유효성 검사",
        "Invalid_period_of_time": "유효하지 않은 시간 범위",
        "hide_Provider_Filter_From_Corporate_Board": "기업용 보드에서 공급자 필터 숨기기",
        "customer_email_is_optional": "승객 앱에서 고객의 이메일은 선택 사항입니다.",
        "disable_hourly_rate": "시간 당 요금과 교통 요금이 동시에 사용 가능할 때 시간 당 요금 사용 중지",
        "customer_gender_is_compulsory": "승객 앱에서 고객의 성별은 필수사항입니다.",
        "SHOW_MAP_STATUS": "지도 상태 표시",
        "Pay_to": "지불대상",
        "EMERGENCY_SOS": "긴급 SOS",
        "customer_address_is_compulsory": "승객 앱에서 고객의 주소는 필수입니다.",
        "customer_id_is_compulsory": "승객 앱에서 고객의 신분증#/국가 신분증#는 필수입니다.",
        "allowPassengerToUploadDocument": "승객이 신분증#/국가 신분증# 문서를 업로드하도록 허용",
        "compulsoryNationalIcDocumentInPaxApp": "승객 앱에서 고객의 신분증#/국가 신분증# 문서는 필수입니다.",
        "doNotAllowAddDriverWhenNationalIdDuplicated": "국가 신분증이 중복되면 운영자가 드라이버를 추가하는 것을 허용하지 마십시오.",
        "forceCustomerToUseLiveLocation": "고객에게 Live Location 사용을 강제하십시오",
        "disableMarketPlace": "새로운 드라이버에 대한 마켓 플레이스를 비활성화",
        "dontShowSecondStageImmediately": "2단계 가입 숨기기",
        "dontAddCarMM": "드라이버가 새 차량 제작 / 모델을 추가하는 것을 허용하지 않음",
        "dontEditCapability": "Do not allow Driver to edit Driver Capability",
        "compulsoryCarInsurance": "드라이버의 차량 보험증서는 필수입니다.",
        "marketPlace": "마켓 플레이스",
        "Enable": "활성화",
        "Disable": "비활성화",
        "showTotalFareWithoutPromotionOnDriverApp": "드라이버 앱에 프로모션 없는 총 요금 표시",
        "showTotalFareWithoutPromotionOnDriverApp_hint": "- 교통: 운전자가 결제를 하기 전에 이 설정을 적용합니다. <br/> - 배달 & 인터시티: 운전자가 작업을 시작하기 전에 이 설정을 적용합니다.",
        "hideFareOnPaxAppForAllCorporateBookings": "모든 기업 예약에 대한 Pax 앱에서 요금 숨기기",
        "hidePaxNameAvatarOnDispatchScreen": "여행 시작전에 드라이버 앱에서 고객 정보 숨기기",
        "showFullCustomerNameOnDriverApp": "드라이버 앱에서 고객의 전체 이름 표시",
        "hideDriverLogoutBtn": "드라이버 앱에 드라이버 로그아웃 버튼 숨기기",
        "showMeetAndGreetButtonForEveryBooking": "모든 예약에 대해 Meet & Greet 버튼 표시",
        "showEcontract": "E-계약 버튼 표시",
        "isShowConfirmationCode": "예약 확인 코드 표시",
        "showIncidentReportButton": "사건 버튼 표시",
        "inReviewStatus": "검토 중 상태",
        "inReviewStatusTooltip": "부킹을 “검토 중”으로 표시합니다. 여행은 운영자가 종료할 때까지 활성 상태를 유지합니다.",
        "incidentBtnDrvApp": "드라이버 앱에서 \"\"사건\"\" 버튼 표시",
        "incidentBtnDrvAppTooltip": "운전자가 사건을 보고할 수 있는 버튼을 활성 여행에 추가합니다. 이를 검토하고 닫을 수 있는 운영자가 됩니다.",
        "fareChangeTolerance": "요금 변경 허용",
        "fareChangeToleranceTooltip": "이 % 이상의 요금 변경이 운영자의 수동 승인을 필요로 합니다.",
        "groupManifest": "그룹 명단",
        "JobOrderedBy": "주문한 작업",
        "optional": "선택 사항",
        "pickupTime": "픽업 시간",
        "route": "경로",
        "settings": "설정",
        "Default_value": "기본 값",
        "limitTopupAmount": {
            "valueByCurrencies": "경고 금액",
            "minimumByCurrencies": "최소 충전 금액",
            "maximumByCurrencies": "최고 충전 금액",
            "title": "최소 및 최대 충전금액"
        },
        "driverApp": "드라이버 앱",
        "passengerApp": "승객 앱",
        "Default_Topup_Values": "기본 충전 값",
        "service_fees": "서비스 요금",
        "commission_fleet": "기본 카풀 위원회",
        "apply_all": "모든 운영 구역에 대해 동일합니다.",
        "apply_custom_zone": "모든 운영 지역간 차별화",
        "apply": "적용",
        "tollFeeDriverCanInput": "운전자가 입력할 수 있는 제한 금액",
        "unlimited": "무제한",
        "limited": "제한",
        "sameFee": "동일한 요금",
        "customizedAirportfee": "맞춤형 공항 요금",
        "noteAirportFeeModal": "참고: 공항 요금은 목록에 있는 공항에만 적용됩니다.",
        "intercity_schedule_trip_time_range": "예약 시간의 연대 순서를 유지하기 위해, 선호/요청 여행의 시간 범위가 일정 여행보다 더 크도록 확인하십시오",
        "airportFee": {
            "tooltipApply": "기본 공항 요금이 기본적으로 각 공항 출발/도착 여행에 적용됩니다. 공항 요금이 맞춤 설정된 경우 해당 장소에 대한 새 요금이 적용됩니다.",
            "titleSearchAiportZone": "공항을 검색하고 요금을 추가하십시오",
            "airport": "공항",
            "currency": "통화",
            "fromAirportFee": "공항 출발 요금",
            "toAirportFee": "공항 도착 요금",
            "action": "행동"
        },
        "Yes": "예",
        "No": "아니오",
        "tipPaymentMethod": "주문 후 고객이 운전사에게 팁을 줄 수 있는 결제 수단",
        "allowPaxUpdateTip": "여행 중에 승객이 팁 퍼센트를 업데이트하게 허용",
        "tipDefaultValues": "여행 후 팁에 대한 기본값",
        "creadit": "신용카드 (개인 카드 / 법인 카드)",
        "wallet": "지갑",
        "tnGeWallet": "TnG 전자지갑",
        "vippseWallet": "Vipps",
        "DurationRegularBooking": "무료 대기 시간",
        "googlePay": "Google Pay",
        "applePay": "Apple Pay",
        "DurationRegularBookingToolTip": "이것은 운전자가 고객을 기다리는 무료 대기 시간의 기간입니다. 그들은 무료 대기 시간이 경과할 때까지 예약을 불출석으로 표시할 수 없습니다.",
        "noShowCountDown": {
            "customizedNoShow": "특정 위치에 대한 맞춤 설정 (예: 공항 ...)",
            "customizedNoShowTitle": "특정 위치 (예: 공항 ...)에 대해 쇼없음 카운트 다운 기간 적용"
        },
        "maxWaitTime": "최대 추가 대기 시간",
        "maxWaitTimeToolTip": "이것은 고객에게 부과될 최대 추가 대기 시간입니다. 요금 설정에서 분당 요금을 맞춤 설정할 수 있습니다.",
        "maxWaitTimePlaceholder": "최대 대기 요금",
        "HEAT_MAP": "히트맵",
        "heatMap": {
            "defaultMode": "기본 모드",
            "radius": "반경",
            "intensity": "강도",
            "opacity": "불투명도",
            "requestedBookings": "요청된 예약",
            "activePassengers": "활동 중인 승객",
            "completedBookings": "완료된 예약",
            "timeoutBookings": "시간이 초과된 예약",
            "tooltipRadius": "각 데이터 지점의 영향 반경, 픽셀로 표시.",
            "tooltipIntensity": "히트맵의 최대 강도.",
            "tooltipOpacity": "히트맵의 불투명도, 0과 1 사이의 숫자로 표현된다."
        },
        "schedule_trip": "일정 여행",
        "driver_starts_trip_before_set_time": "운전자가 설정된 시간 전에 여행을 시작함",
        "request_trip": "요청 여행",
        "preferred_trip": "선호 여행",
        "time_range": "요청 및 선호 여행에 대한 시간 범위",
        "working_time": "근무 시간",
        "hour": "시간",
        "hours": "시간",
        "minutes": "분",
        "indicate_pickup_time_in_advance_to_customer": "고객에게 미리 픽업 시간을 알립니다.",
        "customers_can_select_start_time_and_request_intercity_trip": "고객은 시작 시간을 선택하고 도시간 여행을 요청할 수 있습니다. 또한 운전기사도 자신의 일정에 따른 선호 여행을 생성할 수 있습니다. 예시: 1시간의 시간 범위는 고객과 운전기사가 8:00 am - 9:00 am, 9:00 am - 10:00 am 또는 10:00 am - 11:00 am에 시작하는 도시 간 여행을 생성할 수 있게 합니다.",
        "this_setting_limits_customers_to_create_request_trip_within_working_hours_only": "이 설정은 고객이 근무 시간 내에서만 요청 여행을 생성할 수 있도록 제한합니다.",
        "face_mask_verify": "마스크 검증",
        "faceMask_allZones": "모든 지역",
        "faceMask_customized": "맞춤형 지역",
        "turn_on_verify": "검증을 켜십시오",
        "force_to_wear_face_mask": "마스크를 강제로 착용하게 하십시오",
        "time_range_to_verify": "다시 검증하지 않음",
        "customizedFaceMaskZone": "맞춤형 마스크 검증",
        "zoneOperation": "운영 지역",
        "FaceMaskCustomized": "맞춤설정",
        "time": "시간",
        "day": "일",
        "days": "일",
        "allow_driver_to_skip_verification_after": "검증 후 운전사가 건너뛸 수 있도록 허용",
        "driver_need_to_verify": "운전사가 검증해야 하는 시기",
        "open_app": "앱 열기",
        "start_reservation": "예약 시작",
        "choose_at_least_one": "계속하려면 적어도 하나의 동작을 선택해야 합니다.",
        "face_mask_customized_fail": "계속하려면 적어도 하나의 동작을 선택해야 합니다. ({0}).",
        "vehicleAgeLimit": "차량 연령 제한",
        "vehicleAgeLimit_years": "년",
        "founderFund_firstBooking": "창업자의 기금: 첫 예약만",
        "distance_diversity": "거리 다변화",
        "Add_Surcharge_Distance": "추가",
        "from": "에서",
        "to": "로",
        "surchargeValue": "할증",
        "actions": "동작",
        "please_enter_distance_range_valid": "거리 %{name}은 유효하지 않습니다!",
        "please_enter_distance_to": "거리 \"\"까지\"\"를 입력하십시오",
        "please_enter_surchargeValue": "거리 범위 %{name}에 대한 거리 \"\"할증료\"\"를 입력하십시오,",
        "please_enter_surchargeValue_is_number": "거리 범위 %{name}에 대한 유효한 숫자 \"\"할증료\"\"를 입력하십시오,",
        "Update_service_fee_success": "서비스 요금이 성공적으로 업데이트되었습니다",
        "Update_service_fee_fail": "서비스 요금을 업데이트하는 동안 오류가 발생했습니다",
        "Update_fleet_commission_success": "기본 편대 커미션이 성공적으로 업데이트되었습니다",
        "Update_fleet_commission_fail": "기본 편대 커미션을 업데이트하는 동안 오류가 발생했습니다",
        "RESERVATION_POLICY": "예약 정책",
        "default_expected_pickup_time": "기본 예상 픽업 시간",
        "default_expected_pickup_time_hint": "운전자가 픽업 시간에서 도착할 것으로 예상하는 기본값.",
        "same_original_pickup_time": "원래 픽업 시간과 동일",
        "quarter_before": "15분 전",
        "half_before": "30분 전",
        "quarter_after": "15분 후",
        "half_after": "30분 후",
        "custom": "맞춤",
        "min_before": "분 전",
        "min_after": "분 후",
        "TransactionFee": "거래 수수료",
        "creditCardPercent": "신용카드/ 선불",
        "directBilling": "직접 청구",
        "externalCard": "외부 카드",
        "zoneIds": "위치",
        "vehicles": "차량",
        "default_expected_pickup_time_airport": "기본 예상 픽업 시간 (공항 도착)",
        "expectedPickupTooltip": "비행 번호가 제공되면 이 기본 버퍼를 적용하여 픽업 시간을 자동으로 계산합니다. 이는 관리용 대시보드를 통해 생성된 예약에만 적용됩니다."
    },
    "social": {
        "pax_app": "승객 앱",
        "driver_app": "드라이버 앱",
        "default": "기본",
        "customized": "맞춤설정",
        "html": "HTML",
        "about": "소개",
        "email": "이메일 지원",
        "enablePhone": "전화번호",
        "phone": "",
        "policy": "개인정보 보호정책 링크",
        "termOfUse": "이용 약관 링크",
        "site": "웹사이트",
        "logoDriverIOS": "로고 - IOS",
        "logoDriverAndroid": "로고 - Android",
        "htmlUrl": "HTML 파일",
        "Update_fail": "소셜 업데이트 중 오류가 발생했습니다",
        "Update_success": "소셜이 성공적으로 업데이트되었습니다"
    },
    "user": {
        "Show_per_page": "페이지 당 항목 수",
        "Page": "페이지",
        "Search_here": "여기에 검색",
        "show_pages": "{0} - {1} of {2} 표시됨",
        "Username": "사용자 이름",
        "Name": "이름",
        "Phone_number": "전화번호",
        "Email": "이메일",
        "Permission": "허가",
        "Status": "상태",
        "Actions": "행동",
        "Active": "활성",
        "Inactive": "비활성화",
        "Edit": "편집",
        "Deactivate": "비활성화",
        "Delete": "삭제",
        "Add": "추가",
        "ADD_USER": "사용자 추가",
        "First_name": "이름",
        "Last_name": "성",
        "AgendId": "사용자 번호",
        "Email_address": "이메일 주소",
        "Address": "주소",
        "Required_fields": "필수 입력란",
        "Save": "저장",
        "Cancel": "취소",
        "EDIT_USER": "사용자 수정",
        "Yes": "예",
        "DELETE_USER": "사용자 삭제",
        "DETAIL_USER": "사용자 상세",
        "DELETE_CONFIRM": "선택한 사용자를 삭제하시겠습니까?",
        "Update_user_fail": "사용자 업데이트 중 오류가 발생했습니다",
        "Update_user_success": "사용자가 성공적으로 업데이트되었습니다",
        "Create_user_fail": "사용자를 생성하는 동안 오류가 발생했습니다",
        "Create_user_success": "계정 {0}이(가) 성공적으로 생성되었습니다. 로그인 자격증명 상세 정보는 이메일 {1}을 참고해주십시오.",
        "Load_user_fail": "사용자 로딩 중 오류가 발생했습니다",
        "Update_user_status_fail": "사용자 상태 업데이트 중 오류가 발생했습니다",
        "Delete_user_fail": "사용자를 삭제하는 동안 오류가 발생했습니다",
        "Delete_user_success": "사용자가 성공적으로 삭제되었습니다",
        "CONFIRM_RESET_PASSWORD": "비밀번호를 재설정하시겠습니까?",
        "RESET_PASSWORD": "비밀번호를 재설정하시겠습니까?",
        "Reset_password": "비밀번호 재설정",
        "Select_permission": "권한 선택",
        "Reset_password_success": "비밀번호 성공적으로 재설정"
    },
    "report": {
        "query": {
            "errorMessage": {
                "bookFrom": "예약 시작 날짜를 선택하십시오",
                "paymentMethod": "결제 방법을 선택해 주세요",
                "bookingType": "예약 유형을 선택하십시오",
                "ratingType": "등급 유형을 선택하십시오",
                "stars": "등급 유형을 선택하십시오",
                "type": "유형",
                "transactionType": "거래 유형을 선택하십시오",
                "serviceType": "서비스 유형을 선택하십시오",
                "rideService": "라이딩 서비스를 선택하십시오",
                "invalidEmail": "유효한 이메일 주소를 입력하십시오."
            },
            "search": {
                "driverReferalPax": "검색: 드라이버 이름, 전화 번호",
                "passengerRefersPassengers": "검색: 고객 이름, 전화 번호",
                "driverReferalPaxDetail": "검색: 승객 이름",
                "bookingDetails": "검색: 예약 ID, 운영자, 고객 전화, 고객 이름, 드라이버 이름, ID# / 국가 ID#, 차량번호, 대기 구역, 메모, 여행, 지원 ID",
                "financial": "검색: 드라이버 이름, 전화",
                "completedTime": "완료 시간",
                "collectedTime": "수집 시간",
                "financialDriver": "검색: 예약 ID, 드라이버 이름, ID# / 국가 ID#",
                "carActivity": "검색: 차량 번호판",
                "affiliation": "검색: 예약 ID",
                "prepaidTopUp": "검색: 회사 이름, 충전 ID, 거래 ID",
                "operatorLogs": "검색: 운영자 이름, 사용자 이름, 설명",
                "corporate": "검색: 예약 ID, 드라이버 이름, 법인 사용자, 고객 케이스 문제, 충전 코드",
                "bookingLogs": "검색: 예약 ID, 고객 이름, 지원 ID, 드라이버 이름, ID# / 국가 ID#",
                "rating": "검색: 예약 ID, 고객 전화, 고객 이름, 번호판 번호",
                "mDispatcher": "검색: 예약 ID, 파트너 이름",
                "totalAdjustment": "검색: 예약 ID",
                "incidentCancellation": "검색: 예약 ID, 고객 전화, 지원 ID, 고객 이름",
                "acceptanceCancellationRate": "검색: 드라이버 이름, 전화 번호",
                "revenueDriver": "검색: 드라이버 이름",
                "dailyDriver": "검색: 드라이버 전화, 드라이버 이름, ID# / 국가 ID#",
                "dailyCar": "검색: 차량 번호판, 허가",
                "dailyDriverCar": "검색: 드라이버 전화, 드라이버 이름, ID# / 국가 IC#, 차량 번호판",
                "driverLoginStatus": "검색: 드라이버 전화, 드라이버 이름, ID# / 국가 IC#, 차량 번호판",
                "bookingSummary": "검색: 운영자 이름, 사용자 이름, 예약 ID",
                "creditWallet": "검색: 회사 이름, 드라이버 이름, 예약 ID, 거래 ID, 운영자",
                "cashWallet": "검색: 회사 이름, 드라이버 이름, 예약 ID, 전화 번호",
                "SupplierWallet": "검색: 회사 이름, 예약 ID",
                "settlement": "검색: 드라이버 이름, ID# / 국가 IC#",
                "driverRating": "검색: 예약 ID, 고객 전화, 고객 이름, 번호판 번호, 지원 ID",
                "driverWithdrawal": "드라이버 이름, 전화, 회사, 거래 ID, 참조 #",
                "penaltyCompensation": "검색: 예약 ID, 드라이버 이름, 승객 이름",
                "incompletePayment": "검색: 예약 ID, 지원 ID, 고객 이름",
                "passengerWallet": "검색: 예약 ID, 거래 ID, 고객 이름",
                "driverDeposit": "검색: 회사 이름, 드라이버 이름, 예약 ID, 운영자",
                "refund": "검색: 예약 ID, 여행 Id, 지원 ID, 고객 이름",
                "driverRefersCustomerBookings": "검색: 추천 코드, 지원 ID",
                "driverHistory": "검색: 지급 ID",
                "merchantHistory": "검색: 지급 ID",
                "firstWillWin": "검색: 고객 이름, 고객 전화, 고객 ID",
                "firstWillWinDriver": "검색: 드라이버 이름, 드라이버 전화, 사용자 이름",
                "merchant": "검색: 매장",
                "merchantCashTransactionHistory": "검색: 예약 ID, 거래 ID, 상인 이름",
                "merchantCreditTransactionHistory": "검색: 예약 ID, 거래 ID, 상인 이름",
                "deleteAccountRequest": "검색: 전화",
                "affiliationPayoutHistory": "검색: 지급 ID",
                "thirdPartyBooking": "검색: 예약 Id, 외부 Id"
            },
            "common": {
                "all": "모두"
            },
            "today": "오늘",
            "sendDownloadLink": "수신자 이메일 주소",
            "generaltingYourExcel": "참고하십시오, 귀하의 엑셀 파일을 생성하는 데 시간이 걸릴 수 있습니다. 준비가 되는 대로 이메일로 보내드리겠습니다.",
            "messageSuccess": "파일이 진행 중입니다. 준비가 되면 이메일을 받게 됩니다. 보고서/내보내기 기록에서 진행 상황을 추적하거나 직접 다운로드하십시오",
            "thisMonth": "이번 달",
            "lastMonth": "지난달",
            "past30Days": "지난 30일",
            "thisYear": "올해",
            "custom": "맞춤",
            "customize": "사용자 지정",
            "thisWeek": "이번 주",
            "past7Days": "지난 7일",
            "weekly": "주간",
            "monthly": "월간",
            "allTime": "모든 시간",
            "tomorrow": "내일",
            "nextWeek": "다음 주",
            "lastWeek": "지난 주",
            "nextMonth": "다음 달",
            "next7Day": "다음 7일",
            "yesterday": "어제",
            "fromDate": "시작일",
            "toDate": "종료일",
            "driver": "드라이버: %{name}",
            "customer": "고객: %{name}",
            "referralCode": "추천 코드: %{name}",
            "referer": "추천인: %{name}",
            "referee": "추천받은 사람: %{name}",
            "usedPromoCode": "프로모션: %{name}",
            "voucherCode": "코드: %{name}",
            "city": "도시",
            "company": "회사",
            "company_report": "회사: %{name}",
            "companySupplier_report": "공급업체/회사: %{name}",
            "supplier_report": "공급업체: %{name}",
            "corporate_report": "기업: %{name}",
            "campaign_report": "캠페인: %{name}",
            "operator": "운영자",
            "farmType": "농장 유형",
            "carLicensePlate": "자동차 번호판: %{name}",
            "settlementType": "유형",
            "bookingService": "네트워크 유형",
            "payoutOption": "지불 옵션",
            "currency": "통화",
            "bookingFrom": "에서 예약",
            "Provider": "공급자",
            "thirdPartyAction": "동작",
            "paymentMethod": "결제 방법",
            "paymentStatus": "결제 상태",
            "bookingType": "예약 유형",
            "adjustPrice": "가격 조정",
            "intercityRoute": "도시간 루트",
            "ratingType": "등급 유형",
            "stars": "등급",
            "driverRating": "드라이버 등급",
            "vehicleRating": "차량 등급",
            "mDispatcherType": "파트너 유형",
            "mDispatcher": "파트너 이름",
            "campaign": "캠페인",
            "promocode": "프로모션 코드",
            "canceledBy": "취소한 사람",
            "timezone": "시간대",
            "month": "월",
            "year": "년도",
            "view": "보기",
            "action": "동작",
            "status": "상태",
            "module": "모듈",
            "driverType": "유형",
            "vehicleType": "차량 유형",
            "serviceType": "서비스 유형",
            "expireDate": "만료일",
            "rideSharing": "라이드 공유",
            "rideService": "라이드 서비스",
            "transactionType": "거래 유형",
            "completeFromCC": "CC에서 완료",
            "withDrawalTransactionType": "거래 유형",
            "bookingStatus": "예약 상태",
            "withdrawalStatus": "상태",
            "originalStatus": "원래 결제 상태",
            "currentStatus": "현재 결제 상태",
            "tip": "팁",
            "type": "유형",
            "userType": "사용자 유형",
            "eventType": "이벤트 유형",
            "eventState": "이벤트 상태",
            "eventName": "이벤트 이름",
            "merchantType": "상인 유형",
            "merchantService": "상인 서비스",
            "storeName": "상점",
            "merchant": "상인",
            "event": "이벤트 이름: %{name}",
            "store": "상점 이름: %{name}",
            "selectedMerchant": "상인: %{name}",
            "associatedApps": "관련 앱들",
            "settlement": "결산",
            "rideServiceItem": {
                "all": "모두",
                "regulation": "규제",
                "rideSharing": "라이드 공유"
            },
            "actionItem": {
                "all": "모두",
                "login": "로그인",
                "logout": "로그아웃",
                "bookIn": "사용 가능",
                "bookOff": "사용 불가능",
                "deny": "거부",
                "ignore": "무시",
                "accept": "수락",
                "startTrip": "가는 중",
                "updateBooking": "업데이트",
                "arrive": "도착",
                "pickup": "픽업",
                "drop": "하차",
                "complete": "완료",
                "noShow": "불참",
                "driverNoShow": "기사 불참",
                "rqJob": "배차 중",
                "cancel": "취소"
            },
            "loginStatusItem": {
                "all": "모두",
                "online": "로그인 중",
                "offline": "미로그인"
            },
            "payoutType": "지불 유형",
            "affiliationPayoutTypeItem": {
                "auto": "자동 지불",
                "manual": "수동 지불"
            },
            "affiliationSettlementItem": {
                "payable": "지급 가능",
                "receivable": "수급 가능"
            },
            "affiliationPaymentMethod": {
                "online": "온라인",
                "directInvoicing": "직접 청구"
            },
            "payoutPaymentStatusItem": {
                "paid": "지불됨",
                "pending": "대기 중"
            },
            "farmTypeItem": {
                "all": "모두",
                "farmIn": "Farm In",
                "farmOut": "Farm Out",
                "roaming": "로밍",
                "affiliationOwner": "제휴 주인",
                "farmInAndAffiliationOwner": "내부 경영 및 제휴 주인",
                "farmOutAndAffiliationOwner": "외부 경영 및 제휴 주인"
            },
            "settlementDriverTypeItem": {
                "all": "모든 드라이버",
                "individual": "회사 차량"
            },
            "shortTrip": {
                "all": "모두",
                "shortTrip": "단거리 여행",
                "nonShortTrip": "짧지 않은 여행"
            },
            "paymentMethodItem": {
                "B2BTerminal": "B2B터미널",
                "webBooking": "웹 예약",
                "pendingPayment": "미결제",
                "all": "모두",
                "cash": "현금",
                "cashBySender": "발송자에 의한 현금",
                "cashByRecipient": "수신자에 의한 현금",
                "personalCard": "개인 카드",
                "corporateCard": "기업 카드",
                "qrCodePayment": "QR 코드 결제",
                "directBilling": "직접 청구",
                "externalCard": "외부 카드",
                "mDispatcherCard": "파트너 카드",
                "corporatePrepaid": "기업 선불",
                "canceled": "취소",
                "noShow": "불참",
                "driverNoShow": "기사 불참",
                "incident": "사건",
                "fleetCard": "외부 카드",
                "applePay": "Apple Pay",
                "creditCardExternal": "신용 카드",
                "paxWallet": "지갑",
                "tngeWallet": "TnG 전자지갑",
                "vippseWallet": "Vipps",
                "zainCash": "ZainCash",
                "xendit": "Xendit",
                "exAlipay": "Alipay",
                "FIB": "FIB",
                "SantimPay": "SantimPay",
                "gCash": "GCash",
                "completedWithoutService": "운전자 없이 완료",
                "BankOfGeorgia": "조지아 은행",
                "partialCompleted": "부분 완료",
                "failed": "실패",
                "googlePay": "Google Pay",
                "paymentLink": "결제 링크",
                "easyPaisa": "Easy Paisa",
                "jazzCash": "재즈 캐시",
                "samsung_pay": "삼성 페이",
                "kakao_pay": "카카오 페이",
                "naver_pay": "네이버 페이",
                "wechat_pay": "위챗 페이",
                "alipay": "Alipay",
                "paynow": "PayNow",
                "grabpay": "GrabPay",
                "cashapp": "Cash App Pay"
            },
            "paymentStatusItem": {
                "all": "모두",
                "fullPayment": "전액 결제",
                "partialPayment": "부분 결제",
                "pendingPayment": "미결제",
                "partialRefund": "부분 환불",
                "fullRefund": "전액 환불"
            },
            "companySettlementTypeItem": {
                "all": "모두",
                "fleetOweCompany": "플릿이 회사에 빚",
                "companyOweFleet": "회사가 플릿에 빚"
            },
            "bookingStatusItem": {
                "all": "모두",
                "completed": "완료",
                "incident": "사건",
                "paxNoShow": "승객 불참",
                "driverNoShow": "운전자 불참",
                "rejected": "거절됨",
                "canceledByTimeOut": "시간 초과로 인해 취소됨",
                "canceledByTimeOutRejected": "시간초과에 의한 취소 (거절됨)",
                "canceledByBookingBoard": "예약판에서 취소",
                "canceledByCustomer": "고객에 의한 취소",
                "canceledBySupplier": "공급업체에 의한 취소"
            },
            "bookingFromItem": {
                "all": "모두",
                "paxApp": "승객 앱",
                "mDispatcher": "파트너",
                "kiosk": "키오스크",
                "cc": "커맨드 센터",
                "webBooking": "웹 예약",
                "carHailing": "차량 호출",
                "streetSharing": "스트리트 공유",
                "dashboard": "예약 보드",
                "corp": "예약 보드 (CTM)",
                "dmc": "예약판 (DMC)",
                "Boost_web_link": "부스트 웹 링크"
            },
            "thirdPartyActionItem": {
                "all": "모두",
                "searched": "검색됨",
                "allocated": "배정됨",
                "updated": "업데이트됨",
                "cancelled": "취소됨"
            },
            "bookingTypeItem": {
                "batchDelivery": "배차 배송",
                "all": "모두",
                "now": "지금 (운송)",
                "reservation": "예약 (운송)",
                "intercity": "도시 간",
                "delivery": "배달",
                "shuttle": "셔틀"
            },
            "adjustPrices": {
                "all": "모두",
                "normalPrice": "일반 가격",
                "addonPrice": "추가 가격"
            },
            "bookingServiceItem": {
                "all": "모두",
                "roaming": "로밍",
                "homeFleet": "Farm Out",
                "localBooking": "내부",
                "farmIn": "Farm In",
                "farmInAndAffiliationOwner": "팜 인 & 제휴 소유자",
                "provideService": "Farm In"
            },
            "ratingTypeItem": {
                "all": "모두",
                "like": "좋아요",
                "dislike": "싫어요"
            },
            "starsItem": {
                "all": "모두",
                "star1": "1 별",
                "star2": "2 별",
                "star3": "3 별",
                "star4": "4 별",
                "star5": "5 별"
            },
            "incidentCanceledTypes": {
                "all": "모두",
                "incident": "사건",
                "canceled": "취소"
            },
            "canceledByItem": {
                "all": "모두",
                "CorpAD": "기업 관리자",
                "passenger": "승객",
                "driver": "운전자",
                "merchant": "상인",
                "CC": "CC",
                "mDispatcher": "파트너",
                "Partner": "파트너",
                "webBooking": "웹 예약",
                "timeout": "시간초과"
            },
            "incidentStatusItem": {
                "RESOLVED": "해결됨",
                "DISPUTED": "분쟁 중"
            },
            "bookingSummaryActionItem": {
                "all": "모두",
                "create": "생성",
                "update": "업데이트",
                "cancel": "취소",
                "complete": "완료",
                "incident": "사건"
            },
            "transactionTypeItem": {
                "DriverFees": "Driver Fees",
                "bookingAdjustment": "예약 조정",
                "bankAccount": "은행 계좌로 이체",
                "sentToCustomer": "고객에게 전송",
                "receivedFromDriver": "운전자로부터 받음",
                "sentToDriver": "운전자에게 전송",
                "creditWallet": "신용 지갑으로 이체",
                "netEarning": "순수익",
                "referralEarning": "추천 수익",
                "all": "모두",
                "topUp": "충전",
                "editBalance": "잔액 편집",
                "bookingDeduction": "예약 감액",
                "bookingPromo": "예약 프로모션",
                "topUpGCash": "GCash로 충전",
                "cashWallet": "현금 지갑",
                "topUpMOLPay": "Razer Pay로 충전",
                "topUpQRIS": "QRIS로 상품권 충전",
                "topUpZainCash": "ZainCash로 충전",
                "topUpXendit": "Xendit로 충전",
                "topUpalipayExternal": "Alipay로 충전",
                "topUpFIB": "FIB로 충전",
                "topUpSantimPay": "SantimPay로 충전",
                "topUpTelebirr": "Telebirr로 충전",
                "topUpKsher": "Ksher로 충전",
                "topUpWallet": "{0}로 충전",
                "TnG": "TnG로 충전",
                "credit": "신용카드로 충전",
                "ride": "탑승",
                "tipAfterCompleted": "탑승 후 팁",
                "debtWriteOff": "채무 삭감",
                "refund": "환불",
                "excessOffsetAmount": "과도한 현금 신용",
                "excessDeductionAmount": "과도한 현금 차감",
                "cashExcess": "과도한 현금 차감",
                "gateway": "게이트웨이에서 충전",
                "driverTopUpForPax": "과도한 현금 차감",
                "updatedBalance": "잔액 업데이트",
                "partialEarning": "수익",
                "payout": "지급",
                "payoutManual": "수동 지급",
                "payoutDriver": "지급",
                "itemValue": "항목 값",
                "redeemVoucher": "코드 # 사용",
                "topUpReferrer": "추천 보상",
                "driverInsurance": "운전자 보험",
                "cancellationPenalty": "취소 벌금",
                "WingBank": "Wingbank 계정으로 이체",
                "customerDebt": "고객 채무",
                "googlePay": "Google Pay로 충전",
                "applePay": "Apple Pay로 충전",
                "samsung_pay": "Samsung Pay로 충전",
                "kakao_pay": "Kakao Pay로 충전",
                "naver_pay": "Naver Pay로 충전",
                "wechat_pay": "WeChat Pay로 충전",
                "alipay": "Alipay로 충전",
                "paynow": "PayNow로 충전",
                "grabpay": "GrabPay로 충전",
                "cashapp": "Cash App Pay로 충전",
                "merchantCommission": "판매자 수수료",
                "eWallet": "외부 전자지갑으로 이체",
                "reversed": "출금취소",
                "driverNoShow": "기사 불참",
                "noShowPenalty": "기사 불참",
                "bookingEarning": "순수익"
            },
            "moduleItem": {
                "all": "모두",
                "bookings": "예약",
                "customers": "고객",
                "dispatch": "발송",
                "general": "일반",
                "promotion": "프로모션",
                "quest": "퀘스트",
                "rate": "요금",
                "car": "차량",
                "city": "도시",
                "company": "회사",
                "drivers": "운전자",
                "driverSettlement": "운전자 결제",
                "login": "로그인",
                "logout": "로그아웃",
                "mDispatcher": "파트너",
                "mDispatcherType": "파트너 유형",
                "operation": "운영",
                "partners": "파트너",
                "permission": "허가",
                "queuingArea": "대기 영역",
                "report": "보고서",
                "shift": "교대",
                "user": "사용자",
                "voiceSms": "음성 & SMS",
                "intercityZone": "지역 (시외)",
                "Payout": "지급",
                "code#": "코드 #",
                "ApiManagement": "API 관리"
            },
            "serviceTypeItem": {
                "all": "모두",
                "oneWay": "편도",
                "fromAirport": "공항 출발",
                "toAirport": "공항 도착",
                "hourly": "시간/일당제",
                "roundTrip": "왕복",
                "fromAirportHourlyDaily": "공항 출발 - 시간/일당제",
                "fromAirportRoundTrip": "공항 출발 - 왕복",
                "toAirportHourlyDaily": "공항 도착 - 시간/일당제",
                "toAirportRoundTrip": "공항 도착 - 왕복"
            },
            "merchantTransactionTypeItem": {
                "all": "모두",
                "editBalance": "잔액 편집",
                "payout": "지급",
                "earning": "수익",
                "itemValue": "품목 가치",
                "orderDeduction": "주문 공제"
            },
            "withdrawalTransactionType": {
                "WingBank": "Wingbank 계좌로 이체",
                "bankAccount": "은행 계좌로 이체",
                "cashWallet": "현금 지갑으로 이체",
                "creditWallet": "신용 지갑으로 이체"
            },
            "payoutDriver": {
                "driversHaveBankAccount": "운전자는 은행 계좌를 가지고 있습니다",
                "driversDontHaveBankAccount": "운전자는 은행 계좌를 가지고 있지 않습니다",
                "payoutEndTime": "지급 종료 시간",
                "driverHaveInvalidBankAccount": "운전자의 잘못된 은행 계좌"
            },
            "payoutMerchant": {
                "HaveBankAccount": "상인들은 은행 계좌를 가지고 있습니다",
                "DontHaveBankAccount": "상인들은 은행 계좌를 가지고 있지 않습니다",
                "HaveInvalidBankAccount": "상인들이 유효하지 않은 은행 계좌를 가지고 있습니다",
                "payoutEndTime": "지급 종료 시간"
            }
        },
        "error": {
            "23005": "시스템 성능을 위해 %{interval} %{unitLabel}에서만 보고서를 볼 수 있습니다, 날짜 범위를 조정해 주세요"
        },
        "result": {
            "idPermitType": "ID 유형",
            "noResultFound": "결과를 찾을 수 없습니다",
            "page": "페이지",
            "itemsPerPage": "페이지 당 항목 수",
            "showPages": "총 %{total} 중 %{from} - %{to} 표시",
            "exportToExcel": "엑셀로 내보내기",
            "exportToCSV": "CSV로 내보내기",
            "exportToPaymentFile": "결제 파일로 내보내기",
            "pay": "지불하다",
            "paySelected": "선택한 항목 지불",
            "payAll": "모두 지불",
            "invalidBankAccount": "잘못된 은행 계좌",
            "validBankAccount": "유효한 은행 계좌",
            "bookingDetails": {
                "customerAdjustmentsFee": "고객 조정",
                "supplierDriverAdjustmentsFee": "공급자/운전자 조정",
                "supplierPayout": "공급자 지급",
                "driverPayout": "운전자 지급",
                "profit": "이익",
                "successSendMessage": "귀하의 메시지가 전송되었습니다",
                "packageName": "패키지 이름",
                "transactionId": "거래 ID",
                "proofOfFailure": "실패 증명",
                "recipientsNumber": "수령인 수",
                "recipientsInfo": "수령인 정보",
                "creditTransactionFee": "신용카드 수수료",
                "carTypeRequest": "요청된 차량 유형",
                "bookingId": "예약 #",
                "bookingStatus": "예약 상태",
                "tripId": "여행 #",
                "bookFrom": "에서 예약",
                "bookingService": "네트워크 유형",
                "bookingType": "예약 유형",
                "serviceType": "서비스 유형",
                "operator": "운영자",
                "customerPhone": "고객 전화번호",
                "customerName": "고객 이름",
                "customerIdNumber": "고객 ID# / IC#",
                "corpDivision": "분할",
                "corpDept": "학과",
                "chargeCode": "요금 코드",
                "tripDescription": "여행 설명",
                "rideSharing": "라이드 공유",
                "queueName": "대기 영역",
                "bookingTime": "생성 시간",
                "pickupTime": "픽업 시간",
                "expectedPickupTime": "예상 픽업 시간",
                "dispatchTime": "배젼 시간",
                "onBoardTime": "착석 시간",
                "droppedOffTime": "하차 시간",
                "onBoardDuration": "탑승 시간",
                "dispatch": "배차 번호",
                "completedTime": "완료 시간",
                "driverName": "운전자 이름",
                "driverIdPermit": "아이디#/국가 신분증#",
                "driverLicenseNumber": "운전면허 번호",
                "companyName": "회사",
                "carType": "차량 유형",
                "licensePlate": "차량 번호판",
                "intercityRoute": "도시간 루트",
                "pickupLocation": "픽업 위치",
                "geoPickup": "픽업 위치 위도/경도",
                "extraDestination": "추가 목적지",
                "originDestination": "원래 목적지",
                "originEstDistance": "원래 예상 거리",
                "destination": "실제 목적지",
                "geoDestination": "실제 목적지 위도/경도",
                "pickupFrom": "출발지부터의 픽업 위치",
                "distanceTour": "승차지 거리",
                "internalNotes": "내부 메모",
                "notes": "메모",
                "basicFareCalculator": "기본 요금 계산기",
                "basicFare": "기본 요금",
                "editFare": "기본 요금 수정",
                "oldBasicFare": "이전 기본 요금",
                "airportFee": "공항 요금",
                "meetDriver": "기사 만나기",
                "rushHour": "할증",
                "surchargeParameter": "동적 할증",
                "dynamicFare": "동적 요금",
                "heavyTraffic": "신호 대기",
                "tollFee": "통행료",
                "parkingFee": "주차 요금",
                "gasFee": "가스 요금",
                "otherFees": "다른 요금",
                "subtotal": "소계",
                "subTotalFF": "소계 FF",
                "techFee": "기술 요금",
                "serviceFee": "추가 서비스",
                "fleetServiceFee": "차량 서비스",
                "bookingFee": "예약 비용",
                "salesTax": "판매세",
                "tipAmt": "팁 금액",
                "promoCode": "프로모션 코드",
                "promoAmt": "프로모션 금액",
                "requestedTotalAmount": "OTA Price",
                "total": "총 금액",
                "totalNotRounded": "ROUND (총 금액)",
                "actualReceived": "실제 수령액",
                "differenceAmt": "차이액 (수령)",
                "customerDebt": "고객 채무",
                "markupDifference": "마크업 차이",
                "receivedWhenDropOff": "드랍 오프 시 수령",
                "refundAmount": "환불 금액",
                "requestedPaymentMethod": "요청된 결제 방법",
                "paidBy": "지불자",
                "splitPayment": "분할 결제",
                "paidByWallet": "지갑으로 결제",
                "paidByOtherMethod": "다른 방법으로 결제",
                "cashReceived": "현금 수령",
                "transferredChangeByWallet": "지갑으로 변경 이체",
                "returnedChangeByCash": "현금으로 반환",
                "instructions": "지시사항",
                "additionalServiceName": "이름",
                "additionalServiceValue": "값",
                "sendReceiptHeader": "",
                "sendReceipt": "영수증 보내기",
                "send": "보내기",
                "cancel": "취소",
                "sentReceiptSuccess": "영수증이 성공적으로 전송되었습니다",
                "sentReceiptFailed": "영수증을 지금은 전송할 수 없습니다. 다시 시도해 주십시오.",
                "coRider": "동승자",
                "coriderName": "이름",
                "stopAddress": "추가 목적지",
                "stopGeo": "위도/경도",
                "addonPrice": "고객 가격 조정",
                "oldSubTotal": "조정 전 소계",
                "view_good_receipt": "물품 영수증",
                "view_delivery_receipt": "배달 사진",
                "view": "보기",
                "tipAfterCompletedDetails": "이체: {0}{1}; 거래 수수료: {0}{2}",
                "fleetMarkup": "이익",
                "editedDriverEarning": "수정된 드라이버 수익",
                "driverEarning": "운전사 수입",
                "supplierAmount": "공급자 수익",
                "currencyISO": "통화",
                "pickUpZoneName": "픽업 지역",
                "dynamicFactor": "다이나믹 요금 (계수)",
                "supplierEarning": "공급자 수익",
                "passengerName": "승객 이름",
                "totalPayout": "총 지불",
                "numberOfTrips": "여행 횟수",
                "psgLocation": "승객 위치 (위도/경도)",
                "psgIp": "승객 IP",
                "DeviceImei": "장치 IMEI",
                "otaDiscount": 'OTA Discount',
            },
            "financial": {
                "supplierPayout": "공급자 지급",
                "driverPayout": "운전자 지급",
                "profit": "이익",
                "currencyISO": "통화",
                "supplierAmount": "공급자 수익",
                "driverEarning": "운전사 수입",
                "supplierEarning": "공급자 수익",
                "passengerName": "승객 이름",
                "totalPayout": "총 지불",
                "numberOfTrips": "여행 횟수",
                "driverName": "운전자 이름",
                "driverPhone": "전화번호",
                "driverUserName": "사용자 이름",
                "companyName": "공급자/회사",
                "bookingList": "예약 목록",
                "totalFare": "프로모션 제외 총 요금",
                "netEarning": "순수익",
                "showBookingList": "보기",
                "referralEarning": "추천 수익",
                "totalEarningNet": "총 수익 (순)",
                "totalEarningNetTooltip": "모든 수수료를 플릿에 반환한 후에 벌어들인 돈. 총 수익 (순) = 순 수익 + 이후 팁",
                "totalEarningNetTooltipRefferal": "모든 수수료를 플릿에 반환한 후에 벌어들인 돈. 총 수익 (순) = 추천 수익 + 순 수익 + 팁",
                "totalEarningGross": "총 수익 (총계)",
                "totalEarning": "총 수익",
                "totalEarningGrossTooltip": "예약 요금과 팁에서 벌어들인 돈. 총 수익 (총계) = 총 수익 + 팁",
                "totalEarningGrossTooltipRefferal": "예약 요금과 팁에서 벌어들인 돈. 총 수익 (총계) = 추천 수익 + 총 수익 + 팁",
                "note": "메모",
                "shortTrip": "단거리 여행",
                "deduction": "공제",
                "totalDriverEarning": "총 드라이버 수익",
                "totalDriverEarningTooltip": "온라인 및 오프라인 결제가 모두 포함된 예약이 포함됨",
                "totalDriverPayout": "드라이버 총 지급금",
                "totalDriverPayoutTooltip": "현금이나 오프라인 결제가 포함된 예약은 포함되지 않음"
            },
            "financialDriver": {
                "supplierAmount": "공급자 수수료",
                "payoutType": "지불 유형",
                "date": "날짜",
                "driverTipAfterCompleted": "탑승 후 팁",
                "bookingId": "예약 ID",
                "paidBy": "지불자",
                "bookFrom": "에서 예약",
                "bookingType": "예약 유형",
                "companyName": "회사",
                "driverName": "운전자",
                "driverIdPermit": "아이디#/국가 신분증#",
                "totalFare": "프로모션 제외 총 요금",
                "subtotal": "소계",
                "airportFee": "공항 요금",
                "meetDriver": "기사 만나기",
                "tollFee": "통행료",
                "parkingFee": "주차 요금",
                "gasFee": "가스 요금",
                "rushHour": "출퇴근 시간",
                "transactionFee": "거래 수수료",
                "techFee": "기술 요금",
                "salesTax": "판매세",
                "tipAmt": "팁 금액",
                "bookingFee": "예약 비용",
                "commission": "수수료",
                "deduction": "공제",
                "promoAmt": "프로모션 금액",
                "ridePayment": "라이드 비용",
                "driverTax": "운전자 세금",
                "grossEarning": "총 수입",
                "driverDeduction": "운전자 공제",
                "netEarning": "순수익",
                "payToDriver": "운전자에게 지불",
                "payToFleet": "차량에게 지불",
                "totalNotRounded": "ROUND (총 금액)",
                "fleetServiceFee": "차량 서비스 요금",
                "editedDriverEarning": "수정된 드라이버 수익",
                "stripeFee": "스트라이프 수수료",
                "currencyISO": "통화"
            },
            "financialCompany": {
                "companyName": "공급자/회사",
                "homeFleetNetEarning": "홈 플릿 순수익",
                "affiliateNetEarning": "제휴 순수익",
                "totalNetEarning": "운전자 총 순이익",
                "status": "상태",
                "companyAmount": "총 지불",
                "numberOfTrips": "여행 횟수"
            },
            "companySettlement": {
                "companyName": "회사",
                "pendingSettlement": "보류 중인 정산",
                "viewDetails": "세부사항 확인",
                "settlementType": "유형"
            },
            "companySettlementDetails": {
                "bookId": "예약 ID",
                "dateTime": "날짜 시간",
                "originalPaymentStatus": "원래 결제 상태",
                "subTotal": "소계",
                "fleetAmount": "플릿 금액",
                "driverAmount": "운전자 금액",
                "companyAmount": "회사 금액",
                "companyOweFleet": "회사가 플릿에 빚",
                "fleetOweCompany": "플릿이 회사에 빚",
                "notes": "메모"
            },
            "financialProfit": {
                "profit": "이익",
                "bookingId": "예약 #",
                "subTotal": "소계",
                "subTotalFF": "소계 FF",
                "fleetCommission": "Fleet Commission",
                "techFee": "기술 요금",
                "promotion": "프로모션",
                "markupDifference": "마크업 차이",
                "Profit": "이익",
                "currency": "통화",
                "fleetServiceFee": "플릿 서비스 (플릿 수령)",
                "fleetServiceFeeTooltip": "서비스 요금에서 커미션을 받는 플릿 금액"
            },
            "promotion": {
                "date": "날짜",
                "promoCode": "프로모션 코드",
                "users": "사용자",
                "uses": "사용",
                "checked": "체크",
                "applied": "적용",
                "totalPromoAmount": "전체 프로모션 금액",
                "totalReceipt": "전체 영수증",
                "numberOfUsers": "사용자 수",
                "numberOfPromoCodeAppliance": "프로모션 코드 적용 수",
                "numberOfSuccessfulBookings": "성공적인 예약 수",
                "numberOfCompletedBookings": "완료된 예약 수",
                "numberOfCompletedUsers": "완료된 사용자 수",
                "numberOfUsersApplyPromotion": "프로모션 적용 사용자 수",
                "numberOfUsersApplyPromotionAndCompleteBooking": "프로모션을 적용하고 예약을 완료한 사용자 수",
                "numberOfPromoCodeApplianceTooltip": "모든 사용자에 의한 프로모션 코드 적용 수",
                "numberOfSuccessfulBookingsTooltip": "프로모션 코드로 성공적으로 생성된 예약 수",
                "numberOfCompletedBookingsTooltip": "프로모션 코드가 적용된 완료된 예약 수"
            },
            "export": {
                "createdDate": "날짜",
                "sessionName": "세션 이름",
                "download": "다운로드",
                "delete": "삭제",
                "percent": "퍼센티지",
                "status": "상태",
                "name": "모듈 이름"
            },
            "redeemed": {
                "date": "날짜",
                "code": "코드",
                "customers": "고객",
                "phone": "전화번호",
                "value": "값",
                "currency": "통화",
                "campaignName": "캠페인"
            },
            "carActivity": {
                "plateNumber": "차량 번호판",
                "vehicleType": "차량 유형",
                "companyName": "회사",
                "day1st": "1위",
                "day2nd": "2위",
                "day3rd": "3위",
                "day4th": "4위",
                "day5th": "5위",
                "day6th": "6위",
                "day7th": "7위",
                "day8th": "8위",
                "day9th": "9위",
                "day10th": "10위",
                "day11th": "11위",
                "day12th": "12위",
                "day13th": "13위",
                "day14th": "14일",
                "day15th": "15일",
                "day16th": "16일",
                "day17th": "17일",
                "day18th": "18일",
                "day19th": "19일",
                "day20th": "20일",
                "day21st": "21일",
                "day22nd": "22일",
                "day23rd": "23일",
                "day24th": "24일",
                "day25th": "25일",
                "day26th": "26일",
                "day27th": "27일",
                "day28th": "28일",
                "day29th": "29일",
                "day30th": "30일",
                "day31st": "31일",
                "operationDays": "운영일",
                "activeCars": "전체 활동 차량:"
            },
            "carActivityLogsTitle": "로그",
            "carActivityLogs": {
                "licensePlate": "차량 번호판",
                "companyName": "회사",
                "bookingId": "예약 ID",
                "driverName": "운전자 이름",
                "driverIDNumber": "아이디#/국가 신분증#",
                "date": "수락 시간",
                "bookFrom": "에서 예약"
            },
            "affiliation": {
                "date": "픽업 시간",
                "bookingId": "예약 ID",
                "bookingType": "예약 유형",
                "homeFleet": "홈 플릿",
                "providerFleet": "제공업체 플릿",
                "driver": "운전자",
                "passenger": "승객",
                "paidBy": "지불자",
                "airportFee": "공항 요금",
                "meetDriver": "기사 만나기",
                "rushHour": "할증",
                "tollFee": "통행료",
                "parkingFee": "주차 요금",
                "gasFee": "가스 요금",
                "heavyTraffic": "신호 대기",
                "otherFees": "다른 요금",
                "provider": "공급자",
                "basicFareProvider": "기본 요금 제공자",
                "subTotalProvider": "소계 제공자",
                "techFeeProvider": "기술 요금 제공자",
                "bookingFeeProvider": "예약 수수료 제공자",
                "taxValueProvider": "세금 값 제공자",
                "tipProvider": "팁 제공자",
                "totalFareProvider": "총 운임 제공자",
                "basicFare": "기본 요금",
                "subtotal": "소계",
                "techFee": "기술 요금",
                "bookingFee": "예약 비용",
                "tax": "세금",
                "tip": "팁",
                "totalFare": "합계 요금",
                "payoutInLocalCurrency": "현지 화폐로 된 탑승 수익",
                "payoutInUSD": "탑승 수익 (USD)",
                "fleetCommInUSD": "플릿 수수료 (USD)",
                "bookingFeeInUSD": "예약 수수료 (USD)",
                "totalPayoutInUSD": "총 지불액 (USD)",
                "subTotal": "소계",
                "bookingStatus": "예약 상태",
                "vehicle": "차량",
                "customerPhone": "고객 전화번호",
                "driverPhone": "운전자 전화번호",
                "total": "총계",
                "totalInUSD": "총 요금 (USD)",
                "supplierPayout": "공급자 지급",
                "supplierPayoutInUSD": "공급자 지불액 (USD)",
                "buyerPayout": "구매자 커미션",
                "buyerPayoutInUSD": "커미션 (USD)",
                "buyerCommission": "수수료",
                "buyerCommissionInUSD": "커미션 (USD)",
                "receivableInUSD": "수당 (USD)",
                "payableInUSD": "지급액 (USD)",
                "fleetMarkupInUSD": "이익 (USD)",
                "paymentMethod": "결제 방법",
                "paymentStatus": "결제 상태"
            },
            "prepaidTopUp": {
                "date": "날짜 및 시간",
                "topUpId": "충전 ID",
                "transactionId": "거래 ID",
                "name": "이름",
                "company": "회사",
                "paidBy": "지불자",
                "amount": "금액",
                "newAmount": "새로운 잔액",
                "transactionType": "거래 유형"
            },
            "operatorLogs": {
                "date": "날짜",
                "operator": "운영자",
                "username": "사용자 이름",
                "module": "모듈",
                "description": "설명"
            },
            "corporate": {
                "date": "날짜",
                "bookingId": "예약 ID",
                "operatorName": "기업 운영자",
                "corporateName": "회사",
                "corpTraveler": "기업 사용자",
                "travelerSignature": "여행자 서명",
                "corpId": "회사 id",
                "corpDivision": "회사 부서",
                "costCentre": "비용 센터",
                "corpPO": "회사 PO",
                "managerName": "관리자의 이름",
                "managerEmail": "관리자의 이메일",
                "title": "제목",
                "department": "부서",
                "clientCaseMatter": "고객 케이스 내용 / 여행 설명",
                "chargeCode": "사용 코드 / 여행 코드",
                "driverName": "운전자",
                "pickupLocation": "픽업 위치",
                "destination": "목적지",
                "total": "총 금액",
                "subtotal": "소계",
                "subTotalFF": "소계 FF",
                "commission": "수수료",
                "commissionBooking": "앱/웹앱의 예약에서 커미션 적용",
                "paidBy": "지불자",
                "statusDisplay": "상태",
                "flightNumber": "비행 번호"
            },
            "bookingLogs": {
                "bookingId": "예약 ID",
                "bookingService": "네트워크 유형",
                "bookingType": "예약 유형",
                "driverName": "운전자",
                "driverIdPermit": "아이디#/국가 신분증#",
                "customerName": "승객",
                "pickupTime": "픽업 시간",
                "onBoardTime": "착석 시간",
                "droppedOffTime": "하차 시간",
                "pickupLocation": "픽업 위치",
                "destination": "목적지",
                "dispatchHistory": "배차 이력",
                "otwDistance": "O.T.W 거리",
                "distanceTour": "승차지 거리",
                "duration": "P.O.B 기간",
                "paidBy": "지불자",
                "bookFrom": "에서 예약",
                "map": "지도",
                "showDispatchHistory": "보기",
                "showMap": "보기",
                "paymentActivities": "결제 활동"
            },
            "rating": {
                "date": "날짜",
                "bookingId": "예약 ID",
                "driverName": "운전자",
                "driverIdPermit": "아이디#/국가 신분증#",
                "customerName": "고객 이름",
                "customerPhone": "고객 전화",
                "like": "좋아요",
                "dislike": "싫어요",
                "notes": "댓글",
                "stars": "등급",
                "vehicleRating": "차량 등급",
                "driverRating": "드라이버 등급",
                "plateNumber": "차량 번호"
            },
            "mDispatcher": {
                "date": "날짜",
                "bookingId": "예약 ID",
                "mDispatcherName": "파트너 이름",
                "mDispatcherType": "파트너 유형",
                "subtotal": "소계",
                "commission": "수수료",
                "paidBy": "지불자"
            },
            "totalAdjustment": {
                "date": "날짜",
                "bookingId": "예약 ID",
                "oldAmount": "총계",
                "type": "유형",
                "markupDifference": "마크업 차이",
                "newAmount": "편집된 총계/마크업",
                "username": "운영자",
                "reason": "이유"
            },
            "incidentCancellation": {
                "date": "날짜",
                "bookingId": "예약 ID",
                "customerName": "고객 이름",
                "customerPhone": "고객 전화",
                "bookFrom": "에서 예약",
                "canceledBy": "취소한 사람",
                "type": "유형",
                "reason": "이유",
                "reasonCode": {
                    "0": "다른 여행 옵션을 찾았습니다",
                    "1": "운전자가 너무 멀리 있습니다",
                    "2": "잘못된 위치를 입력했습니다",
                    "3": "너무 오래 기다렸습니다",
                    "4": "운전자가 취소를 요청했습니다",
                    "5": "계획이 변경되었습니다",
                    "6": "위치를 변경하고 싶었습니다",
                    "101": "대부분 또는 모든 항목이 사용할 수 없습니다",
                    "102": "지금은 너무 바쁩니다",
                    "103": "지금은 폐점했습니다",
                    "104": "곧 폐점합니다"
                },
                "canceller": "취소자",
                "incidentStatus": "사건 상태"
            },
            "acceptanceCancellationRate": {
                "companyId": "회사 ID",
                "driverId": "운전자 ID",
                "driverName": "운전자 이름",
                "phoneNumber": "전화번호",
                "company": "회사",
                "acceptanceRate": "수락률",
                "cancellationRate": "취소율",
                "rating": "등급"
            },
            "revenueFleet": {
                "date": "날짜",
                "fareRevenue": "요금 수익",
                "trip": "여행",
                "avgFareTrip": "평균 요금/여행",
                "drivers": "# 드라이버",
                "avgTripPerDriver": "평균 여행/드라이버",
                "dispatcher": "# 디스패처"
            },
            "revenueDriver": {
                "date": "날짜",
                "driverName": "운전자",
                "fareRevenue": "요금 수익",
                "trip": "# 여행",
                "avgFareTrip": "평균 요금/여행"
            },
            "revenueMonthly": {
                "month": "월",
                "trip": "완료된 여행",
                "subtotal": "소계",
                "tipAmt": "팁",
                "techFee": "기술 요금",
                "salesTax": "세금",
                "partnerCommission": "파트너 커미션/ ODD",
                "totalFare": "프로모션 제외 총 요금",
                "netEarning": "순수익",
                "fleetServiceFee": "차량 서비스 요금"
            },
            "dailyDriver": {
                "driverName": "운전자",
                "driverIDPermit": "아이디#/국가 신분증#",
                "driverPhone": "전화",
                "companyName": "회사",
                "workingHoursOnline": "온라인 (시간)",
                "workingHoursAvailable": "사용 가능 (시간)",
                "driverWorkingHours": "드라이버 근무 시간",
                "distance": "드라이버 이동 거리",
                "CC_activity": "CC 활동",
                "fare_summary": "CC 활동",
                "workingHoursNotAvailable": "사용 불가능 (시간)",
                "workingHoursPob": "P.O.B (시간)",
                "workingHoursPobToolTip": "승객 탑승 시간",
                "workingHoursAccepted": "수락됨",
                "workingHoursReject": "거부",
                "workingHoursIgnore": "무시",
                "workingHoursCancel": "취소",
                "completedTripsTotal": "총계",
                "completedTripsCc": "CC에서",
                "completedTripsCarHailing": "차량 호출에서",
                "completedTripsStreetSharing": "가로 공유에서",
                "completedTripsPaxApp": "pax 앱에서",
                "completedTripsWebBooking": "웹 예약에서",
                "completedTripsMDispatcher": "파트너에서",
                "completedTripsKiosk": "Kiosk에서",
                "completedTripsApi": "API에서",
                "ccActivityDispatchedTrips": "디스패치된 여행",
                "ccActivityAccepted": "수락됨",
                "ccActivityReject": "거부",
                "ccActivityIgnore": "무시",
                "ccActivityCancelByPassenger": "승객에 의해 취소됨",
                "ccActivityCancelByDriver": "기사에 의해 취소됨",
                "ccActivityCancelByCc": "CC에 의해 취소됨",
                "ccActivityCancelByAPI": "API에 의해 취소됨",
                "ccActivityNoShow": "불참",
                "fareSummaryTotalCash": "현금",
                "fareSummaryTotalCreditCard": "신용 카드",
                "fareSummaryTotalExternalCard": "외부 카드",
                "fareSummaryTotalPaxWallet": "지갑",
                "fareSummaryTotalDirectBilling": "직접 청구서",
                "fareSummaryTotalQrCode": "QR 코드",
                "fareSummaryTotalPrePaid": "기업 선불",
                "fareSummaryTotalApplePay": "Apple Pay",
                "fareSummaryTotalTngeWallet": "TnG eWallet",
                "fareSummaryTotalVippseWallet": "Vipps",
                "fareSummaryTotal": "총계",
                "ratingNotes": "참고 항목 수",
                "ratingDislike": "싫어하는 수",
                "ratingLike": "좋아하는 수",
                "fareDetailsBasicFare": "기본 요금",
                "fareDetailsAirportFee": "공항 요금",
                "fareDetailsRushHour": "할증",
                "fareDetailsHeavyTraffic": "신호 대기",
                "fareDetailsOtherFees": "다른 요금",
                "fareDetailsSubTotal": "소계",
                "fareDetailsSubTotalFF": "소계 FF",
                "fareDetailsTechFee": "기술 요금",
                "fareDetailsBookingFee": "예약 비용",
                "fareDetailsSalesTax": "판매세",
                "fareDetailsTip": "팁 금액",
                "fareDetailsPromoAmount": "프로모션 금액",
                "fareDetailsTotalAmt": "총 금액",
                "availableDistance": "사용 가능",
                "otwDistance": "O.T.W",
                "otwDistanceToolTip": "출발 거리",
                "pobDistance": "P.O.B",
                "pobDistanceToolTip": "승객 탑승 거리",
                "ratingStars1": "1성 갯수",
                "ratingStars2": "2성 갯수",
                "ratingStars3": "3성 갯수",
                "ratingStars4": "4성 갯수",
                "ratingStars5": "5성 갯수",
                "ratingAvg": "평균",
                "ssnNumber": "SSN 번호",
                "driverEmail": "이메일 주소",
                "driverAddress": "집 주소",
                "fareDetailsAddonPrice": "고객 가격 조정",
                "fareDetailsOldSubTotal": "조정 전 소계"
            },
            "dailyCar": {
                "carInfo": "차량 정보",
                "fareDetails": "요금 세부 정보",
                "completedTrips": "완료된 여행",
                "carInfoCompanyName": "회사",
                "carInfoPermission": "허가",
                "carInfoVehiclePlateNumber": "차량 번호판",
                "carInfoVhcId": "차량 번호",
                "carInfoCarType": "차량 유형",
                "completedTripsTotal": "총계",
                "completedTripsCc": "CC에서",
                "completedTripsCarHailing": "차량 호출에서",
                "completedTripsStreetSharing": "가로 공유에서",
                "completedTripsPaxApp": "pax 앱에서",
                "completedTripsWebBooking": "웹 예약에서",
                "completedTripsMDispatcher": "파트너에서",
                "completedTripsKiosk": "Kiosk에서",
                "completedTripsAPI": "API에서",
                "fareDetailsBasicFare": "기본 요금",
                "fareDetailsAirportFee": "공항 요금",
                "fareDetailsMeetDriver": "기사 만나기",
                "fareDetailsRushHour": "할증",
                "fareDetailsHeavyTraffic": "신호 대기",
                "fareDetailsTollFee": "통행료",
                "fareDetailsParkingFee": "주차 요금",
                "fareDetailsGasFee": "가스 요금",
                "fareDetailsOtherFees": "다른 요금",
                "fareDetailsSubTotal": "소계",
                "fareDetailsSubTotalFF": "소계 FF",
                "fareDetailsTechFee": "기술 요금",
                "fareDetailsBookingFee": "예약 비용",
                "fareDetailsSalesTax": "판매세",
                "fareDetailsTip": "팁",
                "fareDetailsPromoAmount": "프로모션 금액",
                "fareDetailsTotalAmt": "총 금액",
                "fareDetailsAddonPrice": "고객 가격 조정",
                "fareDetailsOldSubTotal": "조정 전 소계"
            },
            "dailyDriverCar": {
                "driverInfo": "운전자 정보",
                "driverName": "운전자 이름",
                "driverIDPermit": "아이디#/국가 신분증#",
                "driverPhone": "전화번호",
                "companyName": "회사",
                "actionInfo": "행동",
                "date": "날짜",
                "action": "동작",
                "bookingId": "예약 ID",
                "carInfo": "차량 정보",
                "permission": "허가",
                "licensePlate": "차량 번호판",
                "carId": "차량 번호",
                "carType": "차량 유형"
            },
            "driverLoginStatus": {
                "driver": "운전자",
                "driverIdPermit": "아이디#/국가 신분증#",
                "phone": "전화번호",
                "username": "사용자 이름",
                "company": "회사",
                "carType": "차량 유형",
                "licensePlate": "차량 번호판",
                "status": "상태"
            },
            "bookingSummary": {
                "date": "날짜",
                "operator": "운영자",
                "username": "사용자 이름",
                "action": "동작",
                "bookingId": "예약 ID"
            },
            "cashWallet": {
                "bankAccount": "은행 계좌로 이체",
                "creditWallet": "신용 지갑으로 이체",
                "tipAfterCompleted": "완료 후 팁",
                "netEarning": "순수익",
                "referralEarning": "추천 수익",
                "receiverAccount": "수신 계좌",
                "dateAndTime": "날짜 및 시간",
                "driverName": "운전자 이름",
                "phoneNumber": "전화번호",
                "userName": "사용자 이름",
                "company": "회사",
                "type": "유형",
                "bookingId": "예약 #",
                "operator": "운영자",
                "reason": "이유",
                "amount": "금액",
                "newAmount": "새로운 잔액",
                "currency": "통화",
                "topUpGCashReason": "GCash로 충전",
                "topUpReason": "신용카드 *{0}에서 충전",
                "cashWalletReason": "현금 지갑에서 충전",
                "topUpMOLPayReason": "Razer Pay [ {0} ]",
                "chargedAmount": "요금 금액",
                "differentPercent": "할인 / 추가 요금 (%)",
                "operatorName": "운영자",
                "sendPayout": "동작",
                "sendPayoutTitle": "지불 이메일 다시 보내기",
                "payoutReason": "{0} (지불 {1} {2})"
            },
            "creditWallet": {
                "receiverType": "수신자 유형",
                "receiverName": "수신자 이름",
                "receiverPhone": "수신자 전화번호",
                "senderPhone": "발신자 전화번호",
                "senderName": "발신자 이름",
                "sentToCustomer": "고객에게 전송",
                "sentToDriver": "운전사에게 보내기",
                "dateAndTime": "날짜 및 시간",
                "driverName": "운전자 이름",
                "phoneNumber": "전화번호",
                "userName": "사용자 이름",
                "company": "회사",
                "type": "유형",
                "bookingId": "예약 #",
                "operator": "운영자",
                "reason": "이유",
                "amount": "금액",
                "newAmount": "새로운 잔액",
                "currency": "통화",
                "transactionId": "거래 ID",
                "topUpGCashReason": "GCash로 충전",
                "topUpReason": "신용카드 *{0}에서 충전",
                "cashWalletReason": "현금 지갑에서 충전",
                "topUpMOLPayReason": "Razer Pay [ {0} ]",
                "topUpWalletReason": "{0} [ {1} ]",
                "chargedAmount": "요금 금액",
                "differentPercent": "할인 / 추가 요금 (%)",
                "cashExcessReason": "고객이 {0}을 지불해야합니다. 현금 받음 {1}",
                "referralEarningReason": "고객 {0} {1}이/가 첫번째 예약 {2}을 완료함",
                "referralEarningReason_2": "고객 {0} {1}이/가 예약 {2}을 완료함",
                "insurance": "운전자 보험"
            },
            "passengerWallet": {
                "dateTime": "날짜 및 시간",
                "customerName": "고객 이름",
                "phoneNumber": "전화번호",
                "type": "유형",
                "bookingId": "예약 #",
                "changedAmount": "변경된 금액",
                "amount": "변경된 금액",
                "newBalance": "새로운 잔액",
                "currency": "통화",
                "transactionId": "거래 ID",
                "Note": "메모",
                "credit": "신용 카드 *{0}로 충전",
                "TnG": "TnG #{0}에 의한 충전",
                "MOLPay": "[RazerPay - #{0}]에서 충전",
                "gatewayName": "[{0} - #{1}]에서 충전",
                "cashExcess": "고객이 {0}를 지불해야 합니다. 현금 주어짐 {1}",
                "editBalance": "잔액 편집",
                "ride": "탑승",
                "topUp": "충전",
                "topUpReferee": "추천 보상 ({0})",
                "topUpReferrer": "새로운 추천인 (#{0}): {1} ({2})"
            },
            "recipientsInfo": {
                "order": "No.",
                "orderId": "주문번호#",
                "name": "수신인 이름",
                "phone": "수신인 전화 번호",
                "address": "수신인 주소",
                "deliveryFee": "배송 요금",
                "ItemValue": "아이템 가치 (COD)",
                "status": "상태",
                "Performer": "연주자",
                "Reason": "이유",
                "proofOfFailure": "실패 증명",
                "referenceNumber": "참조 번호"
            },
            "dispatchHistory": {
                "performer": "연주자",
                "name": "이름",
                "action": "동작",
                "date": "날짜",
                "location": "운전사의 위치",
                "estimate": "차량에서 픽업 위치 추정",
                "passenger": "고객",
                "detachVehicle": "차량 분리",
                "assignVehicle": "차량 배정"
            },
            "payToDriver": {
                "driverName": "운전자",
                "totalUnsettledTransactions": "미결제 트랜잭션 총계",
                "totalUnsettledAmount": "미결제 금액 총계",
                "actions": "행동",
                "pay": "지불하다",
                "remove": "제거",
                "clearSuccess": "선택된 운전사의 수익이 성공적으로 정리되었습니다.",
                "clearFailed": "운전자의 수익 데이터를 지우는데 실패하였습니다. 다시 시도하십시오.",
                "selectDriver": {
                    "title": "",
                    "body": "지불할 운전사를 선택해 주세요.",
                    "buttonTitle": "확인"
                },
                "confirmClear": {
                    "title": "",
                    "body": "이 운전사의 수익 데이터를 정리하시겠습니까? 이 작업은 취소할 수 없습니다.",
                    "buttonTitle": "예",
                    "closeButtonText": "아니오"
                },
                "confirmPay": {
                    "body": "선택된 운전사에게 지불하시겠습니까?",
                    "buttonTitle": "예",
                    "closeButtonText": "아니오"
                },
                "paymentSuccessfully": "운전사에게 성공적으로 정산이 완료되었습니다.",
                "ProcessPayout": "지급 절차 진행"
            },
            "customerQuest": {
                "name": "이름",
                "phoneNumber": "전화번호",
                "supportId": "지원 ID",
                "ranking": "순위",
                "points": "포인트",
                "numberOfReservation": "예약 수",
                "driver": "운전자",
                "customer": "고객",
                "firstWillWin": "첫번째가 이김",
                "firstWillWinLuckyDraw": "먼저 이기면 행운을 가져옵니다 (추첨)",
                "largestWillWin": "가장 크게 이기면 이깁니다 (리더보드)",
                "qualified": "자격이 있습니다",
                "notQualified": "자격이 없습니다",
                "userName": "사용자 이름",
                "completedDate": "완료 날짜",
                "isQualified": "상태",
                "ticket": "티켓",
                "numOfComplete": "완료 수",
                "bookingDistance": "승차지 거리",
                "numberOfIntercity": "시외 이동 수",
                "numberOfDelivery": "배달 수",
                "pleaseSelectEventName": "이벤트 이름을 선택하십시오.",
                "numberOfQualifiedSetting": "합격한 수 (설정):",
                "numberOfActualQualified": "실제로 합격한 수:",
                "driverRating": "드라이버 등급",
                "acceptanceRating": "수용 등급",
                "cancellationRating": "취소 등급",
                "period": "기간:"
            },
            "payoutToDriver": {
                "IFSCCode": "IFSC 코드",
                "payoutID": "지급 ID",
                "driverName": "운전자",
                "driverPhone": "전화번호",
                "companyName": "회사",
                "period": "기간",
                "driverId": "아이디#/국가 신분증#",
                "cashWalletBalance": "현금 지갑 잔액",
                "creditBalance": "신용 잔액",
                "holdAmount": "홀드 금액",
                "minPayout": "최소 지급액",
                "enterMinimumPayoutAmount": "최소 지급액 입력",
                "payoutAmount": "지급 금액",
                "payoutDate": "지급 날짜",
                "actions": "행동",
                "pay": "지불하다",
                "remove": "제거",
                "payoutEndTime": "지급 종료 시간",
                "clearSuccess": "선택된 운전사의 수익이 성공적으로 정리되었습니다.",
                "clearFailed": "운전자의 수익 데이터를 지우는데 실패하였습니다. 다시 시도하십시오.",
                "amountKeepInDriverCashWallet": "운전자의 현금 지갑에 보유하는 금액",
                "selectDriver": {
                    "title": "",
                    "body": "지불할 운전사를 선택해 주세요.",
                    "buttonTitle": "확인"
                },
                "confirmClear": {
                    "title": "",
                    "body": "이 운전사의 수익 데이터를 정리하시겠습니까? 이 작업은 취소할 수 없습니다.",
                    "buttonTitle": "예",
                    "closeButtonText": "아니오"
                },
                "confirmPay": {
                    "body": "선택한 운전자에게 지급하기 원하십니까? <br> - 운전자의 수: <b>%{drivers}</b> <br> - 각 운전자에 대한 최소 지급금 : %{currency} <b>%{min}</b> <br> - 보류중인 금액 : %{currency}<b> %{hold}</b> <br> - 총 지급금 : %{currency} <b>%{total}</b>",
                    "buttonTitle": "예",
                    "closeButtonText": "아니오"
                },
                "paymentSuccessfully": "운전사에게 성공적으로 정산이 완료되었습니다.",
                "paymentCompleted": "지급 완료: <br> - 성공적으로 지급: %{success} <br> - 실패: %{failed} <br> - 총 성공적인 지급: %{currency} %{total}",
                "noteSelectDrivers": "참고: 은행 계좌가 있는 운전자를 선택하여 지불하십시오.",
                "sendPayout": "지급 성공 통지를 이메일 주소로 보내기",
                "accountNumber": "계좌 번호",
                "iBanNumber": "IBAN 번호",
                "accountHoldName": "계좌 소유자의 이름",
                "bankName": "은행명",
                "selelctedDriverHasBeenPaid": "선택된 운전자가 지급되었습니다",
                "selelctedDriverHasBeenFailed": "선택된 운전자가 실패했습니다",
                "selelctedDriverHasBeenUpdateAsInvalid": "선택된 운전자가 '은행 계좌 무효'로 업데이트되었습니다",
                "selelctedDriverHasBeenUpdateAsValid": "선택된 운전자가 '은행 계좌 유효'로 업데이트 되었습니다",
                "isBankAccountOwner": "수혜자가 운전자와 동일합니다",
                "isBankAccountOwner_true": "예",
                "isBankAccountOwner_false": "아니오",
                "beneficiaryIDIC": "수혜자 ID# / IC#",
                "bankRelationship": "관계",
                "bankRelationship_1": "배우자",
                "bankRelationship_2": "딸/아들",
                "bankRelationship_3": "형제/자매",
                "bankRelationship_4": "친척",
                "bankRelationship_5": "친구",
                "bankRelationship_6": "기타: {0}",
                "bankStatus": "은행 상태",
                "emailStatement": "이메일 문",
                "viewStatement": "문 보기",
                "downloadStatement": "PDF로 다운로드",
                "emailStatementSuccess": "이메일 문이 성공적으로 전송되었습니다",
                "NumberDriver": "운전자 수",
                "NumberSupplier": "공급자 수",
                "sendMailPayout": "다음 이메일 주소로 성공적인 지급 통지를 보내기:",
                "confirmPayoutTitle": "선택한 사용자에게 지급하기를 원하십니까?",
                "phoneOfBank": "은행의 전화번호"
            },
            "payoutToMerchant": {
                "payoutId": "지급 ID",
                "merchantName": "상인 이름",
                "phone": "전화번호",
                "accountNumber": "계좌 번호",
                "iBanNumber": "IBAN 번호",
                "bankAccountHolder": "계좌 소유자의 이름",
                "bankName": "은행명",
                "pendingAmount": "보류 중인 금액",
                "payoutAmount": "지급 금액",
                "payoutDate": "지급 날짜",
                "holdAmount": "홀드 금액",
                "minPayout": "최소 지급액",
                "selelctedMerchantHasBeenPaid": "선택한 상인에게 지급되었습니다",
                "selelctedMerchantHasBeenFailed": "선택된 상인에게 실패했습니다",
                "pay": "지불하다",
                "selectMerchant": {
                    "title": "경고",
                    "body": "지급할 상인을 선택하십시오.",
                    "buttonTitle": "확인"
                },
                "confirmPay": {
                    "body": "선택한 상인에게 지급하길 원하십니까? <br> - 상인 수: <b>%{merchants}</b> <br> - 각 상인에 대한 최소 지급금 : %{currency} <b>%{min}</b> <br> - 보류중인 금액 : %{currency}<b> %{hold}</b> <br> - 총 지급금 : %{currency} <b>%{total}</b>",
                    "buttonTitle": "예",
                    "closeButtonText": "아니오"
                },
                "sendPayout": "지급 성공 통지를 이메일 주소로 보내기",
                "HasBeenUpdateAsInvalid": "선택된 상인이 '은행 계좌 무효'로 업데이트되었습니다",
                "HasBeenUpdateAsValid": "선택한 상인(들)이 '유효한 은행 계좌'로 업데이트되었습니다"
            },
            "payoutSupplier": {
                "selelctedSupplierHasBeenUpdateAsValid": "선택한 공급자(들)이 '유효한 은행 계좌'로 업데이트되었습니다",
                "selelctedSupplierHasBeenUpdateAsInvalid": "선택한 공급자(들)는 '유효하지 않은 은행 계좌'로 업데이트되었습니다",
                "selelctedSupplierHasBeenFailed": "선택한 공급자(들)가 실패했습니다",
                "selelctedSupplierHasBeenPaid": "선택한 공급자(들)가 지불되었습니다",
                "confirmPay": {
                    "body": "선택한 공급자(들)에게 지불하시겠습니까? <br> - 공급자 수: <b>%{drivers}</b> <br> - 각 공급자에 대한 최소 지불금: %{currency} <b>%{min}</b> <br> - 홀드 금액: %{currency}<b> %{hold}</b> <br> - 총 지불액: %{currency} <b>%{total}</b>",
                    "buttonTitle": "예",
                    "closeButtonText": "아니오"
                },
                "agentName": "에이전트 이름",
                "walletBalance": "지갑 잔액",
                "newAmount": "새로운 금액"
            },
            "settlementHistory": {
                "date": "날짜",
                "driverName": "운전자 이름",
                "dateRange": "날짜 범위",
                "totalTransaction": "전체 결산된 거래",
                "paidAmount": "전체 결산 금액"
            },
            "settlement": {
                "driverName": "운전자",
                "driverIdPermit": "아이디#/국가 신분증#",
                "totalBookings": "총 예약",
                "total": "총 금액",
                "approved": "승인됨",
                "acct": "ACCT",
                "gross": "GROSS",
                "percent": 0.03,
                "net": "NET"
            },
            "documentExpiry": {
                "driverName": "운전자 이름",
                "driverPhone": "드라이버 전화번호",
                "company": "회사",
                "documentName": "문서 이름",
                "expiredDate": "만료 날짜",
                "status": "상태",
                "statusStr": {
                    "NA": "해당 없음",
                    "expired": "만료됨",
                    "active": "활성",
                    "expireSoon": "곧 만료됨"
                }
            },
            "referralDetail": {
                "bookingId": "북 #",
                "completedDate": "완료 시간",
                "paidBy": "지불자",
                "bookFrom": "에서 예약",
                "driverName": "운전자 이름",
                "driverIdPermit": "아이디#/국가 신분증#",
                "companyName": "회사",
                "Passenger": "승객",
                "Customer": "고객",
                "subtotal": "소계",
                "subTotalFF": "소계 FF",
                "subtotalWithPromo": "프로모션 포함 소계",
                "referralEarning": "추천 수익",
                "Amount": "금액",
                "Note": "메모",
                "Currency": "통화",
                "PercentOfSubTotal": "{0}%의 소계",
                "max": "최대 {0}",
                "referrerInfo": "운전자가 고객을 추천함",
                "phoneReferral": "드라이버 전화번호 #",
                "driverNumber": "아이디#/국가 신분증#",
                "referralCode": "추천 코드",
                "reference": "Reference"
            },
            "referralHistory": {
                "driverName": "운전자 이름",
                "phoneNumber": "전화번호",
                "companyName": "회사",
                "referralCode": "추천 코드",
                "commission": "총 커미션",
                "expectedReferralEarning": "예상 추천 수익",
                "activePaxTooltip": "드라이버의 추천 코드를 최소한 한 번 예약한 후 성공적으로 사용한 승객.",
                "referredPaxTooltip": "아직 예약하지 않은 드라이버의 추천 코드를 사용한 승객.",
                "activePax": "총 활성 고객",
                "referredPax": "총 추천 고객",
                "detailFields": {
                    "passengerId": "승객 ID",
                    "passengerName": "고객 이름",
                    "firstBookingDate": "첫번째 완료된 예약 날짜",
                    "firstBookingDateGMT": "첫번째 완료된 예약 날짜 (GMT)",
                    "passengerPhone": "고객 전화번호",
                    "appliedDate": "추천한 날짜",
                    "referredByDriver": "드라이버 추천",
                    "driverPhone": "운전자 전화번호",
                    "referralCode": "추천 코드"
                },
                "showDetail": "보기",
                "detail": "세부 사항"
            },
            "paxReferralHistory": {
                "customerName": "고객 이름",
                "phoneNumber": "전화번호",
                "referralCode": "추천 코드",
                "commission": "총 커미션",
                "activePaxTooltip": "최소한 한 번 예약한 후 성공적으로 추천 코드를 사용한 승객.",
                "referredPaxTooltip": "아직 예약하지 않은 추천 코드를 사용한 승객.",
                "activePax": "총 활성 고객",
                "referredPax": "총 추천 고객",
                "detailFields": {
                    "passengerId": "승객 ID",
                    "passengerName": "승객 이름",
                    "firstBookingDate": "첫번째 완료된 예약 날짜",
                    "firstBookingDateGMT": "첫번째 완료된 예약 날짜 (GMT)"
                },
                "showDetail": "보기",
                "detail": "세부 사항"
            },
            "driverRefersDriver": {
                "companyName": "회사",
                "phoneNumber": "전화번호",
                "username": "사용자 이름",
                "referralCode": "추천 코드",
                "referrer": "추천인",
                "numberOfReferees": "참조자 수",
                "activeReferees": "활성 참조자",
                "referee": "피추천인",
                "refereePhone": "심판 전화번호",
                "refereeUsername": "심판 사용자 이름",
                "referredDate": "추천한 날짜",
                "activatedDate": "활성화 된 날짜",
                "referrerByDriver": "추천인",
                "referrerPhone": "추천인 전화번호",
                "referralStatus": "추천 상태",
                "lifeTimeBookings": "생애 예약",
                "inReview": "검토 중",
                "activated": "활성화됨"
            },
            "driverWithdrawal": {
                "transferToEWallet": "외부 전자 지갑 *{0}로 이체",
                "channelCode": "채널 코드",
                "channelName": "채널 이름",
                "reversed": "거꾸로",
                "currentBalanceTooltip": "출금 요청 전 드라이버의 현금 월렛 잔액",
                "paymentTime": "지불 시간",
                "requestTime": "요청 시간",
                "referenceId": "참조 #",
                "transactionId": "거래 ID",
                "description": "설명",
                "transferAmount": "이체 금액",
                "currency": "통화",
                "approved": "승인됨",
                "rejected": "거절됨",
                "failed": "실패",
                "reason": "이유"
            },
            "penaltyCompensation": {
                "penaltyAmount": "벌금",
                "totalCollect": "현지 화폐로 지불 필요",
                "totalCollectInUSD": "USD로 지불 필요",
                "compensationAmount": "보상",
                "compensationAmountInUSD": "보상 (USD)",
                "penaltyReason": "벌금 이유",
                "estimatedPrice": "예상 가격",
                "estimatedPriceInUSD": "예상 가격 (USD)",
                "penaltyAmountInUSD": "벌금 (USD)",
                "amount": "금액",
                "amountInUSD": "금액 (USD)"
            },
            "imcompletePayment": {
                "bookingId": "예약 ID",
                "bookFrom": "에서 예약",
                "bookingTime": "예약 날짜/시간",
                "completedTime": "예약 완료 날짜/시간",
                "customerName": "고객 이름",
                "requestedPaymentMethod": "요청된 결제 방법",
                "originalPaymentStatus": "원래 결제 상태",
                "currentPaymentStatus": "현재 결제 상태",
                "updatedDateTime": "수집된 잔액 날짜/시간",
                "totalAmt": "총 금액",
                "originalOutstandingAmount": "원래 미수금액",
                "currentOutstandingAmount": "현재 미수 금액",
                "outstandingAmountPaidBy": "미수 금액 수집자",
                "writeOffDebtMethod": "미수 금액 수집자",
                "reason": "이유",
                "customerPhone": "전화번호",
                "amountCollected": "수집된 금액",
                "partialPaymentAmount": "드롭 오프시 부분 지불"
            },
            "driverDeposit": {
                "dateAndTime": "날짜 및 시간",
                "userName": "사용자 이름",
                "type": "유형",
                "newAmount": "새로운 잔액",
                "topUpGCashReason": "GCash로 충전",
                "topUpReason": "신용카드 *{0}에서 충전",
                "cashWalletReason": "현금 지갑에서 충전",
                "topUpMOLPayReason": "Razer Pay [ {0} ]"
            },
            "refund": {
                "fullRefund": "전액 환불",
                "partialRefund": "부분 환불",
                "tripId": "여행 ID",
                "route": "경로",
                "refundAmount": "환불 금액",
                "refundTime": "환불 시간",
                "paymentStatus": "결제 상태"
            },
            "merchant": {
                "store": "상점",
                "name": "이름",
                "phoneNumber": "전화번호",
                "bookingId": "예약 #",
                "totalOrders": "총 주문",
                "completedOrders": "완료된 주문",
                "canceledOrders": "취소된 주문",
                "incidentOrders": "사건",
                "revenue": "수익",
                "commission": "수수료",
                "earning": "수익",
                "food": "음식",
                "mart": "마트",
                "preferredMerchant": "선호하는 판매자",
                "regularMerchant": "정규 판매자",
                "companyName": "회사"
            },
            "merchantCashTransactionHistory": {
                "companyName": "회사",
                "dateTime": "날짜 및 시간",
                "merchantUserName": "상인 사용자",
                "merchantUserPhone": "전화번호",
                "merchantUserEmail": "이메일",
                "merchantName": "상인",
                "transactionType": "유형",
                "bookId": "예약 #",
                "transactionId": "거래 ID",
                "operatorName": "운영자",
                "reason": "이유",
                "amount": "금액",
                "newBalance": "새로운 잔액",
                "currencyISO": "통화"
            },
            "merchantCreditTransactionHistory": {
                "dateTime": "날짜 및 시간",
                "merchantUserName": "상인 사용자",
                "merchantUserPhone": "전화번호",
                "merchantUserEmail": "이메일",
                "merchantName": "상인",
                "transactionType": "유형",
                "bookId": "예약 #",
                "transactionId": "거래 ID",
                "operatorName": "운영자",
                "reason": "이유",
                "amount": "금액",
                "newBalance": "새로운 잔액",
                "currencyISO": "통화"
            },
            "deleteAccountRequest": {
                "date": "날짜",
                "phone": "전화",
                "username": "사용자 이름",
                "supportId": "지원 ID",
                "requestFrom": "요청자",
                "associatedApps": "관련 앱들",
                "reason": "이유"
            },
            "affiliationPayoutHistory": {
                "payoutId": "결제 ID",
                "dateTime": "날짜 및 시간",
                "payoutType": "유형",
                "accountHolderName": "계좌 소유자의 이름",
                "bankName": "은행명",
                "accountNumber": "계좌 번호",
                "totalPayout": "총 결제금액 (USD)",
                "viewDetails": "세부사항 확인",
                "notes": "메모",
                "bookId": "예약 #",
                "transactionType": "거래 유형",
                "transactionId": "거래 ID (자동 이체)",
                "settlement": "결산",
                "paymentMethod": "유형",
                "networkType": "네트워크 유형"
            },
            "thirdPartyBooking": {
                "date": "날짜",
                "bookingId": "예약 ID",
                "externalId": "외부 ID",
                "psgPhone": "승객 전화번호",
                "psgName": "승객 이름",
                "pickupLocation": "픽업 위치",
                "pickupLocationLatLong": "픽업 위치 위도/경도",
                "dropoffLocation": "하차 위치",
                "dropoffLocationLatLong": "하차 위치 위도/경도",
                "pickupTime": "픽업 시간",
                "numOfPassenger": "승객 수",
                "action": "동작"
            },
            "external": "외부 공급자",
            "inHouse": "내부 공급자",
            "negative": "음수",
            "positive": "긍정",
            "supplierType": "공급자 유형",
            "supplierCompany": "공급자/회사",
            "invalidOrNoBank": "무효",
            "BankInfo": "은행 정보",
            "BankStatusConnect": "게이트웨이 상태",
            "payManually": "수동 결제",
            "payViaGateway": "%{gateway}를 통한 결제",
            "payConfirmModal_manual": "수동 지급 확인",
            "payConfirmModal_manual_note": "선택한 %{type}에 <b>수동 지급</b>을 처리하려고 합니다. 이것은 각 %{type}의 지갑 잔액을 업데이트하고 은행 처리를 위한 지급 보고서를 생성합니다.",
            "payConfirmModal_auto": "자동 지급 확인",
            "payConfirmModal_auto_note": "선택한 %{type}에 <b>%{gateway}</b>를 통한 <b>자동 지급</b>을 처리하려고 합니다. 지급금은 그들의 등록된 은행 계좌로 직접 보내질 것입니다.",
            "Eligible": "자동 지급에 적격",
            "EligibleNote": "오직 %{value} 공급 업체만 자동 지급에 적격합니다. 나머지 공급 업체들에 대한 은행 계좌 정보를 확인하고 업데이트하십시오."
        }
    },
    "zoneSetting": {
        "Add": "추가",
        "Import": "가져오기",
        "Name": "이름",
        "Status": "상태",
        "Active": "활성",
        "Inactive": "비활성화",
        "Deactivate": "비활성화",
        "Activate": "활성화",
        "Delete": "삭제",
        "Cancel": "취소",
        "Input_zone_name": "영역 이름 입력",
        "Save_zone": "영역 저장",
        "Clear_draw": "그리기 지우기",
        "Edit": "편집",
        "Delete_zone_success": "영역이 성공적으로 삭제되었습니다",
        "Delete_zone_fail": "영역을 삭제하는 동안 에러가 발생했습니다",
        "Update_zone_fail": "영역을 업데이트하는 동안 에러가 발생했습니다",
        "Update_zone_success": "영역이 성공적으로 업데이트되었습니다",
        "Create_zone_fail": "영역을 생성하는 동안 에러가 발생했습니다",
        "Create_zone_success": "새로운 영역이 성공적으로 생성되었습니다",
        "Draw_zone": "지도에 영역을 그려주십시오",
        "Import_zones_successful": "영역 가져오기 성공",
        "Import_zones_fail": "영역 가져오기 실패",
        "DELETE_ZONE": "영역 삭제",
        "ZONE_CONFIRM": "선택한 영역을 삭제하시겠습니까?",
        "Name_zone_required": "이름과 영역은 필수입니다!",
        "Select_file": "파일 선택",
        "No": "아니오",
        "Yes": "예",
        "Import_zones_intercity_successful": "[{0}] 영역(들)이 성공적으로 가져온 후, [{1}] 실패.",
        "Import_zones_intercity_successful_failed": "[{0}] 영역(들)이 성공적으로 가져온 후, [{1}] 실패.",
        "Flat_zone": "고정 영역",
        "Json_file": "Json 파일",
        "Import_zones": "영역 가져오기",
        "timezone": "시간대"
    },
    "companySetting": {
        "DELETE_COMPANY": "회사 삭제",
        "DELETE_CONFIRM": "회사를 삭제하시겠습니까?",
        "DETAIL_COMPANY": "에이전트 (회사) 세부 정보",
        "commissionValue": "회사 커미션",
        "connectStatus": "Stripe Connect",
        "connectStripe": "연결",
        "stripeConnectId": "Stripe 계정 ID",
        "loginStripe": "대시보드",
        "disconnectStripe": "연결 해제",
        "Yes": "예",
        "No": "아니오",
        "Cancel": "취소",
        "EDIT_COMPANY": "에이전트 (회사) 편집",
        "ADD_COMPANY": "에이전트 (회사) 추가",
        "Name": "이름",
        "Required_fields": "필수 입력란",
        "Save": "저장",
        "Actions": "행동",
        "Edit": "편집",
        "Add": "추가",
        "Show_per_page": "페이지 당 항목 수",
        "Page": "페이지",
        "show_pages": "{0} - {1} of {2} 표시됨",
        "Create_company_success": "새로운 회사가 성공적으로 생성되었습니다",
        "Create_company_fail": "회사를 생성하는 동안 오류가 발생했습니다",
        "Update_company_success": "회사가 성공적으로 업데이트되었습니다",
        "Update_company_fail": "회사를 업데이트하는 동안 오류가 발생했습니다",
        "Load_company_fail": "회사를 로딩하는 동안 오류가 발생했습니다",
        "Delete_company_success": "회사가 성공적으로 삭제되었습니다",
        "Delete_company_fail": "회사를 삭제하는 동안 오류가 발생했습니다",
        "hideFare": "항상 운임 숨기기",
        "Broadcast_orders": "모든 주문을 방송",
        "paymentMethodsApply": "지불 방식 지원",
        "emailsNotification": "이메일 알림",
        "CopySignUpLink": "가입 링크 복사",
        "operationZone": "운영 지역",
        "delayBroadcast": "주문을 표시 후",
        "releaseTime": "공개 시간",
        "advanceBookingVisibility": "선봉 예약 가시성",
        "advanceBookingVisibilityTooltip": "일정한 일정을 기반으로, 공급 업체가 예약을 볼 수 있는 날짜의 수를 설정하십시오. 이는 예약이 공급 업체에게 적시에 배포되도록 합니다."
    },
    "dispatchSetting": {
        "Cut_off_time_range": "폐업 시간 이후 예약 제한",
        "Cut_off_time_range_tooltip": "만일 폐업 창이 오후 10시 - 오전 6시라면, 고객들은 여전히 오후 10시 이전에 오후 10시 이후의 픽업을 예약할 수 있습니다. 그러나, 현재 시간이 오후 10시 - 오전 6시 사이라면, 허용되는 최초 픽업은 오전 6시 + 리드 타임 이후입니다.",
        "GENERAL": "일반",
        "Offer_interval": "제안 간격 (운전자)",
        "Offer_interval_merchant": "제안 간격 (판매자)",
        "Offer_interval_merchant_toolTip": "판매자가 주문을 수락하는 최대 시간",
        "Offer_interval_toolTip": "운전자가 예약을 수락하는 최대 시간",
        "soundMarketplace": "사운드",
        "sound": "사운드",
        "Auto_re_dispatch_interval_toolTip": "2라운드 사이의 휴식 시간",
        "Maximum_auto_dispatch_duration_toolTip": "운전자에게 예약을 배정하는 최대 시간",
        "Seconds": "초",
        "Auto_re_dispatch_interval": "자동 재배치 간격",
        "Maximum_auto_dispatch_duration": "최대 자동 배치 지속 시간",
        "Time_out": "시간 초과",
        "mins": "분",
        "minTimeBeforeReservation": "운전자가 픽업 시간 전에 예약을 시작하지 못하게 하기",
        "IN_ADVANCE": "선급",
        "Assign_reservation_to_driver": "운전자에게 예약 할당",
        "Dispatcher_confirms_job_for_driver": "디스패처는 운전자를 위한 작업을 확정합니다",
        "Dispatcher_confirms_job_for_offline_driver": "디스패처는 오프라인 운전자에게 예약을 확인합니다",
        "Broadcast_orders": "모든 회사에 주문을 방송",
        "Broadcast_orders_tooltip_1": "만약 당신이 모든 여행을 모든 회사 공급자에게 방송하고 싶다면 이 설정을 활성화하세요. \n각 회사의 프로필에서 방송 모드를 활성화 한다는 것을 기억하세요.",
        "Minimum_book_ahead": "최소 예약 기간",
        "Maximum_book_ahead": "최대 예약 기간 - 단일 주문",
        "Maximum_period_recurring_oders_fleet": "반복주문 최대기간 (플릿운영자용)",
        "Maximum_period_recurring_oders_corp": "반복주문 최대기간 (기업용)",
        "Day": "일",
        "Week": "주",
        "Month": "월",
        "hrs": "시",
        "Driver_cancellation_duration": "운전자 취소 기간",
        "Mins": "분",
        "Maximum_Day": "운전자가 하루에 수락 할 수 있는 최대 예약 수.",
        "Maximum_Accept_Reservation": "운전자가 한 번에 수락 할 수 있는 총 예약 수.",
        "jobRTDriver": "작업을 운전자에게 공개하는 시간 (픽업 전)",
        "jobRTDriverDes": "이미 할당된 운전자가 픽업 시간 전에 어플리케이션에서 작업을 볼 수 있는 시간을 설정합니다. - 예. 픽업 24시간 전.",
        "Local_notification_before": "지역 알림 전",
        "Dispatch_mode": "디스패치 모드",
        "Manual": "수동",
        "Immediate_auto_dispatch": "즉시 자동배치",
        "Delayed_auto_dispatch": "지연된 자동배치",
        "Auto_dispatch_before_pickup_time": "출발 시간 전 자동 배치",
        "Auto_Reassign_Before_Pickup_Time": "픽업 시간 전 자동 재배정",
        "Auto_Reassign_Before_Pickup_Time_Tooltip": "할당된 운전자가 픽업 시간 전 X분에 시작하지 않으면 작업이 자동으로 재배정됩니다. 참고 : 이 기능은 내부 공급자 운전자에게만 적용됩니다.",
        "Required_fields": "필수 입력란",
        "Shuttle": "셔틀",
        "Shuttle_Dispatch_mode": "디스패치 모드",
        "Dispatch_setting_Shuttle_Dispatch_mode_tooltip": "- 수동 모드: 예약이 생성되면 예약이 저장되고 당신의 커맨드 센터의 대기열에 “보류” 상태로 머물게 됩니다. 예약 내역에서 “예약 수정”을 클릭하면, 해당 예약이 바로 할당 모드에 있는 당신의 드라이버들에게 보내지게 되거나, 드라이버가 할당되지 않는 경우에는 모든 드라이버에게 보내지게 됩니다. 이것은 드라이버 장비 달력과 이란더가 통합되게 됩니다. <br>- 지연 모드:예약이 생성되면 예약이 저장되고 당신의 커맨드 센터의 대기열에 “보류” 상태로 머물게 됩니다. 예약은 “미리 처리하기”의 “시간 값” 이전에 자동적으로 할당된 드라이버에게 보내지거나, 드라이버가 할당되지 않는 경우에는 가장 가까운 이용 가능한 드라이버에게 보내지게 됩니다. <br>- 즉시 자동 배송 모드: 예약이 생성되는 즉시 예약은 모든 드라이버에게 자동적으로 보내집니다. 이것은 드라이버 장비 달력과 이란더가 통합되게 됩니다.",
        "Save": "저장",
        "Process_in_advance": "미리 처리",
        "Save_dispatch_success": "디스패치가 성공적으로 업데이트되었습니다",
        "Save_dispatch_fail": "디스패치를 업데이트하는 동안 오류가 발생했습니다",
        "Dispatch_setting_general_tooltip": "요구사항에 따른 예약, 지연된 자동디스패치를 사용한 미리 예약을 적용합니다",
        "Dispatch_setting_Assign_reservation_to_driver_tooltip": "이 옵션을 사용하면 운전자가 자동적으로 예약을 할당하고 예약을 수락합니다",
        "Dispatch_setting_Driver_cancellation_duration_tooltip": "운전사가 예약을 취소하는 시간부터 픽업 시간까지의 기간",
        "Dispatch_setting_Dispatch_mode_tooltip": "- 수동 모드: 예약이 생성되면 예약이 저장되고 당신의 커맨드 센터의 대기열에 “보류” 상태로 머물게 됩니다. 예약 내역에서 “예약 수정”을 클릭하면, 해당 예약이 바로 할당 모드에 있는 당신의 드라이버들에게 보내지게 되거나, 드라이버가 할당되지 않는 경우에는 모든 드라이버에게 보내지게 됩니다. 이것은 드라이버 장비 달력과 이란더가 통합되게 됩니다. <br>- 지연 모드:예약이 생성되면 예약이 저장되고 당신의 커맨드 센터의 대기열에 “보류” 상태로 머물게 됩니다. 예약은 “미리 처리하기”의 “시간 값” 이전에 자동적으로 할당된 드라이버에게 보내지거나, 드라이버가 할당되지 않는 경우에는 가장 가까운 이용 가능한 드라이버에게 보내지게 됩니다. <br>- 즉시 자동 배송 모드: 예약이 생성되는 즉시 예약은 모든 드라이버에게 자동적으로 보내집니다. 이것은 드라이버 장비 달력과 이란더가 통합되게 됩니다.",
        "Notification_nearby_drivers_before_pickup_time": "출발 시간 전에 근처의 운전사들에게 알림",
        "Dispatch_setting_Maximum_Day_tooltip": "이것은 운전사가 동일한 일에 너무 많은 예약을 가지는 것을 제한합니다. 마켓플레이스와 인터시티에 적용됩니다.",
        "Maximum_Accept_Reservation_tooltip": "운전사가 수락한 예약의 수는 이 수를 초과할 수 없습니다. 이 것은 운전사가 한 번에 너무 많은 수를 수락하는 것을 제한합니다. 마켓플레이스와 인터시티에 적용됩니다.",
        "Notification_nearby_drivers_before_pickup_time_tooltip": "고객의 예약이 설정된 시간 전에 어떤 운전자도 수락하지 않으면, 시스템은 근처의 운전사들에게 알림을 보냅니다. 이것은 그들이 마켓플레이스를 확인하고 예약을 수락하도록 격려 할 것입니다.",
        "marketPlace": "마켓 플레이스",
        "howFarDriverSeeBookingMarketplace": "운전사가 마켓플레이스에서 예약을 얼마나 멀리서 볼 수 있는지",
        "shortNoticeOrder": "짧은 통지 주문",
        "shortNoticeOrderTooltip": "예약이 긴급하여 모든 티어에 즉시 표시되어야 하는 시간을 설정하십시오."
    },
    "voiceSMSSetting": {
        "ACCOUNT_SETTINGS": "계정 설정",
        "Account_SID": "계정 SID",
        "Auth_Token": "Auth 토큰",
        "Application_ID": "애플리케이션 ID",
        "SMS_number_1": "SMS 번호 1",
        "SMS_number_2": "SMS 번호 2",
        "SMS_SETTINGS": "SMS 설정",
        "MASKED_PHONE_SETTINGS": "마스킹 전화 설정",
        "SMS_MARKETING_SETTINGS": "SMS 마케팅 설정",
        "Phone_number": "전화번호",
        "Save": "저장",
        "voiceSMS": "TWILIO",
        "DRIVER_APP": "드라이버 앱",
        "PASSENGER_APP": "승객 앱",
        "allowDriverToCallCC": "드라이버가 도움말 센터를 호출하는 것을 허용:",
        "allowDriverToCallHelpdesk": "드라이버가 도움말 센터를 호출하는 것을 허용:",
        "allowDriverToCallPassenger": "드라이버가 아래로 승객에게 전화하도록 허용:",
        "allowPassengerToCallCC": "승객이 아래로 헬프데스크에 전화하도록 허용:",
        "allowPassengerToCallHelpdesk": "승객이 아래로 헬프데스크에 전화하도록 허용:",
        "allowPassengerToCallDriver": "승객이 아래로 드라이버에게 전화하도록 허용:",
        "voip": "VOIP",
        "mobile": "모바일",
        "bookingSMS": "메시지 템플릿",
        "bookingSMSTemplate": {
            "name": "이름",
            "content": "내용",
            "action": "동작",
            "DELETE": "메시지 템플릿 삭제",
            "DELETE_CONFIRM": "선택한 메시지 템플릿을 삭제하시겠습니까?",
            "EDIT": "메시지 템플릿 편집",
            "ADD": "메시지 템플릿 추가",
            "DETAIL": "메시지 템플릿 상세",
            "Update_success": "메시지 템플릿이 성공적으로 업데이트되었습니다",
            "Create_success": "메시지 템플릿이 성공적으로 생성되었습니다",
            "Delete_success": "메시지 템플릿이 성공적으로 삭제되었습니다",
            "Delete_fail": "메시지 템플릿 삭제 중 오류가 발생했습니다",
            "Load_fail": "메시지 템플릿 로드 중 오류가 발생했습니다",
            "Update_fail": "메시지 템플릿 업데이트 중 오류가 발생했습니다",
            "Create_fail": "메시지 템플릿 생성 중 오류가 발생했습니다"
        },
        "bookingSMSModal": {
            "title": "SMS 템플릿 추가",
            "save": "저장",
            "cancel": "취소",
            "titleMessage": "메시지 보내기",
            "template": "템플릿",
            "phoneNumber": "전화번호",
            "content": "내용",
            "messageType": "메시지 유형",
            "inbox": "받은 편지함",
            "sms": "SMS",
            "sendTo": "보낸 사람",
            "passenger": "승객",
            "driver": "운전자"
        }
    },
    "regularSetting": {
        "extraWaitTimeTooltip": "추가로 고객을 기다리는 동안 운전자에게 보상해주는 요금. 최대 대기 시간을 설정하려면 일반 설정으로 이동하세요.",
        "fareWaitTimeLater": "예약별 분당 요금",
        "fareWaitTimeNow": "즉시 분당 요금",
        "transport": "교통",
        "delivery": "배달",
        "Fer_Stop": "정지 요금",
        "First_Stop": "첫 번째 정지 요금",
        "Each_Stop": "추가 정지 요금마다의 요금",
        "Name": "이름",
        "Pay_to_driver_Cash": "공급업체/운전자에게 지불 (현금 예약)",
        "Last_Update": "최근 업데이트",
        "Status": "상태",
        "Required_fields": "필수 입력란",
        "Yes": "예",
        "No": "아니오",
        "Cancel": "취소",
        "Save": "저장",
        "Actions": "행동",
        "Edit": "편집",
        "Add": "추가",
        "Show_per_page": "페이지 당 항목 수",
        "Page": "페이지",
        "show_pages": "{0} - {1} of {2} 표시됨",
        "DELETE_CONFIRM": "삭제하시겠습니까?",
        "ADD_REGULAR_RATE": "정규 요금 추가",
        "EDIT_REGULAR_RATE": "정규 요금 수정",
        "DETAIL_REGULAR_RATE": "정규 요금 상세",
        "DELETE_REGULAR_RATE": "정규 요금 삭제",
        "Delete_confirm_regular_rate": "이 항목을 삭제하시겠습니까?",
        "STARTING": "시작",
        "Starting_Now": "즉시 출발",
        "Starting_Reservation": "예약 출발",
        "FIRST_DISTANCE_FEE": "첫 거리 요금",
        "First_distance_fee": "첫 거리",
        "From": "에서",
        "To": "로",
        "Fee_for_first_distance": "첫 거리 요금",
        "SECOND_DISTANCE_FEE": "두 번째 거리 요금",
        "Second_distance_fee": "두 번째 거리",
        "AFTER_SECOND_DISTANCE": "두 번째 거리 이후",
        "Fee_after_second_distance": "두 번째 거리 이후 요금",
        "PER_MINUTE": "분당",
        "Fee_per_minute": "분당 요금",
        "mi": "mi",
        "hour": "시간",
        "MINIMUM": "최소",
        "Minimum_Now": "즉시 최소",
        "Minimum_Reservation": "예약 최소",
        "PAX_MDISPATCHER_CANCELLATION": "승객/ 파트너 취소",
        "On_demand": "승객/파트너 취소 - 표시",
        "Penalty": "벌금액",
        "In_advance": "승객/파트너 취소 - 포기",
        "PAX_MDISPATCHER_NO_SHOW": "승객/ 파트너 노쇼",
        "Driver_cancel_demand": "운전자 취소 정책 - 표시",
        "Driver_cancel_advance": "운전자 취소 정책 - 진행",
        "Assign_car_type": "차량 유형 지정",
        "Select_car_type": "차량 유형 선택",
        "Active": "활성",
        "Inactive": "비활성화",
        "Deactivate": "비활성화",
        "DELETE_FLATE_RATE": "정액 요금 삭제",
        "Delete_confirm_flat_rate": "이 항목을 삭제하시겠습니까?",
        "EDIT_FLAT_RATE": "정액 요금 편집",
        "ADD_FLAT_RATE": "정액 요금 추가",
        "DELETE_FLAT_RATE": "정액 요금 삭제",
        "DELETE_HOURLY_RATE": "시간당/일일 요금 삭제",
        "Delete_confirm_hour_rate": "이 항목을 삭제하시겠습니까?",
        "EDIT_HOURLY_RATE": "시간당/일일 요금 수정",
        "ADD_HOURLY_RATE": "시간당/일일 요금 추가",
        "DELETE_FLAT_ROUTE": "정액 루트 삭제",
        "DELETE_ROUTE_CONFIRM": "루트를 삭제해도 괜찮겠습니까?",
        "EDIT_ROUTE": "루트 수정",
        "ADD_ROUTE": "루트 추가",
        "Route_name": "경로 이름",
        "Route_type": "루트 유형",
        "Zone_to_zone": "구역간",
        "Zipcode_to_zipcode": "우편번호간",
        "First_location": "첫 번째 위치",
        "Second_location": "두 번째 위치",
        "First_location_zip_note": "*Notes: 여러 우편번호를 동시에 입력하려면 ',' 기호를 사용하십시오. 연속 코드의 경우, 하나씩 입력하는 대신 '->' 기호를 사용하십시오 (예: 90001 -> 90099, 90101, 90102, 90103, 90174, 90185)",
        "Second_location_zip_note": "*Notes: 여러 우편번호를 동시에 입력하려면 ',' 기호를 사용하십시오. 연속 코드의 경우, 하나씩 입력하는 대신 '->' 기호를 사용하십시오 (예: 90001 -> 90099, 90101, 90102, 90103, 90174, 90185)",
        "SINGLE_TRIP_SETUP": "일회용 트립 설정",
        "Route_1": "루트 1 (첫 번째 위치 -> 두 번째 위치)",
        "Route_2": "루트 2 (두 번째 위치 -> 첫 번째 위치)",
        "Limitation": "제한",
        "Unlimited": "무제한",
        "Limited": "제한",
        "Time_coverage": "시간 범위",
        "Extra_time": "추가 시간",
        "ROUND_TRIP_SETUP": "왕복 설정",
        "Round_trip": "왕복",
        "ROUTES": "ROUTES",
        "Route_1_Fare": "루트 1 요금",
        "Route_2_Fare": "루트 2 요금",
        "Round_Trip_Fare": "왕복 요금",
        "Select_a_zone": "구역 선택",
        "minute": "분",
        "VIEW_REGULAR_RATE": "일반 요금 상세보기",
        "VIEW_FLAT_RATE": "정액 조회",
        "VIEW_HOURLY_RATE": "시간당 요금 보기",
        "HOURLY_PACKAGE_RATE": "시간당 패키지 요금",
        "Package_name": "패키지 이름",
        "Package_duration": "패키지 기간",
        "PackageId": "패키지 ID",
        "Base_rate": "기본 요금",
        "Distance_coverage": "거리 범위",
        "Extra_duration": "추가 기간",
        "Extra_distance": "추가 거리",
        "DELETE_HOURLY_PACKAGE": "시간당 패키지 삭제",
        "DELETE_PACKAGE_CONFIRM": "패키지 요금을 삭제하시겠습니까?",
        "EDIT_PACKAGE": "패키지 수정",
        "VIEW_PACKAGE": "패키지 세부정보 보기",
        "ADD_PACKAGE": "패키지 추가",
        "Fee_per_extra_duration": "추가 기간 당 비용",
        "Fee_per_extra_distance": "추가 거리당 요금",
        "hours": "시간",
        "days": "일",
        "Update_flat_rate_success": "정액 요금이 성공적으로 업데이트되었습니다",
        "Update_flat_rate_fail": "정액 요금 업데이트 중 오류 발생",
        "Created_flat_rate_success": "정액 요금이 성공적으로 생성되었습니다",
        "Created_flat_rate_fail": "정액 요금 생성 중 오류 발생",
        "Update_flat_rate_route_success": "정액 요금 루트가 성공적으로 업데이트되었습니다",
        "Update_flat_rate_route_fail": "정액 요금 루트 업데이트 중 오류 발생",
        "Created_flat_rate_route_success": "정액 요금 루트가 성공적으로 생성되었습니다",
        "Created_flat_rate_route_fail": "정액 요금 루트 생성 중 오류 발생",
        "Loading_flat_rate_fail": "정액 요금 세부사항 로드 중 오류 발생",
        "Delete_flat_rate_route_fail": "정액 요금 루트 삭제 중 오류 발생",
        "Delete_flat_rate_success": "정액 요금이 성공적으로 삭제되었습니다",
        "Delete_flat_rate_fail": "정액 요금 삭제 중 오류 발생",
        "Update_intercity_rate_success": "시외 요금이 성공적으로 업데이트되었습니다",
        "Update_intercity_rate_fail": "시외 요금 업데이트 중 오류 발생",
        "Created_intercity_rate_success": "시외 요금이 성공적으로 생성되었습니다",
        "Created_intercity_rate_fail": "시외 요금 생성 중 오류 발생",
        "Update_intercity_rate_route_success": "시외 요금 루트가 성공적으로 업데이트되었습니다",
        "Update_intercity_rate_route_fail": "시외 요금 루트 업데이트 중 오류 발생",
        "Created_intercity_rate_route_success": "시외 요금 루트가 성공적으로 생성되었습니다",
        "Created_intercity_rate_route_fail": "시외 요금 루트 생성 중 오류 발생",
        "Loading_intercity_rate_fail": "시외 요금 세부사항 로드 중 오류 발생",
        "Delete_intercity_rate_route_fail": "시외 요금 루트 삭제 중 오류 발생",
        "Delete_intercity_rate_success": "시외 요금이 성공적으로 삭제되었습니다",
        "Delete_intercity_rate_fail": "시외 요금 삭제 중 오류 발생",
        "Update_regular_rate_success": "일반 요금이 성공적으로 업데이트되었습니다",
        "Update_regular_rate_fail": "일반 요금 업데이트 중 오류 발생",
        "Create_regular_rate_success": "일반 요금이 성공적으로 생성되었습니다",
        "Create_regular_rate_fail": "일반 요금 생성 중 오류 발생",
        "Update_hourly_rate_success": "시간당 요금이 성공적으로 업데이트되었습니다",
        "Update_hourly_rate_fail": "시간당 요금 업데이트 중 오류 발생",
        "Create_hourly_rate_success": "시간당 요금이 성공적으로 생성되었습니다",
        "Create_hourly_rate_fail": "시간당 요금 생성 중 오류 발생",
        "Update_hourly_rate_package_success": "시간당 패키지 요금이 성공적으로 업데이트되었습니다",
        "Update_hourly_rate_package_fail": "시간당 패키지 요금 업데이트 중 오류 발생",
        "Create_hourly_rate_package_success": "시간당 패키지 요금이 성공적으로 생성되었습니다",
        "Create_hourly_rate_package_fail": "시간당 패키지 요금 생성 중 오류 발생",
        "Load_hourly_rate_fail": "시간당 요금 세부사항 로드 중 오류 발생",
        "Update_hourly_status": "시간당 요금 상태 업데이트 중 오류 발생",
        "Delete_hourly_fail": "시간당 요금 삭제 중 오류 발생",
        "Delete_hourly_success": "시간당 요금이 성공적으로 삭제되었습니다",
        "Loading_regular_rate_fail": "일반 요금 세부사항 로드 중 오류 발생",
        "Update_regular_status_fail": "일반 요금 상태 업데이트 중 오류 발생",
        "Delete_regular_rate_success": "일반 요금이 성공적으로 삭제되었습니다",
        "Delete_regular_rate_fail": "일반 요금 삭제 중 오류 발생",
        "Please_go_to_Car_Type_settings": "이 요금을 어떤 차량 유형에든 적용하려면 설정 > 차 > 차량 유형으로 이동하세요.",
        "Car_type_filter": "차량 유형 필터",
        "Delete_package_error": "패키지를 삭제하는 중 오류가 발생했습니다!",
        "Pax_mDispatcher_cancellation_tooltip": "승객에게 적용된 취소 정책",
        "Penalty_tooltip": "고객이 청구될 금액. 패널티에 세금이나 기술료를 추가할 수 있습니다.",
        "Pax_mDispatcher_no_show_tooltip": "승객에게 적용된 노쇼 정책. 이 요금은 운전자가 픽업 위치에서 승객을 보지 못할 때 \"\"노쇼\"\"를 누르면 청구됩니다.",
        "detail_route": "상세 경로",
        "detail_package": "상세 패키지",
        "THIRD_DISTANCE_FEE": "제3거리 요금",
        "AFTER_DISTANCE_FEE": "제3거리 요금 이후",
        "Loading_delivery_rate_fail": "배송 요금 상세 로딩 중 오류 발생",
        "Update_delivery_rate_fail": "배송 요금 업데이트 중 오류 발생",
        "Update_delivery_rate_success": "배송 요금이 성공적으로 업데이트되었습니다",
        "Created_delivery_rate_success": "배송 요금이 성공적으로 생성되었습니다",
        "Created_delivery_rate_fail": "배송 요금 생성 중 오류 발생",
        "Starting_fee": "시작 요금",
        "First_distance": "첫 거리",
        "Second_distance": "두 번째 거리",
        "Third_distance": "세 번째 거리",
        "Fee_for_second_distance": "두 번째 거리 요금",
        "Fee_for_third_distance": "세 번째 거리 요금",
        "Fee_after_third_distance": "세 번째 거리 이후 요금",
        "Assign_rate_to_car_type": "차량유형에 요금 할당",
        "car_type": "차량유형",
        "PRICE_ADJUSTABLE": "가격 조정 가능",
        "Amount_Step": "가격 조정 가능",
        "Tax": "세금",
        "TechFee": "기술 요금",
        "Pay_to_driver": "공급업체/운전자에게 지불",
        "Pay_to_driver_tooltip": "운전자에게 보상하는 옵션들:\n- 고정 금액: 운전자가 받을 고정 금액.\n- 수수료: 패널티 금액에 적용된 운전자의 설정 수수료.",
        "Fix_amount": "금액",
        "Commission": "수수료",
        "fareFlat": "정액 요금",
        "flatRoute": "평면 경로",
        "Mode": "모드",
        "speedThresholdKM": "속도 임계값 (km/h)",
        "speedThresholdMI": "속도 임계값 (mi/h)",
        "timeAndMileage": "시간 및 거리",
        "timeOrMileage": "시간 또는 거리",
        "perDistanceKM": "1km당",
        "perDistanceMI": "1마일당",
        "perTime": "분당",
        "regularRates": "일반 요금",
        "newRate": "새로운 요금",
        "enterName": "요금 이름 입력",
        "actualMode": "실제 요금",
        "estimatedMode": "견적 요금",
        "feePerStop": "추가 정지당 요금",
        "extraWaitTime": "추가 대기 시간",
        "startingFee": "시작",
        "minimumFee": "최소",
        "minAppend": "/분",
        "kmAppend": "/km",
        "miAppend": "/mi",
        "kmhrAppend": "km/h",
        "mihrAppend": "mi/h",
        "feePerKm": "1km당",
        "feePerMi": "1마일당",
        "feeSpeedThreshold": "속도 임계값",
        "serviceType": "서비스 유형",
        "fareMode": "공식",
        "calculationMode": "계산 모드",
        "timeChangeMode": "시간 요금 모드",
        "minimum_Percent_Adjust": "추정 요금에서 최소 %",
        "maximum_Percent_Adjust": "추정 요금에서 최대 %",
        "AllowAdjustPrice": "고객에게 가격 조정 허용",
        "Calculation": "계산",
        "distanceTier": "거리 구간",
        "perKm": "1km당 요금",
        "perMi": "1마일당 요금",
        "flatFee": "정액 요금",
        "defaultRate": "기본 요금",
        "timeRange": "시간 범위",
        "bookingType": "예약 유형",
        "rateDetail": "요금 상세",
        "subRate": "하위 요금",
        "specialRates": "특별 요금",
        "surcharge": "할증",
        "penalty": "벌금",
        "basedOriginMode": "원래 픽업 시간 기준",
        "basedDriverMode": "운전자 픽업 시간 기준",
        "hourlyRate": "시간당 요금",
        "flat_Fare": "정액 요금",
        "flatFeeOption": "정액 요금",
        "fareModeTooltip": "시간 또는 거리는 고객 요금에만 적용되며, 공급업체/운전자 지불 요금에는 적용되지 않습니다.",
        "cloneRate": "요금 복사하기",
        "rateName": "요금 이름",
        "Infinity": "무한대",
        "Fee": "요금",
        "headerTile": "헤더 제목 입력",
        "enterFooter": "푸터 제목 입력",
        "invoiceNo": "송장 번호.",
        "paidOn": "지급 일",
        "amountPaid": "지급 금액",
        "isFeePerSeatActive": "승객당 요금",
        "minSeat": "최소 승객 수",
        "minSeatTooltip": "이것은 예약에 청구될 최소 좌석 수입니다.",
        "dropOffZoneIds": "하차 구역",
        "applyGeniusDiscount": "Booking.com: Genius 할인(5%) 적용"
    },
    "flatRateSettings": {
        "flatZoneNote": "여기에서 생성하는 구역은 정액 요금 설정에만 사용됩니다."
    },
    "deliverySetting": {
        "Name": "이름",
        "Last_Update": "최근 업데이트",
        "Status": "상태",
        "Actions": "행동"
    },
    "sharingSetting": {
        "EDIT_RATE": "거리 공유율 수정",
        "ADD_RATE": "거리 공유율 추가",
        "VIEW_RATE": "거리 공유율 보기",
        "Name": "이름",
        "startingFee": "기본 요금",
        "minimumFee": "최소 요금",
        "Update_streetSharing_rate_fail": "거리 공유율 업데이트 중 오류 발생",
        "Update_streetSharing_rate_success": "거리 공유율이 성공적으로 업데이트되었습니다",
        "Created_streetSharing_rate_success": "거리 공유율이 성공적으로 생성되었습니다",
        "Created_streetSharing_rate_fail": "거리 공유율 생성 중 오류 발생",
        "Loading_streetSharing_rate_fail": "거리 공유율 상세 정보 불러오는 중 오류 발생",
        "Delete_streetSharing_rate_success": "거리 공유율이 성공적으로 삭제되었습니다",
        "Delete_streetSharing_rate_fail": "거리 공유율 삭제 중 오류 발생",
        "Delete_streetSharing_rate": "거리 공유율 삭제",
        "Assign_Car": "차량 유형 지정"
    },
    "carTypeSetting": {
        "ID": "자동차 종류 ID",
        "newService": "새로운 서비스",
        "editService": "서비스 편집",
        "serviceInfo": "서비스 정보",
        "name": "이름",
        "namePH": "차량 종류 이름",
        "enterNumber": "숫자를 입력하세요",
        "appDisplayName": "이름",
        "shortDescription": "간단한 설명",
        "maxPassengers": "최대 승객 수",
        "maxLuggage": "최대 수하물 수",
        "vehiclePhoto": "차량 사진들",
        "iconShowList": "목록에 보여줄 아이콘",
        "imageShowWeb": "웹에 보여줄 이미지",
        "carPinOnMap": "지도 위 차량 PIN",
        "recommendedSize": "추천 크기:",
        "serviceSetting": "서비스 설정",
        "serviceType": "서비스 유형",
        "reservation": "예약",
        "onDemand": "즉시 요청",
        "destinationSetting": "목적지 설정",
        "requireDestination": "목적지 필요",
        "extraDestination": "추가 목적지",
        "calculatorFareMode": "요금 계산 방식",
        "hideDestinationOnDemand": "즉시 요청",
        "meteredFare": "미터 단위 요금",
        "quotedFare": "견적 요금",
        "availableZones": "이용 가능한 지역",
        "dispatchAssociation": "디스패치 협회",
        "Save": "저장",
        "Edit": "편집",
        "Cancel": "취소",
        "validateName": "이름을 입력하세요",
        "validateAppDisplayName": "이름을 입력하세요",
        "validateSelectImage": "이미지를 선택하세요",
        "updateSuccess": "업데이트 성공",
        "createSuccess": "생성 성공",
        "failApi": "문제가 발생했습니다!",
        "validateRequire": "승객 수를 지정하고 수하물을 다시 확인해주세요."
    },
    "carSetting": {
        "Details": "세부사항",
        "vehicleInfo": "차량 정보",
        "Documents": "문서들",
        "vehicle": "차량",
        "addVehicle": "차량 추가",
        "detailVehicle": "차량 세부사항",
        "additionalVehicleTitle": "추가 차량 정보",
        "Phone_Number_Tooltip": "고객이 사용할 전용 차량 전화번호를 입력하세요. 제공하지 않을 경우, 전화는 기본적으로 운전자 개인 번호로 이동합니다. 전용 연락처를 구비한 공급자에 이상적입니다.",
        "discardChange": "변경 내용 폐기",
        "model_name_is_required": "모델 이름이 필요합니다",
        "DELETE_CAR": "차량 삭제",
        "DELETE_CONFIRM": "선택한 차량을 삭제하시겠습니까?",
        "Yes": "예",
        "Cancel": "취소",
        "EDIT_CAR": "차량 편집",
        "CREATE_CAR": "차량 생성",
        "Plate_Number": "차량 번호",
        "Car_Type": "차량 유형",
        "Select_car_type": "차량 유형 선택",
        "Make": "제조사",
        "Select_car_make": "차량 제조사 선택",
        "Model": "모델",
        "Select_a_car_model": "자동차 모델 선택",
        "Year": "생산 연도",
        "Select_year": "년도 선택",
        "Hardware_Meter": "하드웨어 미터",
        "VIN": "차량 식별 번호 (VIN)",
        "Company": "회사",
        "Select_company": "회사 선택",
        "Max_Passengers": "최대 승객 수",
        "Max_Luggage": "최대 수하물 수",
        "Color": "색상",
        "License_expiry": "운전 면허 만료",
        "Required_fields": "필수 입력란",
        "Save": "저장",
        "Add": "추가",
        "Car_Model": "자동차 모델",
        "Created_Date": "생성 날짜",
        "Status": "상태",
        "Actions": "행동",
        "Show_per_page": "페이지 당 항목 수",
        "Page": "페이지",
        "show_pages": "{0} - {1} of {2} 표시됨",
        "Active": "활성",
        "activeVehicle": "활성 차량",
        "Inactive": "비활성화",
        "Edit": "편집",
        "Deactivate": "비활성화",
        "Activate": "활성화",
        "Delete": "삭제",
        "Name": "이름",
        "MODEL_LIST": "모델 목록",
        "Model_Name": "모델 이름",
        "Add_Model": "모델 추가",
        "DELETE_CAR_MODEL": "자동차 모델 삭제",
        "DELETE_CONFIRM_MODEL": "자동차 모델을 삭제하시겠습니까?",
        "DELETE_CAR_MAKE": "자동차 제조사 삭제",
        "DELETE_CONFIRM_CAR_MAKE": "이 자동차 제조사를 삭제하시겠습니까?",
        "EDIT_CAR_MAKE": "자동차 제조사 편집",
        "CREATE_CAR_MAKE": "자동차 제조사 추가",
        "Assign_Rate": "요금 할당",
        "ASSIGN_RATE": "요금 할당",
        "Car_type_ID": "차량 유형 ID",
        "App_Display_Name": "이름",
        "Affiliate_car_type": "제휴 자동차 유형",
        "Regular_rate": "정규 요금",
        "Zone": "구역",
        "Rate": "요금",
        "Zone_Rate": "지역 - 요금",
        "Flat_Fare": "정액 요금",
        "Flat_Delivery": "배송 고정",
        "Select_flat_rate": "고정 요금 선택",
        "Hourly_daily_rate": "시간/일별",
        "Dispatch_To": "배차 해주기",
        "Normal_Fare": "일반",
        "Upload_an_image": "이미지 업로드",
        "DETAIL_CAR": "자동차 세부 정보",
        "DELETE_MULTI_CAR": "선택한 차량 삭제",
        "DELETE_MULTI_CAR_CONFIRM": "이 차량들을 삭제하시겠습니까 ,비활성 상태의 차량만 삭제할 수 있습니다?",
        "DETAIL_CAR_MAKE": "자동차 제조사",
        "Car_Make": "자동차 제조사",
        "Create_car_success": "새 차량이 성공적으로 생성되었습니다",
        "Update_car_success": "이 차량이 성공적으로 업데이트되었습니다.",
        "Update_car_fail": "차량 업데이트 중 오류 발생",
        "Create_car_fail": "차량 생성 중 오류 발생",
        "Load_car_fail": "차량 로드 중 오류 발생",
        "Delete_car_fail": "차량 삭제 중 오류 발생",
        "Delete_car_success": "차량이 성공적으로 삭제되었습니다",
        "Change_cars_status_success": "모든 차량 상태가 성공적으로 변경되었습니다",
        "Change_cars_status_fail": "차량 상태 변경 중 오류 발생",
        "Delete_cars_success": "선택한 모든 차량이 성공적으로 삭제되었습니다",
        "Delete_cars_fail": "차량 삭제 중 오류 발생",
        "Update_car_type_success": "자동차 유형이 성공적으로 업데이트되었습니다",
        "Update_car_type_fail": "자동차 유형 업데이트 중 오류 발생",
        "Load_car_type_details_fail": "자동차 유형 세부 정보를 로드할 수 없습니다",
        "Update_car_make_fail": "자동차 제조사 업데이트 중 오류 발생",
        "Update_car_make_success": "자동차 제조사가 성공적으로 업데이트되었습니다",
        "Create_car_make_fail": "자동차 제조사 생성 중 오류 발생",
        "Create_car_make_success": "새 자동차 제조사가 성공적으로 생성되었습니다",
        "Update_car_model_fail": "자동차 모델 업데이트 중 오류 발생",
        "Update_car_model_success": "자동차 모델이 성공적으로 업데이트되었습니다",
        "Create_car_model_fail": "자동차 모델 생성 중 오류 발생",
        "Create_car_model_success": "새 자동차 모델이 성공적으로 생성되었습니다",
        "Loading_car_model_fail": "자동차 모델 로드 중 오류 발생",
        "Delete_car_make_success": "자동차 제조사가 성공적으로 삭제되었습니다",
        "Delete_cat_make_fail": "자동차 제조사 삭제 중 오류 발생",
        "Delete_regular_rate_success": "정규 요금 삭제 성공",
        "Delete_regular_rate_fail": "정규 요금 삭제 오류",
        "Update_status_error": "상태 업데이트 오류",
        "Case_number": "사건 번호",
        "Phone_Number": "전화번호",
        "ERROR_INPUT_VALIDPHONE": "유효한 전화번호를 입력하십시오.",
        "Car_type_filter": "차량 유형 필터",
        "No": "아니오",
        "Intercity_Rate": "시외 요금",
        "Select_intercity_rate": "시외 요금 선택",
        "Delivery_Rate": "배송 요금",
        "Select_delivery_rate": "배송 요금 선택",
        "vehicleOwner": "차량의 소유자 이름",
        "EDIT_CAR_COLOR": "차량 색상 편집",
        "DETAIL_CAR_COLOR": "자동차 색상 세부 정보",
        "CREATE_CAR_COLOR": "차량 색상 추가",
        "Car_Color": "차량 색상",
        "Update_car_color_fail": "자동차 색상 업데이트 중 오류 발생.",
        "Update_car_color_success": "자동차 색상이 성공적으로 업데이트되었습니다.",
        "Create_car_color_fail": "차량 색상 생성 중 오류 발생.",
        "Create_car_color_success": "새 차량 색상이 성공적으로 생성되었습니다",
        "Delete_car_color_success": "자동차 색상이 성공적으로 삭제되었습니다.",
        "Delete_car_color_fail": "자동차 색상 삭제 중 오류 발생.",
        "DELETE_CAR_COLOR": "자동차 색상 삭제",
        "DELETE_CONFIRM_CAR_COLOR": "이 자동차 색상을 삭제하시겠습니까?",
        "sharing_Rate": "스트리트 공유 요금",
        "bookingAffiliate": "제휴 Booking.com 자동차 유형",
        "streetSharing": "스트리트 공유",
        "colorCode": "색상 코드",
        "selectColorCode": "색상 코드 선택"
    },
    "operationSetting": {
        "Driver": "운전자",
        "Search_driver_name": "운전자 이름 검색",
        "Company": "회사",
        "License_plate": "차량 번호판",
        "Select_license_plate": "차량 번호판 선택",
        "Shift": "교대",
        "Zone": "구역",
        "Required_fields": "필수 입력란",
        "Save": "저장",
        "No": "No.",
        "Car_Type": "차량 유형",
        "Plate_Number": "차량 번호",
        "Unassign": "미할당",
        "Please_choose_driver": "운전자를 선택해주세요.",
        "Please_choose_company": "회사를 선택해주세요.",
        "Please_license_plate": "번호판을 선택해주세요.",
        "Please_choose_shift": "근무 시간을 선택해 주세요.",
        "Please_choose_zone": "구역을 선택해 주세요.",
        "CONFIRM_UNASSIGN": "이 기사님을 배치 해제하시겠습니까?",
        "Assign_success": "연산이 성공적으로 배정되었습니다",
        "Unassign_success": "기사님이 성공적으로 배정 해제되었습니다."
    },
    "paymentMethod": {
        "cash": "현금",
        "easyPaisa": "Easy Paisa",
        "jazzCash": "재즈 캐시",
        "cashBySender": "발송자에 의한 현금",
        "cashByRecipient": "수신자에 의한 현금",
        "personalCard": "개인 카드",
        "corporateCard": "기업 카드",
        "qrCodePayment": "QR 코드 결제",
        "directBilling": "직접 청구",
        "externalCard": "외부 카드",
        "mDispatcherCard": "파트너 카드",
        "corporatePrepaid": "기업 선불",
        "fleetCard": "외부 카드",
        "applePay": "Apple Pay",
        "creditExternalCard": "신용 카드",
        "googlePay": "Google Pay",
        "wallet": "지갑",
        "BankOfGeorgia": "조지아 은행",
        "tnGeWalletlet": "TnG 전자지갑",
        "paymentMethod_1": "현금",
        "paymentMethod_2": "개인 카드",
        "paymentMethod_3": "파트너 카드",
        "paymentMethod_4": "기업 카드",
        "paymentMethod_5": "직접 청구",
        "paymentMethod_6": "외부 카드",
        "paymentMethod_7": "기업 선불",
        "paymentMethod_8": "QR 코드 결제",
        "paymentMethod_9": "Apple Pay",
        "paymentMethod_11": "에어페이",
        "paymentMethod_12": "신용 카드",
        "paymentMethod_13": "지갑",
        "paymentMethod_14": "TnG 전자지갑",
        "paymentMethod_16": "발송자에 의한 현금",
        "paymentMethod_17": "수신자에 의한 현금",
        "paymentMethod_19": "부스트 전자지갑",
        "paymentMethod_20": "Vipps",
        "paymentMethod_21": "ZainCash",
        "paymentMethod_23": "Google Pay",
        "paymentMethod_25": "Easy Paisa",
        "paymentMethod_27": "삼성 페이",
        "paymentMethod_28": "카카오 페이",
        "paymentMethod_29": "네이버 페이",
        "paymentMethod_30": "위챗 페이",
        "paymentMethod_31": "Alipay",
        "paymentMethod_32": "PayNow",
        "paymentMethod_33": "GrabPay",
        "paymentMethod_34": "Cash App Pay",
        "vippseWallet": "Vipps",
        "paymentMethod_credit": "개인 카드",
        "paymentMethod_razerPay": "레이저페이",
        "paymentMethod_gCash": "GCash",
        "paymentMethod_zainCash": "ZainCash",
        "paymentMethod_xenDit": "Xendit",
        "paymentMethod_alipayExternal": "Alipay",
        "paymentMethod_FIB": "FIB",
        "paymentMethod_SantimPay": "SantimPay",
        "paymentMethod_ksher": "Ksher",
        "paymentMethod_paydunya": "페이둔야",
        "paymentMethod_fawry": "파워리",
        "paymentMethod_BankOfGeorgia": "조지아 은행",
        "paymentLink": "결제 링크",
        "paymentMethod_xendit": "Xendit",
        "paymentMethod_easyPaisa": "Easy Paisa",
        "paymentMethod_jazzCash": "재즈 캐시",
        "paymentMethod_flooz": "플루즈",
        "paymentMethod_tmoney": "티머니",
        "paymentMethod_samsung_pay": "삼성 페이",
        "paymentMethod_kakao_pay": "카카오 페이",
        "paymentMethod_naver_pay": "네이버 페이",
        "paymentMethod_wechat_pay": "위챗 페이",
        "paymentMethod_alipay": "Alipay",
        "paymentMethod_paynow": "PayNow",
        "paymentMethod_grabpay": "GrabPay",
        "paymentMethod_cashapp": "Cash App Pay"
    },
    "changePassword": {
        "Change_password": "비밀번호 변경",
        "Current_password": "현재 비밀번호",
        "New_password": "새 비밀번호",
        "Confirm_password": "비밀번호 확인",
        "ERROR_INPUT_PASSWORD": "비밀번호를 입력해 주세요",
        "ERROR_INPUT_VALID_PASSWORD": "비밀번호는 최소 8자, 숫자 하나와 특수문자를 포함해야 합니다",
        "ERROR_INPUT_MATCH_PASSWORD": "비밀번호가 일치하지 않습니다. 다시 시도해 주세요",
        "Save": "저장",
        "Cancel": "취소"
    },
    "userProfile": {
        "My_account": "내 계정",
        "Username": "사용자 이름",
        "First_name": "이름",
        "Last_name": "성",
        "Phone_number": "전화번호",
        "Email_address": "이메일 주소",
        "Address": "주소",
        "Save": "저장",
        "Edit_profile": "프로필 편집",
        "Change_password": "비밀번호 변경",
        "ERROR_INPUT_USERNAME": "사용자 이름을 입력해 주세요.",
        "ERROR_INPUT_FIRSTNAME": "이름을 입력하십시오.",
        "ERROR_INPUT_VALID_EMAIL": "올바른 이메일을 입력해 주세요.",
        "Required_fields": "필수 입력란"
    },
    "General": {
        "widgetChat": "Support / Chat",
        "searchQueuingDriver": "검색: 드라이버 이름, 전화 번호",
        "search": "검색",
        "User": "사용자",
        "My_Account": "내 계정",
        "Product_Discovery": "제품 탐색",
        "Sign_out": "로그아웃",
        "My_site": "내 사이트",
        "Command_center": "커맨드 센터",
        "Notifications": "알림",
        "Show_all": "모두 보기",
        "SOS_Notifications": "SOS 알림",
        "You_dont_have_any_message": "메시지가 없습니다",
        "Mon": "월",
        "Tue": "화",
        "Wed": "수",
        "Thu": "목",
        "Fri": "금",
        "Sat": "토",
        "Sun": "일",
        "Now": "지금",
        "NowComplete": "지금 (실제 픽업 시간)",
        "hrs": "시",
        "patmentMethod_1": "현금",
        "patmentMethod_2": "개인 카드",
        "patmentMethod_3": "파트너 카드",
        "patmentMethod_4": "기업 카드",
        "patmentMethod_5": "직접 청구",
        "patmentMethod_6": "외부 카드",
        "patmentMethod_7": "기업 선불",
        "patmentMethod_8": "QR 코드",
        "patmentMethod_9": "Apple Pay",
        "patmentMethod_10": "Apple Pay",
        "patmentMethod_12": "신용 카드",
        "patmentMethod_13": "지갑",
        "patmentMethod_14": "TnG 전자지갑",
        "patmentMethod_16": "발송자에 의한 현금",
        "patmentMethod_17": "수신자에 의한 현금",
        "patmentMethod_19": "부스트",
        "patmentMethod_20": "Vipps",
        "patmentMethod_23": "Google Pay",
        "patmentMethod_24": "결제 링크",
        "patmentMethod_25": "Easy Paisa",
        "patmentMethod_26": "재즈 캐시",
        "patmentMethod_27": "삼성 페이",
        "patmentMethod_28": "카카오 페이",
        "patmentMethod_29": "네이버 페이",
        "patmentMethod_30": "위챗 페이",
        "patmentMethod_31": "Alipay",
        "patmentMethod_32": "PayNow",
        "patmentMethod_33": "GrabPay",
        "patmentMethod_34": "Cash App Pay",
        "patmentMethod_ZainCash": "ZainCash",
        "patmentMethod_Xendit": "Xendit",
        "patmentMethod_FIB": "FIB",
        "patmentMethod_SantimPay": "SantimPay",
        "patmentMethod_GCash": "GCash",
        "patmentMethod_cash": "현금",
        "patmentMethod_credit": "개인 카드",
        "patmentMethod_mDispatcher": "파트너 카드",
        "patmentMethod_corpCredit": "기업 카드",
        "patmentMethod_directBilling": "직접 청구",
        "patmentMethod_fleetCard": "외부 카드",
        "patmentMethod_prepaid": "기업 선불",
        "patmentMethod_QRCode": "QR 코드",
        "patmentMethod_applePay": "Apple Pay",
        "patmentMethod_easyPaisa": "Easy Paisa",
        "patmentMethod_jazzCash": "재즈 캐시",
        "patmentMethod_prePaid": "기업 선불",
        "patmentMethod_GooglePay": "Google Pay",
        "patmentMethod_creditCardExternal": "신용 카드",
        "patmentMethod_exXendit": "QRIS",
        "patmentMethod_PaxWallet": "지갑",
        "patmentMethod_TnGeWallet": "TnG 전자지갑",
        "patmentMethod_boosteWallet": "부스트",
        "patmentMethod_Vipps": "Vipps",
        "patmentMethod_exZainCash": "ZainCash",
        "patmentMethod_exGCash": "GCash",
        "patmentMethod_exPayTM": "PayTM",
        "patmentMethod_exFlooz": "플루즈",
        "patmentMethod_exTmoney": "티머니",
        "patmentMethod_exTelebirr": "GCash",
        "paymentMethod_exzainCash": "ZainCash",
        "paymentMethod_exXendit": "Xendit",
        "paymentMethod_exalipay": "Alipay",
        "paymentMethod_exFIB": "FIB",
        "paymentMethod_exSantimPay": "SantimPay",
        "patmentMethod_exKsher": "Ksher",
        "paymentMethod_paydunya": "페이둔야",
        "paymentMethod_exfawry": "파워리",
        "patmentMethod_exBankOfGeorgia": "조지아 은행",
        "patmentMethod_exPayDunya": "페이둔야",
        "patmentMethod_21": "ZainCash",
        "patmentMethod_paymentLink": "결제 링크",
        "patmentMethod_card": "개인 카드",
        "patmentMethod_corporateCard": "기업 카드",
        "patmentMethod_paxWallet": "지갑",
        "patmentMethod_externalWallet": "외부 지갑",
        "patmentMethod_googlePay": "Google Pay",
        "patmentMethod_manual": "수동",
        "patmentMethod_samsung_pay": "삼성 페이",
        "patmentMethod_kakao_pay": "카카오 페이",
        "patmentMethod_naver_pay": "네이버 페이",
        "patmentMethod_wechat_pay": "위챗 페이",
        "patmentMethod_alipay": "Alipay",
        "patmentMethod_paynow": "PayNow",
        "patmentMethod_grabpay": "GrabPay",
        "patmentMethod_cashapp": "Cash App Pay",
        "patmentMethod_online": "카드/온라인 결제",
        "patmentMethod_check": "체크",
        "patmentMethod_wire": "와이어",
        "patmentMethod_digitalWallet": "디지털 지갑",
        "patmentMethod_bankTransfer": "은행 이체",
        "patmentMethod_offlineMethod": "오프라인 결제",
        "patmentAirlineMethod_5": "직접 청구",
        "patmentAirlineMethod_4": "항공사 카드",
        "patmentAirlineMethod_7": "항공사 선불",
        "Name": "이름",
        "Delete": "삭제",
        "App_SOS_dialog_form_message_1": "{0} 긴급 SOS!",
        "App_SOS_dialog_form_message_2": "저는 이곳에서 도움이 필요합니다",
        "App_SOS_dialog_form_message_3": "예약: {0}, 운전자: {1}, 승객: {2}, 번호판: {3} ({4})",
        "mins": "분",
        "Credit_Card": "신용 카드",
        "ALL": "모두",
        "NotFound": "요청하신 페이지를 찾을 수 없습니다",
        "ServerError": "문제가 발생했습니다",
        "AccessDenied": "이 모듈에 대한 접근 권한이 없습니다!",
        "Retry": "다시 시도",
        "Can_not_get_data": "데이터를 가져올 수 없습니다"
    },
    "shiftSettings": {
        "Add": "추가",
        "Show_per_page": "페이지 당 항목 수",
        "Page": "페이지",
        "Name": "이름",
        "Time_Range": "시간 범위",
        "Actions": "행동",
        "show_pages": "{0} - {1} of {2} 표시됨",
        "Edit": "편집",
        "Delete": "삭제",
        "EDIT_SHIFT_SETTING": "근무 시간 설정 수정",
        "ADD_SHIFT_SETTING": "근무 시간 설정 추가",
        "DETAIL_SHIFT_SETTING": "근무 시간 설정 상세",
        "DELETE_SHIFT_SETTING": "근무 시간 설정 삭제",
        "Delete_confirm_shift_setting": "이 항목을 삭제하시겠습니까?",
        "Required_fields": "필수 입력란",
        "Save": "저장",
        "Cancel": "취소",
        "From": "에서",
        "To": "로",
        "Edit_shift_template": "근무 시간 템플릿 수정",
        "Add_shift_template": "근무 시간 템플릿 추가",
        "Detail_shift_template": "근무 시간 템플릿 상세",
        "Delete_shift_template": "근무 시간 템플릿 삭제",
        "Delete_confirm_shift_template": "이 항목을 삭제하시겠습니까?",
        "Working_time": "근무 시간",
        "Create_shift_settings_success": "새로운 근무 설정이 성공적으로 생성되었습니다",
        "Create_shift_settings_fail": "근무 설정 생성 중 오류가 발생했습니다",
        "Update_shift_settings_success": "근무 설정이 성공적으로 업데이트되었습니다",
        "Update_shift_settings_fail": "근무 설정 업데이트 중 오류가 발생했습니다",
        "Delete_shift_settings_success": "근무 설정이 성공적으로 삭제되었습니다",
        "Delete_shift_settings_fail": "근무 설정 삭제 중 오류가 발생했습니다",
        "Create_shift_template_success": "새로운 근무 템플릿이 성공적으로 생성되었습니다",
        "Create_shift_template_fail": "근무 템플릿 생성 중 오류가 발생했습니다",
        "Update_shift_template_success": "근무 템플릿이 성공적으로 업데이트되었습니다",
        "Update_shift_template_fail": "근무 템플릿 업데이트 중 오류가 발생했습니다",
        "Delete_shift_template_success": "근무 템플릿이 성공적으로 삭제되었습니다",
        "Delete_shift_template_fail": "근무 템플릿 삭제 중 오류가 발생했습니다",
        "Yes": "예",
        "No": "아니오"
    },
    "promotionSettings": {
        "Detail_campaign": "캠페인 상세",
        "Edit_campaign": "캠페인 수정",
        "Add_campaign": "캠페인 추가",
        "Delete_campaign": "캠페인 삭제",
        "Delete_confirm_campaign": "선택한 캠페인을 삭제하시겠습니까?",
        "Add": "추가",
        "Corporate_list": "기업 목록",
        "permittedCorporate": "승인된 기업 목록",
        "CorporateCustomers": "기업 고객",
        "auto_add_corporate": "기업 사용자의 프로모션 목록에 자동 추가",
        "Show_per_page": "페이지 당 항목 수",
        "Page": "페이지",
        "Name": "이름",
        "Actions": "행동",
        "Private": "개인",
        "show_pages": "{0} - {1} of {2} 표시됨",
        "Edit": "편집",
        "Delete": "삭제",
        "Send_to_inbox": "받은 편지함으로 전송",
        "Save": "저장",
        "Duplicate": "중복",
        "Cancel": "취소",
        "Required_fields": "필수 입력란",
        "Promotion_code": "프로모션 코드",
        "Promotion_type": "프로모션 유형",
        "Campaign": "캠페인",
        "Type": "유형",
        "Value": "값",
        "keepMinFee": "프로모션 후 전체 요금은 최소 요금보다 커야합니다",
        "Zone": "구역",
        "paymentMethodsApply": "결제 방법들",
        "schedules": "스케줄",
        "minimumEstFareApply": "코드 적용을 위한 최소 예상 총 요금",
        "quantityLimitPerYear": "연간 사용자당 최대 사용 횟수",
        "termAndCondition": "이용 약관",
        "Valid_from": "유효 시작일",
        "Valid_to": "유효 종료일",
        "Total_uses_user": "전체 사용자/사용 횟수",
        "Released_quantity": "발송 수량",
        "Number_of_sending_inbox": "발송함 메시지 수",
        "Status": "상태",
        "Activate": "활성화",
        "Deactivate": "비활성화",
        "Add_promotion_code": "프로모션 코드 추가",
        "Edit_promotion_code": "프로모션 코드 편집",
        "Detail_promotion_code": "프로모션 코드 세부사항",
        "Delete_promotion_code": "프로모션 코드 삭제",
        "Delete_confirm_promotion_code": "선택한 프로모션 코드를 삭제하시겠습니까?",
        "New_customer": "신규 고객",
        "Budget_per_user": "예산/이용자 (전체 프로모션 기간)",
        "Budget_per_user_day": "예산/이용자/일",
        "Budget_per_user_month": "예산/이용자/월",
        "Budget_per_user_year": "예산/이용자/년",
        "Unlimited": "무제한",
        "Limited": "제한",
        "Total_uses_per_user": "최대 사용 횟수/이용자 (전체 프로모션 기간)",
        "Send_an_in_box_automatically_to_new_customers": "신규 고객에게 자동으로 메시지 보내기",
        "Notes": "메모",
        "Public": "공개",
        "Create_campaign_success": "새 캠페인이 성공적으로 생성되었습니다",
        "Create_campaign_fail": "캠페인 생성 중 오류가 발생했습니다",
        "Update_campaign_success": "캠페인이 성공적으로 업데이트되었습니다",
        "Update_campaign_fail": "캠페인 업데이트 중 오류가 발생했습니다",
        "Delete_campaign_success": "캠페인이 성공적으로 삭제되었습니다",
        "Delete_campaign_fail": "캠페인 삭제 중 오류가 발생했습니다",
        "Loading_campaign_fail": "캠페인 로딩 중 오류가 발생했습니다",
        "Update_campaign_status_success": "캠페인 상태가 성공적으로 업데이트되었습니다",
        "Update_campaign_status_fail": "캠페인 상태 업데이트 중 오류가 발생했습니다",
        "Loading_promotion_code_fail": "프로모션 코드 로딩 중 오류가 발생했습니다",
        "Select_campaign": "캠페인 선택",
        "Create_promotion_code_success": "새 프로모션 코드가 성공적으로 생성되었습니다",
        "Create_promotion_code_fail": "프로모션 코드 생성 중 오류가 발생했습니다",
        "Update_promotion_code_status_success": "프로모션 코드 상태가 성공적으로 업데이트되었습니다",
        "Update_promotion_code_status_fail": "프로모션 코드 상태 업데이트 중 오류가 발생했습니다",
        "Delete_promotion_code_confirmation": "이 프로모션 코드들을 삭제하시겠습니까?",
        "Just_delete_inactive": "** 비활성 상태의 프로모션 코드만 삭제할 수 있습니다.",
        "Send_inbox_confirmation": "이 프로모션 코드를 승객 메일함으로 보내시겠습니까?",
        "Send_inbox_success": "프로모션 코드가 성공적으로 발송되었습니다.",
        "Send_inbox_fail": "프로모션 코드 발송이 실패했습니다. 다시 시도해 주세요!",
        "Confirmation": "확인",
        "Delete_promotion_codes_success": "프로모션 코드가 성공적으로 삭제되었습니다",
        "Delete_promotion_codes_fail": "프로모션 코드 삭제 중 오류가 발생했습니다",
        "Delete_multiple_promotion_codes_success": "프로모션 코드가 성공적으로 삭제되었습니다",
        "Delete_multiple_promotion_codes_fail": "프로모션 코드 삭제 중 오류가 발생했습니다",
        "Delete_promotion_code_success": "프로모션 코드가 성공적으로 삭제되었습니다",
        "Delete_promotion_code_fail": "프로모션 코드 삭제 중 오류가 발생했습니다",
        "Update_multiple_promotion_code_status_success": "프로모션 코드 상태가 성공적으로 업데이트되었습니다.",
        "Update_multiple_promotion_code_status_fail": "프로모션 코드 상태를 삭제하는 동안 오류가 발생했습니다.",
        "Search_here": "여기에 검색",
        "Please_input_campaign_name": "캠페인 이름을 입력해 주세요",
        "Please_input_promotion_code": "프로모션 코드를 입력해 주세요",
        "Please_input_promotion_code_at_least_4_characters": "적어도 4자 이상 입력해 주세요.",
        "Please_select_campaign": "캠페인을 선택해 주세요",
        "Please_input_value": "값을 입력해 주세요",
        "Please_select_date": "날짜를 선택해 주세요",
        "Please_add_schedules": "스케줄을 추가해 주세요",
        "Please_add_corporate": "기업을 추가해 주세요",
        "Please_choose_at_least_one_customer": "적어도 하나의 고객을 선택해 주세요.",
        "This_campaign_name_has_been_existing_on_the_system_Please_input_another_one": "이 캠페인 이름은 시스템에 이미 존재합니다. 다른 이름을 입력해 주세요.",
        "This_promotion_code_has_been_existing_on_the_system_Please_input_another_one": "이 프로모션 코드는 시스템에 이미 존재합니다. 다른 코드를 입력해 주세요.",
        "Invalid_file": "파일 내용이 유효하지 않습니다",
        "File_size_larger_than_5Mb": "파일 크기가 5MB보다 큽니다",
        "Import_promotions_success": "파일이 성공적으로 불러와졌습니다",
        "Import_Promotions": "파일 불러오기",
        "Number_successful_imports": "불러온 항목",
        "Number_skipped": "스킵 항목",
        "File": "파일",
        "Phone_Numbers": "전화번호",
        "Import_Promotion_code_success": "프로모션 코드 <b>{0}</b>이(가) 성공적으로 불러와졌습니다",
        "Import_Promotion_code_fail": "프로모션 코드 <b>{0}</b> 불러오기가 실패했습니다. 다시 시도해 주세요",
        "Customer_type": "고객 유형",
        "All": "모두",
        "Referred_customers": "추천된 고객",
        "Common_customers": "일반 고객",
        "Operation_zone": "운영 구역",
        "totalUsesLimitPerDay": "일일 최대 사용 횟수/이용자",
        "quantityLimitPerDay": "일일 최대 수량",
        "quantityLimitPerMonth": "월별 최대 수량/이용자",
        "applyVerifiedCustomers": "검증된 말레이시아 고객에게만 적용",
        "applyWhenBudgetLimit": "예산 한도가 소진될 때까지 사용자가 코드를 적용할 수 있습니다",
        "applyVerifiedCustomersTooltip": "이 프로모션은 시스템에 본인의 ID 카드를 업로드한 말레이시아인에게만 적용됩니다.",
        "valueLimitPerUse": "최대 값/사용 (앱 v48 이상 적용)",
        "Promotion_Services": "서비스",
        "transport": "교통",
        "shuttle": "셔틀",
        "parcel": "소포",
        "food": "음식",
        "mart": "마트",
        "intercity": "도시 간",
        "addSchedule": "스케줄 추가",
        "editSchedule": "스케줄 편집",
        "date": "날짜",
        "Time_range": "시간 범위",
        "startTime": "출발 시간",
        "endTime": "종료 시간",
        "applyForOtherDays": "다른 날짜에 적용",
        "scheduleTimeOverlap": "스케줄 시간은 서로 중첩되지 않아야 합니다",
        "schedule_startDate_greater_than_endDate": "시작 날짜가 종료 날짜보다 더 늦습니다",
        "scheduleTimeDuplicate": "시간표는 겹치지 않아야 합니다",
        "promoIcon": "프로모 아이콘",
        "bannerImage": "배너 이미지",
        "Upload_an_image": "이미지 업로드",
        "Click_here_to_view": "여기를 클릭하여 보기."
    },
    "quest_event": {
        "name": "이름",
        "userType": "사용자 유형",
        "carType": "차량 유형",
        "operationZones": "운영 지역",
        "type": "이벤트 유형",
        "isLuckyDraw": "럭키 드로우 라운드",
        "start_date": "시작 날짜",
        "end_date": "종료 날짜",
        "numOfQualify": "자격을 얻은 수",
        "event_progress": "이벤트 진행 상황",
        "isActive": "상태",
        "Actions": "행동",
        "passenger": "고객",
        "driver": "운전자",
        "first_will_win": "첫번째가 이김",
        "largest_will_win": "가장 크게 이기면 이깁니다 (리더보드)",
        "not_start": "시작되지 않음",
        "active": "활성",
        "closed": "마감",
        "event_details": "퀘스트 상세",
        "add_event": "퀘스트 추가",
        "limited": "제한",
        "unlimited": "무제한",
        "eventImage": "이벤트 이미지",
        "sharedImage": "공유 이미지",
        "qualifiedImage": "자격 이미지",
        "expiredImage": "만료된 이미지",
        "luckyDrawImage": "럭키 드로 이미지",
        "Upload_an_image": "이미지 업로드",
        "Required_Image": "이미지 확장자 (.jpg, .png, .gif)",
        "ok": "확인",
        "eventId": "이벤트 ID",
        "passengerMetric": {
            "booking_distance": "예약 거리",
            "booking_time": "예약 시간",
            "booking_amount_spent": "예약 금액 소비",
            "num_of_ondemand": "온디맨드 수",
            "num_of_reservation": "예약 수",
            "num_of_intercity": "시외 이동 수",
            "num_of_delivery": "배달 수",
            "num_of_referral": "추천 수",
            "num_of_sharing": "공유 수",
            "topup_wallet_amount": "월렛 충전 금액",
            "num_of_complete_wallet": "완료된 예약 수 (월렛)",
            "num_of_complete_booking_by_referee": "완료된 예약 수 (추천인에 의해)",
            "number_of_complete_booking": "완료된 예약 수",
            "number_of_food_mart": "음식/마트 수"
        },
        "driverMetric": {
            "booking_distance": "작업 거리",
            "booking_time": "작업 시간",
            "num_of_referral": "추천 수",
            "num_of_complete": "완료된 예약 수 (단일 고객)",
            "num_of_referral_driver": "추천 수 (운전자)",
            "num_of_accept": "예약 수락한 수",
            "num_of_receive": "예약 받은 수",
            "num_of_cancel": "운전자가 취소한 예약 수",
            "sum_of_rating": "총 평점 별 수",
            "total_rating": "총 평가 횟수",
            "earnings_amount": "수입 금액",
            "num_of_complete_wallet": "완료된 예약 수 (월렛)",
            "num_of_complete_booking_by_referee": "완료된 예약 수 (추천인에 의해)",
            "available_time": "온라인 시간"
        },
        "Click_here_to_view": "여기를 클릭하여 보기.",
        "view": "여기를 클릭하여 보기.",
        "metricType": "유형",
        "task": "태스크",
        "value": "값",
        "quantity": "수량",
        "quests_list": "퀘스트",
        "rankImages": "랭크 이미지 (포인트)",
        "qualifiedPrizeOrder": "자격 상품",
        "luckyDrawPrizeOrder": "럭키 드로 상품",
        "reward": "아이템",
        "from": "에서",
        "to": "로",
        "image": "이미지",
        "Add_Prize": "추가",
        "bannerText": "배너 텍스트",
        "buttonText": "버튼 텍스트",
        "bannerLink": "배너 링크",
        "shortLink": "짧은 링크",
        "buttonLinkDesktop": "버튼 링크 (데스크톱)",
        "buttonLinkAndroid": "버튼 링크 (Android)",
        "buttonLinkiOS": "버튼 링크 (iOS)",
        "termsURL": "이용 약관 링크",
        "metadataTitle": "메타데이터 제목",
        "metadataDescription": "메타데이터 설명",
        "isDarkMode": "다크 모드",
        "isActive_details": "활성",
        "Required_fields": "필수 입력란",
        "change": "변경",
        "Please_input_name": "이름을 입력하세요",
        "Please_select_date": "날짜를 선택해 주세요",
        "endDate_invalid": "종료 날짜가 유효하지 않음",
        "startDate_greater_than_endDate": "시작 날짜가 종료 날짜보다 더 늦습니다",
        "Please_input_termsURL": "이용 약관 링크를 입력해주세요",
        "Please_input_metadataTitle": "메타데이터 제목을 입력해주세요",
        "Please_input_metadataDescription": "메타데이터 설명을 입력해주세요",
        "Please_input_bannerText": "배너 텍스트를 입력해주세요",
        "Please_input_buttonText": "버튼 텍스트를 입력해주세요",
        "Please_input_bannerLink": "배너 링크를 입력해주세요",
        "Please_input_shortLink": "짧은 링크를 입력해주세요",
        "Please_input_buttonLinkDesktop": "버튼 링크를 입력해주세요 (데스크톱)",
        "Please_input_buttonLinkAndroid": "버튼 링크를 입력해주세요 (안드로이드)",
        "Please_input_buttonLinkiOS": "버튼 링크를 입력해주세요 (iOS)",
        "the_range_1_to_5": "%{name}에 대해 1에서 5 사이의 값을 입력해주세요!",
        "the_range_1_to_100": "%{name}에 대해 1에서 100 사이의 값을 입력해주세요!",
        "task_is_empty": "%{name}에 대한 작업을 입력해주세요!",
        "task_limit_50_characters": "%{name}에 대한 작업의 최대 길이는 50자입니다!",
        "please_input_points": "%{name}에 대한 포인트를 입력해주세요!",
        "please_input_value": "%{name}에 대한 값을 입력해주세요!",
        "value_is_invalid": "%{name}, 값은 숫자여야 합니다",
        "please_upload_image": "아이템 %{name}에 대한 이미지를 업로드해주세요!",
        "rank_invalid": "순위 %{name}이(가) 유효하지 않습니다!",
        "rank_invalid_to": "\"\"까지\"\" 순위는 숫자여야 합니다,",
        "deepLink": "딥링크",
        "point_per_task": "작업 당 포인트",
        "points": "포인트",
        "points_per_some_think": "%{unit} 당 포인트",
        "criterias": "기준 (선택사항)",
        "criterias_list": "기준",
        "criteriaType": "유형",
        "criteriaValue": "값",
        "acceptance_rating": "수용 등급 (이상)",
        "cancellation_rating": "취소 등급 (이하)",
        "driver_rating": "운전자 등급 (이상)",
        "please_upload_image_rank": "순위 %{name}에 대한 이미지를 업로드하십시오!",
        "Update_event_success": "퀘스트가 성공적으로 업데이트되었습니다",
        "Update_event_fail": "퀘스트 업데이트 중 오류가 발생했습니다",
        "Create_event_success": "새 퀘스트가 성공적으로 생성되었습니다",
        "Create_event_fail": "퀘스트 생성 중 오류가 발생했습니다",
        "suspend_list": "중지 목록"
    },
    "voucherSettings": {
        "Search_here": "여기에 검색",
        "Voucher_code": "코드 #",
        "Campaign": "캠페인",
        "Type": "유형",
        "Value": "값",
        "Valid_from": "유효 시작일",
        "Valid_to": "유효 종료일",
        "isActive": "상태",
        "Activate": "활성화",
        "Deactivate": "비활성화",
        "Actions": "행동",
        "Active": "활성",
        "Inactive": "비활성화",
        "redeemed": "인증됨",
        "expired": "만료됨",
        "Add_Voucher_code": "코드 추가",
        "Add": "추가",
        "Show_per_page": "페이지 당 항목 수",
        "Page": "페이지",
        "Name": "이름",
        "show_pages": "{0} - {1} of {2} 표시됨",
        "Edit": "편집",
        "Delete": "삭제",
        "Save": "저장",
        "Duplicate": "중복",
        "Cancel": "취소",
        "Required_fields": "필수 입력란",
        "Detail_voucher_code": "상세 바우처 코드",
        "Delete_voucher_code": "바우처 코드 삭제",
        "Confirmation": "확인",
        "Delete_confirm_voucher_code": "선택한 바우처 코드를 삭제하시겠습니까?",
        "Delete_voucher_code_confirmation": "이 바우처 코드들을 삭제하시겠습니까?",
        "Just_delete_inactive": "** 비활성 상태인 바우처 코드만 삭제할 수 있습니다.",
        "Loading_voucher_code_fail": "바우처 코드를 불러오는 동안 오류가 발생했습니다",
        "Select_campaign": "캠페인 선택",
        "Create_voucher_code_success": "새 바우처 코드가 성공적으로 생성되었습니다",
        "Create_voucher_code_fail": "바우처 코드 생성 중 오류가 발생했습니다",
        "Update_voucher_code_status_success": "바우처 코드 상태가 성공적으로 업데이트되었습니다",
        "Update_voucher_code_status_fail": "바우처 코드 상태 업데이트 중 오류가 발생했습니다",
        "Delete_voucher_codes_success": "바우처 코드가 성공적으로 삭제되었습니다",
        "Delete_voucher_codes_fail": "바우처 코드를 삭제하는 동안 오류가 발생했습니다",
        "Delete_multiple_voucher_codes_success": "바우처 코드들이 성공적으로 삭제되었습니다",
        "Delete_multiple_voucher_codes_fail": "바우처 코드들을 삭제하는 동안 오류가 발생했습니다",
        "Delete_voucher_code_success": "바우처 코드가 성공적으로 삭제되었습니다",
        "Delete_voucher_code_fail": "바우처 코드를 삭제하는 동안 오류가 발생했습니다",
        "Update_multiple_voucher_code_status_success": "바우처 코드 상태들이 성공적으로 업데이트되었습니다",
        "Update_multiple_voucher_code_status_fail": "바우처 코드 상태를 삭제하는 동안 오류가 발생하였습니다",
        "Please_input_voucher_code": "바우처 코드를 입력해주세요",
        "Please_input_voucher_code_at_least_4_characters": "적어도 4자 이상 입력해 주세요.",
        "Please_select_campaign": "캠페인을 선택해 주세요",
        "Please_input_value": "값을 입력해 주세요",
        "Please_select_date": "날짜를 선택해 주세요",
        "Invalid_file": "파일 내용이 유효하지 않습니다",
        "File_size_larger_than_5Mb": "파일 크기가 5MB보다 큽니다",
        "Import_vouchers_success": "파일이 성공적으로 불러와졌습니다",
        "Import_vouchers": "파일 불러오기",
        "Number_successful_imports": "불러온 항목",
        "Number_skipped": "스킵 항목",
        "File": "파일",
        "Phone_Numbers": "전화번호",
        "Import_voucher_code_success": "바우처 코드 <b>{0}</b>가 성공적으로 가져온 되었습니다",
        "Import_voucher_code_fail": "바우처 코드 <b>{0}</b> 가져오기가 실패하였습니다. 다시 시도해주세요",
        "All": "모두"
    },
    "pointConfig": {
        "point_config": "포인트 설정",
        "Convert_spent_amount_to_points": "소비한 금액을 포인트로 전환",
        "Convert_topup_amount_to_points": "금액을 포인트로 전환",
        "Redeem_points_to_voucher": "포인트를 쿠폰으로 교환",
        "others": "기타",
        "Online_Payment": "온라인 결제",
        "transport": "교통",
        "parcel": "소포",
        "food": "음식",
        "mart": "마트",
        "delivery": "배달",
        "intercity": "도시 간",
        "applyCash": "현금 신청",
        "point": "포인트",
        "vourcherName": "이름",
        "pointsToRedeem": "교환할 포인트",
        "vourcherValue": "쿠폰 가치",
        "validTime": "유효 시간",
        "month": "개월",
        "day": "일",
        "termAndCondition": "이용 약관",
        "Actions": "행동",
        "add_voucher": "추가",
        "instructionURL": "지시사항 링크",
        "displayName": "슈퍼 앱에 이름 표시",
        "isActive": "활성",
        "EDIT_VOUCHER": "쿠폰 업데이트",
        "DETAIL_VOUCHER": "쿠폰 상세 정보",
        "CREATE_VOUCHER": "쿠폰 추가",
        "update_successfully": "포인트 설정이 성공적으로 업데이트되었습니다",
        "Create_voucher_successfully": "새 쿠폰이 성공적으로 생성되었습니다",
        "Create_voucher_fail": "쿠폰 생성 중에 오류가 발생했습니다",
        "Update_voucher_successfully": "쿠폰이 성공적으로 업데이트되었습니다",
        "Update_voucher_fail": "쿠폰 업데이트 중에 오류가 발생했습니다",
        "Delete_voucher_successfully": "쿠폰이 성공적으로 삭제되었습니다",
        "Delete_voucher_fail": "쿠폰 삭제 중에 오류가 발생했습니다",
        "Confirmation": "확인",
        "Delete_voucher_confirmation": "이 쿠폰을 삭제하시겠습니까?",
        "Please_enter_value_least_one": "환전 비율은 필수입니다! 소비금액 또는 충전금액을 입력하여 계속하십시오.",
        "Please_enter_value_is_number_spentAmount": "\"\"{0}\"\"서비스에서 유효한 금액을 입력하십시오.\"\",",
        "Please_enter_value_is_number_topUp": "\"\"{0}\"\"방식에서 유효한 금액을 입력하십시오.\"\","
    },
    "resetPassword": {
        "New_Password": "새 비밀번호",
        "New_Comfirm_Password": "새로운 확인 비밀번호",
        "Save": "저장",
        "INFO_SUCCESS": "비밀번호 재설정 링크가 이메일로 보내졌습니다",
        "TOKEN_EXPIRED": "비밀번호 재설정 토큰이 만료되었습니다",
        "Back_To_Login_Page": "로그인 페이지로 돌아가기"
    },
    "permission": {
        "editBooking": "농장 예약 수정",
        "companyOperator": "회사 운영자",
        "Third_Party_Integration_Booking": "제3자 통합 (Booking.com)",
        "Third_Party_Integration_HolidayTaxis": "제3자 통합 (HolidayTaxis)",
        "supplierPermission": "공급 업체 권한",
        "Hint_edit_booking": "회사/배송업체가 농장 소유주에 의해 위탁된 예약을 수정할 수 있습니다.",
        "View": "보기",
        "Actions": "행동",
        "EditFare": "요금 편집",
        "EditDriverEarning": "운전자 수익 수정",
        "EditTotal": "총계 수정",
        "ImportBookings": "운송 예약 가져오기",
        "ImportDeliveryBookings": "배송 예약 가져오기",
        "ShowFare": "요금 표시",
        "delete_permission": "권한 삭제",
        "DELETE_CONFIRM": "선택한 권한을 삭제하시겠습니까!",
        "Yes": "예",
        "No": "아니오",
        "Cancel": "취소",
        "DRIVERS": "운전자",
        "Driver_list": "운전자 목록",
        "Enter_to_search": "검색 입력",
        "Permitted_driver_list": "허가된 운전자 리스트",
        "Save": "저장",
        "CAR": "차량",
        "Car_list": "자동차 리스트",
        "Permitted_car_list": "허가된 자동차 리스트",
        "Edit_permission": "권한 수정",
        "Add_permission": "권한 추가",
        "Detail_permission": "권한 상세 정보",
        "Name": "이름",
        "Driver_Car": "운전자/자동차",
        "All": "모두",
        "Company": "회사",
        "By_specific": "특정한",
        "Drivers": "운전자",
        "Cars": "자동차",
        "Show_per_page": "페이지 당 항목 수",
        "Page": "페이지",
        "show_pages": "{0} - {1} of {2} 표시됨",
        "Delete": "삭제",
        "Edit": "편집",
        "Status": "상태",
        "Action": "동작",
        "Inactive": "비활성화",
        "Active": "활성",
        "Update_status_error": "상태 업데이트 오류",
        "All_tooltip": "모든 운전자는 Map, Cue, Drivers, Operation 그리고 Reports에서 표시됩니다. 모든 차량은 Car mgmt에서 표시됩니다",
        "Company_tooltip": "이 회사에 허가된 운전사는 Map, Cue, Drivers, Operation 그리고 Reports에서 표시됩니다. 이 회사에 허가된 차량은 Car mgmt에서 표시됩니다",
        "By_specific_tooltip": "이 목록에서 허가된 운전사는 Drivers, Operation에서 표시됩니다. 이 목록에서 허가된 차량은 Car mgmt에서 표시됩니다",
        "Full_permissions": "전체 권한",
        "Balance": "잔액 변경",
        "ChangeBalance": "신용 잔액 변경",
        "ChangeCashBalance": "현금 잔액 변경",
        "TotalBalance": "총 잔액",
        "WriteOffDebt": "빚 탕감",
        "topupPaxWallet": "잔액 변경",
        "SeFleetCommission": "전체 드라이버에 대한 플릿 커미션 설정",
        "EditFleetCommission": "플릿 커미션 편집",
        "EditBalance": "잔액 편집",
        "ViewHeatMap": "열 지도 보기",
        "Delete_permission_success": "권한이 성공적으로 삭제되었습니다",
        "Delete_permission_fail": "권한 삭제 중 오류가 발생했습니다",
        "Create_permission_fail": "새 권한 생성 중 오류가 발생했습니다",
        "Create_permission_success": "새 권한이 성공적으로 생성되었습니다",
        "Update_permission_fail": "권한 업데이트 중 오류가 발생했습니다",
        "Update_permission_success": "권한이 성공적으로 업데이트되었습니다",
        "No_action_selected": "동작 리스트에서 최소 하나의 동작을 선택해 주세요",
        "Required_fields": "필수 입력란",
        "sendSMS": "메시지 보내기 (SMS)",
        "sendInbox": "메시지 보내기 (받은편지함)",
        "PayToDriver": "드라이버에게 지불' 보기",
        "PayoutHistory": "지불 내역' 보기",
        "Pay": "드라이버에게 지불",
        "ActivateDriver": "드라이버 활성화",
        "Export": "내보내기",
        "Export_csv": ".csv 내보내기",
        "Street-sharing_rate": "스트리트 공유 요금"
    },
    "thirdPartySettings": {
        "category": "카테고리",
        "Not_over_limit_subs": "10개 이상의 하위 위치를 생성할 수 없습니다",
        "Show_per_page": "페이지 당 항목 수",
        "Page": "페이지",
        "show_pages": "{0} - {1} of {2} 표시됨",
        "Delete": "삭제",
        "Edit": "편집",
        "Status": "상태",
        "Actions": "행동",
        "Action": "동작",
        "Inactive": "비활성화",
        "Active": "활성",
        "website": "웹사이트",
        "Check_Google_Address": "위도 & 경도에서 Google 주소 확인",
        "Delete_Category_success": "카테고리가 성공적으로 삭제되었습니다",
        "Delete_category_fail": "카테고리 삭제 중 오류가 발생했습니다",
        "availableTime": "이용 가능 시간",
        "Please_choose_at_least_one_category": "적어도 하나의 카테고리를 선택해 주세요",
        "Please_input_category_name": "카테고리 이름을 입력해 주세요",
        "Create_category_success": "카테고리가 성공적으로 생성되었습니다",
        "Create_category_fail": "카테고리 생성 중 오류가 발생했습니다",
        "Update_third_party_success": "위치 정보가 성공적으로 업데이트되었습니다",
        "Update_category_fail": "카테고리 업데이트 중 오류가 발생했습니다",
        "All_Category": "모든 카테고리",
        "Delete_Category": "카테고리 수정",
        "Edit_Category": "카테고리 수정",
        "Add_Category": "카테고리 추가",
        "Add_Third_Party_location": "제 3자 위치 추가",
        "Add": "추가",
        "Edit_Third_Party_location": "제 3자 위치 편집",
        "Location_Not_Found": "위치를 찾을 수 없습니다",
        "Create_third_party_success": "위치가 성공적으로 생성되었습니다",
        "Create_third_party_fail": "위치 생성 중 오류가 발생했습니다",
        "Update_third_party_fail": "위치 업데이트 중 오류가 발생했습니다",
        "Alias": "별칭",
        "Address": "주소",
        "Latitude": "위도",
        "Longitude": "경도",
        "Please_input_address": "주소를 입력하십시오.",
        "Please_input_name": "위치 이름을 입력해 주세요",
        "Please_input_latitude": "위도를 입력해 주세요",
        "Please_input_longitude": "경도를 입력해 주세요",
        "Save": "저장",
        "Cancel": "취소",
        "Required_fields": "필수 입력란",
        "Last_update": "최근 업데이트",
        "Username": "사용자 이름",
        "locationType": "위치 유형",
        "single": "단일 위치",
        "multiple": "여러 위치",
        "AddMore": "더 추가하기",
        "locationList": "위치 목록",
        "instructionLink": "지시사항 링크",
        "location": "위치",
        "checkOnMap": "지도에서 확인하기",
        "Remove": "제거",
        "all": "모두",
        "PU": "픽업만 가능",
        "DO": "하차만 가능",
        "namePlaceholder": "회의 장소의 이름.",
        "instructionLinkPlaceholder": "전체 지시사항이 포함된 Html 페이지",
        "instructionLinkTooltip": "지시사항 페이지의 링크를 입력해 주세요. 승객은 이 링크에서 픽업 위치를 찾는 방법을 따를 수 있습니다.",
        "longitudePlaceholder": 108.1837969,
        "latitudePlaceholder": 16.0393381,
        "Error_message_lat_in_range": "위도는 -90.0에서 90.0사이여야 합니다",
        "Error_message_lng_in_range": "경도는 -180.0에서 180.0사이여야 합니다.",
        "Delete_third_party_success": "위치가 성공적으로 삭제되었습니다",
        "Delete_third_party_fail": "위치 삭제 중 오류가 발생했습니다",
        "Delete_location": "위치 삭제",
        "Note_guide": "참고: 지도에서 검색할 때, 당신의 위치는 핀으로 빠르게 표시됩니다.",
        "PostalCode": "우편번호",
        "meetZonesTooltip": "집합 지역: 이 지역은 모든 지정된 집합 점들을 포함합니다. 특정 픽업과 하차 점들이 명확히 식별해야 하는 공항과 같은 위치에 유용합니다.",
        "instructions": "픽업 지시사항",
        "pickupMode": "픽업 유형",
        "tripSegment": "이동 구간",
        "buildingLevel": "건물 레벨",
        "instructionType": "지시사항 유형",
        "instructionUrl": "지시사항 URL",
        "instructionImage": "지시사항 이미지",
        "imageInstructions": "픽업 이미지 설명",
        "addMultipleInstructions": "여러 픽업 지시사항 추가.",
        "maximum3Images": "최대 3개의 이미지.",
        "image": "이미지",
        "uploadImage": "이미지 업로드",
        "description": "설명",
        "descriptionPlaceholder": "회의 장소의 이름.",
        "altText": "Alt 텍스트",
        "altTextPlaceholder": "회의 장소의 이름.",
        "addImage": "이미지 추가",
        "imageCount": "이미지 수",
        "viewEditImages": "이미지 보기/편집",
        "addMeetingZone": "회의 장소 추가"
    },
    "city": {
        "DELETE_CITY": "도시 삭제",
        "DELETE_CONFIRM": "선택한 도시를 삭제하시겠습니까?",
        "Yes": "예",
        "No": "아니오",
        "Cancel": "취소",
        "EDIT_CITY": "도시 편집",
        "ADD_CITY": "도시 추가",
        "Name": "이름",
        "Required_fields": "필수 입력란",
        "Save": "저장",
        "Add": "추가",
        "Show_per_page": "페이지 당 항목 수",
        "Page": "페이지",
        "show_pages": "{0} - {1} of {2} 표시됨",
        "Delete": "삭제",
        "Edit": "편집",
        "DETAIL_CITY": "도시 세부사항",
        "Update_city_success": "도시가 성공적으로 업데이트되었습니다",
        "Create_city_success": "새 도시가 성공적으로 생성되었습니다",
        "Delete_city_success": "도시가 성공적으로 삭제되었습니다",
        "cityName": "도시 이름",
        "Service": "서비스",
        "serviceTransportation": "교통",
        "serviceAssistant": "조수",
        "serviceDelivery": "배달",
        "isShowDriverSignUp": "제공자 가입에서 보기",
        "note_isShowDriverSignUp": "(4.6.46 이상의 새 가입 모듈에 적용)"
    },
    "blockPassenger": {
        "Imei": "IMEI",
        "EditImei": "블록 IMEI 편집",
        "AddImei": "블록 IMEI 추가",
        "DetailImei": "블록 IMEI 세부 정보",
        "Update_Imei_success": "블록 IMEI가 성공적으로 업데이트되었습니다",
        "Update_Imei_Fail": "블록 IMEI 업데이트 중 오류가 발생했습니다",
        "Create_Imei_success": "새로운 블록 IMEI가 성공적으로 생성되었습니다",
        "Create_Imei_Fail": "블록 IMEI 생성 중 오류가 발생했습니다",
        "Delete_Imei_success": "블록 IMEI가 성공적으로 삭제되었습니다",
        "Delete_Imei_fail": "블록 IMEI 삭제 중 오류가 발생했습니다",
        "DELETE_IMEI": "블록 IMEI 삭제",
        "DELETE_CONFIRM": "선택한 블록 IMEI를 삭제하시겠습니까?"
    },
    "jobTab": {
        "DELETE_JOBTAB": "작업 탭 삭제",
        "DELETE_CONFIRM": "선택한 작업 탭을 삭제하시겠습니까?",
        "Yes": "예",
        "No": "아니오",
        "Cancel": "취소",
        "EDIT_JOBTAB": "작업 탭 편집",
        "ADD_JOBTAB": "작업 탭 추가",
        "Name": "이름",
        "Required_fields": "필수 입력란",
        "Save": "저장",
        "Add": "추가",
        "Show_per_page": "페이지 당 항목 수",
        "Page": "페이지",
        "show_pages": "{0} - {1} of {2} 표시됨",
        "Delete": "삭제",
        "Edit": "편집",
        "DETAIL_JOBTAB": "작업 탭 세부사항",
        "Update_JOBTAB_success": "작업 탭이 성공적으로 업데이트되었습니다",
        "Create_JOBTAB_success": "새 작업 탭이 성공적으로 생성되었습니다",
        "Delete_JOBTAB_success": "작업 탭이 성공적으로 삭제되었습니다",
        "JOBTABName": "작업 탭 이름",
        "jobsLink": "링크"
    },
    "driverNote": {
        "name": "드라이버 노트",
        "DELETE": "드라이버 알림 삭제",
        "DELETE_CONFIRM": "선택한 드라이버 알림을 삭제하시겠습니까?",
        "EDIT": "드라이버 알림 편집",
        "ADD": "드라이버 알림 추가",
        "DETAIL": "드라이버 알림 세부사항",
        "Update_success": "드라이버 알림이 성공적으로 업데이트되었습니다",
        "Create_success": "새 드라이버 알림이 성공적으로 생성되었습니다",
        "Delete_success": "드라이버 알림이 성공적으로 삭제되었습니다",
        "Delete_fail": "드라이버 알림 삭제 중 오류 발생",
        "Load_fail": "드라이버 알림 로딩 중 오류 발생",
        "Update_fail": "드라이버 알림 업데이트 중 오류 발생",
        "Create_fail": "드라이버 알림 생성 중 오류 발생"
    },
    "flightIntegration": {
        "Username": "사용자 이름",
        "provider": "항공 제공자",
        "Key": "API 키",
        "apiKeys": "API 키",
        "apiId": "API Id",
        "Save": "저장",
        "Update_flight_integration_success": "항공 인테그레이션이 성공적으로 업데이트되었습니다",
        "Update_flight_integration_fail": "항공 인테그레이션 업데이트 중 오류 발생"
    },
    "smsIntegration": {
        "provider": "SMS 제공자",
        "apiToken": "API 토큰",
        "subAccountId": "하위 계정 ID",
        "senderIdSource": "발신자 ID (출처):",
        "apiKey": "API 키",
        "username": "사용자 이름",
        "shortCode": "단축 코드",
        "key": "키",
        "webService": "웹 서비스",
        "bearerToken": "Bearer 토큰",
        "keyId": "키 ID",
        "email": "이메일",
        "appKey": "앱 키",
        "sender": "송신자",
        "password": "비밀번호",
        "maskedPhone": "마스킹된 전화번호",
        "senderId": "발신자 ID",
        "webservice": "웹 서비스",
        "brandname": "브랜드 이름",
        "appSecret": "앱 비밀번호",
        "consumerKey": "소비자 키",
        "requestUrl": "요청 URL",
        "authId": "인증 ID",
        "authToken": "Auth 토큰",
        "authKey": "인증키",
        "templateId": "템플릿 ID",
        "templateKey": "템플릿 키",
        "phloId": "PHLO ID",
        "dlcNumber": "10DLC 번호",
        "app_key": "앱 키",
        "api_key": "API 키",
        "accountSID": "계정 SID",
        "applicationId": "애플리케이션 ID",
        "phoneNumber": "SMS 번호 1",
        "phoneNumber2": "SMS 번호 2",
        "SenderID_1": "발신자ID 1",
        "SenderID_2": "발신자ID 2",
        "smsMarketingNumber": "SMS 마케팅 전화 번호",
        "updateSMSSuccess": "sms가 성공적으로 업데이트되었습니다",
        "Deleted_success": "SMS가 성공적으로 삭제되었습니다",
        "receiverCountries": "수신 국가",
        "error": {
            "ERROR_CREATE": "SMS 생성 중 오류가 발생했습니다",
            "COUNTRY_EXISTED": "시스템에 이미 존재하는 국가입니다",
            "ERROR_DELETE": "SMS 삭제 실패",
            "ERROR_UPDATE": "SMS 업데이트 실패"
        },
        "identifierId": "식별자 ID"
    },
    "mDispatcher": {
        "mDispatchers": "파트너",
        "Active": "활성",
        "Inactive": "비활성화",
        "Deactivate": "비활성화",
        "Activate": "활성화",
        "Delete": "삭제",
        "Save": "저장",
        "Edit": "편집",
        "ADD_MDISPATCHER": "파트너 추가",
        "EDIT_MDISPATCHER": "파트너 수정",
        "Phone_number": "전화번호",
        "first_name": "이름",
        "last_name": "성",
        "email": "이메일",
        "address": "주소",
        "mDispatcher_type": "파트너 유형",
        "mDispatcher_type_toolTip": "더 많은 파트너 유형을 추가하려면 설정 > 파트너 유형으로 이동하십시오",
        "queuing_area_toolTip": "대기 영역을 더 추가하려면 대기 영역 메뉴로 이동하십시오.",
        "mDispatcher": "파트너",
        "card_management": "카드 관리",
        "Select_mDispatcher_type": "파트너 유형 선택",
        "Amount": "금액",
        "Percent": "퍼센티지",
        "Yes": "예",
        "Required_fields": "필수 입력란",
        "Cancel": "취소",
        "commission_type": "커미션 유형",
        "commission_value": "커미션 값",
        "Name": "이름",
        "Phone_Number": "전화번호",
        "queuing_area": "대기 영역",
        "mdispatcher_type": "파트너 유형",
        "registered_from": "등록 from",
        "registration_date": "등록 날짜",
        "status": "상태",
        "actions": "행동",
        "Select_queue_area": "대기영역 선택",
        "for_new_mDipatcher_account_password_default_is_password": "새 파트너 계정의 기본 비밀번호는 \"\"12345678\"\"입니다",
        "Create_mDispatcher_success": "새 파트너가 성공적으로 생성되었습니다",
        "Create_mDispatcher_fail": "파트너 생성 중 오류가 발생했습니다",
        "Load_mDispatcher_fail": "파트너 로딩 중 오류가 발생했습니다",
        "Update_mDispatcher_success": "파트너가 성공적으로 업데이트되었습니다",
        "Update_mDispatcher_fail": "파트너 업데이트 중 오류가 발생했습니다",
        "Update_mDispatcher_status_success": "파트너 상태가 성공적으로 업데이트되었습니다",
        "Update_mDispatcher_status_fail": "파트너 상태 업데이트 중 오류가 발생했습니다",
        "Update_mDispatcher_statuses_success": "파트너 상태가 성공적으로 업데이트되었습니다",
        "Update_mDispatcher_statuses_fail": "파트너 상태 업데이트 중 오류가 발생했습니다",
        "Delete_mDispatcher_success": "파트너가 성공적으로 삭제되었습니다",
        "Delete_mDispatcher_fail": "파트너 삭제 중 오류가 발생했습니다",
        "Delete_mDispatchers_success": "파트너가 성공적으로 삭제되었습니다",
        "Delete_mDispatchers_fail": "파트너를 삭제하는 중 오류가 발생했습니다",
        "Do_you_want_to_delete_these_mDipatchers": "이 파트너들을 삭제하시겠습니까?",
        "Only_mDistcher_in_the_inactive_status_can_be_deleted": "***비활성 상태의 mDistcher만 삭제할 수 있습니다",
        "No_card": "카드를 찾을 수 없음",
        "Reset_Password": "비밀번호 재설정",
        "Reset_password_success": "파트너 비밀번호가 성공적으로 재설정되었습니다",
        "Reset_password_fail": "파트너 비밀번호를 재설정하는 중 오류가 발생했습니다",
        "Do_you_want_to_reset_password": "비밀번호를 재설정하시겠습니까?",
        "ERROR_EXISTED_PHONE": "이 전화는 이미 시스템에 존재합니다. 다른 번호를 입력하십시오.",
        "ERROR_INPUT_VALIDPHONE": "유효한 전화번호를 입력하십시오.",
        "Partner_detail": "파트너 정보",
        "ALERT_SELECT_ACTIVATE": "활성화할 파트너를 선택하십시오.",
        "ALERT_SELECT_DEACTIVATE": "비활성화할 파트너를 선택하십시오.",
        "CONFIRM_DEACTIVATE_MULTI": "이 파트너들을 비활성화하시겠습니까?",
        "CONFIRM_ACTIVATE_MULTI": "이 파트너들을 활성화하시겠습니까?",
        "ERROR_COMMISSION_NUMBERS": "올바른 번호를 입력해 주세요.",
        "No_Support": "이 지역에서는 새로운 카드 추가가 현재 지원되지 않습니다",
        "Add": "추가",
        "Default_zone": "기본 영역",
        "required_email_payment": "파트너의 이메일이 필요합니다. 계속하려면 프로필을 업데이트해주십시오.",
        "titleGuestQR": "파트너 손님-QR 링크",
        "questQRContent": "당신의 개인화된 파트너 예약 링크가 여기에 있습니다! 바, 호텔 리셉션, 게스트 룸, 웹사이트 등 고객이 택시 또는 배송 서비스가 필요한 어디에서나 눈에 띄게 표시하세요. 고객들이 쉽고 빠르게 여행을 예약하도록 독특한 QR 코드로 스탠디를 디자인해 보세요!",
        "View_Guest_QR": "게스트 QR 보기"
    },
    "mDispatcherType": {
        "Name": "이름",
        "Required_fields": "필수 입력란",
        "Save": "저장",
        "Cancel": "취소",
        "No": "아니오",
        "Add": "추가",
        "Show_per_page": "페이지 당 항목 수",
        "Page": "페이지",
        "show_pages": "{0} - {1} of {2} 표시됨",
        "Delete": "삭제",
        "Edit": "편집",
        "DELETE_MDISPATCHER_TYPE": "파트너 유형 삭제",
        "DELETE_CONFIRM": "파트너 유형을 삭제하시겠습니까?",
        "Yes": "예",
        "EDIT_MDISPATCHER_TYPE": "파트너 유형 편집",
        "ADD_MDISPATCHER_TYPE": "파트너 유형 추가",
        "DETAIL_MDISPATCHER_TYPE": "파트너 유형 세부사항",
        "Actions": "행동",
        "Delete_mDispatcherType_success": "파트너 유형이 성공적으로 삭제되었습니다",
        "Delete_mDispatcherType_fail": "파트너 유형 삭제 중 오류가 발생했습니다",
        "Load_mDispatcherType_fail": "파트너 유형 로드 중 오류가 발생했습니다",
        "Create_mDispatcherType_success": "새 파트너 유형이 성공적으로 생성되었습니다",
        "Create_mDispatcherType_fail": "파트너 유형 생성 중 오류가 발생했습니다",
        "Update_mDispatcherType_success": "파트너 유형이 성공적으로 업데이트되었습니다",
        "Update_mDispatcherType_fail": "파트너 유형 업데이트 중 오류가 발생했습니다"
    },
    "queuingArea": {
        "queuing_area_info": "대기 영역 정보",
        "queuingDrivers": "활성 드라이버",
        "Name": "이름",
        "Required_fields": "필수 입력란",
        "Save": "저장",
        "Cancel": "취소",
        "Yes": "예",
        "No": "아니오",
        "Add": "추가",
        "Show_per_page": "페이지 당 항목 수",
        "Enter_to_search": "검색 입력",
        "Page": "페이지",
        "show_pages": "{0} - {1} of {2} 표시됨",
        "Delete": "삭제",
        "Edit": "편집",
        "Active": "활성",
        "Inactive": "비활성화",
        "Deactivate": "비활성화",
        "Activate": "활성화",
        "drivers": {
            "order": "주문",
            "Driver_name": "운전자 이름",
            "Phone_Number": "전화번호",
            "driverLicenseNumber": "차량 번호판",
            "Car_Type": "차량 유형",
            "checkInTime": "체크인 시간",
            "duration": "기간",
            "timestampScore": "타임스탬프 점수",
            "changeOrderDriver": "주문 변경",
            "detailOrderDriver": "드라이버 주문",
            "Yes": "예",
            "No": "아니오",
            "insert": "삽입",
            "refresh": "새로 고침",
            "insertDriver": "대기열에 드라이버 삽입",
            "orderDriver": "주문번호#",
            "reason": "이유",
            "removeDriver": "대기열에서 드라이버 제거",
            "removeDriverConfirm": "이 드라이버를 대기열에서 제거하시겠습니까?",
            "driverNotStay": "이 드라이버는 대기 영역 내에 없습니다. 나중에 다시 시도해 주세요.",
            "overOrder": "주문 번호는 대기중인 드라이버 수를 초과할 수 없습니다.",
            "noDriverFound": "드라이버를 찾을 수 없습니다.",
            "driverUpdateErrRs": "드라이버가 대기열 영역 내에 없습니다. 나중에 다시 시도해 주세요.",
            "orderUpdateErrRs": "주문 번호는 대기중인 드라이버 수를 초과할 수 없습니다.",
            "removeDriverSuccess": "드라이버는 성공적으로 대기 영역에서 제거되었습니다.",
            "removeDriverFail": "대기 영역에서 드라이버를 제거하는 도중 오류가 발생했습니다.",
            "operationInsertFailRs": "드라이버가 존재하지 않거나 사용할 수 없습니다.",
            "versionInsertFailRs": "이 기능을 적용하려면 드라이버는 드라이버 애플리케이션을 최신 버전으로 업그레이드해야 합니다.",
            "queueInsertFailRs": "대기열이 존재하지 않거나 드라이버가 대기열 영역 내에 없습니다. 나중에 다시 시도해 주세요.",
            "vehicleInsertFailRs": "대기열이 드라이버의 차량 유형을 지원하지 않습니다.",
            "orderInsertFailRs": "주문 번호는 대기중인 드라이버 수를 초과할 수 없습니다.",
            "positionInsertFailRs": "대기 영역에 드라이버를 삽입하는 도중 오류가 발생했습니다.",
            "insertDriverSuccess": "드라이버는 성공적으로 대기 영역에 삽입되었습니다.",
            "changeOrderSuccess": "드라이버의 위치가 성공적으로 변경되었습니다.",
            "insertDriverFail": "대기열 영역에서 드라이버를 삽입하는 도중에 오류가 발생했습니다.",
            "changeOrderFail": "대기 영역에서 드라이버 위치를 변경하는 도중에 오류가 발생했습니다.",
            "selectToInsert": "검색: 드라이버 이름, 전화 번호",
            "updateBy": "운영자에 의해 업데이트됨",
            "changeOrder": "주문 변경",
            "remove": "제거"
        },
        "keepDriverPlaceCancelNoShow": "예약이 취소되거나 이행되지 않았을 때 드라이버의 위치 유지",
        "keepDriverPlaceUnavailable": "드라이버가 사용할 수 없을 때 드라이버의 위치 유지",
        "range": "대기열 범위",
        "queueRangeTooltip": "드라이버들이 드라이버 앱에서 대기열 위치 번호를 어떻게 볼지에 대한 예시입니다. 예를 들어:\n- 대기열 범위를 1로 설정: 드라이버들은 대기열 내 자신의 위치를 하나의 숫자로 보게됩니다: 1, 2, 3, 4, 등.\n- 대기열 범위를 5로 설정: 드라이버들은 대기열 내 자신의 위치를 범위로 보게됩니다: 1-5, 6-10, 11-15, 16-20, 등.\n- 대기열 범위를 10으로 설정: 드라이버들은 대기열 내 자신의 위치를 범위로 보게됩니다: 1-10, 11-20, 21-30, 31-40, 등.",
        "queueCanceledTooltip": "- 승객이 취소하거나 노쇼한 경우, 드라이버는 설정 시간 내에 대기열로 다시 들어오면 최상위 위치로 남게 됩니다.\n- 드라이버가 짧은 여행 예약을 완료한 후 설정 시간 내에 대기열로 다시 들어오면 드라이버의 위치는 높은 우선순위로 설정됩니다.",
        "DELETE_QUEUING_AREA": "대기열 영역 삭제",
        "DELETE_CONFIRM": "대기열 영역을 삭제하시겠습니까?",
        "EDIT_QUEUING_AREA": "대기열 영역 편집",
        "ADD_QUEUING_AREA": "대기열 영역 추가",
        "DETAIL_QUEUING_AREA": "대기열 영역 세부사항",
        "Queuing_area": "대기 영역",
        "Address": "주소",
        "Enter_a_location": "위치 입력",
        "Entered_Address_is_incorrect": "시스템이 귀하의 위치를 파악할 수 없습니다. 추천 주소를 사용해주세요.",
        "Not_supported_zone": "이 대기열 영역은 지원 영역 내에 없습니다",
        "Active_mDispatcher_list": "활성 파트너 목록",
        "Queue_list": "대기열 목록",
        "Allow_radius": "반경 허용",
        "Min_drivers_required": "# 최소 드라이버 필요",
        "Open_queuing_area": "열린 대기 구역",
        "Auto_dispatch": "대기중인 드라이버에게 자동 할당 (파트너 앱 사용 불필요)",
        "Active_car_list": "활성화된 차량 목록",
        "mDispatcher": "파트너",
        "Google_Address": "Google 주소",
        "Status": "상태",
        "Update_status_error": "상태 업데이트 오류",
        "driver_checkin_area": "드라이버 체크인 영역",
        "EDIT_POLYGONS": "폴리곤 수정",
        "pax_pickup_area": "승객 픽업 영역",
        "pickup_area": "픽업 지역",
        "your_chosen_polygon": "선택한 폴리곤",
        "other_queues": "다른 대기열",
        "operation_zones": "운영 구역",
        "delete_pickup_area_confirm": "이 픽업 영역을 삭제하시겠습니까?",
        "delete_pickup_area": "픽업 영역 삭제",
        "please_choose_driver_check_in_area": "드라이버 체크인 영역을 선택하세요.",
        "please_choose_pick_up_area": "픽업 영역을 선택하세요.",
        "Load_queuing_area_fail": "대기 구역 로딩 중 오류 발생",
        "Create_queuingArea_success": "대기 구역이 성공적으로 생성되었습니다",
        "Update_queuingArea_success": "대기 구역이 성공적으로 업데이트되었습니다",
        "Delete_queuingArea_success": "대기 구역이 성공적으로 삭제되었습니다",
        "Delete_queuingArea_fail": "대기 구역 삭제 중 오류 발생",
        "Create_queuingArea_fail": "대기 구역 생성 중 오류 발생",
        "Load_queuingArea_fail": "대기 구역 로딩 중 오류 발생",
        "Update_queuingArea_fail": "대기 구역 업데이트 중 오류 발생"
    },
    "appBanner": {
        "Save": "저장",
        "Pax_app": "승객 앱",
        "Apply_to": "적용하기",
        "Please_select_view": "보기를 선택하세요",
        "Select_Type": "배너 유형을 선택하세요",
        "Home_view": "홈 보기",
        "Other_view": "기타 보기",
        "Banner_1": "배너 #1",
        "Upload_an_image": "이미지 미선택",
        "Action": "동작",
        "NA": "해당 없음",
        "Link_to_website": "웹사이트로 연결",
        "Make_a_call": "전화 걸기",
        "Send_an_email": "이메일 보내기",
        "Banner_2": "배너 #2",
        "Banner_3": "배너 #3",
        "Driver_app": "드라이버 앱",
        "pax": "승객 앱",
        "driver": "드라이버 앱",
        "merchant": "머천트 앱",
        "Name": "이름",
        "viewType": "유형",
        "status": "상태",
        "image": "이미지",
        "html": "HTML",
        "Delete_Banner": "배너 삭제",
        "Delete_confirm_banner": "선택한 배너를 삭제하시겠습니까?",
        "Delete_banner_success": "배너가 성공적으로 삭제되었습니다",
        "Delete_banner_fail": "배너 삭제 중 오류 발생",
        "edit_banner": "배너 수정",
        "detail_banner": "배너 세부정보",
        "create_banner": "배너 추가",
        "note_1": "* 파일 확장자는 .jpg, .jpeg, .png, .gif이며 크기는 %{limit}MB 이하여야 합니다.",
        "note_2": "* 이미지는 16:9 관점 비율을 가져야 합니다.",
        "note_3": "* 인박스, 친구 추천, 영수증, 예약 내역, 프로모션 코드, 신용카드/결제 방법 추가, 프로필, 처리 대기/확인된 예약, 완료된 보기 등 기타 보기.",
        "Update_app_banner_success": "앱 배너가 성공적으로 업데이트되었습니다.",
        "Update_app_banner_fail": "앱 배너 업데이트에 실패했습니다!",
        "Create_app_banner_success": "앱 배너가 성공적으로 생성되었습니다",
        "Create_app_banner_fail": "앱 배너 생성에 실패했습니다!",
        "Note": "보다 나은 앱 성능을 위해 .png 형식의 파일을 사용해 주세요 (투명 배경, 400:200px 크기)",
        "Limit_size_upload": "파일 크기는 8MB 미만이어야 합니다.",
        "display_duration": "표시 시간",
        "playback_settings": "재생 설정",
        "display_banner_again_after": "다음에 다시 배너 표시",
        "stop_display_banner_after": "배너 표시 종료",
        "enable_playback": "재생 활성화",
        "Update_playback_success": "재생 설정이 성공적으로 업데이트되었습니다",
        "Update_playback_fail": "재생 설정 업데이트에 실패했습니다!",
        "language": "언어",
        "single": "단일 언어",
        "multi": "다중 언어",
        "es-ES": "스페인어",
        "en-US": "영어",
        "fr-FR": "프랑스어",
        "id-ID": "인도네시아어",
        "vi-VN": "베트남어",
        "ur-PK": "우르두어",
        "ms-MY": "말레이어",
        "ar-AR": "아랍어",
        "nb-NO": "노르웨이어",
        "en-GB": "영국 영어",
        "am-ET": "암하라어",
        "ro-RO": "루마니아어",
        "version": "앱 버전",
        "comparisonVersionApp": {
            "is": "다음 중 하나임",
            "is_not": "다음 중 하나가 아님",
            "is_one_of": "다음 중 하나에 속함",
            "is_not_one_of": "다음 중 어느 것에도 속하지 않음",
            "greater_or_equal": "다음 이상",
            "less_or_equal": "다음 이하"
        },
        "platform": "플랫폼",
        "platformItem": {
            "all": "모두",
            "iOS": "iOS",
            "android": "Android"
        },
        "userStatus": "사용자 상태",
        "Active": "활성",
        "Inactive": "비활성화",
        "in_review_completed": "검토 중 (프로필 완료)",
        "in_review_incomplete": "검토 중 (프로필 미완료)",
        "in_review_inProgress": "검토 중 (프로필 작성 중)",
        "zones": "구역"
    },
    "reservation": {
        "name": "예약",
        "company": "회사",
        "carType": "차량 유형",
        "licensePlate": "번호판: %{name}",
        "driver": "드라이버: %{name}",
        "showAllDrivers": "모든 운전사 보기",
        "available": "사용 가능",
        "reserved": "예약됨",
        "search_holder": "회사, 운전사 이름, 차량 유형, 번호판",
        "all": "모두",
        "today": "오늘",
        "thisWeek": "이번 주",
        "day": "일일",
        "week": "주간",
        "bookingID": "예약 ID",
        "tripId": "여행 ID",
        "pickupTime": "픽업 시간",
        "pickupLocation": "픽업 위치",
        "monday": "월요일",
        "tuesday": "화요일",
        "wednesday": "수요일",
        "thursday": "목요일",
        "friday": "금요일",
        "saturday": "토요일",
        "sunday": "일요일",
        "overlapped": "중복됨",
        "noData": "데이터를 찾을 수 없습니다.",
        "bookingDetails": "예약 내역",
        "reservedHint": "예약이 확인되었습니다",
        "availableHint": "확인된 예약이 없습니다",
        "overlappedHint": "두 개 이상의 확인된 예약이 중복됩니다"
    },
    "dashboard": {
        "API": "API",
        "cc": "CC",
        "dmc": "예약 보드",
        "streetSharing": "스트리트 공유",
        "kiosk": "키오스크",
        "mDispatcher": "파트너",
        "paxApp": "승객 앱",
        "webBooking": "웹 예약",
        "carHailing": "차량 호출",
        "acceptance": "수락",
        "booking_com": "Booking.com",
        "completed": "완료",
        "noShow": "불참",
        "driverNoShow": "기사 불참",
        "canceled": "취소",
        "incident": "사건",
        "rate1": "1 별",
        "rate2": "2 별",
        "rate3": "3 별",
        "rate4": "4 별",
        "rate5": "5 별",
        "Export_to_Excel": "엑셀로 내보내기",
        "Profit": "이익",
        "day_change": "일일 변동",
        "week_change": "주간 변동",
        "month_change": "월간 변동",
        "Booking_requests": "예약 요청",
        "Complete_bookings": "완료된 예약",
        "New_customers": "신규 고객",
        "Booking_dashboard": "예약 보드",
        "others": "기타",
        "Revenue_booking": "이익 & 완료된 예약",
        "Profit_finish_booking": "이익 & 완료된 예약",
        "Booking_request": "예약 요청",
        "Finished_booking": "완료된 예약",
        "failed": "실패",
        "partialCompleted": "부분 완료",
        "Finished_booking_char_header": "완료된 예약 ({0})",
        "Bookings": "예약 ({0})",
        "Ratings": "평점 ({0})",
        "Daily": "일일",
        "Weekly": "주간",
        "Monthly": "월간",
        "Total_customer": "전체 고객 {0}",
        "ProfitToolTips": "모든 비용을 제외한 플릿의 소득",
        "RevenueToolTips": "선택된 기간 동안 플릿이 실제로 받는 금액, 프로모션, 운전사에 대한 공제, 세금 등 포함",
        "ProfitChangeToolTips": "이전 기간과 비교하여 플릿의 이익 변동율",
        "BookingRequestsToolTips": "선택된 기간 동안 생성된 수요 예약과 예약의 총 수",
        "PercentageOfAcceptanceToolTips": "선택된 기간 동안 수락된 예약의 백분율",
        "BookingChangeHint": "이전 기간에 비해 생성된 예약 변동율",
        "CompletedBookingHint": "선택된 기간 동안 완료된 수요 예약과 예약의 총 수",
        "PercentageOfSatisfactionHint": "선택된 기간 동안의 만족도 백분율",
        "CompleteBookingDailyChangeHint": "이전 기간과 비교해서 완료된 예약 변동율",
        "NewCustomersHint": "선택된 기간 동안 등록된 새 고객의 총 수",
        "CustomerChangeHint": "고객 수의 변동 수와 백분율을 이전 기간과 비교",
        "TotalCustomer": "시스템 내의 고객 총 수",
        "ProfitAndFinishedBookingHint": "선택된 기간 동안의 플릿 예약 완료",
        "BookingRequestHint": "선택된 기간 동안 생성된 수요 예약과 예약의 총 수",
        "FinishedBookingChartsHint": "취소, 쇼 없음, 사고, 완료를 포함한 선택된 기간 동안 종료된 수요 예약과 예약의 총 수",
        "Customer_count": "{0} 고객 수",
        "Revenue": "수익"
    },
    "referral": {
        "first_package": "첫 패키지 (즉, Pax의 첫 완료된 예약)",
        "driver_refers_to_pax": "운전자가 고객을 추천함",
        "driver_will_get": "운전사가 받을 금액",
        "money": "돈",
        "amount": "금액",
        "percent": "퍼센티지",
        "settlement": "완료된 예약의 총 금액의 수수료 (%)",
        "pax_will_get": "Pax이 받을 것",
        "promotion_code": "프로모션 코드",
        "select_a_promotion": "프로모션 코드 선택",
        "maximum": "최대",
        "second_package": "2번째 패키지",
        "from": "에서",
        "to": "로",
        "After_2nd_package": "2번째 패키지 이후",
        "from_end_value_of_above_package": "마지막 패키지의 값 + 1",
        "Expiration_date": "만료일",
        "Never": "항상",
        "Customized_date": "맞춤 날짜",
        "limited": "제한",
        "unlimited": "무제한",
        "Valid_from": "유효 시작일",
        "Valid_to": "유효 종료일",
        "Invitation_limit": "심판 한도/드라이버",
        "Status": "상태",
        "Active": "활성",
        "Inactive": "비활성화",
        "note": "* 캠페인이 활성화된 후에는 보상값의 업데이트가 새 고객에게만 적용됩니다.",
        "Required_fields": "필수 입력란",
        "refferal_update_successfully": "추천 설정이 성공적으로 업데이트되었습니다",
        "distributeIncentiveToDriver": "운전자에게 인센티브 분배",
        "Immediate": "즉시",
        "Periodic": "주기적 (수동)",
        "Period": "기간",
        "startDate": "시작 날짜",
        "nextDistributionDate": "다음 분배 날짜",
        "oneMonth": "1 달",
        "threeMonth": "3 달",
        "sixMonth": "6 달",
        "passenger_refers_to_pax": "고객이 고객을 추천함",
        "referer_will_get": "추천인이 받을 것",
        "referee_will_get": "추천인이받을 것",
        "promo": "프로모션",
        "Pax_invitation_limit": "사용자당 초대 제한",
        "promoPaidBy": "프로모션 지불자",
        "fleet": "차량대열",
        "driver": "운전자",
        "promoCode": "프로모션 코드",
        "isSendInbox": "함수함 보내기",
        "isDefaultCode": "앱에서 자동 적용",
        "autoApplyOnWeb": "웹에서 자동 적용",
        "isDefaultCode_hint": "고객의 목록에 프로모션 코드 추가 및 고객이 주문 생성 시 예약에 자동 적용",
        "Actions": "행동",
        "add_promoCode": "추가",
        "Send_an_in_box_automatically_to_new_customers": "고객에게 메일을 보내기",
        "set_default_promo_code": "앱에서 자동 적용",
        "EDIT_PROMO_CODE": "프로모션 코드 편집",
        "DETAIL_PROMO_CODE": "프로모션 코드 세부 사항",
        "CREATE_PROMO_CODE": "프로모션 코드 생성",
        "DELETE_PROMO_CODE": "프로모션 코드 삭제",
        "DELETE_CONFIRM_PROMO_CODE": "이 프로모션 코드를 삭제하시겠습니까?",
        "ERROR_INPUT_SOURCE": "적어도 하나를 선택하세요."
    },
    "upload_document": {
        "NO_FILE_CHOSEN": "선택한 파일 없음",
        "Limit_size_upload": "파일 크기 제한 돌파 {0}Mb."
    },
    "payment_info": {
        "member_since": "가입일",
        "package_name": "패키지 이름",
        "last_payment": "마지막 결제",
        "credit_card": "신용 카드",
        "last_digits": "마지막 4자리",
        "default": "기본",
        "add_new_card": "새 카드 추가",
        "history": "기록",
        "transaction_date": "거래 일",
        "transaction_id": "거래 ID",
        "billing_cycle": "청구주기",
        "amount": "금액",
        "payment_history": "청구 내역",
        "card_information": "카드 정보",
        "card_holder": "카드 소유자",
        "card_number": "카드 번호",
        "expiration_date": "만료일",
        "cvv": "CVV"
    },
    "search_by": {
        "group_id": "그룹 ID",
        "booking_id": "예약 #",
        "recurring_id": "상환 #",
        "ExternalID": "외부 #",
        "tripId": "여행 #",
        "driver_name": "운전자 이름",
        "driver_phone_number": "운전자 전화번호",
        "license_plate": "차량 번호판",
        "vehicle": "차량",
        "operator": "운영자",
        "passenger_email": "승객 이메일",
        "passenger_name": "승객 이름",
        "passenger_phone_number": "승객 전화번호",
        "destination": "목적지",
        "pick_up": "픽업",
        "flight_number": "편 번호",
        "book_from": "에서 예약",
        "note": "메모",
        "email": "이메일",
        "phone": "전화"
    },
    "withdrawal": {
        "transferToEWallet": "외부 전자 지갑 *{0}로 이체",
        "channelCode": "채널 코드",
        "channelName": "채널 이름",
        "reversed": "거꾸로",
        "requestTime": "요청 시간",
        "referenceId": "참조 #",
        "driverName": "운전자 이름",
        "phoneNumber": "전화번호",
        "company": "회사",
        "description": "설명",
        "requestAmount": "요청 금액",
        "transferAmount": "이체 금액",
        "currentBalance": "현재 잔액",
        "currency": "통화",
        "action": "동작",
        "approve": "승인",
        "reject": "거부",
        "transferToBankAccount": "은행 계좌 *{0}로 이체됨",
        "transferToWingBank": "Wing 은행 ID *{0}로 이체됨",
        "transferToCreditWallet": "신용 지갑으로 이체",
        "reason": "이유",
        "search": "드라이버 이름, 전화, 회사, 거래 ID, 참조 #",
        "message": {
            "approve": "{0}의 금액을 이 운전자에게 지불하겠습니까?",
            "approveMulti": "선택한 운전자에게 급여를 지급하시겠습니까?",
            "approveSuccess": "선택한 요청이 지불되었습니다",
            "approveFail": "선택한 요청이 성공하지 못했습니다. 다시 시도해 주세요.",
            "approveMultiSuccess": "{1} 개 중 {0} 개의 선택한 요청이 지불되었습니다.",
            "approveMultiFail": "{1} 개 중 {0} 개의 선택한 요청이 성공하지 못했습니다. 다시 시도해 주세요.",
            "buttonConfirmTitle": "예",
            "closeButtonText": "아니오",
            "pleaseInputReason": "이유를 입력하세요",
            "rejectSuccess": "운전자의 요청이 거부되었습니다",
            "rejectFail": "선택한 요청을 거부하는 데 실패했습니다"
        },
        "getDataFailure": "데이터를 가져올 수 없습니다",
        "rejectRequest": "요청 거부"
    },
    "dynamicSurcharge": {
        "operationZone": "운영 지역",
        "activeSurcharge": "활성 추가 요금",
        "surcharge": "할증",
        "surchargeName": "추가 요금 이름",
        "parameter": "파라미터 (예: 1.x)",
        "pickupPoint": "픽업 지역",
        "dropOffPoint": "하차 지역",
        "delete_surcharge_success": "추가 요금이 성공적으로 삭제되었습니다",
        "delete_surcharge_fail": "추가 요금을 삭제하는 동안 오류가 발생했습니다",
        "update_surcharge_fail": "추가 요금을 업데이트하는 동안 오류가 발생했습니다",
        "update_surcharge_success": "추가 요금이 성공적으로 업데이트되었습니다",
        "create_surcharge_fail": "추가 요금을 생성하는 동안 오류가 발생했습니다",
        "create_surcharge_success": "추가 요금이 성공적으로 생성되었습니다",
        "active_surcharge_fail": "추가 요금을 활성화하는 동안 오류가 발생했습니다",
        "active_surcharge_success": "추가 요금이 성공적으로 활성화되었습니다",
        "deactive_surcharge_fail": "추가 요금을 비활성화하는 동안 오류가 발생했습니다",
        "deactive_surcharge_success": "할증이 성공적으로 비활성화되었습니다",
        "delete_surcharge": "할증 삭제",
        "delete_confirm_message": "선택한 할증을 삭제하시겠습니까?",
        "note": "*노트: 이것은 기본 요금이 곱해질 양입니다. 예: 파라미터가 1.5x일 때 $20의 요금은 $30이 됩니다"
    },
    "dynamicFare": {
        "operationZone": "운영 지역",
        "activeFare": "활성 요금",
        "fare": "요금",
        "fareName": "요금 이름",
        "factor": "곱하기 요인",
        "fix_amount": "금액",
        "parameter": "파라미터 (예: 1.x)",
        "delete_fare_success": "요금이 성공적으로 삭제되었습니다",
        "delete_fare_fail": "요금을 삭제하는 동안 오류가 발생했습니다",
        "update_fare_fail": "요금을 업데이트하는 동안 오류가 발생했습니다",
        "update_fare_success": "요금이 성공적으로 업데이트되었습니다",
        "create_fare_fail": "요금을 생성하는 동안 오류가 발생했습니다",
        "create_fare_success": "요금이 성공적으로 생성되었습니다",
        "active_fare_fail": "요금을 활성화하는 동안 오류가 발생했습니다",
        "active_fare_success": "요금이 성공적으로 활성화되었습니다",
        "deactive_fare_fail": "요금을 비활성화하는 동안 오류가 발생했습니다",
        "deactive_fare_success": "요금이 성공적으로 비활성화되었습니다",
        "delete_fare": "요금 삭제",
        "delete_confirm_message": "선택한 요금을 삭제하시겠습니까?",
        "note": "*노트: 이것은 기본 요금이 곱해질 양입니다. 예: 파라미터가 1.5x일 때 $20의 요금은 $30이 됩니다",
        "note_amount": "*노트: 이것은 기본 요금이 더해질 양입니다. 예: 설정된 금액이 $5일 때 $20의 요금은 $25가 됩니다"
    },
    "notifications": {
        "search": "예약 ID, 외부 ID 검색",
        "searchProviderName": "제공자 이름 검색",
        "statusItem": {
            "all": "모든 알림",
            "canceledByDriver": "운송 - 운전자에 의해 취소됨",
            "canceledByPartner": "제휴 - 파트너에 의해 취소됨",
            "reservationReminder": "예약 알림",
            "localPending": "로컬 - 보류 중",
            "reservationIsNotStarted": "예약이 시작되지 않음",
            "partnerRequestsCars": "파트너 요청 차량",
            "timeout": "시간초과",
            "noShow": "제휴 - 노쇼",
            "driverNoShow": "기사 불참",
            "affiliatePending": "제휴 - 보류 중",
            "affiliatePaymentFailed": "제휴 결제 실패",
            "affiliateTimeout": "제휴 시간 초과",
            "flightApi": "항공 API",
            "DebtWriteOff": "채무 삭감",
            "driverCancelTrip": "시내 - 운전자에 의해 취소됨",
            "minimumSeatRequired": "최소 좌석 요구",
            "newFarmInJobFrom3rd": "Booking.com - 새 예약",
            "canceledJobBy3rd": "Booking.com - 취소",
            "updatedJobBy3rd": "Booking.com - 업데이트",
            "incidentJobBy3rd": "Booking.com - 사건",
            "newFarmInJobFromHolidayTaxis": "HolidayTaxis - 새 예약",
            "canceledJobByHolidayTaxis": "HolidayTaxis - 취소",
            "updatedJobByHolidayTaxis": "HolidayTaxis - 업데이트",
            "newFarmInJobFromKarhoo": "Karhoo - 새 예약",
            "canceledJobByKarhoo": "Karhoo - 취소됨",
            "updatedJobByKarhoo": "Karhoo - 업데이트됨",
            "newFarmInJobFromHoppa": "Hoppa - 새 예약",
            "canceledJobByHoppa": "Hoppa - 취소됨",
            "updatedJobByHoppa": "Hoppa - 업데이트됨",
            "newFarmInJobFromKlook": "Klook - 새 예약",
            "canceledJobByKlook": "Klook - 취소됨",
            "updatedJobByKlook": "Klook - 업데이트됨",
            "newFarmInJobFromTransferZ": "TransferZ - 새 예약",
            "canceledJobByTransferZ": "TransferZ - 취소됨",
            "updatedJobByTransferZ": "TransferZ - 업데이트됨",
            "incidentReport": "사건",
            "incidentAutoReport": "검토 필요"
        },
        "sos": {
            "sosSearch": "예약 ID, 여객 이름, 운전자 이름 검색",
            "statusItem": {
                "all": "모두",
                "driver": "운전자",
                "passenger": "승객",
                "crew": "승무원"
            }
        }
    },
    "smartData": {
        "No": "No.",
        "driverName": "이름",
        "phone": "전화",
        "rating": "등급",
        "completed": "완료",
        "noShow": "불참",
        "driverNoShow": "기사 불참",
        "incident": "사건",
        "canceled": "기사에 의해 취소됨",
        "accepted": "수락됨",
        "reject": "거부",
        "ignore": "무시",
        "earning": "수익",
        "query": {
            "top20": "상위 20",
            "top50": "상위 50",
            "top100": "상위 100",
            "bottom20": "하위 20",
            "bottom50": "하위 50",
            "bottom100": "하위 100"
        },
        "status": {
            "canceled": "기사에 의해 취소됨",
            "noShow": "불참",
            "driverNoShow": "기사 불참",
            "incident": "사건",
            "completed": "완료",
            "earning": "수익",
            "reject": "거부",
            "ignore": "무시",
            "accepted": "수락됨"
        }
    },
    "Reject": "불참",
    "Do not allow Driver to start reservat": "제휴",
    "intercityRate": {
        "Delete_intercity_rate": "도시 간 요금 삭제",
        "edit_intercity_rate": "도시 간 요금 수정",
        "view_intercity_rate": "도시 간 요금 보기",
        "add_intercity_rate": "도시 간 요금 추가",
        "Delete_confirm_intercity_rate": "이 항목을 삭제하시겠습니까?",
        "Update_intercity_rate_success": "시외 요금이 성공적으로 업데이트되었습니다",
        "Update_intercity_rate_fail": "시외 요금 업데이트 중 오류 발생",
        "Created_intercity_rate_success": "시외 요금이 성공적으로 생성되었습니다",
        "Created_intercity_rate_fail": "시외 요금 생성 중 오류 발생",
        "Update_intercity_rate_route_success": "시외 요금 루트가 성공적으로 업데이트되었습니다",
        "Update_intercity_rate_route_fail": "도시 간 요금 루트 업데이트 중 오류 발생",
        "Created_intercity_rate_route_success": "시외 요금 루트가 성공적으로 생성되었습니다",
        "Created_intercity_rate_route_fail": "도시 간 요금 루트 생성 중 오류 발생",
        "Loading_intercity_rate_fail": "시외 요금 세부사항 로드 중 오류 발생",
        "Delete_intercity_rate_route_fail": "시외 요금 루트 삭제 중 오류 발생",
        "Delete_intercity_rate_success": "시외 요금이 성공적으로 삭제되었습니다",
        "Delete_intercity_rate_fail": "시외 요금 삭제 중 오류 발생"
    },
    "intercityRoute": {
        "alias": "별칭",
        "routeNameHint": "루트 이름을 변경하려면 설정 > 구역 > 도시 간으로 이동하여 도시 구역의 이름을 변경하십시오.",
        "pricePerSeat": "시트당 가격 (세금 제외)",
        "distance": "거리",
        "duration": "기간",
        "cancellationPenalty": "시트당 벌금",
        "noShow": "여객/파트너 불참",
        "penalty": "시트당 벌금",
        "no_show_tooltip": "고객이 시트당 지불해야 할 금액입니다. 벌금 외에도 고객은 세금 또는 기술료를 지불해야 할 수 있습니다.",
        "firstLocation": "첫 번째 위치",
        "secondLocation": "두 번째 위치",
        "routeOneSetup": "루트 1 설정",
        "routetwoSetup": "루트 2 설정",
        "schedules": "스케줄",
        "date": "날짜",
        "time": "시간",
        "editSchedule": "스케줄 편집",
        "addSchedule": "스케줄 추가",
        "requestTimeEnable": "고객이 요청 시간을 설정할 수 있게 허용",
        "extraFee": "추가 요금",
        "hideRouteEnable": "이 루트 숨기기",
        "timeRange": "시간 범위",
        "workingTime": "근무 시간",
        "applyForOtherDays": "다른 날짜에 적용",
        "limitSeatLuggage": "좌석 / 수하물 제한",
        "warningMinimumSeats": "최소 좌석 요구",
        "warningMinimumSeatsHint": "여행을 하려면 필요한 최소 좌석 수",
        "allowStartLessMinRequiredSeats": "좌석 요구량에 관계없이 운전자가 여행 시작",
        "allowStartLessMinRequiredSeatsHint": "요청된 좌석 수가 최소 좌석 요구량보다 적더라도 운전자가 여행을 시작할 수 있게 허용",
        "freeLuggagePerSeat": "시트당 무료 수하물",
        "freeLuggagePerSeatHint": "시트당 포함된 무료 수하물 수",
        "allowToAddExtraLuggage": "추가 수하물 추가",
        "allowToAddExtraLuggageHint": "여객이 추가 수하물을 추가할 수 있게 허용",
        "feePerExtraLuggage": "추가 수하물당 요금",
        "Delete_intercity_route": "도시 간 루트 삭제",
        "Delete_confirm_intercity_route": "이 루트를 삭제하시겠습니까?",
        "Update_intercity_route_fail": "도시 간 요금 루트 업데이트 중 오류 발생",
        "Update_intercity_route_success": "시외 노선이 성공적으로 업데이트되었습니다",
        "created_intercity_route_success": "시외 노선이 성공적으로 생성되었습니다",
        "created_intercity_route_fail": "도시 간 요금 루트 생성 중 오류 발생",
        "Delete_intercity_route_success": "시외 노선이 성공적으로 삭제되었습니다",
        "Delete_intercity_route_fail": "시외 노선 삭제 중 오류가 발생했습니다",
        "penalty_less_than_or_equal_to_price": "1인당 가격 이하 값을 입력해 주세요.",
        "scheduleTimeOverlap": "스케줄 시간은 서로 중첩되지 않아야 합니다",
        "allows_adding_extra": "고객이 편성하지 않은 시간을 요청할 때 추가 요금을 부과할 수 있습니다.",
        "this_is_to_limit_users": "이는 사용자(예: 고객, 운전자, 운영자)가 이 노선에서 새로운 예약이나 여행을 생성하는 것을 제한하기 위한 것입니다. 기존 예약이나 여행은 예약으로 남아 있습니다"
    },
    "dayOfWeek": {
        "0": "일요일",
        "1": "월요일",
        "2": "화요일",
        "3": "수요일",
        "4": "목요일",
        "5": "금요일",
        "6": "토요일"
    },
    "intercityBooking": {
        "route": "경로",
        "departureDate": "출발 날짜",
        "departureTime": "출발 시간",
        "Departure": "출발",
        "Arrival": "도착",
        "RefundFare": "환불 요금",
        "intercityZoneNote": "여기서 생성하는 구역은 시외 요금을 설정하는 데만 사용됩니다.",
        "zoneNameHint": "구역 이름을 간결하고 명확하게 유지해 고객이 쉽게 검색하고 선택할 수 있도록 해주세요.",
        "zoneUploadNote_2": "* 이미지 해상도는 1095x360이고 파일 크기는 5MB 이하로 하는 것이 권장됩니다.",
        "Complete_booking": "예약 완료",
        "ConfirmCancel": "취소 확인"
    },
    "deliveryRate": {
        "Delete_delivery_rate": "배송 요금 삭제",
        "edit_delivery_rate": "배송 요금 편집",
        "view_delivery_rate": "배송 요금 보기",
        "add_delivery_rate": "배송 요금 추가",
        "Delete_confirm_delivery_rate": "이 항목을 삭제하시겠습니까?",
        "Update_delivery_rate_success": "배송 요금이 성공적으로 업데이트되었습니다",
        "Update_delivery_rate_fail": "배송 요금 업데이트 중 오류 발생",
        "Created_delivery_rate_success": "배송 요금이 성공적으로 생성되었습니다",
        "Created_delivery_rate_fail": "배송 요금 생성 중 오류 발생",
        "Update_delivery_rate_route_success": "배송 요금 노선이 성공적으로 업데이트되었습니다",
        "Update_delivery_rate_route_fail": "배송 요금 노선 업데이트 중 오류가 발생했습니다",
        "Created_delivery_rate_route_success": "배송 요금 노선이 성공적으로 생성되었습니다",
        "Created_delivery_rate_route_fail": "배송 요금 노선 생성 중 오류가 발생했습니다",
        "Loading_delivery_rate_fail": "배송 요금 상세 로딩 중 오류 발생",
        "Delete_delivery_rate_route_fail": "배송 요금 노선 삭제 중 오류가 발생했습니다",
        "Delete_delivery_rate_success": "배송 요금이 성공적으로 삭제되었습니다",
        "Delete_delivery_rate_fail": "배송 요금 삭제 중 오류가 발생했습니다",
        "distance_km": "1km당 요금",
        "distance_mile": "mil당 요금",
        "flat": "정액 요금",
        "startingFee": "시작 요금",
        "feeFirstDistance": "첫 번째 거리 요금",
        "feeSecondDistance": "두 번째 거리 요금",
        "feeThirdDistance": "세 번째 거리 요금",
        "feeAfterThirdDistance": "세 번째 거리 이후 요금",
        "feePerMinute": "분당 요금",
        "feeMinimum": "최소 요금",
        "feeFirstStop": "첫 번째 정지 요금",
        "feeExtraStop": "추가 정지 요금마다의 요금"
    },
    "aiAtlasSettings": {
        "title": "아틀라스 AI 챗봇",
        "titleDes": "Atlas에 회사와 서비스에 대해 알려주세요",
        "information": "Atlas 정보",
        "informationDes": "예를 들어 회사 세부 정보인 이메일, 전화번호, 주소 등을 추가합니다.",
        "updateSettingSuccess": "AI Atlas 설정 성공적으로 업데이트",
        "updateSettingFail": "AI Atlas 설정 업데이트 실패"
    },
    "pwaSettings": {
        "pwa": "PWA",
        "iconName": "아이콘 & 이름",
        "logoBackgroundColor": "로고, 배경 & 색상",
        "longName": "긴 이름",
        "shortName": "짧은 이름",
        "icon192": "홈 스크린 아이콘 (192x192)",
        "icon512": "스플래시 스크린 아이콘",
        "logo": "로고 (300x300)",
        "logoMenu": "메뉴 로고 (300x300)",
        "backgroundImage": "배경 이미지 - 교통 (1024x500)",
        "backgroundImageDelivery": "배경 이미지 - 배달 (1024x500)",
        "mainColor": "주요 색상",
        "secondaryColor": "보조 색상",
        "showMainColor": "배경 이미지 대신 주요 색상 표시",
        "success": "PWA 설정이 성공적으로 업데이트되었습니다",
        "failed": "PWA 설정 업데이트 실패. 다시 시도해 주세요!",
        "errorUploadFileSize": "필요한 차원은 {0}x{0} px입니다.",
        "hideWBInstallAppBtn": "앱 설치 버튼 숨기기",
        "enableBookNow": "지금",
        "enableGuestCheckout": "비회원 결제",
        "enableBookLater": "나중에",
        "enableHideRecipient": "수취인 정보 숨기기 (패키지 내용, 배달 지시사항)",
        "pwaLink": "승객용 PWA",
        "partnerLink": "파트너용 PWA",
        "pwaDriverLink": "운전자용 PWA",
        "providerSignUp": "운전자 가입 링크",
        "AdsTracking": "광고 추적",
        "googleId": "구글 태그 ID",
        "placeholdergoogleId": "구글 태그 ID 입력",
        "metaId": "메타 픽셀 ID",
        "placeholdermetaId": "메타 픽셀 ID 입력"
    },
    "emailConfig": {
        "emailServer": "이메일 서버",
        "default": "기본",
        "customized": "맞춤설정",
        "fromName": "발신자 이름",
        "email": "발신 이메일",
        "replyTo": "답장 받을 사람",
        "userAuth": "사용자 이름",
        "password": "비밀번호",
        "smtpServer": "SMTP 서버",
        "port": "SMTP 포트",
        "isAuthenticated": "인증됨",
        "option": "옵션 활성화",
        "none": "없음",
        "tls": "TLS",
        "ssl": "SSL",
        "save": "저장",
        "cancel": "취소",
        "success": "이메일 서버 업데이트 성공",
        "fail": "이메일 서버 업데이트 실패",
        "loadFail": "이메일 서버 상세정보 로드 실패"
    },
    "driverFields": {
        "Load_fail": "",
        "Edit": "편집",
        "View": "보기",
        "Cancel": "취소",
        "show": "보기",
        "hide": "숨기기",
        "EDIT_DRIVER_FIELDS": "드라이버 필드 편집",
        "DETAIL_DRIVER_FIELDS": "드라이버 필드 상세",
        "ADD_DRIVER_FIELDS": "드라이버 필드 추가",
        "fieldKey": "필드 키",
        "fieldName": "필드 이름",
        "availableCC": "커맨드 센터에서 사용 가능",
        "availableDrvSignUp": "드라이버 등록시 사용 가능",
        "availableCompanyCar": "사내 차량 - 이송 운전기사",
        "deliveryCompany": "사내 차량 - 배달 운전기사",
        "availableIndividualCar": "개인 차량 - 이송 운전기사",
        "deliveryIndividual": "개인 차량 - 배달 운전기사",
        "required": "필수",
        "Update_fail": "드라이버 필드 업데이트 중 오류 발생",
        "Update_success": "드라이버 필드가 성공적으로 업데이트되었습니다",
        "FieldKey": "필드 키",
        "FieldName": "필드 이름 (미국 영어)",
        "CommandCenter": "커맨드 센터에서 사용 가능",
        "SignUp": "드라이버 등록시 사용 가능",
        "CompanyTransport": "사내 차량 - 이송",
        "CompanyDelivery": "사내 차량 - 배달",
        "IndividualTransport": "개인 차량 - 이송",
        "IndividualDelivery": "개인 차량 - 배달",
        "Require": "필수",
        "Actions": "행동",
        "fieldType": "필드 유형",
        "default": "기본",
        "customized": "맞춤설정"
    },
    "driverDocument": {
        "Load_fail": "",
        "Edit": "편집",
        "View": "보기",
        "Cancel": "취소",
        "show": "보기",
        "hide": "숨기기",
        "EDIT_DRIVER_DOCUMENT": "드라이버 문서 편집",
        "DETAIL_DRIVER_DOCUMENT": "드라이버 문서 상세",
        "ADD_DRIVER_DOCUMENT": "드라이버 문서 추가",
        "documentKey": "문서 키",
        "documentName": "문서 이름",
        "documentNameDetail": {
            "zh-HK": "전통 중국어",
            "it-IT": "표준 이탈리아어",
            "es-ES": "스페인어",
            "en-US": "미국 영어",
            "fr-FR": "표준 프랑스어",
            "zh-CN": "간체 중국어",
            "id-ID": "인도네시아어",
            "vi-VN": "베트남어",
            "ur-PK": "우르두어 (파키스탄 이슬람 공화국)",
            "ms-MY": "말레이어 (말레이시아)",
            "ar-AR": "아랍어",
            "en-GB": "영국 영어",
            "nb-NO": "노르웨이어",
            "am-ET": "암하라어",
            "ro-RO": "루마니아어",
            "th-TH": "타이어",
            "ta-IN": "타밀어",
            "hi-IN": "힌디어",
            "te-IN": "텔루구어",
            "ka-GE": "조지아어",
            "ru-RU": "러시아어",
            "kn-IN": "칸나다어"
        },
        "isIndividual": "사내 차량 - 이송 운전기사",
        "deliveryCompany": "사내 차량 - 배달 운전기사",
        "isOwner": "개인 운전기사 - 이송 운전기사",
        "deliveryIndividual": "개인 운전기사 - 배달 운전기사",
        "availableCC": "커맨드 센터에서 사용 가능",
        "availableDrvSignUp": "드라이버 등록시 사용 가능",
        "isRequired": "필수",
        "isExpiredDate": "만료 날짜 - 커맨드 센터",
        "expiredDateForDrvSignUp": "만료 날짜 - 드라이버 등록",
        "requireExpiredDate": "만료 날짜 필요",
        "requireExpiredDateForDrvSignUp": "만료 날짜 필요",
        "requireDocumentId": "문서 ID 필요",
        "documentId": "문서 ID - 커맨드 센터",
        "documentIdForDrvSignUp": "문서 ID - 드라이버 등록",
        "Update_fail": "드라이버 문서 업데이트 중 오류 발생",
        "Update_success": "드라이버 문서가 성공적으로 업데이트되었습니다",
        "DocumentKey": "문서 키",
        "DocumentName": "문서 이름 (미국 영어)",
        "CommandCenter": "커맨드 센터에서 사용 가능",
        "SignUp": "드라이버 등록시 사용 가능",
        "CompanyTransport": "사내 차량 - 이송",
        "CompanyDelivery": "사내 차량 - 배달",
        "IndividualTransport": "개인 차량 - 이송",
        "IndividualDelivery": "개인 차량 - 배달",
        "Require": "필수",
        "Actions": "행동"
    },
    "holidayTaxis": {
        "title": "HolidayTaxis API 자격증명",
        "note": "HolidayTaxis의 기술 팀과 연락하여 시스템에 연결할 수 있는 API 키를 제공하도록 요청하세요.",
        "apiKey": "API 키",
        "placeHolderApiKey": "API 키 입력"
    },
    "trailNotes": {
        "maxLengthFiles": "댓글당 최대 3개의 파일",
        "maxSizeFiles": "파일당 최대 10MB",
        "typeFiles": "지원하는 파일 유형: pdf, doc, docx, csv, xls, xlsx, jpeg, jpg, png, webp, txt, note",
        "maxComments": "예약당 최대 20개의 댓글",
        "bookingActivity": "예약 활동",
        "viewAll": "모두 보기",
        "operator": "운영자",
        "driver": "운전자",
        "passenger": "고객",
        "pHInput": "새로운 댓글을 추가하십시오. 저장을 클릭하여 노트를 저장할 수 있습니다. 여러 파일을 여기로 끌어다 놓을 수도 있습니다.",
        "addFiles": "파일 추가",
        "save": "저장",
        "inputNotes": "텍스트를 입력하십시오",
        "successDeleteTrailNotes": "트레일 노트를 성공적으로 삭제했습니다",
        "successCreateTrailNotes": "트레일 노트를 성공적으로 생성했습니다",
        "deleteTrailNote": "트레일 노트 삭제",
        "msgDeleteTrailNote": "이것을 삭제하시겠습니까?"
    },
    "supplier": {
        "permissionRequired": "운영자는 권한을 선택해야 합니다",
        "offerDetail": "제안 상세정보",
        "orderDetail": "주문 상세정보",
        "bookingNumber": "예약 번호",
        "date": "날짜",
        "pickupLocation": "픽업 위치",
        "dropoffLocation": "배달 위치",
        "passenger": "승객",
        "luggage": "수하물",
        "pickupService": "픽업 서비스",
        "pickupSignage": "픽업 안내",
        "flightNumber": "비행 번호",
        "departure": "출발",
        "arrival": "도착",
        "terminal": "터미널",
        "gate": "게이트",
        "meetGreet": "만나러 가기",
        "specialRequests": "특별 요청",
        "additionalServices": "추가 서비스",
        "price": "가격",
        "prices": "가격들",
        "guest": "손님",
        "serviceClass": "서비스 등급",
        "distance": "거리",
        "duration": "기간",
        "acceptOffer": "제안 수락",
        "updateBooking": "예약 업데이트",
        "package": "패키지",
        "route": "경로",
        "assignedChauffer": "배정된 샤퍼",
        "assignedVehicle": "배정된 차량",
        "logs": "로그",
        "link": "링크",
        "desLink": "링크 복사를 위해 클릭",
        "trackLink": "링크 추적",
        "driverLink": "드라이버 링크",
        "close": "닫기",
        "links": "링크",
        "linksDes": "링크 복사를 위해 클릭",
        "status": "상태",
        "rating": "등급",
        "permissions": "권한",
        "permissionsNote": "팀에게 다양한 수준의 권한을 부여하십시오. 운영자가 열린 제안을 볼 수 있게 할지 이미 수락된 배정만 볼 수 있게 할지 선택할 수 있습니다.",
        "owner": "소유자",
        "ownerNote": "전체 접근",
        "manageUsers": "사용자 관리",
        "manageUsersNote": "새 운영자 추가/제거",
        "manageDrivers": "운전기사 관리",
        "manageDriversNote": "운전기사 추가/제거",
        "manageVehicles": "차량 관리",
        "manageVehiclesNote": "차량 추가/제거",
        "mapView": "실시간 맵",
        "mapViewNote": "맵에서 운전기사와 활성 여행을 실시간으로 추적하세요.",
        "calendarView": "캘린더 보기",
        "calendarViewNote": "모든 배정된 여행의 캘린더를 보세요.",
        "bookingView": "예약 보기",
        "bookingViewNote": "현재 예약을 보고 관리하고, 운전기사를 배정하고, 차량을 할당하세요.",
        "offersView": "제안 보기",
        "offersViewNote": "새로운 작업 제안을 수락하세요.",
        "pricing": "가격결정",
        "pricingNote": "여행 가격 보기",
        "report": "보고서",
        "reportNote": "예약 및 재무 보고서 보기",
        "reportExport": "보고서 출력",
        "reportExportNote": "보고서를 .csv로 내보내기",
        "userDetail": "사용자 상세정보",
        "addOperator": "운영자 추가",
        "updateOperator": "운영자 업데이트",
        "supplier": "공급자",
        "zone": "구역",
        "emails": "이메일",
        "email": "이메일",
        "phoneNumber": "전화번호",
        "Deactivate": "비활성화",
        "Activate": "활성화",
        "ALERT_SELECT_DEACTIVATE": "비활성화할 공급자를 선택하십시오",
        "ALERT_SELECT_ACTIVATE": "활성화할 공급자를 선택하십시오",
        "CONFIRM_DEACTIVATE_MULTI": "이 공급자를 비활성화하시겠습니까?",
        "CONFIRM_ACTIVATE_MULTI": "이 공급자를 활성화하시겠습니까?",
        "Update_supplier_user_status_success": "공급자 상태가 성공적으로 업데이트되었습니다",
        "Update_supplier_user_status_fail": "공급자 상태를 업데이트하는 동안 오류가 발생했습니다",
        "agent": "에이전트",
        "Supplier": "공급자",
        "addSupplier": "공급자 추가",
        "detailSupplier": "공급자 세부 정보",
        "addUser": "사용자 추가",
        "Add": "추가",
        "ContactInfo": "연락처 정보",
        "policy": "정책",
        "users": "사용자",
        "setting": "설정",
        "zones": "구역",
        "actions": "행동",
        "companyName": "회사 이름",
        "corporationType": "법인 유형",
        "country": "국가",
        "nationality": "국적",
        "driverIC": "드라이버 IC",
        "ADMIN_INFORMATION": "관리 정보",
        "firstName": "이름",
        "lastName": "성",
        "commissionValue": "Fleet Commission",
        "commissionValueDes": "완료된 모든 주문에 대해 플릿이 받는 커미션을 설정하십시오.",
        "SupplierType": "공급자 유형",
        "SupplierTypeDes": "공급자 유형을 선택하십시오.",
        "paymentMethodsApplyDes": "공급자가 처리할 수 있는 작업 특정 결제 방법:",
        "bookingSettings": "예약 설정",
        "bookingSettingsDes": "효율적인 공급자 운영을 위해 작업 가시성, 릴리스 시간 및 지연을 설정합니다.",
        "advanceBookingVisibilityTooltip": "공급자가 주문을 볼 수 있는 날짜를 몇 일 전으로 설정하십시오.",
        "delayBroadcastToolTip": "주어진 시간이나 날의 시작(00:00)에서 지연 시간을 설정하십시오. 이 지연은 초기 릴리스 시간 이후에 작업이 공급자에게 언제 표시되는지를 제어합니다.",
        "releaseTimeToolTip": "공급자가 예약을 볼 수 있는 첫날부터 공급자에게 작업을 릴리스하는 하루의 시간을 설정하십시오. 이 시간이 공급자에게 충분한 준비 시간을 제공하는지 확인하십시오.",
        "otherSettings": "기타 설정",
        "hideFare": "드라이버 - 항상 요금 숨기기",
        "hideFareDes": "이 공급자의 모든 드라이버에 대한 요금을 숨깁니다.",
        "supplierJobRequired": "공급자 작업 수락 필요",
        "supplierJobRequiredDes": "공급자는 작업을 인정하고 수락해야 드라이버/차량을 지정하거나 마켓플레이스의 드라이버에게 작업을 볼 수 있게 할 수 있습니다.",
        "supplierApproval": "공급자 드라이버/차량 승인",
        "supplierApprovalDes": "공급자 운영자가 그들의 플릿 내에서 드라이버와 차량을 활성화하는 것을 허용합니다.",
        "emailsApply": "이메일 알림",
        "emailsApplyDes": "새로운 작업, 예약 업데이트를 보내려면 이메일.",
        "address": "주소",
        "zipCode": "우편/우편번호",
        "city": "도시",
        "state": "주/성",
        "tax": "세금 신분 번호",
        "businessRegistration": "사업자 등록 번호",
        "vatNumber": "VAT ID/번호",
        "mobile": "모바일",
        "editOperator": "운영자 편집",
        "searchEmail": "이메일 검색",
        "acceptOfferSuccess": "제안 성공적으로 수락",
        "acceptOfferFail": "예약을 찾을 수 없거나 다른 공급자가 예약을 수락함",
        "driverPayout": "운전자 지급",
        "payout": "지급",
        "totalPayout": "총 지불",
        "totalPayoutDes": "총 지불액은 기본 지불액과 공급자에게 할당하기로 선택한 추가 수수료를 포함합니다.",
        "supplierPayout": "공급자 지급",
        "driverTip": "드라이버 팁",
        "cancel": "취소",
        "save": "저장",
        "activeSupplier": "활성 공급자",
        "userName": "사용자 이름",
        "bookingCompletedView": "완료된 예약",
        "bookingCompletedViewNote": "모든 완료된 예약의 이력을 확인하십시오.",
        "driverEarning": "운전사 수입",
        "payoutCurrency": "지급 화폐",
        "payoutCurrencyDes": "공급자/드라이버에게 지급할 화폐",
        "autoCreatePayout": "자동 지불 작성",
        "autoCreatePayoutDes": "파트너에게 지불 성명서를 자동으로 작성하는 시점을 설정하십시오",
        "startDate": "시작 날짜",
        "frequency": "빈도",
        "daily": "일일",
        "weekly": "주간",
        "biWeekly": "격주",
        "monthly": "월간",
        "commissionSupplier": "수수료",
        "commissionSupplierDes": "완료된 모든 주문에 대해 공급자가 받는 커미션을 설정하십시오.",
        "amount": "고정 금액",
        "percent": "퍼센티지",
        "commissionSupplierValue": "커미션 값 입력",
        "payments": "결제",
        "paymentsDes": "매 지급 일정마다 지급될 금액",
        "ConnectWithStripe": "Stripe와 연결",
        "viewStripeAccount": "Stripe 계정 보기",
        "viewBankInfo": "은행 정보 보기",
        "AddBankInfo": "은행 정보 추가",
        "confirmChangeBalane": "공급자 잔액을 변경하시겠습니까?",
        "changeBalaneSuccess": "공급자 현금 잔액이 성공적으로 업데이트되었습니다",
        "restrictedZoneAccess": "제한된 지역 접근",
        "restrictedZoneAccessDes": "군사 기지 또는 공군 시설과 같은 특정 고보안 또는 제어 영역을 정의하십시오. 이런 장소들에서는 픽업이나 드롭오프가 특별 접근권이나 허가가 있는 운전자에게만 허가됩니다.",
        "DrvSignUpLink": "운전자 가입 링크"
    },
    "vehicleLeadTime": {
        "vehicleLeadTime": "차량 Lead Time 정책",
        "customLocationLeadTime": "사용자 정의 위치 Lead Time",
        "leadTime": "Lead Time",
        "ConfirmDelete": "이 정책을 삭제하시겠습니까?",
        "Delete_success": "정책이 성공적으로 삭제되었습니다",
        "Update_Policy_success": "정책이 성공적으로 업데이트되었습니다",
        "Create_Policy_success": "정책이 성공적으로 생성되었습니다",
        "Update_Policy_fail": "정책 업데이트 중에 오류가 발생하였습니다",
        "Create_Policy_fail": "정책 작성 중에 오류가 발생하였습니다",
        "setDefaultSuccess": "기본 차량 리드 타임 정책이 성공적으로 설정되었습니다",
        "setDefaultFail": "기본 정책 설정 중에 오류가 발생하였습니다",
        "Policies": "정책들",
        "pricingPolicy": "가격 정책",
        "customizeLeadTime": "리드 타임 사용자 정의",
        "SelectVehiclePolicy": "차량 리드 타임 정책 선택"
    },
    "noResultFound": "결과를 찾을 수 없습니다",
    "invalidDate": "날짜가 유효하지 않습니다. mm/dd/yyyy 형식으로 날짜를 입력해주세요.",
    "billingUsage": {
        "GSNTitle": "GSN 지갑",
        "GSNNote": "플릿이 네트워크에서 작업을 보내거나 받기 위해 충전합니다.",
        "GSNPlatform": "플랫폼",
        "GSNPlatformNote": "구독 및 예약 사용량 추적. 청구 주기 말에 청구됩니다. GSN 지갑과는 별도입니다.",
        "GSNPlatformLimit": "플랫폼 청구",
        "GSNPlatformLimitNote": "구독 및 사용량 추적. 청구 주기 말에 청구됩니다. GSN 지갑과는 별도입니다.",
        "usageBalanceNote": "구독 및 사용량 추적. 청구 주기 말에 청구됩니다. GSN 지갑과는 별도입니다.",
        "usageBalanceNoteDate": "구독 및 사용 미결제",
        "usageBalanceNoteDateValue": "만기 %{date}.",
        "usageBalance": "사용 잔액",
        "platformUsage": "플랫폼 사용량",
        "payoutBalance": "정산 잔액",
        "invoicePayoutBalanceTooltip": "완료된 네트워크 예약으로 번 수익으로, 출금 가능합니다. 신용 잔액이 부족하면 이 잔액으로 네트워크 거래를 충당할 수 있습니다.",
        "autoPayoutBalanceTooltip": "네트워크에서 번 수익을 보여 주며 출금할 수 있습니다. 신용 잔액이 낮으면 수수료가 여기서 자동으로 차감될 수 있습니다.",
        "creditBalance": "신용 잔액",
        "gsnCreditBalance": "GSN 신용 잔액",
        "totalBalance": "총 잔액",
        "paid": "완료",
        "failed": "실패",
        "processing": "처리 중",
        "pending": "대기 중",
        "bookingDeduct": "GSN Farm-Out",
        "cancellationPenalty": "GSN 지연 취소",
        "noShowPenalty": "GSN 노쇼",
        "withdraw": "출금",
        "bookingEarning": "GSN Farm-In",
        "booking": "플랫폼 수수료",
        "subscriptionFee": "Subscription Fee",
        "waived": "Waived*",
        "learnMore": "자세히 알아보기",
        "viewUsage": "View Usage",
        "productDiscovery": "제품 발견",
        "productDiscoveryDescription": "GoodJourney로 시작할 수 있는 모든 것을 탐색하세요. 드라이버 앱, 웹 예약 도구 및 운영을 지원하는 기타 제품을 발견하세요.",
        "overview": "개요",
        "paymentMethods": "결제 방법들",
        "billingHistory": "청구 내역",
        "creditGrants": "신용 부여",
        "transactionHistory": "거래 내역",
        "getStartedDescription": "예약, 배치, 결제, 공급 업체 관리를 위한 종합 플랫폼입니다.",
        "getStartedButton": "시작하기",
        "walletOverview": "지갑 개요",
        "calculateTotal": "총계 = 신용 + 현금",
        "autoRechargeOn": "신용 잔액이 $0에 도달하면 무료 티어로 감소합니다. 자동 충전을 활성화하여 신용 잔액을 자동으로 충전하세요.",
        "autoRechargeOff": "팁: 자동 충전을 활성화하여 잔액을 유지하세요. 신용이 $0으로 떨어지면, 새로운 예약이 일시 중지될 때까지 자금을 추가해야 합니다.",
        "updateSettingsOn": "설정 업데이트",
        "updateSettingsOff": "자동 충전 활성화",
        "autoChargeTitle": "자동 충전 설정",
        "autoChargeTitleQuestion": "자동 충전을 설정하시겠습니까?",
        "autoChargeCbx": "예, 신용 잔액이 설정한 임계값 이하로 떨어졌을 때 카드를 자동으로 충전합니다.",
        "crdBelow": "신용 잔액이 이하로 내려가면",
        "crdBelowNote": "{0}과 {1} 사이의 금액을 입력하세요",
        "backupTo": "신용 잔액을 다시 설정한 수치로 올립니다.",
        "backupToNote": "{0}과 {1} 사이의 금액을 입력하세요",
        "greaterThan": "값은 {0}보다 커야 합니다",
        "lessThan": "값은 {0}보다 작아야 합니다",
        "AddBalance": "신용 잔액에 추가",
        "toAdd": "추가할 금액",
        "confirm": "결제 확인",
        "usageCredit": "Good Journey 미 사용 크레딧",
        "estTotal": "예상 합계",
        "topUpSuccess": "충전 성공",
        "topUpFailMessage": "신용을 충전하는 동안 오류가 발생했습니다",
        "autoRechargeSuccess": "자동 충전 설정이 성공적으로 업데이트되었습니다",
        "autoRechargeFailMessage": "자동 충전 설정 업데이트 중에 오류가 발생했습니다",
        "creditBalanceTooltip": "선불 잔액은 플랫폼 요금과 사용량에 사용됩니다. 서비스가 중단 없이 원활히 진행되도록 잔액을 유지하세요.",
        "gsnCreditBalanceTooltip": "네트워크 전반에서 예약을 보내고 받는 데 쓰이는 선불 크레딧입니다. 중단 없이 거래하려면 충분한 잔액을 유지하세요.",
        "creditLineTitle": "신용 한도",
        "creditLineTooltip": "Good Journey Network 활동에 대한 신용 한도입니다. 사용액은 한도에서 차감되며, 가용액은 결제가 필요하기 전까지의 여유입니다.",
        "creditLineLimit": "한도",
        "creditLineUsed": "사용액",
        "creditLineAvailable": "사용 가능",
        "creditLineNextPaymentLead": "다음 자동 결제 %{date}",
        "creditLineNextPaymentTail": "또는 잔액이 %{limitAmount}에 도달할 때",
        "creditLineNextPaymentTailOnly": "잔액이 %{limitAmount}에 도달하면 결제가 필요합니다",
        "creditLineMakePayment": "결제하기",
        "cashBalanceTooltip": "이것은 네트워크에서 완료된 작업에서의 수익입니다. 이 금액은 인출 가능입니다. 신용 잔액이 낮으면 여기서도 수수료가 차감될 수 있습니다.",
        "systemTopUp": "시스템 충전",
        "gsnManualTopUp": "수동 충전",
        "gsnSystemTopUp": "시스템 충전",
        "autoTopUp": "자동 충전",
        "manualTopUp": "수동 충전",
        "subscription": "구독",
        "subscriptionOneTime": "한 번만 구독",
        "subscriptionAddOn": "추가 구독",
        "subscriptionAddOnOneTime": "한 번만 추가 구독",
        "booking": "예약 비용",
        "addOn": "추가 항목",
        "subscriptionEnded": "구독이 종료되었습니다. 계속하려면 새 계획을 선택하세요.",
        "continue": "계속",
        "openGuide": "안내문 열기",
        "amountMustBeGreaterThan": "금액은 {0}보다 커야 합니다",
        "amountMustBeLessThan": "금액은 {0}보다 작아야 합니다",
        "billingAndUsage": "청구 및 이용",
        "manageSubscription": "구독 관리",
        "failedToOpenBillingUrl": "청구 URL을 열지 못했습니다",
        "autoChargeAmountMustBeGreaterThanThreshold": "자동 충전이 활성화되면, 금액은 충전 임계값(5)보다 커야 합니다",
        "rechargeWillHappenImmediately": "충전은 즉시 이루어집니다",
        "rechargeWillHappenImmediatelyDescription": "신용 잔액이 설정한 재충전 임계값 이하이므로, 이 설정을 저장한 후에 즉시 재충전이 이루어집니다.",
        "amountIsRequired": "금액이 필요합니다",
        "selectPaymentMethod": "결제 방식 선택",
        "byContinuingYouAgree": "계속 진행함으로써 귀하는 우리의",
        "serviceCreditTerms": "서비스 신용 약관에 동의합니다",
        "paidCreditsNonRefundable": "유료 크레딧은 환불이 불가하며 구매일로부터 1년 후에 소멸합니다.",
        "back": "뒤로",
        "cancel": "취소",
        "topUp": "충전",
        "autoRechargeIs": "자동 충전은",
        "on": "켜짐",
        "off": "꺼짐",
        "viewTransactions": "거래 확인",
        "bankInfo": "은행 정보",
        "setupPayment": "결제 설정",
        "bookingUsage": "Booking Usage",
        "overages": "Overages",
        "included": "included",
        "of": "of",
        "extra": "extra",
        "received": "받은 금액",
        "state": "주",
        "active": "활성",
        "expired": "만료됨",
        "balance": "잔액",
        "expires": "만료",
        "last7Days": "지난 7일",
        "viewHistory": "내역 보기",
        "creditsListedHereWillBeRemoved": "여기에 나열된 크레딧은 만료 날짜에 잔액에서 제거됩니다.",
        "recentTransactions": "최근 거래",
        "onlyPreviewShown": "전체 원장을 보려면 거래를 확인하세요. 미리보기만 표시됩니다.",
        "showingTransactionsPast12Months": "지난 12개월 이내의 거래 보기",
        "filter": "필터",
        "export": "내보내기",
        "all": "모두",
        "date": "날짜",
        "amount": "금액",
        "addOns": "추가 항목",
        "edit": "편집",
        "usage": "사용량",
        "usageThisCycle": "이 사이클에서의 사용량",
        "requests": "요청들",
        "base": "기본",
        "overage": "초과",
        "per": "당",
        "endOfSubscription": "구독 종료",
        "fleetPlan": "플릿 플랜",
        "currentPlan": "현재 플랜",
        "billing": "청구",
        "startDate": "시작 날짜",
        "nextBillingDate": "구독 종료일",
        "change": "변경",
        "getStarted": "시작하기",
        "oneTimeSetup": "한번만 설정:",
        "fee": "비용:",
        "overagePerRequest": "초과",
        "overagePerRequestText": "요청 당",
        "upToRequestsIncluded": "최대",
        "requestsIncluded": "포함된 요청",
        "subscribed": "가입됨",
        "contactUs": "문의하기",
        "enableOnlyWhatYouNeed": "필요한 기능만 활성화하세요. 가격은 청구 주기에 따라 조정됩니다. 과다 사용에 대한 추가 항목은 귀하의 차량 편성 지갑에서 차감됩니다.",
        "subscriptionSummary": "구독 요약",
        "reviewAndUpdate": "구독을 검토하고 업데이트하십시오.",
        "plan": "플랜",
        "ongoingTotal": "진행 중인 총합",
        "nextBillingCycle": "다음 청구 주기",
        "cancelSubscription": "구독 취소",
        "areYouSureCancelSubscription": "정말 구독을 취소하시겠습니까? 서비스에 계속 액세스 할 수 있습니다.",
        "until": "까지",
        "resumeSubscription": "구독 계속하기",
        "no": "아니오",
        "yes": "예",
        "updateSubscription": "구독 업데이트",
        "upgrade": "업그레이드",
        "from": "에서:",
        "totalDueToday": "오늘 날짜에 맞게 지불",
        "howProrationWorks": "프로 비율 작용 방식",
        "prorationDescription": "현재 플랜 또는 추가 항목의 미사용 기간은 새로운 플랜으로 할인됩니다. 주기 중간에 추가된 추가 항목은 현재 청구 기간에 남아있는 일수에 대해서만 부과됩니다.",
        "pleaseSelectPaymentMethod": "결제 방법을 선택해 주십시오",
        "paymentConfirmedSuccessfully": "결제 확인 성공",
        "failedToConfirmPayment": "결제 확인 실패",
        "confirmPayment": "Confirm Payment",
        "failedToGetBillingPlan": "국가 코드 별 청구 계획을 가져오는 데 실패하였습니다",
        "failedToGetPreview": "청구계획 미리 보기를 가져오는 데 실패했습니다",
        "failedToPreviewAddOns": "추가 항목 미리보기에 실패했습니다.",
        "subscriptionCancelledSuccessfully": "구독이 성공적으로 취소되었습니다.",
        "failedToCancelSubscription": "구독 취소에 실패했습니다.",
        "addOnChangedSuccessfully": "추가 항목이 성공적으로 변경되었습니다.",
        "failedToChangedAddOn": "추가 항목 변경 실패",
        "failedToGetUsage": "사용 상태 조회 실패",
        "annual": "연간",
        "monthly": "월간",
        "currentPlanButton": "현재 플랜",
        "upgradeButton": "업그레이드",
        "save": "저장",
        "expiresText": "만료",
        "noExpiry": "만료 없음",
        "managePayment": "결제 관리",
        "changePlan": "Change Plan",
        "addOns": "애드온",
        "viewUsage": "사용량 보기",
        "requestWithdrawal": "출금 요청",
        "withdraw": "출금",
        "withdrawalGsn": {
            "requestWithdrawal": "출금 요청",
            "reviewWithdrawal": "출금 검토",
            "payTo": "지급 대상",
            "availableBalance": "사용 가능 잔액 ({currency})",
            "payoutBalance": "정산 잔액 ({currency})",
            "payoutBalanceLabel": "정산 잔액",
            "amountOwedToPlatform": "플랫폼 미납 금액",
            "availableToWithdraw": "출금 가능 금액",
            "amountToWithdraw": "출금 금액 ({currency})",
            "minimumWithdrawal": "최소 출금: {amount} {currency}",
            "minimumTransferAmount": "최소 이체 금액: {amount} {currency}",
            "noPayoutMethods": "지급 수단 없음",
            "review": "검토",
            "payoutSpeed": "지급 속도",
            "normalPayout": "일반 지급",
            "instantPayout": "즉시 지급",
            "recommended": "추천",
            "transferFeePercent": "이체 수수료 {percent}%",
            "transferFee": "이체 수수료",
            "withdrawalAmount": "출금 금액",
            "amountDeducted": "차감 금액",
            "youWillReceive": "받으실 금액",
            "totalToReceive": "총 수령액",
            "confirmWithdrawal": "출금 확인",
            "disclaimer": "출금은 USD로 송금됩니다",
            "disclaimer1": "수취 은행이 현지 통화로 환전하고 자체 수수료와 환율을 적용할 수 있습니다",
            "disclaimer2": "실제 수령액은 송금액과 다를 수 있습니다.",
            "requestSuccess": "출금 요청이 제출되었습니다."
        },
        "addNewPaymentMethod": "새 결제 수단 추가",
        "warningCurrentBalance": "플랫폼에 지급해야 할 금액이 현재 정산 잔액을 초과합니다. 지금은 출금을 요청할 수 없습니다."
    },
    "signup": {
        "limitation": {
            "driver": "Driver",
            "vehicle": "Vehicle",
            "operator": "Operator",
            "drivers": "Drivers",
            "vehicles": "Vehicles",
            "operators": "Operators"
        },
        "language": "언어",
        "contactHeader": "문제 또는 질문이 있으면 문의하십시오",
        "stepAccountTitle": "계정 생성",
        "stepAccountDesc": "사용자 이름과 비밀번호를 입력하십시오",
        "stepCompanyTitle": "회사 정보",
        "stepCompanyDesc": "로고, 컬러 테마, 회사 정보를 추가하세요.",
        "stepZoneTitle": "운영 지역",
        "stepZoneDesc": "운영 도시를 선택하십시오.",
        "stepPlanTitle": "플랜 선택",
        "stepPlanDesc": "당신에게 적합한 결제 플랜을 선택하십시오.",
        "stepPlanCustom": "맞춤형 플랜",
        "stepPlanTitleCustom": "맞춤형 플랜 검토",
        "stepPlanDescCustom": "귀하의 차량에 맞게 특별히 제작된 플랜입니다.",
        "accountStepTitle": "계정 생성",
        "accountStepUsername": "사용자 이름",
        "accountStepEmail": "이메일",
        "accountStepChoosePassword": "비밀번호 선택",
        "accountStepConfirmPassword": "비밀번호 확인",
        "accountStepPasswordHint": "비밀번호는 최소 8자, 1개의 대문자 그리고 1개의 특수 문자가 포함되어야 합니다",
        "accountStepCreateAccount": "계정 생성",
        "accountStepAlreadyHaveAccount": "이미 계정이 있으십니까?",
        "accountStepCaptchaError": "캡챠를 확인해 주십시오",
        "accountStepGenericError": "계정을 생성하는 동안 오류가 발생했습니다.",
        "accountStepSuccess": "계정이 성공적으로 생성되었습니다.",
        "usernameRequired": "사용자 이름이 필요합니다",
        "usernameMinLength": "사용자 이름은 최소 3자 이상이어야 합니다",
        "usernameMaxLength": "사용자 이름은 20자 이내여야 합니다",
        "usernamePattern": "사용자 이름은 소문자로 시작해야 하며 소문자와 숫자만 포함할 수 있습니다",
        "emailRequired": "이메일이 필요합니다",
        "emailInvalid": "이메일이 유효하지 않습니다",
        "passwordRequired": "비밀번호가 필요합니다",
        "passwordMinLength": "비밀번호는 최소 8자 이상이어야 합니다",
        "passwordPattern": "비밀번호는 최소한 1개의 대문자와 1개의 특수 문자가 포함되어야 합니다",
        "confirmPasswordMismatch": "비밀번호가 일치하지 않습니다",
        "companyStepTitle": "회사 정보",
        "companyStepAddLogo": "로고 추가",
        "companyStepColorTheme": "색상 테마",
        "companyStepSelectThemeColor": "테마 색상 선택",
        "companyStepFirstName": "이름",
        "companyStepLastName": "성",
        "companyStepPhone": "전화",
        "companyStepEmail": "이메일",
        "companyStepCompanyName": "회사 이름",
        "companyStepFleetId": "차량 편성 ID",
        "companyStepCompanyAddress": "회사 주소",
        "companyStepCompanyWebsite": "회사 웹사이트",
        "companyStepDriversNumber": "차량 편성에는 몇 대의 차량이 있습니까?",
        "companyStepVehiclesNumber": "차량 편성에는 몇대의 차량이 있습니까?",
        "companyStepContinue": "계속",
        "companyStepGenericError": "회사 저장을 도중에 오류가 발생했습니다.",
        "companyStepSuccess": "회사 저장이 성공적으로 완료되었습니다.",
        "companyStepPhoneInvalid": "유효한 전화번호를 입력하십시오",
        "companyNameRequired": "회사 이름이 필요합니다",
        "fleetIdRequired": "FleetID가 필요합니다",
        "fleetIdPattern": "4-30자여야 하며 소문자로 시작해야 하고 소문자와 숫자만 포함할 수 있습니다",
        "zoneStepTitle": "운영 영역 설정",
        "zoneStepDescription": "이것이 개시 운영 구역입니다. 향후 확장을 위해 자유롭게",
        "zoneStepSearchAddress": "주소 검색",
        "zoneStepLatitude": "위도",
        "zoneStepLongitude": "경도",
        "zoneStepRadius": "중심 지역에서 얼마나 멀리 갈 것인가요?",
        "zoneStepRadiusDescription": "중심점에서 가장 먼 거리.",
        "zoneStepContinue": "계속",
        "zoneStepGenericError": "구역 저장 중 오류 발생",
        "zoneStepSuccess": "구역이 성공적으로 저장됨",
        "zoneStepInvalidCoordinates": "위도와 경도가 유효하지 않습니다",
        "latitudeRequired": "위도는 필수입력 항목입니다",
        "latitudeDecimalPlaces": "위도는 소수점 아래 10자리까지만 가능합니다",
        "latitudeRange": "위도는 -90도와 90도 사이여야 합니다",
        "longitudeRequired": "경도는 필수입력 항목입니다",
        "longitudeDecimalPlaces": "경도는 소수점 아래 10자리까지만 가능합니다",
        "longitudeRange": "경도는 -180도와 180도 사이여야 합니다",
        "radiusRequired": "반경은 필수입력 항목입니다",
        "radiusMinError": "반경은 최소 {0} km 이상이어야 합니다",
        "radiusMaxError": "반경은 {0} km를 초과할 수 없습니다",
        "contactUs": "문의하기",
        "planTitle": "플랜 선택",
        "planDescription": "당신의 필요에 맞는 플랜을 선택하세요. 언제든지 업그레이드 또는 취소 가능. 숨겨진 비용은 전혀 없습니다.",
        "planDescriptionCustom": "귀하의 차량에 맞게 특별히 제작된 플랜입니다.",
        "billingMonthly": "월간",
        "billingAnnual": "연간",
        "saveBadge": "20% 절약",
        "popularBadge": "가장 인기 있는",
        "customPricing": "맞춤",
        "periodAnnual": "연간",
        "periodMonthly": "월간",
        "bonusCredits": "일회성 보너스 {0} 크레딧",
        "savePercentage": "{0}% 절약",
        "oneTimeSetupFee": "일회성 설정 수수료",
        "waived": "Waived*",
        "planFeatures": {
            "feePerBooking39": "예약 당 3.9%",
            "feePerBooking29": "예약 당 2.9%",
            "feePerBooking": "추가 예약당 {0}",
            "freeBookingPerMonth": "월 {0} 무료 예약",
            "unlimitedUsers": "무제한 사용자",
            "commandCenterAdminDashboard": "커맨드 센터 관리자 대시보드",
            "nativeDriverApp": "네이티브 드라이버 앱",
            "webDriverApp": "웹 드라이버 앱",
            "customerBookingLink": "고객 예약 링크",
            "plusEverythingInStartup": "스타트업에 포함된 모든 것",
            "corporateManagement": "기업 관리",
            "invoicingManagement": "인보이싱 관리",
            "driverPayoutManagement": "드라이버 지불 관리",
            "promotionManagement": "프로모션 관리",
            "plusEverythingInPro": "프로에 포함된 모든 것",
            "tierDiscountPricing": "티어 할인 가격",
            "customFeatureDevelopment": "사용자 정의 피처 개발",
            "unlimitedOperators": "무제한 운영자",
            "unlimitedDrivers": "무제한 운전자",
            "unlimitedVehicles": "무제한 차량"
        },
        "planDescriptions": {
            "enterprise": "Enterprise에는 맞춤 청구, 전담 온보딩, 계층 할인 가격 책정 및 특정 워크플로우에 완벽하게 맞춤 기능 개발이 포함됩니다."
        },
        "limitedNotes": "(*) 한정 기간 독점 프로모션",
        "unlimitedText": "무제한",
        "volumeDiscount": "볼륨 할인",
        "letsTalkButton": "가능한 대화해봅시다!",
        "buildingStepTitle": "여러분의 대용량을 구축 중입니다...",
        "congratulationsTitle": "축하합니다! 계정이 준비되었습니다",
        "congratulationsDescription": "여기에서 관리자 대시보드에 로그인하세요.",
        "congratulationsViewDashboard": "대시보드 보기",
        "congratulationsContact": "질문이 있으시면 저희에게 연락주세요:",
        "fleetIdDescription": "여러분의 대용량에 대한 짧고 간단한 코드를 선택하세요 — 공유하거나 기억하기 쉽습니다.",
        "fleetIdPlaceholder": "예: goodjourney",
        "firstNameRequired": "이름은 필수 입력 항목입니다",
        "logIn": "로그인",
        "instead": "대신.",
        "submittingData": "데이터 제출 중...",
        "upload": "업로드",
        "phoneNumberPlaceholder": "\"\"+1 전화번호\"\"",
        "km": "KM",
        "selectPlan": "플랜 선택",
        "upgrade": "업그레이드",
        "goodJourney": "Good Journey",
        "loading": "로딩 중...",
        "lastNameRequired": "성은 필수 입력 항목입니다",
        "agreeToTerms": "계속 진행하면, 귀하는 다음을 읽고 동의했음을 인정합니다",
        "termsOfService": "이용 약관",
        "privacyPolicy": "개인정보 보호정책",
        "and": "그리고",
        "refresh": "새로고침",
        "takingTooLong": "너무 오래 걸리나요?"
    },
    "addonTemplate": {
        "Addon_Template": "Add-On Template",
        "Add_On_Template": "Add-On Template",
        "Create_addon_template_success": "Add-on template has been created successfully",
        "Create_addon_template_fail": "The errors occurred while creating add-on template",
        "Update_addon_template_success": "Add-on template has been updated successfully",
        "Update_addon_template_fail": "The errors occurred while updating add-on template",
        "Update_template_success": "Template has been updated successfully",
        "Update_template_fail": "The errors occurred while updating template",
        "Edit_Template": "Edit Template",
        "New_Template": "New Template",
        "Enter_Add_On_Template_Name": "Enter Add-On Template Name*",
        "Confirm_Delete": "Confirm Delete",
        "Confirm_Delete_Message": "Are you sure you want to delete this template? Deleting this template will unlink from all the partners/corp it links to",
        "Delete_success": "Template has been deleted successfully",
        "Delete_fail": "The errors occurred while deleting template",
        "Set_Default": "Set as Default",
        "Confirm_Set_Default_Message": "Are you sure you want to set this Add-On as default?",
        "Set_Default_Success": "Add-on template has been set as default successfully",
        "Set_Default_Fail": "The errors occurred while setting add-on template as default",
        "Clone_addon_template": "Clone Add-On Template"
    },
    "addonService": {
        "Additional_Service": "Additional Service",
        "Service_Name": "Service Name",
        "Description": "Description",
        "desPlaceholder": "Brief description of the service",
        "namePlaceholder": "e.g. Meet & Greet, Local-E Sim, GST Tax",
        "Who_pays_for_this_add_on": "Who pays for this add-on?",
        "customer": "Customer",
        "driver": "Driver",
        "fleet": "Fleet",
        "Required": "Required",
        "Apply_Tax": "Apply Tax",
        "Itemize": "Itemize",
        "Attribute": "Attribute",
        "Fee_Type": "Fee Type",
        "feeType.amount": "Amount",
        "feeType.percentageSubtotal": "Percentage of Subtotal",
        "feeType.percentageTotal": "Percentage of Total",
        "feeType.custom": "Custom (Driver Input)",
        "Unit_Settings": "Unit Settings",
        "unit.none": "None",
        "unit.perDay": "per day",
        "unit.eachTime": "each time",
        "unit.perPerson": "per person",
        "Maximum_Quantity": "Maximum Quantity",
        "Maximum_Quantity_Value": "Maximum Quantity Value",
        "How_much_will_the_fleet_make": "How much will the fleet make for this add-on?",
        "Fleet_Commission": "Fleet Commission",
        "Percentage": "Percentage",
        "Amount": "Amount",
        "Currency": "Currency",
        "Unlimited": "Unlimited",
        "Limited": "Limited",
        "Vehicle_Type": "Vehicle Type",
        "Service_Type": "Service Type",
        "Meeting_Zone": "Meeting Zone",
        "Trip_Context": "Trip Context",
        "Trip_Context_Value": {
            "departure": "Departure",
            "arrival": "Arrival"
        },
        "Operation_Zone": "Operation Zone",
        "Restricted_Zone": "Restricted Zone",
        "User_Type": "User Type",
        "Price_Unit": "Price Unit",
        "Info": "Info",
        "Rules": "Rules",
        "Basic_Information": "Basic Information",
        "Delete": "Delete",
        "Delete_addon_service": "Are you sure you want to delete this add-on service?",
        "Delete_success": "Add-on service has been deleted successfully",
        "Delete_fail": "The errors occurred while deleting add-on service",
        "Create_addon_service_success": "Add-on service has been created successfully",
        "Create_addon_service_fail": "The errors occurred while creating add-on service",
        "Update_addon_service_success": "Add-on service has been updated successfully",
        "Update_addon_service_fail": "The errors occurred while updating add-on service",
        "Please_save_template_first": "Please save the template first before adding services",
        "Attribute_Tooltip": "Travel Attribute: Used to map this add-on to its corresponding standardized service key across connected OTAs (e.g., CHILD_SEAT, MEET_GREET).",
        "feeType": {
            "amount": "Amount",
            "percentageSubtotal": "Percentage of Subtotal",
            "percentageTotal": "Percentage of Total",
            "custom": "Custom (Driver Input)"
        },
        "unit": {
            "none": "None",
            "perDay": "Per day (Charge per day)",
            "eachTime": "Each time (Charge per ride)",
            "perPerson": "Per person (Charge per person)",
            "each": "Each (Charge per quantity)"
        },
        "none": "None",
        "perDay": "Per day",
        "eachTime": "Each time",
        "perPerson": "Per person",
        "each": "Each",
        "Unit_Settings_Title": "Unit Settings",
        "Itemize_Tooltip": "Itemize: This will list the add-on as a separate line item in the fare breakdown. If this is disabled, it will be under additional services.",
        "Booking_Channel": "Booking Channel",
        "pointToPoint": "Point To Point",
        "fromAirport": "From Airport",
        "toAirport": "To Airport",
        "hourly": "Hourly",
        "roundTrip": "Round Trip",
        "ADD_ON_BOOKING_CHANNEL_VALUE": {
            "PWA": "Web App",
            "passenger": "Customer App",
            "API": "API",
            "CC": "Command Center",
            "partner": "Partner App",
            "CarHailing": "Street Hailing",
            "streetSharing": "Street Sharing"
        },
        "Select_Attribute": "Select Attribute",
        "allowNoteInput": "Driver Input: Notes or Receipts",
        "allowNoteInputTooltip": "Allows drivers to submit notes and upload supporting photos or receipts for this service at the end of the trip (e.g. parking fees, tolls, additional charges).",
        "isDriverCapability": "Driver Capability",
        "Driver_Capability_Tooltip": "Exposes this service as a selectable capability in the driver profile. Used for driver profiling and booking-to-driver matching.",
        "isVehicleAttribute": "Vehicle Attribute",
        "Vehicle_Attribute_Tooltip": "Exposes this service as a selectable attribute in the vehicle profile. Used for vehicle profiling and booking matching.",
        "linkAtr": "Link attributes to a specific driver.",
        "addOnServicePolicy": "Add-On Policy",
        "selectAddonTemplate": "Select Add-on Template"
    }
};
